(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.bo.aL === region.bN.aL)
	{
		return 'on line ' + region.bo.aL;
	}
	return 'on lines ' + region.bo.aL + ' through ' + region.bN.aL;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (Object.prototype.hasOwnProperty.call(value, key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	var unwrapped = _Json_unwrap(value);
	if (!(key === 'toJSON' && typeof unwrapped === 'function'))
	{
		object[key] = unwrapped;
	}
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.d5,
		impl.e1,
		impl.eQ,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		Z: func(record.Z),
		br: record.br,
		bk: record.bk
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.Z;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.br;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.bk) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.d5,
		impl.e1,
		impl.eQ,
		function(sendToApp, initialModel) {
			var view = impl.e4;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.d5,
		impl.e1,
		impl.eQ,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.bm && impl.bm(sendToApp)
			var view = impl.e4;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.dB);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.e$) && (_VirtualDom_doc.title = title = doc.e$);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.en;
	var onUrlRequest = impl.eo;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		bm: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.c1 === next.c1
							&& curr.bV === next.bV
							&& curr.c_.a === next.c_.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		d5: function(flags)
		{
			return A3(impl.d5, flags, _Browser_getUrl(), key);
		},
		e4: impl.e4,
		e1: impl.e1,
		eQ: impl.eQ
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { d0: 'hidden', dJ: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { d0: 'mozHidden', dJ: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { d0: 'msHidden', dJ: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { d0: 'webkitHidden', dJ: 'webkitvisibilitychange' }
		: { d0: 'hidden', dJ: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		c9: _Browser_getScene(),
		dm: {
			dp: _Browser_window.pageXOffset,
			dq: _Browser_window.pageYOffset,
			$7: _Browser_doc.documentElement.clientWidth,
			bU: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		$7: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		bU: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			c9: {
				$7: node.scrollWidth,
				bU: node.scrollHeight
			},
			dm: {
				dp: node.scrollLeft,
				dq: node.scrollTop,
				$7: node.clientWidth,
				bU: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			c9: _Browser_getScene(),
			dm: {
				dp: x,
				dq: y,
				$7: _Browser_doc.documentElement.clientWidth,
				bU: _Browser_doc.documentElement.clientHeight
			},
			dU: {
				dp: x + rect.left,
				dq: y + rect.top,
				$7: rect.width,
				bU: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}


// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.dW.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.dW.b, xhr)); });
		$elm$core$Maybe$isJust(request.dl) && _Http_track(router, xhr, request.dl.a);

		try {
			xhr.open(request.eb, request.e2, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.e2));
		}

		_Http_configureRequest(xhr, request);

		request.dB.a && xhr.setRequestHeader('Content-Type', request.dB.a);
		xhr.send(request.dB.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.bT; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.e_.a || 0;
	xhr.responseType = request.dW.d;
	xhr.withCredentials = request.dt;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		e2: xhr.responseURL,
		de: xhr.status,
		eO: xhr.statusText,
		bT: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			eM: event.loaded,
			dc: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			eu: event.loaded,
			dc: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.q) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.r),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.r);
		} else {
			var treeLen = builder.q * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.s) : builder.s;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.q);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.r) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.r);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{s: nodeList, q: (len / $elm$core$Array$branchFactor) | 0, r: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {bP: fragment, bV: host, cX: path, c_: port_, c1: protocol, c2: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Main$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$LoadingMessage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$Model = F2(
	function (state, tickInterval) {
		return {aO: state, bw: tickInterval};
	});
var $author$project$Main$c_TICKTIME = 20;
var $author$project$LoadingModel$InitTick = function (a) {
	return {$: 1, a: a};
};
var $author$project$LoadingModel$Initial = {$: 0};
var $author$project$LoadingModel$LoadingModel = F2(
	function (tapUrl, state) {
		return {aO: state, bt: tapUrl};
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$LoadingModel$GotRom = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 4;
		case 6:
			return 4;
		case 7:
			return 8;
		case 8:
			var w = builder.a;
			return w;
		case 9:
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$LE = 0;
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 0:
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 1:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i16, mb, offset, n, !e);
			case 2:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i32, mb, offset, n, !e);
			case 3:
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 4:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u16, mb, offset, n, !e);
			case 5:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u32, mb, offset, n, !e);
			case 6:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f32, mb, offset, n, !e);
			case 7:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f64, mb, offset, n, !e);
			case 8:
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 9:
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Decode$decode = F2(
	function (_v0, bs) {
		var decoder = _v0;
		return A2(_Bytes_decode, decoder, bs);
	});
var $elm$bytes$Bytes$Decode$Decoder = $elm$core$Basics$identity;
var $elm$bytes$Bytes$Decode$andThen = F2(
	function (callback, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var newOffset = _v1.a;
				var a = _v1.b;
				var _v2 = callback(a);
				var decodeB = _v2;
				return A2(decodeB, bites, newOffset);
			});
	});
var $elm$bytes$Bytes$Decode$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$bytes$Bytes$Decode$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$bytes$Bytes$Decode$map = F2(
	function (func, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var aOffset = _v1.a;
				var a = _v1.b;
				return _Utils_Tuple2(
					aOffset,
					func(a));
			});
	});
var $elm$core$Elm$JsArray$push = _JsArray_push;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$insertTailInTree = F4(
	function (shift, index, tail, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		if (_Utils_cmp(
			pos,
			$elm$core$Elm$JsArray$length(tree)) > -1) {
			if (shift === 5) {
				return A2(
					$elm$core$Elm$JsArray$push,
					$elm$core$Array$Leaf(tail),
					tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
				return A2($elm$core$Elm$JsArray$push, newSub, tree);
			}
		} else {
			var value = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!value.$) {
				var subTree = value.a;
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, subTree));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4(
						$elm$core$Array$insertTailInTree,
						shift - $elm$core$Array$shiftStep,
						index,
						tail,
						$elm$core$Elm$JsArray$singleton(value)));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$unsafeReplaceTail = F2(
	function (newTail, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var originalTailLen = $elm$core$Elm$JsArray$length(tail);
		var newTailLen = $elm$core$Elm$JsArray$length(newTail);
		var newArrayLen = len + (newTailLen - originalTailLen);
		if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
			var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;
			if (overflow) {
				var newShift = startShift + $elm$core$Array$shiftStep;
				var newTree = A4(
					$elm$core$Array$insertTailInTree,
					newShift,
					len,
					newTail,
					$elm$core$Elm$JsArray$singleton(
						$elm$core$Array$SubTree(tree)));
				return A4($elm$core$Array$Array_elm_builtin, newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
			} else {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					newArrayLen,
					startShift,
					A4($elm$core$Array$insertTailInTree, startShift, len, newTail, tree),
					$elm$core$Elm$JsArray$empty);
			}
		} else {
			return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, tree, newTail);
		}
	});
var $elm$core$Array$push = F2(
	function (a, array) {
		var tail = array.d;
		return A2(
			$elm$core$Array$unsafeReplaceTail,
			A2($elm$core$Elm$JsArray$push, a, tail),
			array);
	});
var $elm$bytes$Bytes$Decode$succeed = function (a) {
	return F2(
		function (_v0, offset) {
			return _Utils_Tuple2(offset, a);
		});
};
var $author$project$Z80Rom$arrayStep = F2(
	function (decoder, _v0) {
		var n = _v0.a;
		var xs = _v0.b;
		return (n <= 0) ? $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(xs)) : A2(
			$elm$bytes$Bytes$Decode$map,
			function (x) {
				return $elm$bytes$Bytes$Decode$Loop(
					_Utils_Tuple2(
						n - 1,
						A2($elm$core$Array$push, x, xs)));
			},
			decoder);
	});
var $elm$bytes$Bytes$Decode$loopHelp = F4(
	function (state, callback, bites, offset) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var decoder = _v0;
			var _v1 = A2(decoder, bites, offset);
			var newOffset = _v1.a;
			var step = _v1.b;
			if (!step.$) {
				var newState = step.a;
				var $temp$state = newState,
					$temp$callback = callback,
					$temp$bites = bites,
					$temp$offset = newOffset;
				state = $temp$state;
				callback = $temp$callback;
				bites = $temp$bites;
				offset = $temp$offset;
				continue loopHelp;
			} else {
				var result = step.a;
				return _Utils_Tuple2(newOffset, result);
			}
		}
	});
var $elm$bytes$Bytes$Decode$loop = F2(
	function (state, callback) {
		return A2($elm$bytes$Bytes$Decode$loopHelp, state, callback);
	});
var $author$project$Z80Rom$array_decoder = F2(
	function (size, decoder) {
		return A2(
			$elm$bytes$Bytes$Decode$loop,
			_Utils_Tuple2(size, $elm$core$Array$empty),
			$author$project$Z80Rom$arrayStep(decoder));
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$Utils$listToDict = function (intlist) {
	var x = A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, intlist);
	return $elm$core$Dict$fromList(x);
};
var $author$project$Z80Rom$grabRomDecoder = function (romData) {
	return $elm$bytes$Bytes$Decode$succeed(
		$author$project$Utils$listToDict(
			$elm$core$Array$toList(romData)));
};
var $elm$bytes$Bytes$Decode$unsignedInt8 = _Bytes_read_u8;
var $author$project$Z80Rom$romDecoder = A2(
	$elm$bytes$Bytes$Decode$andThen,
	$author$project$Z80Rom$grabRomDecoder,
	A2($author$project$Z80Rom$array_decoder, 16384, $elm$bytes$Bytes$Decode$unsignedInt8));
var $author$project$Z80Rom$parseRomFile = function (bytes) {
	return A2($elm$bytes$Bytes$Decode$decode, $author$project$Z80Rom$romDecoder, bytes);
};
var $author$project$MessageHandler$bytesToRom = function (httpResponse) {
	switch (httpResponse.$) {
		case 0:
			var url = httpResponse.a;
			return $elm$core$Result$Err(
				$elm$http$Http$BadUrl(url));
		case 1:
			return $elm$core$Result$Err($elm$http$Http$Timeout);
		case 2:
			return $elm$core$Result$Err($elm$http$Http$NetworkError);
		case 3:
			var metadata = httpResponse.a;
			return $elm$core$Result$Err(
				$elm$http$Http$BadStatus(metadata.de));
		default:
			var body = httpResponse.b;
			var _v1 = $author$project$Z80Rom$parseRomFile(body);
			if (!_v1.$) {
				var a = _v1.a;
				return $elm$core$Result$Ok(a);
			} else {
				return $elm$core$Result$Err(
					$elm$http$Http$BadBody('ROM parse failed'));
			}
	}
};
var $author$project$Z80Debug$debugLog = F3(
	function (msg, thingToLog, thingToReturn) {
		return thingToReturn;
	});
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {c4: reqs, dh: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.dl;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.c4));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.dh)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					dt: r.dt,
					dB: r.dB,
					dW: A2(_Http_mapExpect, func, r.dW),
					bT: r.bT,
					eb: r.eb,
					e_: r.e_,
					dl: r.dl,
					e2: r.e2
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{dt: false, dB: r.dB, dW: r.dW, bT: r.bT, eb: r.eb, e_: r.e_, dl: r.dl, e2: r.e2}));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{dB: $elm$http$Http$emptyBody, dW: r.dW, bT: _List_Nil, eb: 'GET', e_: $elm$core$Maybe$Nothing, dl: $elm$core$Maybe$Nothing, e2: r.e2});
};
var $author$project$LoadingModel$romLoad = function (url) {
	return A4(
		$author$project$Z80Debug$debugLog,
		'loadRom',
		url,
		$elm$http$Http$get,
		{
			dW: A2(
				$elm$http$Http$expectBytesResponse,
				function (result) {
					return $author$project$LoadingModel$GotRom(result);
				},
				$author$project$MessageHandler$bytesToRom),
			e2: url
		});
};
var $author$project$LoadingModel$loadingInit = function (data) {
	var tick = A2($elm$core$Task$perform, $author$project$LoadingModel$InitTick, $elm$time$Time$now);
	var load = $author$project$LoadingModel$romLoad(data.c7);
	return _Utils_Tuple2(
		A2($author$project$LoadingModel$LoadingModel, data.dj, $author$project$LoadingModel$Initial),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[load, tick])));
};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Main$init = function (data) {
	var _v0 = $author$project$LoadingModel$loadingInit(data);
	var m = _v0.a;
	var c = _v0.b;
	return _Utils_Tuple2(
		A2(
			$author$project$Main$Model,
			$author$project$Main$Loading(m),
			$author$project$Main$c_TICKTIME),
		A2($elm$core$Platform$Cmd$map, $author$project$Main$LoadingMessage, c));
};
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Main$RunningMessage = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$QaopModel$FlipFlash = function (a) {
	return {$: 2, a: a};
};
var $author$project$QaopModel$Tick = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {c0: processes, di: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.c0;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.di);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$QaopModel$qaopSubs = F2(
	function (model, tickInterval) {
		if (model.l.bn.aN) {
			return $elm$core$Platform$Sub$none;
		} else {
			var ticker = A2(
				$elm$time$Time$every,
				tickInterval,
				function (posix) {
					return $author$project$QaopModel$Tick(posix);
				});
			var flasher = A2(
				$elm$time$Time$every,
				tickInterval * 16,
				function (posix) {
					return $author$project$QaopModel$FlipFlash(posix);
				});
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[ticker, flasher]));
		}
	});
var $author$project$Main$subscriptions = function (model) {
	var _v0 = model.aO;
	if (!_v0.$) {
		return $elm$core$Platform$Sub$none;
	} else {
		var qaopModel = _v0.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Main$RunningMessage,
			A2($author$project$QaopModel$qaopSubs, qaopModel, model.bw));
	}
};
var $author$project$Main$Running = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$LoadingModel$NowRunning = function (a) {
	return {$: 1, a: a};
};
var $author$project$LoadingModel$OnlyTime = function (a) {
	return {$: 1, a: a};
};
var $author$project$Qaop$Qaop = F3(
	function (spectrum, state, keys) {
		return {d7: keys, bn: spectrum, aO: state};
	});
var $author$project$QaopModel$QaopModel = F6(
	function (qaop, count, elapsed_millis, time, loadPressed, globalFlash) {
		return {y: count, aq: elapsed_millis, aW: globalFlash, bf: loadPressed, l: qaop, aQ: time};
	});
var $author$project$LoadingModel$ROM = function (a) {
	return {$: 2, a: a};
};
var $author$project$LoadingModel$StillLoading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Spectrum$Spectrum = F8(
	function (cpu, rom48k, paused, loading, want_pause, tape, screen_refresh, border_refresh) {
		return {dF: border_refresh, ap: cpu, aY: loading, aN: paused, eH: rom48k, eL: screen_refresh, dj: tape, by: want_pause};
	});
var $author$project$Z80Flags$FlagRegisters = F5(
	function (a, ff, fr, fa, fb) {
		return {bA: a, aE: fa, aF: fb, U: ff, ag: fr};
	});
var $author$project$Interrupts$IFF_0 = 0;
var $author$project$Interrupts$IM0 = 0;
var $author$project$Interrupts$InterruptRegisters = F4(
	function (iM, halted, ir, r) {
		return {d$: halted, d1: iM, bZ: ir, et: r};
	});
var $author$project$Z80Types$MainRegisters = F5(
	function (b, c, d, e, hl) {
		return {dw: b, dI: c, dN: d, dT: e, aG: hl};
	});
var $author$project$Z80Types$MainWithIndexRegisters = F7(
	function (b, c, d, e, hl, ix, iy) {
		return {dw: b, dI: c, dN: d, dT: e, aG: hl, o: ix, p: iy};
	});
var $author$project$Z80CoreWithClockTime$Z80 = F4(
	function (coreWithClock, alt_main, alt_flags, iff) {
		return {bD: alt_flags, bE: alt_main, ao: coreWithClock, d2: iff};
	});
var $author$project$Z80Core$Z80Core = F4(
	function (env, main, flags, interrupts) {
		return {B: env, K: flags, be: interrupts, u: main};
	});
var $author$project$Z80CoreWithClockTime$Z80CoreWithClockTime = F3(
	function (core, clockTime, pc) {
		return {dM: clockTime, ae: core, cY: pc};
	});
var $author$project$CpuTimeCTime$CpuTimeCTime = F2(
	function (cpu_time, ctime) {
		return {F: cpu_time, aC: ctime};
	});
var $author$project$CpuTimeCTime$NoCont = {$: 0};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $author$project$CpuTimeCTime$c_FRSTART = -14335;
var $author$project$CpuTimeCTime$reset_cpu_time = A2($author$project$CpuTimeCTime$CpuTimeCTime, $author$project$CpuTimeCTime$c_FRSTART, $author$project$CpuTimeCTime$NoCont);
var $author$project$Z80Env$Z80Env = F3(
	function (ram, sp, borderColour) {
		return {dE: borderColour, bl: ram, eN: sp};
	});
var $author$project$Z80Env$z80env_constructor = A3($author$project$Z80Env$Z80Env, $elm$core$Dict$empty, 0, 7);
var $author$project$Z80$constructor = function () {
	var time = $author$project$CpuTimeCTime$reset_cpu_time;
	var main = A7($author$project$Z80Types$MainWithIndexRegisters, 0, 0, 0, 0, 0, 0, 0);
	var interrupts = A4($author$project$Interrupts$InterruptRegisters, 0, false, 0, 0);
	var flags = A5($author$project$Z80Flags$FlagRegisters, 0, 0, 0, 0, 0);
	var alternate = A5($author$project$Z80Types$MainRegisters, 0, 0, 0, 0, 0);
	return A4(
		$author$project$Z80CoreWithClockTime$Z80,
		A3(
			$author$project$Z80CoreWithClockTime$Z80CoreWithClockTime,
			A4($author$project$Z80Core$Z80Core, $author$project$Z80Env$z80env_constructor, main, flags, interrupts),
			time,
			0),
		alternate,
		flags,
		0);
}();
var $author$project$Z80Rom$Z80ROM = F3(
	function (rom48k, keyboard, z80ram) {
		return {b$: keyboard, eH: rom48k, e6: z80ram};
	});
var $author$project$Keyboard$Keyboard = F2(
	function (keyboard, kempston) {
		return {aI: kempston, b$: keyboard};
	});
var $Chadtech$elm_vector$Vector8$Internal$Vector = $elm$core$Basics$identity;
var $Chadtech$elm_vector$Vector8$repeat = function (a) {
	return {j: a, b3: a, b: a, c: a, d: a, e: a, f: a, g: a};
};
var $author$project$Keyboard$constructor = A2(
	$author$project$Keyboard$Keyboard,
	$Chadtech$elm_vector$Vector8$repeat(255),
	_List_Nil);
var $author$project$Z80Ram$Z80Ram = F2(
	function (screen, non_screen) {
		return {a$: non_screen, eK: screen};
	});
var $author$project$SpectrumColour$BorderWhite = 7;
var $author$project$ScreenStorage$Z80Screen = F2(
	function (lines, border) {
		return {dD: border, ea: lines};
	});
var $author$project$Z80MemoryDict$Z80MemoryDict = $elm$core$Basics$identity;
var $author$project$Z80MemoryDict$ramListToDict = function (list) {
	var ramarray = A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, list);
	return $elm$core$Dict$fromList(ramarray);
};
var $author$project$Z80MemoryDict$constructor = function (list) {
	return $author$project$Z80MemoryDict$ramListToDict(list);
};
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $Chadtech$elm_vector$Vector24$Internal$Vector = $elm$core$Basics$identity;
var $Chadtech$elm_vector$Vector24$repeat = function (a) {
	return {j: a, b3: a, b4: a, b5: a, b6: a, b7: a, b8: a, b9: a, ca: a, cb: a, cc: a, cd: a, b: a, ce: a, cf: a, cg: a, ch: a, c: a, d: a, e: a, f: a, g: a, h: a, i: a};
};
var $Chadtech$elm_vector$Vector32$Internal$Vector = $elm$core$Basics$identity;
var $Chadtech$elm_vector$Vector32$repeat = function (a) {
	return {j: a, b3: a, b4: a, b5: a, b6: a, b7: a, b8: a, b9: a, ca: a, cb: a, cc: a, cd: a, b: a, ce: a, cf: a, cg: a, ch: a, ci: a, cj: a, ck: a, cl: a, cm: a, cn: a, c: a, co: a, cp: a, d: a, e: a, f: a, g: a, h: a, i: a};
};
var $author$project$ScreenStorage$constructor = function () {
	var screen_line = $author$project$Z80MemoryDict$constructor(
		A2($elm$core$List$repeat, 256, 0));
	var attr_line = $Chadtech$elm_vector$Vector32$repeat(56);
	var line = {dv: attr_line, af: screen_line};
	return A2(
		$author$project$ScreenStorage$Z80Screen,
		$Chadtech$elm_vector$Vector24$repeat(line),
		7);
}();
var $author$project$Z80Ram$constructor = function () {
	var ram = A2($elm$core$List$repeat, 49152 - 6912, 0);
	return A2(
		$author$project$Z80Ram$Z80Ram,
		$author$project$ScreenStorage$constructor,
		$author$project$Z80MemoryDict$constructor(ram));
}();
var $author$project$Z80Rom$constructor = function (rom_dict) {
	return A3($author$project$Z80Rom$Z80ROM, rom_dict, $author$project$Keyboard$constructor, $author$project$Z80Ram$constructor);
};
var $author$project$Spectrum$BorderRefresh = F4(
	function (bordchg, refrb_t, refrb_x, refrb_y) {
		return {dC: bordchg, ev: refrb_t, ew: refrb_x, ex: refrb_y};
	});
var $author$project$Spectrum$new_border_refresh = A4($author$project$Spectrum$BorderRefresh, 0, 0, 0, 0);
var $author$project$Spectrum$ScreenRefresh = F5(
	function (scrchg, refrs_t, refrs_a, refrs_b, refrs_s) {
		return {ey: refrs_a, ez: refrs_b, eA: refrs_s, eB: refrs_t, eJ: scrchg};
	});
var $author$project$Spectrum$new_screen_refresh = function () {
	var scrchg = A2($elm$core$List$repeat, 24, 0);
	return A5($author$project$Spectrum$ScreenRefresh, scrchg, 0, 0, 0, 0);
}();
var $author$project$Spectrum$constructor = function (z80rom) {
	return A8(
		$author$project$Spectrum$Spectrum,
		$author$project$Z80$constructor,
		$author$project$Z80Rom$constructor(z80rom),
		true,
		false,
		1,
		$elm$core$Maybe$Nothing,
		$author$project$Spectrum$new_screen_refresh,
		$author$project$Spectrum$new_border_refresh);
};
var $author$project$QaopModel$GotTAP = function (a) {
	return {$: 0, a: a};
};
var $author$project$Tapfile$Tapfile = F4(
	function (length, flagByte, data, block) {
		return {bG: block, af: data, ba: flagByte, aX: length};
	});
var $author$project$Tapfile$grabWholeThingDecoder = F2(
	function (tapfileheader, tapfile_body) {
		var x = function () {
			var _v0 = tapfileheader.af;
			switch (_v0.$) {
				case 0:
					return $elm$core$Maybe$Nothing;
				case 1:
					return $elm$core$Maybe$Nothing;
				case 2:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		return $elm$bytes$Bytes$Decode$succeed(
			A4($author$project$Tapfile$Tapfile, tapfileheader.aX, tapfileheader.ba, tapfileheader.af, tapfile_body));
	});
var $author$project$Tapfile$tapBlockLength = function (tapFileHeader) {
	switch (tapFileHeader.$) {
		case 0:
			var end = tapFileHeader.a;
			return end.I;
		case 1:
			var end = tapFileHeader.a;
			return end.I;
		case 2:
			var end = tapFileHeader.a;
			return end.I;
		default:
			var end = tapFileHeader.a;
			return end.I;
	}
};
var $author$project$Tapfile$TapfileBlock = F4(
	function (dataLength, blockFlagByte, data, checksum) {
		return {dA: blockFlagByte, dK: checksum, af: data, dO: dataLength};
	});
var $author$project$Tapfile$listStep = F2(
	function (decoder, _v0) {
		var n = _v0.a;
		var xs = _v0.b;
		return (n <= 0) ? $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(
				$elm$core$List$reverse(xs))) : A2(
			$elm$bytes$Bytes$Decode$map,
			function (x) {
				return $elm$bytes$Bytes$Decode$Loop(
					_Utils_Tuple2(
						n - 1,
						A2($elm$core$List$cons, x, xs)));
			},
			decoder);
	});
var $author$project$Tapfile$listWithLengthDecoder = F2(
	function (len, decoder) {
		return A2(
			$elm$bytes$Bytes$Decode$loop,
			_Utils_Tuple2(len, _List_Nil),
			$author$project$Tapfile$listStep(decoder));
	});
var $elm$bytes$Bytes$Decode$map4 = F5(
	function (func, _v0, _v1, _v2, _v3) {
		var decodeA = _v0;
		var decodeB = _v1;
		var decodeC = _v2;
		var decodeD = _v3;
		return F2(
			function (bites, offset) {
				var _v4 = A2(decodeA, bites, offset);
				var aOffset = _v4.a;
				var a = _v4.b;
				var _v5 = A2(decodeB, bites, aOffset);
				var bOffset = _v5.a;
				var b = _v5.b;
				var _v6 = A2(decodeC, bites, bOffset);
				var cOffset = _v6.a;
				var c = _v6.b;
				var _v7 = A2(decodeD, bites, cOffset);
				var dOffset = _v7.a;
				var d = _v7.b;
				return _Utils_Tuple2(
					dOffset,
					A4(func, a, b, c, d));
			});
	});
var $elm$bytes$Bytes$Decode$unsignedInt16 = function (endianness) {
	return _Bytes_read_u16(!endianness);
};
var $author$project$Tapfile$spectrumUnsigned16Bit = $elm$bytes$Bytes$Decode$unsignedInt16(0);
var $author$project$Tapfile$tapFileBlockDecoder = function (blockLength) {
	return A5(
		$elm$bytes$Bytes$Decode$map4,
		$author$project$Tapfile$TapfileBlock,
		$author$project$Tapfile$spectrumUnsigned16Bit,
		$elm$bytes$Bytes$Decode$unsignedInt8,
		A2($author$project$Tapfile$listWithLengthDecoder, blockLength, $elm$bytes$Bytes$Decode$unsignedInt8),
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Tapfile$tapFilename = function (tapFileHeader) {
	switch (tapFileHeader.$) {
		case 0:
			var end = tapFileHeader.a;
			return end.V;
		case 1:
			var end = tapFileHeader.a;
			return end.V;
		case 2:
			var end = tapFileHeader.a;
			return end.V;
		default:
			var end = tapFileHeader.a;
			return end.V;
	}
};
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$String$fromList = _String_fromList;
var $elm$core$Basics$modBy = _Basics_modBy;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$Utils$toHexString2 = function (value) {
	return '0x' + A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$toUpper(
			$rtfeldman$elm_hex$Hex$toString(value)));
};
var $author$project$Tapfile$decodeTapBody = function (tapfileheader) {
	var tapBlockLen = $author$project$Tapfile$tapBlockLength(tapfileheader.af);
	var filename = $author$project$Tapfile$tapFilename(tapfileheader.af);
	var actualBlockLength = A3(
		$author$project$Z80Debug$debugLog,
		'filename blocklen',
		_Utils_Tuple3(
			filename,
			tapBlockLen,
			$author$project$Utils$toHexString2(tapBlockLen)),
		tapBlockLen);
	var block_decoder = $author$project$Tapfile$tapFileBlockDecoder(actualBlockLength);
	return A2(
		$elm$bytes$Bytes$Decode$andThen,
		$author$project$Tapfile$grabWholeThingDecoder(tapfileheader),
		block_decoder);
};
var $author$project$Tapfile$TapfileHeader = F3(
	function (length, flagByte, data) {
		return {af: data, ba: flagByte, aX: length};
	});
var $elm$bytes$Bytes$Decode$map3 = F4(
	function (func, _v0, _v1, _v2) {
		var decodeA = _v0;
		var decodeB = _v1;
		var decodeC = _v2;
		return F2(
			function (bites, offset) {
				var _v3 = A2(decodeA, bites, offset);
				var aOffset = _v3.a;
				var a = _v3.b;
				var _v4 = A2(decodeB, bites, aOffset);
				var bOffset = _v4.a;
				var b = _v4.b;
				var _v5 = A2(decodeC, bites, bOffset);
				var cOffset = _v5.a;
				var c = _v5.b;
				return _Utils_Tuple2(
					cOffset,
					A3(func, a, b, c));
			});
	});
var $author$project$Tapfile$CharArray = function (a) {
	return {$: 2, a: a};
};
var $author$project$Tapfile$Code = function (a) {
	return {$: 3, a: a};
};
var $author$project$Tapfile$NumberArray = function (a) {
	return {$: 1, a: a};
};
var $author$project$Tapfile$Program = function (a) {
	return {$: 0, a: a};
};
var $author$project$Tapfile$CodeTapeHeader = F5(
	function (filename, blockLength, startOfCodeBlock, threeTwoSevenSixEight, checksum) {
		return {I: blockLength, dK: checksum, V: filename, bp: startOfCodeBlock, bv: threeTwoSevenSixEight};
	});
var $elm$bytes$Bytes$Decode$map5 = F6(
	function (func, _v0, _v1, _v2, _v3, _v4) {
		var decodeA = _v0;
		var decodeB = _v1;
		var decodeC = _v2;
		var decodeD = _v3;
		var decodeE = _v4;
		return F2(
			function (bites, offset) {
				var _v5 = A2(decodeA, bites, offset);
				var aOffset = _v5.a;
				var a = _v5.b;
				var _v6 = A2(decodeB, bites, aOffset);
				var bOffset = _v6.a;
				var b = _v6.b;
				var _v7 = A2(decodeC, bites, bOffset);
				var cOffset = _v7.a;
				var c = _v7.b;
				var _v8 = A2(decodeD, bites, cOffset);
				var dOffset = _v8.a;
				var d = _v8.b;
				var _v9 = A2(decodeE, bites, dOffset);
				var eOffset = _v9.a;
				var e = _v9.b;
				return _Utils_Tuple2(
					eOffset,
					A5(func, a, b, c, d, e));
			});
	});
var $elm$bytes$Bytes$Decode$string = function (n) {
	return _Bytes_read_string(n);
};
var $author$project$Tapfile$codeHeaderDecoder = A6(
	$elm$bytes$Bytes$Decode$map5,
	$author$project$Tapfile$CodeTapeHeader,
	$elm$bytes$Bytes$Decode$string(10),
	$author$project$Tapfile$spectrumUnsigned16Bit,
	$author$project$Tapfile$spectrumUnsigned16Bit,
	$author$project$Tapfile$spectrumUnsigned16Bit,
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $elm$bytes$Bytes$Decode$fail = _Bytes_decodeFailure;
var $author$project$Tapfile$ProgramTapeHeader = F5(
	function (filename, blockLength, autoStartLineNumber, startOfVariablesArea, checksum) {
		return {a7: autoStartLineNumber, I: blockLength, dK: checksum, V: filename, bq: startOfVariablesArea};
	});
var $author$project$Tapfile$programHeaderDecoder = A6(
	$elm$bytes$Bytes$Decode$map5,
	$author$project$Tapfile$ProgramTapeHeader,
	$elm$bytes$Bytes$Decode$string(10),
	$author$project$Tapfile$spectrumUnsigned16Bit,
	$author$project$Tapfile$spectrumUnsigned16Bit,
	$author$project$Tapfile$spectrumUnsigned16Bit,
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Tapfile$TapeHeaderEnd = F5(
	function (filename, blockLength, parameter_1, parameter_2, checksum) {
		return {I: blockLength, dK: checksum, V: filename, er: parameter_1, es: parameter_2};
	});
var $author$project$Tapfile$tapeheaderEndDecoder = A6(
	$elm$bytes$Bytes$Decode$map5,
	$author$project$Tapfile$TapeHeaderEnd,
	$elm$bytes$Bytes$Decode$string(10),
	$author$project$Tapfile$spectrumUnsigned16Bit,
	$author$project$Tapfile$spectrumUnsigned16Bit,
	$author$project$Tapfile$spectrumUnsigned16Bit,
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Tapfile$tapfileDataDecoder = function (headerType) {
	switch (headerType) {
		case 0:
			return A2($elm$bytes$Bytes$Decode$map, $author$project$Tapfile$Program, $author$project$Tapfile$programHeaderDecoder);
		case 1:
			return A2($elm$bytes$Bytes$Decode$map, $author$project$Tapfile$NumberArray, $author$project$Tapfile$tapeheaderEndDecoder);
		case 2:
			return A2($elm$bytes$Bytes$Decode$map, $author$project$Tapfile$CharArray, $author$project$Tapfile$tapeheaderEndDecoder);
		case 3:
			return A2($elm$bytes$Bytes$Decode$map, $author$project$Tapfile$Code, $author$project$Tapfile$codeHeaderDecoder);
		default:
			return A3(
				$author$project$Z80Debug$debugLog,
				'tapfileDataDecoder unknown header type',
				$author$project$Utils$toHexString2(headerType),
				$elm$bytes$Bytes$Decode$fail);
	}
};
var $author$project$Tapfile$decodeTapeHeader = function () {
	var length = $author$project$Tapfile$spectrumUnsigned16Bit;
	var headerType = $elm$bytes$Bytes$Decode$unsignedInt8;
	var flagByte = $elm$bytes$Bytes$Decode$unsignedInt8;
	return A4(
		$elm$bytes$Bytes$Decode$map3,
		$author$project$Tapfile$TapfileHeader,
		length,
		flagByte,
		A2($elm$bytes$Bytes$Decode$andThen, $author$project$Tapfile$tapfileDataDecoder, headerType));
}();
var $author$project$Tapfile$tapfileDecoder = A2($elm$bytes$Bytes$Decode$andThen, $author$project$Tapfile$decodeTapBody, $author$project$Tapfile$decodeTapeHeader);
var $author$project$Tapfile$tapfileStepDecoder = F2(
	function (decoder, _v0) {
		var n = _v0.a;
		var xs = _v0.b;
		return (n <= 0) ? $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(xs)) : A2(
			$elm$bytes$Bytes$Decode$map,
			function (x) {
				return $elm$bytes$Bytes$Decode$Loop(
					_Utils_Tuple2(
						(((n - x.aX) - 2) - $elm$core$List$length(x.bG.af)) - 4,
						A2($elm$core$List$cons, x, xs)));
			},
			decoder);
	});
var $author$project$Tapfile$tapfileListDecoder = F2(
	function (len, decoder) {
		var y = A3($author$project$Z80Debug$debugLog, 'TAP file size', len, $elm$core$Maybe$Nothing);
		return A2(
			$elm$bytes$Bytes$Decode$loop,
			_Utils_Tuple2(len, _List_Nil),
			$author$project$Tapfile$tapfileStepDecoder(decoder));
	});
var $elm$bytes$Bytes$width = _Bytes_width;
var $author$project$Tapfile$parseTapFile = function (bytes) {
	var result = A2(
		$elm$bytes$Bytes$Decode$decode,
		A2(
			$author$project$Tapfile$tapfileListDecoder,
			$elm$bytes$Bytes$width(bytes),
			$author$project$Tapfile$tapfileDecoder),
		bytes);
	if (!result.$) {
		var list = result.a;
		return $elm$core$List$reverse(list);
	} else {
		return _List_Nil;
	}
};
var $author$project$MessageHandler$bytesToTap = function (httpResponse) {
	switch (httpResponse.$) {
		case 0:
			var url = httpResponse.a;
			return $elm$core$Result$Err(
				$elm$http$Http$BadUrl(url));
		case 1:
			return $elm$core$Result$Err($elm$http$Http$Timeout);
		case 2:
			return $elm$core$Result$Err($elm$http$Http$NetworkError);
		case 3:
			var metadata = httpResponse.a;
			return $elm$core$Result$Err(
				$elm$http$Http$BadStatus(metadata.de));
		default:
			var body = httpResponse.b;
			return $elm$core$Result$Ok(
				$author$project$Tapfile$parseTapFile(body));
	}
};
var $author$project$QaopModel$tapLoad = function (url) {
	return A4(
		$author$project$Z80Debug$debugLog,
		'loadTap',
		url,
		$elm$http$Http$get,
		{
			dW: A2(
				$elm$http$Http$expectBytesResponse,
				function (result) {
					return $author$project$QaopModel$GotTAP(result);
				},
				$author$project$MessageHandler$bytesToTap),
			e2: url
		});
};
var $author$project$LoadingModel$updateLoading = F2(
	function (initMessage, loadingModel) {
		if (!initMessage.$) {
			var result = initMessage.a;
			if (!result.$) {
				var z80rom = result.a;
				var _v2 = loadingModel.aO;
				switch (_v2.$) {
					case 0:
						var newModel = _Utils_update(
							loadingModel,
							{
								aO: $author$project$LoadingModel$ROM(z80rom)
							});
						return _Utils_Tuple2(
							$author$project$LoadingModel$StillLoading(newModel),
							$elm$core$Platform$Cmd$none);
					case 1:
						var posix = _v2.a;
						var qaop = A3(
							$author$project$Qaop$Qaop,
							$author$project$Spectrum$constructor(z80rom),
							0,
							_List_Nil);
						var qaopModel = A6($author$project$QaopModel$QaopModel, qaop, 0, 0, posix, false, false);
						return _Utils_Tuple2(
							$author$project$LoadingModel$NowRunning(qaopModel),
							$author$project$QaopModel$tapLoad(loadingModel.bt));
					default:
						var z80ROM = _v2.a;
						return _Utils_Tuple2(
							$author$project$LoadingModel$StillLoading(loadingModel),
							$elm$core$Platform$Cmd$none);
				}
			} else {
				return _Utils_Tuple2(
					$author$project$LoadingModel$StillLoading(loadingModel),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			var posix = initMessage.a;
			var _v3 = loadingModel.aO;
			switch (_v3.$) {
				case 0:
					return _Utils_Tuple2(
						$author$project$LoadingModel$StillLoading(
							_Utils_update(
								loadingModel,
								{
									aO: $author$project$LoadingModel$OnlyTime(posix)
								})),
						$elm$core$Platform$Cmd$none);
				case 1:
					return _Utils_Tuple2(
						$author$project$LoadingModel$StillLoading(loadingModel),
						$elm$core$Platform$Cmd$none);
				default:
					var z80ROM = _v3.a;
					var qaop = A3(
						$author$project$Qaop$Qaop,
						$author$project$Spectrum$constructor(z80ROM),
						0,
						_List_Nil);
					var qaopModel = A6($author$project$QaopModel$QaopModel, qaop, 0, 0, posix, false, false);
					return _Utils_Tuple2(
						$author$project$LoadingModel$NowRunning(qaopModel),
						$author$project$QaopModel$tapLoad(loadingModel.bt));
			}
		}
	});
var $author$project$QaopModel$CharacterUnKey = function (a) {
	return {$: 6, a: a};
};
var $author$project$QaopModel$ControlUnKey = function (a) {
	return {$: 8, a: a};
};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$Process$sleep = _Process_sleep;
var $andrewMacmurray$elm_delay$Delay$after = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$always(msg),
			$elm$core$Process$sleep(time));
	});
var $author$project$Keyboard$ControlKeyDownEvent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Keyboard$Alt = 3;
var $author$project$Keyboard$ArrowDown = 7;
var $author$project$Keyboard$ArrowLeft = 6;
var $author$project$Keyboard$ArrowRight = 9;
var $author$project$Keyboard$ArrowUp = 8;
var $author$project$Keyboard$Backspace = 4;
var $author$project$Keyboard$Control = 1;
var $author$project$Keyboard$Enter = 2;
var $author$project$Keyboard$Escape = 5;
var $author$project$Keyboard$Shift = 0;
var $author$project$Keyboard$c_CONTROL_KEY_MAP = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Shift', 0),
			_Utils_Tuple2('Control', 1),
			_Utils_Tuple2('Enter', 2),
			_Utils_Tuple2('Escape', 5),
			_Utils_Tuple2('Alt', 3),
			_Utils_Tuple2('Backspace', 4),
			_Utils_Tuple2('ArrowLeft', 6),
			_Utils_Tuple2('ArrowDown', 7),
			_Utils_Tuple2('ArrowUp', 8),
			_Utils_Tuple2('ArrowRight', 9)
		]));
var $author$project$Keyboard$ctrlKeyDownEvent = F2(
	function (string, keys) {
		var control_key = A2($elm$core$Dict$get, string, $author$project$Keyboard$c_CONTROL_KEY_MAP);
		var newkeys = function () {
			if (!control_key.$) {
				var a = control_key.a;
				return A2(
					$elm$core$List$cons,
					$author$project$Keyboard$ControlKeyDownEvent(a),
					keys);
			} else {
				return keys;
			}
		}();
		return A3($author$project$Z80Debug$debugLog, 'control key down ' + (string + ' newkeys '), newkeys, newkeys);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$Keyboard$ctrlKeyNotEqual = F2(
	function (event, str) {
		if (!event.$) {
			return true;
		} else {
			var string = event.a;
			return !_Utils_eq(str, string);
		}
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$Keyboard$ctrlKeyUpEvent = F2(
	function (string, keys) {
		var maybe_control_key = A2($elm$core$Dict$get, string, $author$project$Keyboard$c_CONTROL_KEY_MAP);
		var newkeys = function () {
			if (!maybe_control_key.$) {
				var control_key = maybe_control_key.a;
				return A2(
					$elm$core$List$filter,
					function (item) {
						return A2($author$project$Keyboard$ctrlKeyNotEqual, item, control_key);
					},
					keys);
			} else {
				return keys;
			}
		}();
		return A3($author$project$Z80Debug$debugLog, 'control key up ' + (string + ' newkeys '), newkeys, newkeys);
	});
var $author$project$Z80Tape$Z80Tape = F2(
	function (tapePos, tapfiles) {
		return {eT: tapePos, eZ: tapfiles};
	});
var $author$project$Z80Tape$TapePosition = F2(
	function (position, tapfileNumber) {
		return {bj: position, eY: tapfileNumber};
	});
var $author$project$Z80Tape$zeroPosition = A2($author$project$Z80Tape$TapePosition, 0, 0);
var $author$project$Spectrum$new_tape = F2(
	function (tapfileList, spectrum) {
		var x = A3(
			$author$project$Z80Debug$debugLog,
			'new_tape list',
			$elm$core$List$length(tapfileList),
			$elm$core$Maybe$Nothing);
		var tapedict = A2(
			$author$project$Z80Tape$Z80Tape,
			$author$project$Z80Tape$zeroPosition,
			$elm$core$Dict$fromList(
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, tap) {
							return _Utils_Tuple2(index, tap);
						}),
					tapfileList)));
		return _Utils_update(
			spectrum,
			{
				dj: $elm$core$Maybe$Just(tapedict)
			});
	});
var $elm$core$Bitwise$complement = _Bitwise_complement;
var $author$project$Utils$char = $elm$core$Bitwise$and(65535);
var $author$project$SingleNoParams$ex_af = function (z80) {
	var clock = z80.ao;
	var core = clock.ae;
	return _Utils_update(
		z80,
		{
			bD: core.K,
			ao: _Utils_update(
				clock,
				{
					ae: _Utils_update(
						core,
						{K: z80.bD})
				})
		});
};
var $author$project$Interrupts$IFF_3 = 1;
var $author$project$Z80CoreWithClockTime$get_ei = function (z80) {
	return z80.d2 === 1;
};
var $author$project$CpuTimeCTime$CpuTimeAnd16BitValue = F2(
	function (time, value16) {
		return {aQ: time, bx: value16};
	});
var $author$project$CpuTimeCTime$addCpuTimeTime = F2(
	function (value, z80env) {
		return _Utils_update(
			z80env,
			{F: z80env.F + value});
	});
var $author$project$CpuTimeCTime$c_SCRENDT = (191 * 224) + 126;
var $author$project$CpuTimeCTime$cont = F2(
	function (n, cpuTimeCTime) {
		var _v0 = cpuTimeCTime.aC;
		if (!_v0.$) {
			return cpuTimeCTime;
		} else {
			var t = _v0.a;
			if ((t + n) <= 0) {
				return cpuTimeCTime;
			} else {
				var s = $author$project$CpuTimeCTime$c_SCRENDT - t;
				if (s < 0) {
					return cpuTimeCTime;
				} else {
					var new_s = A2($elm$core$Basics$modBy, 224, s);
					var maybe_ntk = function () {
						if (new_s > 126) {
							var new_n = n - (new_s - 126);
							return (new_n <= 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								{aH: 15, a_: new_n, a4: 6});
						} else {
							var s2 = new_s & 7;
							var k = new_s >> 3;
							if (s2 === 7) {
								var n1 = n - 1;
								return (!n1) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									{aH: k, a_: n1, a4: s2 - 1});
							} else {
								return $elm$core$Maybe$Just(
									{aH: k, a_: n, a4: s2});
							}
						}
					}();
					if (!maybe_ntk.$) {
						var ntk = maybe_ntk.a;
						var n3 = (ntk.a_ - 1) >> 1;
						var n4 = (_Utils_cmp(ntk.aH, n3) < 0) ? ntk.aH : n3;
						return _Utils_update(
							cpuTimeCTime,
							{F: cpuTimeCTime.F + (ntk.a4 + (6 * n4))});
					} else {
						return cpuTimeCTime;
					}
				}
			}
		}
	});
var $author$project$CpuTimeCTime$cont1 = F2(
	function (tmp_t, z80) {
		var t = tmp_t + z80.F;
		return ((t < 0) || (_Utils_cmp(t, $author$project$CpuTimeCTime$c_SCRENDT) > -1)) ? z80 : (((t & 7) >= 6) ? z80 : ((A2($elm$core$Basics$modBy, 224, t) < 126) ? A2($author$project$CpuTimeCTime$addCpuTimeTime, 6 - (t & 7), z80) : z80));
	});
var $author$project$Z80Debug$debugTodo = F3(
	function (msg, thingToLog, thingToReturn) {
		return thingToReturn;
	});
var $author$project$Z80Rom$getROMValue = F2(
	function (addr, z80rom) {
		var _v0 = A2($elm$core$Dict$get, addr, z80rom.eH);
		if (!_v0.$) {
			var a = _v0.a;
			return a;
		} else {
			return A3(
				$author$project$Z80Debug$debugTodo,
				'getROMValue',
				$elm$core$String$fromInt(addr),
				-1);
		}
	});
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $author$project$Utils$toHexString = function (value) {
	return '0x' + A3(
		$elm$core$String$padLeft,
		4,
		'0',
		$elm$core$String$toUpper(
			$rtfeldman$elm_hex$Hex$toString(value)));
};
var $author$project$Z80MemoryDict$getMemValue = F2(
	function (addr, z80mem) {
		var z80dict = z80mem;
		var _v1 = A2($elm$core$Dict$get, addr, z80dict);
		if (!_v1.$) {
			var a = _v1.a;
			return a;
		} else {
			return A3(
				$author$project$Z80Debug$debugTodo,
				'Z80Memory:getValue ' + $author$project$Utils$toHexString(addr),
				$author$project$Utils$toHexString(
					$elm$core$Dict$size(z80dict)),
				-1);
		}
	});
var $Chadtech$elm_vector$Vector24$Index0 = 0;
var $Chadtech$elm_vector$Vector32$Index0 = 0;
var $Chadtech$elm_vector$Vector24$get = F2(
	function (index, _v0) {
		var vector = _v0;
		switch (index) {
			case 0:
				return vector.j;
			case 1:
				return vector.b3;
			case 2:
				return vector.b;
			case 3:
				return vector.c;
			case 4:
				return vector.d;
			case 5:
				return vector.e;
			case 6:
				return vector.f;
			case 7:
				return vector.g;
			case 8:
				return vector.h;
			case 9:
				return vector.i;
			case 10:
				return vector.b4;
			case 11:
				return vector.b5;
			case 12:
				return vector.b6;
			case 13:
				return vector.b7;
			case 14:
				return vector.b8;
			case 15:
				return vector.b9;
			case 16:
				return vector.ca;
			case 17:
				return vector.cb;
			case 18:
				return vector.cc;
			case 19:
				return vector.cd;
			case 20:
				return vector.ce;
			case 21:
				return vector.cf;
			case 22:
				return vector.cg;
			default:
				return vector.ch;
		}
	});
var $Chadtech$elm_vector$Vector32$get = F2(
	function (index, _v0) {
		var vector = _v0;
		switch (index) {
			case 0:
				return vector.j;
			case 1:
				return vector.b3;
			case 2:
				return vector.b;
			case 3:
				return vector.c;
			case 4:
				return vector.d;
			case 5:
				return vector.e;
			case 6:
				return vector.f;
			case 7:
				return vector.g;
			case 8:
				return vector.h;
			case 9:
				return vector.i;
			case 10:
				return vector.b4;
			case 11:
				return vector.b5;
			case 12:
				return vector.b6;
			case 13:
				return vector.b7;
			case 14:
				return vector.b8;
			case 15:
				return vector.b9;
			case 16:
				return vector.ca;
			case 17:
				return vector.cb;
			case 18:
				return vector.cc;
			case 19:
				return vector.cd;
			case 20:
				return vector.ce;
			case 21:
				return vector.cf;
			case 22:
				return vector.cg;
			case 23:
				return vector.ch;
			case 24:
				return vector.ci;
			case 25:
				return vector.cj;
			case 26:
				return vector.ck;
			case 27:
				return vector.cl;
			case 28:
				return vector.cm;
			case 29:
				return vector.cn;
			case 30:
				return vector.co;
			default:
				return vector.cp;
		}
	});
var $Chadtech$elm_vector$Vector8$Index0 = 0;
var $author$project$ScreenStorage$VectorDataOffset = F2(
	function (index24, index8) {
		return {bW: index24, bX: index8};
	});
var $author$project$ScreenStorage$calcDataOffset = function (start) {
	var data_offset = (7 & start) << 3;
	var bankStart = 192 & start;
	var bankOffset = (63 & start) >> 3;
	return (bankStart + bankOffset) + data_offset;
};
var $Chadtech$elm_vector$Vector24$Index1 = 1;
var $Chadtech$elm_vector$Vector24$Index10 = 10;
var $Chadtech$elm_vector$Vector24$Index11 = 11;
var $Chadtech$elm_vector$Vector24$Index12 = 12;
var $Chadtech$elm_vector$Vector24$Index13 = 13;
var $Chadtech$elm_vector$Vector24$Index14 = 14;
var $Chadtech$elm_vector$Vector24$Index15 = 15;
var $Chadtech$elm_vector$Vector24$Index16 = 16;
var $Chadtech$elm_vector$Vector24$Index17 = 17;
var $Chadtech$elm_vector$Vector24$Index18 = 18;
var $Chadtech$elm_vector$Vector24$Index19 = 19;
var $Chadtech$elm_vector$Vector24$Index2 = 2;
var $Chadtech$elm_vector$Vector24$Index20 = 20;
var $Chadtech$elm_vector$Vector24$Index21 = 21;
var $Chadtech$elm_vector$Vector24$Index22 = 22;
var $Chadtech$elm_vector$Vector24$Index23 = 23;
var $Chadtech$elm_vector$Vector24$Index3 = 3;
var $Chadtech$elm_vector$Vector24$Index4 = 4;
var $Chadtech$elm_vector$Vector24$Index5 = 5;
var $Chadtech$elm_vector$Vector24$Index6 = 6;
var $Chadtech$elm_vector$Vector24$Index7 = 7;
var $Chadtech$elm_vector$Vector24$Index8 = 8;
var $Chadtech$elm_vector$Vector24$Index9 = 9;
var $Chadtech$elm_vector$Vector24$intToIndex = function (_int) {
	switch (_int) {
		case 0:
			return $elm$core$Maybe$Just(0);
		case 1:
			return $elm$core$Maybe$Just(1);
		case 2:
			return $elm$core$Maybe$Just(2);
		case 3:
			return $elm$core$Maybe$Just(3);
		case 4:
			return $elm$core$Maybe$Just(4);
		case 5:
			return $elm$core$Maybe$Just(5);
		case 6:
			return $elm$core$Maybe$Just(6);
		case 7:
			return $elm$core$Maybe$Just(7);
		case 8:
			return $elm$core$Maybe$Just(8);
		case 9:
			return $elm$core$Maybe$Just(9);
		case 10:
			return $elm$core$Maybe$Just(10);
		case 11:
			return $elm$core$Maybe$Just(11);
		case 12:
			return $elm$core$Maybe$Just(12);
		case 13:
			return $elm$core$Maybe$Just(13);
		case 14:
			return $elm$core$Maybe$Just(14);
		case 15:
			return $elm$core$Maybe$Just(15);
		case 16:
			return $elm$core$Maybe$Just(16);
		case 17:
			return $elm$core$Maybe$Just(17);
		case 18:
			return $elm$core$Maybe$Just(18);
		case 19:
			return $elm$core$Maybe$Just(19);
		case 20:
			return $elm$core$Maybe$Just(20);
		case 21:
			return $elm$core$Maybe$Just(21);
		case 22:
			return $elm$core$Maybe$Just(22);
		case 23:
			return $elm$core$Maybe$Just(23);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $Chadtech$elm_vector$Vector8$Index1 = 1;
var $Chadtech$elm_vector$Vector8$Index2 = 2;
var $Chadtech$elm_vector$Vector8$Index3 = 3;
var $Chadtech$elm_vector$Vector8$Index4 = 4;
var $Chadtech$elm_vector$Vector8$Index5 = 5;
var $Chadtech$elm_vector$Vector8$Index6 = 6;
var $Chadtech$elm_vector$Vector8$Index7 = 7;
var $Chadtech$elm_vector$Vector8$intToIndex = function (_int) {
	switch (_int) {
		case 0:
			return $elm$core$Maybe$Just(0);
		case 1:
			return $elm$core$Maybe$Just(1);
		case 2:
			return $elm$core$Maybe$Just(2);
		case 3:
			return $elm$core$Maybe$Just(3);
		case 4:
			return $elm$core$Maybe$Just(4);
		case 5:
			return $elm$core$Maybe$Just(5);
		case 6:
			return $elm$core$Maybe$Just(6);
		case 7:
			return $elm$core$Maybe$Just(7);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$ScreenStorage$calcVectorDataOffset = function (_int) {
	var dataOffset = $author$project$ScreenStorage$calcDataOffset(_int);
	var rowIndex = A2(
		$elm$core$Maybe$withDefault,
		0,
		$Chadtech$elm_vector$Vector24$intToIndex((dataOffset / 8) | 0));
	var dataIndex = A2(
		$elm$core$Maybe$withDefault,
		0,
		$Chadtech$elm_vector$Vector8$intToIndex(dataOffset % 8));
	return A2($author$project$ScreenStorage$VectorDataOffset, rowIndex, dataIndex);
};
var $Chadtech$elm_vector$Vector32$Index1 = 1;
var $Chadtech$elm_vector$Vector32$Index10 = 10;
var $Chadtech$elm_vector$Vector32$Index11 = 11;
var $Chadtech$elm_vector$Vector32$Index12 = 12;
var $Chadtech$elm_vector$Vector32$Index13 = 13;
var $Chadtech$elm_vector$Vector32$Index14 = 14;
var $Chadtech$elm_vector$Vector32$Index15 = 15;
var $Chadtech$elm_vector$Vector32$Index16 = 16;
var $Chadtech$elm_vector$Vector32$Index17 = 17;
var $Chadtech$elm_vector$Vector32$Index18 = 18;
var $Chadtech$elm_vector$Vector32$Index19 = 19;
var $Chadtech$elm_vector$Vector32$Index2 = 2;
var $Chadtech$elm_vector$Vector32$Index20 = 20;
var $Chadtech$elm_vector$Vector32$Index21 = 21;
var $Chadtech$elm_vector$Vector32$Index22 = 22;
var $Chadtech$elm_vector$Vector32$Index23 = 23;
var $Chadtech$elm_vector$Vector32$Index24 = 24;
var $Chadtech$elm_vector$Vector32$Index25 = 25;
var $Chadtech$elm_vector$Vector32$Index26 = 26;
var $Chadtech$elm_vector$Vector32$Index27 = 27;
var $Chadtech$elm_vector$Vector32$Index28 = 28;
var $Chadtech$elm_vector$Vector32$Index29 = 29;
var $Chadtech$elm_vector$Vector32$Index3 = 3;
var $Chadtech$elm_vector$Vector32$Index30 = 30;
var $Chadtech$elm_vector$Vector32$Index31 = 31;
var $Chadtech$elm_vector$Vector32$Index4 = 4;
var $Chadtech$elm_vector$Vector32$Index5 = 5;
var $Chadtech$elm_vector$Vector32$Index6 = 6;
var $Chadtech$elm_vector$Vector32$Index7 = 7;
var $Chadtech$elm_vector$Vector32$Index8 = 8;
var $Chadtech$elm_vector$Vector32$Index9 = 9;
var $Chadtech$elm_vector$Vector32$intToIndex = function (_int) {
	switch (_int) {
		case 0:
			return $elm$core$Maybe$Just(0);
		case 1:
			return $elm$core$Maybe$Just(1);
		case 2:
			return $elm$core$Maybe$Just(2);
		case 3:
			return $elm$core$Maybe$Just(3);
		case 4:
			return $elm$core$Maybe$Just(4);
		case 5:
			return $elm$core$Maybe$Just(5);
		case 6:
			return $elm$core$Maybe$Just(6);
		case 7:
			return $elm$core$Maybe$Just(7);
		case 8:
			return $elm$core$Maybe$Just(8);
		case 9:
			return $elm$core$Maybe$Just(9);
		case 10:
			return $elm$core$Maybe$Just(10);
		case 11:
			return $elm$core$Maybe$Just(11);
		case 12:
			return $elm$core$Maybe$Just(12);
		case 13:
			return $elm$core$Maybe$Just(13);
		case 14:
			return $elm$core$Maybe$Just(14);
		case 15:
			return $elm$core$Maybe$Just(15);
		case 16:
			return $elm$core$Maybe$Just(16);
		case 17:
			return $elm$core$Maybe$Just(17);
		case 18:
			return $elm$core$Maybe$Just(18);
		case 19:
			return $elm$core$Maybe$Just(19);
		case 20:
			return $elm$core$Maybe$Just(20);
		case 21:
			return $elm$core$Maybe$Just(21);
		case 22:
			return $elm$core$Maybe$Just(22);
		case 23:
			return $elm$core$Maybe$Just(23);
		case 24:
			return $elm$core$Maybe$Just(24);
		case 25:
			return $elm$core$Maybe$Just(25);
		case 26:
			return $elm$core$Maybe$Just(26);
		case 27:
			return $elm$core$Maybe$Just(27);
		case 28:
			return $elm$core$Maybe$Just(28);
		case 29:
			return $elm$core$Maybe$Just(29);
		case 30:
			return $elm$core$Maybe$Just(30);
		case 31:
			return $elm$core$Maybe$Just(31);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ScreenStorage$getScreenDataIndex = function (addr) {
	var lineOffset = addr % 256;
	var lineNumber = A2(
		$elm$core$Maybe$withDefault,
		0,
		$Chadtech$elm_vector$Vector24$intToIndex((addr / 256) | 0));
	var line32 = A2(
		$elm$core$Maybe$withDefault,
		0,
		$Chadtech$elm_vector$Vector32$intToIndex(lineOffset % 32));
	var addr32 = A2(
		$elm$core$Maybe$withDefault,
		0,
		$Chadtech$elm_vector$Vector8$intToIndex((lineOffset / 32) | 0));
	return _Utils_Tuple3(lineNumber, addr32, line32);
};
var $Chadtech$elm_vector$Vector24$indexToInt = function (index) {
	switch (index) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		case 7:
			return 7;
		case 8:
			return 8;
		case 9:
			return 9;
		case 10:
			return 10;
		case 11:
			return 11;
		case 12:
			return 12;
		case 13:
			return 13;
		case 14:
			return 14;
		case 15:
			return 15;
		case 16:
			return 16;
		case 17:
			return 17;
		case 18:
			return 18;
		case 19:
			return 19;
		case 20:
			return 20;
		case 21:
			return 21;
		case 22:
			return 22;
		default:
			return 23;
	}
};
var $Chadtech$elm_vector$Vector8$indexToInt = function (index) {
	switch (index) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		default:
			return 7;
	}
};
var $author$project$ScreenStorage$getScreenDataOffset = function (addr) {
	var _v0 = $author$project$ScreenStorage$getScreenDataIndex(addr);
	var lineNumber = _v0.a;
	var addr32 = _v0.b;
	var line32 = _v0.c;
	var lineOffset = ($Chadtech$elm_vector$Vector24$indexToInt(lineNumber) * 8) + $Chadtech$elm_vector$Vector8$indexToInt(addr32);
	var dataOffset = $author$project$ScreenStorage$calcVectorDataOffset(lineOffset);
	return _Utils_Tuple3(dataOffset.bW, dataOffset.bX, line32);
};
var $Chadtech$elm_vector$Vector32$indexToInt = function (index) {
	switch (index) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		case 7:
			return 7;
		case 8:
			return 8;
		case 9:
			return 9;
		case 10:
			return 10;
		case 11:
			return 11;
		case 12:
			return 12;
		case 13:
			return 13;
		case 14:
			return 14;
		case 15:
			return 15;
		case 16:
			return 16;
		case 17:
			return 17;
		case 18:
			return 18;
		case 19:
			return 19;
		case 20:
			return 20;
		case 21:
			return 21;
		case 22:
			return 22;
		case 23:
			return 23;
		case 24:
			return 24;
		case 25:
			return 25;
		case 26:
			return 26;
		case 27:
			return 27;
		case 28:
			return 28;
		case 29:
			return 29;
		case 30:
			return 30;
		default:
			return 31;
	}
};
var $author$project$ScreenStorage$getScreenValue = F2(
	function (addr, z80screen) {
		if (addr < 6144) {
			var _v0 = $author$project$ScreenStorage$getScreenDataOffset(addr);
			var lineNumber = _v0.a;
			var addr32 = _v0.b;
			var line32 = _v0.c;
			var lineOffset = ($Chadtech$elm_vector$Vector8$indexToInt(addr32) * 32) + $Chadtech$elm_vector$Vector32$indexToInt(line32);
			var line = A2($Chadtech$elm_vector$Vector24$get, lineNumber, z80screen.ea);
			return A2($author$project$Z80MemoryDict$getMemValue, lineOffset, line.af);
		} else {
			var offset = addr - 6144;
			var row = A2(
				$elm$core$Maybe$withDefault,
				0,
				$Chadtech$elm_vector$Vector24$intToIndex((offset / 32) | 0));
			var oldrow = A2($Chadtech$elm_vector$Vector24$get, row, z80screen.ea);
			var col = A2(
				$elm$core$Maybe$withDefault,
				0,
				$Chadtech$elm_vector$Vector32$intToIndex(offset % 32));
			return A2($Chadtech$elm_vector$Vector32$get, col, oldrow.dv);
		}
	});
var $author$project$Z80Ram$getRamValue = F2(
	function (addr, z80ram) {
		var ram_addr = addr - 6912;
		return (ram_addr >= 0) ? A2($author$project$Z80MemoryDict$getMemValue, ram_addr, z80ram.a$) : A2($author$project$ScreenStorage$getScreenValue, addr, z80ram.eK);
	});
var $author$project$Z80Mem$getRamValue = F3(
	function (addr, z80rom, z80env) {
		var _v0 = A2($elm$core$Dict$get, addr, z80env.bl);
		if (!_v0.$) {
			var a = _v0.a;
			return a;
		} else {
			return A2($author$project$Z80Ram$getRamValue, addr, z80rom.e6);
		}
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $author$project$Utils$shiftLeftBy8 = function (reg) {
	return reg << 8;
};
var $author$project$Z80Mem$mem16 = F4(
	function (addr, rom48k, clockTime, z80env) {
		var z80env_time = function () {
			var _v0 = clockTime.aC;
			if (!_v0.$) {
				return clockTime;
			} else {
				var until = _v0.a;
				var n = clockTime.F - until;
				return (n > 0) ? A2($author$project$CpuTimeCTime$cont, n, clockTime) : clockTime;
			}
		}();
		var addr1 = addr - 16383;
		if (!(!(addr1 & 16383))) {
			if (addr1 < 0) {
				var low = A2($author$project$Z80Rom$getROMValue, addr, rom48k);
				var high = A2($author$project$Z80Rom$getROMValue, addr1 + 16384, rom48k);
				return A2(
					$author$project$CpuTimeCTime$CpuTimeAnd16BitValue,
					_Utils_update(
						z80env_time,
						{aC: $author$project$CpuTimeCTime$NoCont}),
					low | $author$project$Utils$shiftLeftBy8(high));
			} else {
				var z80env_1_time = (addr1 < 16384) ? A2(
					$author$project$CpuTimeCTime$addCpuTimeTime,
					6,
					A2(
						$author$project$CpuTimeCTime$cont1,
						3,
						A2($author$project$CpuTimeCTime$cont1, 0, z80env_time))) : _Utils_update(
					z80env_time,
					{aC: $author$project$CpuTimeCTime$NoCont});
				var low = A3($author$project$Z80Mem$getRamValue, addr - 16384, rom48k, z80env);
				var high = A3($author$project$Z80Mem$getRamValue, addr1, rom48k, z80env);
				return A2(
					$author$project$CpuTimeCTime$CpuTimeAnd16BitValue,
					z80env_1_time,
					low | $author$project$Utils$shiftLeftBy8(high));
			}
		} else {
			var addr1shift14 = addr1 >> 14;
			if (!addr1shift14) {
				var new_z80_time = A2($author$project$CpuTimeCTime$cont1, 3, z80env_time);
				var low = A2($author$project$Z80Rom$getROMValue, addr, rom48k);
				var high = A3($author$project$Z80Mem$getRamValue, 0, rom48k, z80env);
				return A2(
					$author$project$CpuTimeCTime$CpuTimeAnd16BitValue,
					new_z80_time,
					low | $author$project$Utils$shiftLeftBy8(high));
			} else {
				if (addr1shift14 === 1) {
					var new_env_time = A2($author$project$CpuTimeCTime$cont1, 0, z80env_time);
					var low = A3($author$project$Z80Mem$getRamValue, addr - 16384, rom48k, z80env);
					var high = A3($author$project$Z80Mem$getRamValue, addr1, rom48k, z80env);
					return A2(
						$author$project$CpuTimeCTime$CpuTimeAnd16BitValue,
						new_env_time,
						low | $author$project$Utils$shiftLeftBy8(high));
				} else {
					if (addr1shift14 === 2) {
						var low = A3($author$project$Z80Mem$getRamValue, addr - 16384, rom48k, z80env);
						var high = A3($author$project$Z80Mem$getRamValue, addr1, rom48k, z80env);
						return A2(
							$author$project$CpuTimeCTime$CpuTimeAnd16BitValue,
							_Utils_update(
								z80env_time,
								{aC: $author$project$CpuTimeCTime$NoCont}),
							low | $author$project$Utils$shiftLeftBy8(high));
					} else {
						var low = A3($author$project$Z80Mem$getRamValue, 49151, rom48k, z80env);
						var high = A2($author$project$Z80Rom$getROMValue, 0, rom48k);
						return A2(
							$author$project$CpuTimeCTime$CpuTimeAnd16BitValue,
							_Utils_update(
								z80env_time,
								{aC: $author$project$CpuTimeCTime$NoCont}),
							low | $author$project$Utils$shiftLeftBy8(high));
					}
				}
			}
		}
	});
var $author$project$Spectrum$checkLoad = function (spectrum) {
	var cpu = spectrum.ap;
	var pc1 = cpu.ao.cY;
	if ($author$project$Z80CoreWithClockTime$get_ei(cpu) || ((pc1 < 1387) || (pc1 > 1540))) {
		return $elm$core$Maybe$Nothing;
	} else {
		var sp1 = cpu.ao.ae.B.eN;
		var _v0 = function () {
			if (pc1 >= 1507) {
				var _v1 = _Utils_Tuple2(
					A4($author$project$Z80Mem$mem16, sp1, spectrum.eH, cpu.ao.dM, cpu.ao.ae.B).bx,
					$author$project$Utils$char(sp1) + 2);
				var pc2 = _v1.a;
				var sp2 = _v1.b;
				return (pc2 === 1510) ? _Utils_Tuple2(
					A4($author$project$Z80Mem$mem16, sp2, spectrum.eH, cpu.ao.dM, cpu.ao.ae.B).bx,
					$author$project$Utils$char(sp2) + 2) : _Utils_Tuple2(pc2, sp2);
			} else {
				return _Utils_Tuple2(pc1, sp1);
			}
		}();
		var pc = _v0.a;
		var sp = _v0.b;
		if ((pc < 1387) || (pc > 1422)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var clock = cpu.ao;
			var core = clock.ae;
			var env = core.B;
			var new_env = _Utils_update(
				env,
				{eN: sp});
			var new_cpu = _Utils_update(
				cpu,
				{
					ao: _Utils_update(
						clock,
						{
							ae: _Utils_update(
								core,
								{B: new_env})
						})
				});
			return $elm$core$Maybe$Just(
				$author$project$SingleNoParams$ex_af(new_cpu));
		}
	}
};
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $author$project$Z80Flags$c_FC = 1;
var $author$project$Z80Flags$c_FZ = 64;
var $author$project$Z80Flags$c_F53 = 40;
var $author$project$Z80Flags$c_FH = 16;
var $author$project$Z80Flags$c_FN = 2;
var $author$project$Z80Flags$c_FP = 4;
var $author$project$Z80Flags$c_FS = 128;
var $author$project$Utils$shiftRightBy8 = function (reg) {
	return reg >> 8;
};
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $author$project$Z80Flags$getFlags = function (flags) {
	var ini = {bA: flags.aE, dw: flags.aF, T: flags.U, et: flags.ag};
	var lhs_f = ini.T & ($author$project$Z80Flags$c_FS | $author$project$Z80Flags$c_F53);
	var ra = ini.et ^ ini.bA;
	var rhs_f = $author$project$Utils$shiftRightBy8(ini.T) & $author$project$Z80Flags$c_FC;
	var old_f = lhs_f | rhs_f;
	var new_f = (!ini.et) ? (old_f | $author$project$Z80Flags$c_FZ) : old_f;
	var u = $author$project$Utils$shiftRightBy8(ini.dw);
	var new_new_f = (u & $author$project$Z80Flags$c_FN) | new_f;
	var ra_b_u = u ^ (ini.dw ^ ra);
	var really_new_f = (ra_b_u & $author$project$Z80Flags$c_FH) | new_new_f;
	var _v0 = (!(ini.bA & (~255))) ? _Utils_Tuple2(ra & (ini.dw ^ ini.et), 5) : _Utils_Tuple2(38505 * $author$project$Z80Flags$c_FP, 15 & (ini.et ^ (ini.et >> 4)));
	var a = _v0.a;
	var b = _v0.b;
	return ($author$project$Z80Flags$c_FP & (a >> b)) | really_new_f;
};
var $author$project$Z80Types$get_de = function (z80) {
	return z80.dT | $author$project$Utils$shiftLeftBy8(z80.dN);
};
var $author$project$CpuTimeCTime$ContUntil = function (a) {
	return {$: 1, a: a};
};
var $author$project$CpuTimeCTime$CpuTimeAndValue = F2(
	function (time, value) {
		return {aQ: time, e3: value};
	});
var $author$project$Z80Mem$mem = F4(
	function (base_addr, time, rom48k, ram) {
		var z80env_time = function () {
			var _v1 = time.aC;
			if (!_v1.$) {
				return time;
			} else {
				var until = _v1.a;
				var n = time.F - until;
				return (n > 0) ? A2($author$project$CpuTimeCTime$cont, n, time) : time;
			}
		}();
		var addr = base_addr - 16384;
		var _v0 = function () {
			if (addr >= 0) {
				if (addr < 16384) {
					var new_z80_time = A2($author$project$CpuTimeCTime$cont1, 0, z80env_time);
					return _Utils_Tuple3(
						new_z80_time,
						$author$project$CpuTimeCTime$ContUntil(new_z80_time.F + 3),
						A3($author$project$Z80Mem$getRamValue, addr, rom48k, ram));
				} else {
					return _Utils_Tuple3(
						z80env_time,
						$author$project$CpuTimeCTime$NoCont,
						A3($author$project$Z80Mem$getRamValue, addr, rom48k, ram));
				}
			} else {
				return _Utils_Tuple3(
					z80env_time,
					$author$project$CpuTimeCTime$NoCont,
					A2($author$project$Z80Rom$getROMValue, base_addr, rom48k));
			}
		}();
		var new_time = _v0.a;
		var ctime = _v0.b;
		var value = _v0.c;
		return A2(
			$author$project$CpuTimeCTime$CpuTimeAndValue,
			_Utils_update(
				new_time,
				{aC: ctime}),
			value);
	});
var $elm$core$Basics$not = _Basics_not;
var $author$project$Z80Flags$setFlags = F2(
	function (f_in, flags) {
		var fr = $author$project$Z80Flags$c_FZ & (~f_in);
		var ff = f_in | $author$project$Utils$shiftLeftBy8(f_in);
		var fb_rhs = ($author$project$Z80Flags$c_FP & ff) << 5;
		var fb_lhs = (~128) & ff;
		var fb = fb_lhs | fb_rhs;
		var fa = 255 & fb;
		return _Utils_update(
			flags,
			{aE: fa, aF: fb, U: ff, ag: fr});
	});
var $author$project$Z80Env$setMem = F4(
	function (z80_addr, value, time_input, z80env) {
		var z80env_time = function () {
			var _v1 = time_input.aC;
			if (!_v1.$) {
				return time_input;
			} else {
				var until = _v1.a;
				var n = time_input.F - until;
				return (n > 0) ? A2($author$project$CpuTimeCTime$cont, n, time_input) : _Utils_update(
					time_input,
					{aC: $author$project$CpuTimeCTime$NoCont});
			}
		}();
		var addr = z80_addr - 16384;
		var _v0 = function () {
			if (addr < 16384) {
				if (addr < 0) {
					return _Utils_Tuple2(z80env, $author$project$CpuTimeCTime$NoCont);
				} else {
					var z80env_1_time = A2($author$project$CpuTimeCTime$cont1, 0, z80env_time);
					var new_time = $author$project$CpuTimeCTime$ContUntil(z80env_1_time.F + 3);
					return _Utils_Tuple2(
						_Utils_update(
							z80env,
							{
								bl: A3($elm$core$Dict$insert, addr, value, z80env.bl)
							}),
						new_time);
				}
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						z80env,
						{
							bl: A3($elm$core$Dict$insert, addr, value, z80env.bl)
						}),
					$author$project$CpuTimeCTime$NoCont);
			}
		}();
		var new_env = _v0.a;
		var ctime = _v0.b;
		return _Utils_Tuple2(
			new_env,
			_Utils_update(
				z80env_time,
				{aC: ctime}));
	});
var $author$project$Z80Env$setMemIgnoringTime = F4(
	function (z80_addr, value, time_input, z80env) {
		return A4($author$project$Z80Env$setMem, z80_addr, value, time_input, z80env).a;
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $author$project$Tapfile$tapfileDataToList = function (tapfiledata) {
	switch (tapfiledata.$) {
		case 0:
			var programTapeHeader = tapfiledata.a;
			var varLow = 255 & programTapeHeader.bq;
			var varHigh = $author$project$Utils$shiftRightBy8(programTapeHeader.bq);
			var filename = A2(
				$elm$core$List$map,
				function (_char) {
					return $elm$core$Char$toCode(_char);
				},
				$elm$core$String$toList(programTapeHeader.V));
			var blockLow = 255 & programTapeHeader.I;
			var blockHigh = $author$project$Utils$shiftRightBy8(programTapeHeader.I);
			var autoStartLow = 255 & programTapeHeader.a7;
			var autoStartHigh = $author$project$Utils$shiftRightBy8(programTapeHeader.a7);
			return A2(
				$elm$core$List$append,
				A2($elm$core$List$cons, 0, filename),
				_List_fromArray(
					[blockLow, blockHigh, autoStartLow, autoStartHigh, varLow, varHigh, programTapeHeader.dK]));
		case 1:
			var tapeHeaderEnd = tapfiledata.a;
			return A3($author$project$Z80Debug$debugTodo, 'tapFileDataToList', 'numberArray', _List_Nil);
		case 2:
			var tapeHeaderEnd = tapfiledata.a;
			return A3($author$project$Z80Debug$debugTodo, 'tapFileDataToList', 'CharArray', _List_Nil);
		default:
			var codeTapeHeader = tapfiledata.a;
			var twosevenLow = 255 & codeTapeHeader.bv;
			var twoSevenHigh = $author$project$Utils$shiftRightBy8(codeTapeHeader.bv);
			var startLow = 255 & codeTapeHeader.bp;
			var startHigh = $author$project$Utils$shiftRightBy8(codeTapeHeader.bp);
			var filename = A2(
				$elm$core$List$map,
				function (_char) {
					return $elm$core$Char$toCode(_char);
				},
				$elm$core$String$toList(codeTapeHeader.V));
			var blockLow = 255 & codeTapeHeader.I;
			var blockHigh = $author$project$Utils$shiftRightBy8(codeTapeHeader.I);
			return A2(
				$elm$core$List$append,
				A2($elm$core$List$cons, 3, filename),
				_List_fromArray(
					[blockLow, blockHigh, startLow, startHigh, twosevenLow, twoSevenHigh, codeTapeHeader.dK]));
	}
};
var $author$project$CpuTimeCTime$CpuTimeSpAnd16BitValue = F3(
	function (time, sp, value16) {
		return {eN: sp, aQ: time, bx: value16};
	});
var $author$project$Z80Mem$z80_pop = F3(
	function (z80rom, clockTime, z80_env) {
		var v = A4($author$project$Z80Mem$mem16, z80_env.eN, z80rom, clockTime, z80_env);
		var time = A2($author$project$CpuTimeCTime$addCpuTimeTime, 6, v.aQ);
		return A3($author$project$CpuTimeCTime$CpuTimeSpAnd16BitValue, time, (z80_env.eN + 2) & 65535, v.bx);
	});
var $author$project$Spectrum$doLoad2 = F3(
	function (full_cpu, z80rom, tape) {
		var p = tape.eT;
		var cpu = full_cpu.ao;
		var z80_core = cpu.ae;
		var flags = z80_core.K;
		var main = z80_core.u;
		var startState = {
			bA: flags.bA,
			N: false,
			ad: false,
			A: $author$project$Z80Types$get_de(main),
			T: $author$project$Z80Flags$getFlags(flags),
			at: 0,
			o: main.o,
			aJ: 255 & main.aG,
			aj: p.bj,
			aa: $elm$core$Maybe$Nothing,
			S: z80_core.B
		};
		var toLog = 'ix = ' + ($author$project$Utils$toHexString(startState.o) + (' de ' + ($author$project$Utils$toHexString(startState.A) + (' a ' + ($author$project$Utils$toHexString2(startState.bA) + (' f ' + ($author$project$Utils$toHexString2(startState.T) + (' p ' + $elm$core$String$fromInt(p.eY)))))))));
		var headerLoading = A3($author$project$Z80Debug$debugLog, 'input', toLog, !flags.bA);
		var maybeData = function () {
			var _v3 = A2($elm$core$Dict$get, p.eY, tape.eZ);
			if (!_v3.$) {
				var aTapfile = _v3.a;
				var tapeData = headerLoading ? $author$project$Tapfile$tapfileDataToList(aTapfile.af) : A2(
					$elm$core$List$append,
					aTapfile.bG.af,
					_List_fromArray(
						[aTapfile.bG.dK]));
				var new_data = A3(
					$elm$core$List$foldl,
					F2(
						function (item, state) {
							var _v4 = _Utils_Tuple2(state.N, state.aa);
							var break1 = _v4.a;
							var rf1 = _v4.b;
							var l = function () {
								if (!break1) {
									var x = (((state.o - startState.o) < 8) || (state.A < 8)) ? (headerLoading ? A3(
										$author$project$Z80Debug$debugLog,
										'header',
										'ix = ' + ($author$project$Utils$toHexString(state.o) + (' de ' + ($author$project$Utils$toHexString(state.A) + (' item ' + $author$project$Utils$toHexString2(item))))),
										$elm$core$Maybe$Nothing) : A3(
										$author$project$Z80Debug$debugLog,
										'body',
										'ix = ' + ($author$project$Utils$toHexString(state.o) + (' de ' + ($author$project$Utils$toHexString(state.A) + (' item ' + $author$project$Utils$toHexString2(item))))),
										$elm$core$Maybe$Nothing)) : $elm$core$Maybe$Nothing;
									return item & 255;
								} else {
									return state.aJ;
								}
							}();
							var h = (!break1) ? (state.at ^ l) : state.at;
							var new_p = (!break1) ? (state.aj + 1) : state.aj;
							var _v5 = function () {
								if ((!break1) && (!state.A)) {
									var debug = A3(
										$author$project$Z80Debug$debugLog,
										'de zero',
										$author$project$Utils$toHexString2(h) + (' ' + $author$project$Utils$toHexString2(item)),
										$elm$core$Maybe$Nothing);
									return ((!h) || (h === 255)) ? _Utils_Tuple3(
										0,
										$elm$core$Maybe$Just($author$project$Z80Flags$c_FC),
										true) : _Utils_Tuple3(
										h,
										$elm$core$Maybe$Just(0),
										true);
								} else {
									return _Utils_Tuple3(state.bA, rf1, break1);
								}
							}();
							var a = _v5.a;
							var rf2 = _v5.b;
							var break2 = _v5.c;
							var a_rf_f_break_3 = {bA: a, N: break2, ad: false, T: state.T, aa: rf2, S: state.S};
							var data_a_rf_break = function () {
								if ((!a_rf_f_break_3.N) && (!a_rf_f_break_3.ad)) {
									if (!(!(a_rf_f_break_3.T & $author$project$Z80Flags$c_FC))) {
										return _Utils_update(
											a_rf_f_break_3,
											{
												S: A4($author$project$Z80Env$setMemIgnoringTime, state.o, l, cpu.dM, state.S)
											});
									} else {
										var new_a = A4($author$project$Z80Mem$mem, state.o, cpu.dM, z80rom, z80_core.B).e3 ^ l;
										return (!(!new_a)) ? _Utils_update(
											a_rf_f_break_3,
											{
												bA: new_a,
												N: true,
												aa: $elm$core$Maybe$Just(0)
											}) : _Utils_update(
											a_rf_f_break_3,
											{bA: new_a});
									}
								} else {
									return a_rf_f_break_3;
								}
							}();
							return _Utils_update(
								state,
								{
									bA: data_a_rf_break.bA,
									N: data_a_rf_break.N,
									ad: false,
									A: (state.N || state.ad) ? state.A : (state.A - 1),
									T: data_a_rf_break.T,
									at: h,
									o: (state.N || state.ad) ? state.o : $author$project$Utils$char(state.o + 1),
									aJ: l,
									aj: new_p,
									aa: data_a_rf_break.aa,
									S: data_a_rf_break.S
								});
						}),
					startState,
					tapeData);
				return $elm$core$Maybe$Just(new_data);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		if (!maybeData.$) {
			var tapeData = maybeData.a;
			var z80_env = tapeData.S;
			var x = A3(
				$author$project$Z80Debug$debugLog,
				'returning ix',
				$author$project$Utils$toHexString(tapeData.o),
				$elm$core$Maybe$Nothing);
			var new_position = headerLoading ? _Utils_update(
				p,
				{bj: tapeData.aj}) : _Utils_update(
				p,
				{bj: tapeData.aj, eY: p.eY + 1});
			var cpu_main = _Utils_update(
				main,
				{
					dN: $author$project$Utils$shiftRightBy8(tapeData.A),
					dT: 255 & tapeData.A,
					aG: tapeData.aJ | $author$project$Utils$shiftLeftBy8(tapeData.at),
					o: tapeData.o
				});
			var _v1 = function () {
				var _v2 = tapeData.aa;
				if (!_v2.$) {
					var rf = _v2.a;
					var popped = A3($author$project$Z80Mem$z80_pop, z80rom, cpu.dM, tapeData.S);
					var logged = 'rf ' + ($author$project$Utils$toHexString2(rf) + (' pc ' + ($author$project$Utils$toHexString2(popped.bx) + (' a ' + $author$project$Utils$toHexString2(tapeData.bA)))));
					var y = headerLoading ? A3($author$project$Z80Debug$debugLog, 'header pop', logged, $elm$core$Maybe$Nothing) : A3($author$project$Z80Debug$debugLog, 'body pop', logged, $elm$core$Maybe$Nothing);
					return _Utils_Tuple2(
						_Utils_update(
							z80_core,
							{
								B: _Utils_update(
									z80_env,
									{eN: popped.eN}),
								K: A2(
									$author$project$Z80Flags$setFlags,
									rf,
									_Utils_update(
										flags,
										{bA: tapeData.bA}))
							}),
						popped.bx);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							z80_core,
							{
								B: z80_env,
								K: A2(
									$author$project$Z80Flags$setFlags,
									tapeData.T,
									_Utils_update(
										flags,
										{bA: tapeData.bA}))
							}),
						cpu.cY);
				}
			}();
			var core_1 = _v1.a;
			var new_pc = _v1.b;
			var new_core = _Utils_update(
				core_1,
				{u: cpu_main});
			return _Utils_Tuple3(
				_Utils_update(
					full_cpu,
					{
						ao: _Utils_update(
							cpu,
							{ae: new_core, cY: new_pc})
					}),
				tapeData.A <= 0,
				new_position);
		} else {
			var clock = full_cpu.ao;
			var core = clock.ae;
			var new_flags = A2($author$project$Z80Flags$setFlags, $author$project$Z80Flags$c_FZ, core.K);
			return _Utils_Tuple3(
				_Utils_update(
					full_cpu,
					{
						ao: _Utils_update(
							clock,
							{
								ae: _Utils_update(
									core,
									{K: new_flags})
							})
					}),
				false,
				p);
		}
	});
var $Chadtech$elm_vector$Vector8$get = F2(
	function (index, _v0) {
		var vector = _v0;
		switch (index) {
			case 0:
				return vector.j;
			case 1:
				return vector.b3;
			case 2:
				return vector.b;
			case 3:
				return vector.c;
			case 4:
				return vector.d;
			case 5:
				return vector.e;
			case 6:
				return vector.f;
			default:
				return vector.g;
		}
	});
var $author$project$Spectrum$doLoad = F3(
	function (full_cpu, z80rom, tape) {
		var clock = full_cpu.ao;
		var cpu = clock.ae;
		if (!(1 & A2($Chadtech$elm_vector$Vector8$get, 7, z80rom.b$.b$))) {
			var flags = A2($author$project$Z80Flags$setFlags, 0, cpu.K);
			var core = _Utils_update(
				cpu,
				{K: flags});
			return _Utils_Tuple3(
				_Utils_update(
					full_cpu,
					{
						ao: _Utils_update(
							clock,
							{ae: core})
					}),
				false,
				tape.eT);
		} else {
			return A3($author$project$Spectrum$doLoad2, full_cpu, z80rom, tape);
		}
	});
var $author$project$CpuTimeCTime$addDuration = F2(
	function (duration, time) {
		var offset = function () {
			switch (duration) {
				case 0:
					return 4;
				case 1:
					return 5;
				case 2:
					return 6;
				case 3:
					return 7;
				case 4:
					return 8;
				case 5:
					return 9;
				case 6:
					return 10;
				case 7:
					return 11;
				case 8:
					return 12;
				case 9:
					return 13;
				case 10:
					return 14;
				case 11:
					return 15;
				case 12:
					return 16;
				case 13:
					return 17;
				case 14:
					return 18;
				case 16:
					return 20;
				case 17:
					return 23;
				default:
					return 19;
			}
		}();
		return _Utils_update(
			time,
			{F: time.F + offset});
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$CpuTimeCTime$FourTStates = 0;
var $author$project$Z80$c_DI = 243;
var $author$project$Z80$c_EI = 251;
var $author$project$Z80$c_EXX = 217;
var $author$project$Z80$c_EX_AF_AFDASH = 8;
var $author$project$Z80$c_HALT = 118;
var $author$project$Z80CoreWithClockTime$di_0xF3 = function (full_z80) {
	return _Utils_update(
		full_z80,
		{d2: 0});
};
var $author$project$Z80CoreWithClockTime$ei_0xFB = function (full_z80) {
	return _Utils_update(
		full_z80,
		{d2: 1});
};
var $author$project$Z80CoreWithClockTime$add_cpu_time = F2(
	function (value, z80) {
		var env = A2($author$project$CpuTimeCTime$addCpuTimeTime, value, z80.dM);
		return _Utils_update(
			z80,
			{dM: env});
	});
var $author$project$CpuTimeCTime$c_FRTIME = 69888;
var $author$project$CpuTimeCTime$c_TIME_LIMIT = $author$project$CpuTimeCTime$c_FRSTART + $author$project$CpuTimeCTime$c_FRTIME;
var $author$project$SingleNoParams$execute_0x76_halt = function (z80) {
	var clock = z80.ao;
	var n = (($author$project$CpuTimeCTime$c_TIME_LIMIT - clock.dM.F) + 3) >> 2;
	var z80_core = clock.ae;
	var interrupts = z80_core.be;
	var new_core = (n > 0) ? A2(
		$author$project$Z80CoreWithClockTime$add_cpu_time,
		4 * n,
		_Utils_update(
			clock,
			{
				ae: _Utils_update(
					z80_core,
					{
						be: _Utils_update(
							interrupts,
							{d$: true, et: interrupts.et + n})
					})
			})) : _Utils_update(
		clock,
		{
			ae: _Utils_update(
				z80_core,
				{
					be: _Utils_update(
						interrupts,
						{d$: true})
				})
		});
	return _Utils_update(
		z80,
		{ao: new_core});
};
var $author$project$SingleNoParams$exx = function (z80) {
	var clock = z80.ao;
	var core = clock.ae;
	var main = core.u;
	var alt = z80.bE;
	return _Utils_update(
		z80,
		{
			bE: _Utils_update(
				alt,
				{dw: main.dw, dI: main.dI, dN: main.dN, dT: main.dT, aG: main.aG}),
			ao: _Utils_update(
				clock,
				{
					ae: _Utils_update(
						core,
						{
							u: _Utils_update(
								main,
								{dw: alt.dw, dI: alt.dI, dN: alt.dN, dT: alt.dT, aG: alt.aG})
						})
				})
		});
};
var $author$project$Z80$nonCoreFuncs = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			$author$project$Z80$c_EX_AF_AFDASH,
			_Utils_Tuple2($author$project$SingleNoParams$ex_af, 0)),
			_Utils_Tuple2(
			$author$project$Z80$c_EXX,
			_Utils_Tuple2($author$project$SingleNoParams$exx, 0)),
			_Utils_Tuple2(
			$author$project$Z80$c_HALT,
			_Utils_Tuple2($author$project$SingleNoParams$execute_0x76_halt, 0)),
			_Utils_Tuple2(
			$author$project$Z80$c_DI,
			_Utils_Tuple2($author$project$Z80CoreWithClockTime$di_0xF3, 0)),
			_Utils_Tuple2(
			$author$project$Z80$c_EI,
			_Utils_Tuple2($author$project$Z80CoreWithClockTime$ei_0xFB, 0))
		]));
var $author$project$Z80$nonCoreOpCodeList = $elm$core$Dict$keys($author$project$Z80$nonCoreFuncs);
var $author$project$Z80$isCoreOpCode = function (value) {
	return !A2($elm$core$List$member, value, $author$project$Z80$nonCoreOpCodeList);
};
var $author$project$Z80$stillLooping = function (z80core) {
	return _Utils_cmp($author$project$CpuTimeCTime$c_TIME_LIMIT, z80core.dM.F) > 0;
};
var $author$project$Z80$coreLooping = function (_v0) {
	var z80core = _v0.a;
	var timeAndValue = _v0.b;
	return $author$project$Z80$isCoreOpCode(timeAndValue.e3) && $author$project$Z80$stillLooping(z80core);
};
var $author$project$CpuTimeCTime$addExtraCpuTime = F2(
	function (value, z80env) {
		var offset = function () {
			if (!value) {
				return 5;
			} else {
				return 7;
			}
		}();
		return _Utils_update(
			z80env,
			{F: z80env.F + offset});
	});
var $author$project$Z80Core$CoreOnly = function (a) {
	return {$: 0, a: a};
};
var $author$project$Utils$byte = function (value) {
	return (!(!(value & 128))) ? (value - 256) : value;
};
var $author$project$Z80Flags$adc = F2(
	function (b, the_flags) {
		var fb = b;
		var fa = the_flags.bA;
		var ff = (fa + fb) + ($author$project$Utils$shiftRightBy8(the_flags.U) & $author$project$Z80Flags$c_FC);
		var fr = ff & 255;
		return _Utils_update(
			the_flags,
			{bA: fr, aE: fa, aF: fb, U: ff, ag: fr});
	});
var $author$project$Z80Flags$sbc = F2(
	function (b, flagRegs) {
		var fb = ~b;
		var fa = flagRegs.bA;
		var ff = (fa - b) - ($author$project$Utils$shiftRightBy8(flagRegs.U) & $author$project$Z80Flags$c_FC);
		var fr = ff & 255;
		return _Utils_update(
			flagRegs,
			{bA: fr, aE: fa, aF: fb, U: ff, ag: fr});
	});
var $author$project$Z80Flags$z80_add = F2(
	function (b, the_flags) {
		var fb = b;
		var fa = the_flags.bA;
		var ff = fa + fb;
		var fr = ff & 255;
		return _Utils_update(
			the_flags,
			{bA: fr, aE: fa, aF: fb, U: ff, ag: fr});
	});
var $author$project$Z80Flags$z80_and = F2(
	function (b, flagRegs) {
		var fr = flagRegs.bA & b;
		var ff = fr;
		var a = ff;
		var fa = ~a;
		return _Utils_update(
			flagRegs,
			{bA: a, aE: fa, aF: 0, U: ff, ag: fr});
	});
var $author$project$Z80Flags$z80_cp = F2(
	function (b, flagRegs) {
		var fb = ~b;
		var fa = flagRegs.bA;
		var r = fa - b;
		var ff = (r & (~$author$project$Z80Flags$c_F53)) | (b & $author$project$Z80Flags$c_F53);
		var fr = r & 255;
		return _Utils_update(
			flagRegs,
			{aE: fa, aF: fb, U: ff, ag: fr});
	});
var $author$project$Z80Flags$z80_or = F2(
	function (b, flagRegs) {
		var fr = flagRegs.bA | b;
		var ff = fr;
		var a = ff;
		var fa = a | 256;
		return _Utils_update(
			flagRegs,
			{bA: a, aE: fa, aF: 0, U: ff, ag: fr});
	});
var $author$project$Z80Flags$z80_sub = F2(
	function (b, flagRegs) {
		var fb = ~b;
		var fa = flagRegs.bA;
		var ff = fa - b;
		var fr = ff & 255;
		return _Utils_update(
			flagRegs,
			{bA: fr, aE: fa, aF: fb, U: ff, ag: fr});
	});
var $author$project$Z80Flags$z80_xor = F2(
	function (b, flagRegs) {
		var fr = flagRegs.bA ^ b;
		var ff = fr;
		var a = ff;
		var fa = a | 256;
		return _Utils_update(
			flagRegs,
			{bA: a, aE: fa, aF: 0, U: ff, ag: fr});
	});
var $author$project$Z80Flags$changeFlags = F3(
	function (flagFunc, _int, flags) {
		switch (flagFunc) {
			case 0:
				return A2($author$project$Z80Flags$adc, _int, flags);
			case 1:
				return A2($author$project$Z80Flags$z80_add, _int, flags);
			case 2:
				return A2($author$project$Z80Flags$z80_sub, _int, flags);
			case 3:
				return A2($author$project$Z80Flags$sbc, _int, flags);
			case 4:
				return A2($author$project$Z80Flags$z80_and, _int, flags);
			case 5:
				return A2($author$project$Z80Flags$z80_xor, _int, flags);
			case 6:
				return A2($author$project$Z80Flags$z80_or, _int, flags);
			default:
				return A2($author$project$Z80Flags$z80_cp, _int, flags);
		}
	});
var $author$project$Z80Flags$IntWithFlags = F2(
	function (value, flags) {
		return {K: flags, e3: value};
	});
var $author$project$Z80Flags$dec = F2(
	function (v, flagRegs) {
		var vv = (v - 1) & 255;
		var ff = flagRegs.U & 256;
		return A2(
			$author$project$Z80Flags$IntWithFlags,
			vv,
			_Utils_update(
				flagRegs,
				{aE: v, aF: -1, U: ff | vv, ag: vv}));
	});
var $author$project$Z80Flags$inc = F2(
	function (v, flagRegs) {
		var vv = (v + 1) & 255;
		var ff = flagRegs.U & 256;
		return A2(
			$author$project$Z80Flags$IntWithFlags,
			vv,
			_Utils_update(
				flagRegs,
				{aE: v, aF: 1, U: ff | vv, ag: vv}));
	});
var $author$project$DoubleWithRegisters$applyDoubleWithRegistersDelta = F4(
	function (cpu_time, z80changeData, rom48k, z80) {
		switch (z80changeData.$) {
			case 0:
				var param = z80changeData.a;
				var z80_main = z80.u;
				var _int = $author$project$Utils$shiftLeftBy8(param) | (z80_main.o & 255);
				return _Utils_update(
					z80,
					{
						u: _Utils_update(
							z80_main,
							{o: _int})
					});
			case 1:
				var param = z80changeData.a;
				var main = z80.u;
				var _int = param | (main.o & 65280);
				return _Utils_update(
					z80,
					{
						u: _Utils_update(
							main,
							{o: _int})
					});
			case 2:
				var param = z80changeData.a;
				var z80_main = z80.u;
				var _int = $author$project$Utils$shiftLeftBy8(param) | (z80_main.p & 255);
				return _Utils_update(
					z80,
					{
						u: _Utils_update(
							z80_main,
							{p: _int})
					});
			case 3:
				var param = z80changeData.a;
				var main = z80.u;
				var _int = param | (main.p & 65280);
				return _Utils_update(
					z80,
					{
						u: _Utils_update(
							main,
							{p: _int})
					});
			case 10:
				var offset = z80changeData.a;
				var address_f = z80changeData.b;
				var value_f = z80changeData.c;
				var main = z80.u;
				var address = 65535 & (address_f(main) + $author$project$Utils$byte(offset));
				var _v1 = A4(
					$author$project$Z80Env$setMem,
					address,
					value_f(main),
					cpu_time,
					z80.B);
				var env1 = _v1.a;
				var clockTime = _v1.b;
				return _Utils_update(
					z80,
					{B: env1});
			case 9:
				var changeOneRegister = z80changeData.a;
				var addr_f = z80changeData.b;
				var offsetparam = z80changeData.c;
				var main = z80.u;
				var addr = 65535 & (addr_f(main) + $author$project$Utils$byte(offsetparam));
				var new_b = A4($author$project$Z80Mem$mem, addr, cpu_time, rom48k, z80.B);
				var new_main = function () {
					switch (changeOneRegister) {
						case 0:
							return _Utils_update(
								main,
								{dw: new_b.e3});
						case 1:
							return _Utils_update(
								main,
								{dI: new_b.e3});
						case 2:
							return _Utils_update(
								main,
								{dN: new_b.e3});
						case 3:
							return _Utils_update(
								main,
								{dT: new_b.e3});
						case 4:
							return _Utils_update(
								main,
								{
									aG: (255 & main.aG) | $author$project$Utils$shiftLeftBy8(new_b.e3)
								});
						default:
							return _Utils_update(
								main,
								{aG: (65280 & main.aG) | (255 & new_b.e3)});
					}
				}();
				return _Utils_update(
					z80,
					{u: new_main});
			case 4:
				var addr_f = z80changeData.a;
				var offset = z80changeData.b;
				var flags = z80.K;
				var addr = 65535 & (addr_f(z80.u) + $author$project$Utils$byte(offset));
				var new_a = A4($author$project$Z80Mem$mem, addr, cpu_time, rom48k, z80.B);
				return _Utils_update(
					z80,
					{
						K: _Utils_update(
							flags,
							{bA: new_a.e3})
					});
			case 5:
				var addr_f = z80changeData.a;
				var param = z80changeData.b;
				var addr = addr_f(z80.u) + $author$project$Utils$byte(param);
				var _v3 = A4($author$project$Z80Env$setMem, addr, z80.K.bA, cpu_time, z80.B);
				var env_1 = _v3.a;
				var newTime = _v3.b;
				return _Utils_update(
					z80,
					{B: env_1});
			case 8:
				var flagFunc = z80changeData.a;
				var address_f = z80changeData.b;
				var offset = z80changeData.c;
				var flags = z80.K;
				var address = 65535 & (address_f(z80.u) + $author$project$Utils$byte(offset));
				var value = A4($author$project$Z80Mem$mem, address, cpu_time, rom48k, z80.B);
				return _Utils_update(
					z80,
					{
						K: A3($author$project$Z80Flags$changeFlags, flagFunc, value.e3, flags)
					});
			case 6:
				var inAddr_f = z80changeData.a;
				var offset = z80changeData.b;
				var base_addr = 65535 & (inAddr_f(z80.u) + $author$project$Utils$byte(offset));
				var ramAddr = base_addr - 16384;
				if (ramAddr >= 0) {
					var value = A4($author$project$Z80Mem$mem, base_addr, cpu_time, rom48k, z80.B);
					var valueWithFlags = A2($author$project$Z80Flags$inc, value.e3, z80.K);
					var _v4 = A4($author$project$Z80Env$setMem, base_addr, valueWithFlags.e3, value.aQ, z80.B);
					var env_1 = _v4.a;
					var newTime = _v4.b;
					return _Utils_update(
						z80,
						{B: env_1, K: valueWithFlags.K});
				} else {
					return z80;
				}
			default:
				var inAddr_f = z80changeData.a;
				var offset = z80changeData.b;
				var base_addr = 65535 & (inAddr_f(z80.u) + $author$project$Utils$byte(offset));
				var ramAddr = base_addr - 16384;
				if (ramAddr >= 0) {
					var value = A4($author$project$Z80Mem$mem, base_addr, cpu_time, rom48k, z80.B);
					var valueWithFlags = A2($author$project$Z80Flags$dec, value.e3, z80.K);
					var _v5 = A4($author$project$Z80Env$setMem, base_addr, valueWithFlags.e3, value.aQ, z80.B);
					var env_1 = _v5.a;
					var newTime = _v5.b;
					return _Utils_update(
						z80,
						{B: env_1, K: valueWithFlags.K});
				} else {
					return z80;
				}
		}
	});
var $author$project$Z80Types$get_bc = function (z80_main) {
	return z80_main.dI | $author$project$Utils$shiftLeftBy8(z80_main.dw);
};
var $author$project$Z80Env$setRam = F3(
	function (addr, value, z80env) {
		return _Utils_update(
			z80env,
			{
				bl: A3($elm$core$Dict$insert, addr, value, z80env.bl)
			});
	});
var $author$project$Z80Env$setMem16 = F4(
	function (addr, value, time_input, z80env) {
		var addr1 = addr - 16383;
		if (!(!(addr1 & 16383))) {
			var z80env_time = function () {
				var _v0 = time_input.aC;
				if (!_v0.$) {
					return time_input;
				} else {
					var until = _v0.a;
					var n = time_input.F - until;
					return (n > 0) ? A2($author$project$CpuTimeCTime$cont, n, time_input) : time_input;
				}
			}();
			var newTime = _Utils_update(
				z80env_time,
				{aC: $author$project$CpuTimeCTime$NoCont});
			return (addr1 < 0) ? _Utils_Tuple2(z80env, newTime) : ((addr1 >= 16384) ? _Utils_Tuple2(
				A3(
					$author$project$Z80Env$setRam,
					addr1,
					$author$project$Utils$shiftRightBy8(value),
					A3($author$project$Z80Env$setRam, addr1 - 1, value & 255, z80env)),
				newTime) : _Utils_Tuple2(
				A4(
					$author$project$Z80Env$setMemIgnoringTime,
					addr + 1,
					$author$project$Utils$shiftRightBy8(value),
					newTime,
					A4($author$project$Z80Env$setMemIgnoringTime, addr, value & 255, newTime, z80env)),
				newTime));
		} else {
			return _Utils_Tuple2(
				A4(
					$author$project$Z80Env$setMemIgnoringTime,
					addr + 1,
					$author$project$Utils$shiftRightBy8(value),
					time_input,
					A4($author$project$Z80Env$setMemIgnoringTime, addr, value & 255, time_input, z80env)),
				time_input);
		}
	});
var $author$project$Z80Types$set_bc_main = F2(
	function (v, z80_main) {
		return _Utils_update(
			z80_main,
			{
				dw: $author$project$Utils$shiftRightBy8(v),
				dI: v & 255
			});
	});
var $author$project$Z80Types$set_de_main = F2(
	function (v, z80_main) {
		return _Utils_update(
			z80_main,
			{
				dN: $author$project$Utils$shiftRightBy8(v),
				dT: v & 255
			});
	});
var $author$project$Z80Execute$applyEdFourByte = F4(
	function (clockTime, z80changeData, rom48k, z80_core) {
		if (!z80changeData.$) {
			var _int = z80changeData.a;
			var sixteenBit = z80changeData.b;
			var reg = function () {
				switch (sixteenBit) {
					case 0:
						return z80_core.u.aG;
					case 1:
						return $author$project$Z80Types$get_de(z80_core.u);
					case 2:
						return $author$project$Z80Types$get_bc(z80_core.u);
					default:
						return z80_core.B.eN;
				}
			}();
			var _v1 = A4($author$project$Z80Env$setMem16, _int, reg, clockTime, z80_core.B);
			var env = _v1.a;
			var newTime = _v1.b;
			return $author$project$Z80Core$CoreOnly(
				_Utils_update(
					z80_core,
					{B: env}));
		} else {
			var _int = z80changeData.a;
			var sixteenBit = z80changeData.b;
			var value = A4($author$project$Z80Mem$mem16, _int, rom48k, clockTime, z80_core.B);
			var core = function () {
				switch (sixteenBit) {
					case 0:
						var z80_main = z80_core.u;
						var main = _Utils_update(
							z80_main,
							{aG: value.bx});
						return _Utils_update(
							z80_core,
							{u: main});
					case 1:
						var main = A2($author$project$Z80Types$set_de_main, value.bx, z80_core.u);
						return _Utils_update(
							z80_core,
							{u: main});
					case 2:
						var main = A2($author$project$Z80Types$set_bc_main, value.bx, z80_core.u);
						return _Utils_update(
							z80_core,
							{u: main});
					default:
						var env = z80_core.B;
						return _Utils_update(
							z80_core,
							{
								B: _Utils_update(
									env,
									{eN: value.bx})
							});
				}
			}();
			return $author$project$Z80Core$CoreOnly(core);
		}
	});
var $author$project$Z80Core$JumpBack = 1;
var $author$project$Z80Core$Looper = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Z80Core$LooperWithDelay = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Z80Core$NoOffset = 0;
var $author$project$GroupED$ed_adc_hl = F3(
	function (b, z80_main, z80_flags) {
		var fb = $author$project$Utils$shiftRightBy8(b);
		var a = z80_main.aG;
		var fa = $author$project$Utils$shiftRightBy8(a);
		var r1 = (a + b) + ($author$project$Utils$shiftRightBy8(z80_flags.U) & $author$project$Z80Flags$c_FC);
		var ff = $author$project$Utils$shiftRightBy8(r1);
		var r = $author$project$Utils$char(r1);
		var fr = $author$project$Utils$shiftRightBy8(r) | $author$project$Utils$shiftLeftBy8(r);
		return _Utils_Tuple2(
			_Utils_update(
				z80_flags,
				{aE: fa, aF: fb, U: ff, ag: fr}),
			r);
	});
var $author$project$GroupED$adc_hl = F2(
	function (b, z80) {
		var z80_main = z80.u;
		var _v0 = A3($author$project$GroupED$ed_adc_hl, b, z80_main, z80.K);
		var flags = _v0.a;
		var hl = _v0.b;
		return _Utils_update(
			z80,
			{
				K: flags,
				u: _Utils_update(
					z80_main,
					{aG: hl})
			});
	});
var $author$project$GroupED$adc_hl_sp = F3(
	function (_v0, clockTime, z80) {
		return A2($author$project$GroupED$adc_hl, z80.B.eN, z80);
	});
var $author$project$GroupED$cpir = F5(
	function (incOrDec, repeat, rom48k, clockTime, z80_core) {
		var z80_flags = z80_core.K;
		var old_a = z80_core.u.aG;
		var new_bc = 65535 & ($author$project$Z80Types$get_bc(z80_core.u) - 1);
		var newMain = A2($author$project$Z80Types$set_bc_main, new_bc, z80_core.u);
		var hl = function () {
			if (!incOrDec) {
				return 65535 & (old_a + 1);
			} else {
				return 65535 & (old_a - 1);
			}
		}();
		var fa = 127 & z80_core.K.bA;
		var b = A4($author$project$Z80Mem$mem, old_a, clockTime, rom48k, z80_core.B);
		var fb = ~(128 | b.e3);
		var v = 255 & (z80_flags.bA - b.e3);
		var fr = (127 & v) | (v >> 7);
		var new_v = (!(!($author$project$Z80Flags$c_FH & (z80_core.K.bA ^ (b.e3 ^ v))))) ? (v - 1) : v;
		var old_ff = (65280 & z80_core.K.U) | ((~$author$project$Z80Flags$c_F53) & v);
		var ff = (new_v & 8) | (old_ff | (32 & (new_v << 4)));
		var a = new_bc;
		var _v0 = function () {
			if (!(!a)) {
				var newish_pc = (repeat && (!(!v))) ? 1 : 0;
				return _Utils_Tuple3(128 | fa, 128 | fb, newish_pc);
			} else {
				return _Utils_Tuple3(fa, fb, 0);
			}
		}();
		var new_fa = _v0.a;
		var new_fb = _v0.b;
		var new_pc = _v0.c;
		return _Utils_Tuple3(
			_Utils_update(
				z80_core,
				{
					K: _Utils_update(
						z80_flags,
						{aE: new_fa, aF: new_fb, U: ff, ag: fr}),
					u: _Utils_update(
						newMain,
						{aG: hl})
				}),
			b.aQ,
			new_pc);
	});
var $author$project$Z80Flags$f_szh0n0p = F2(
	function (r, flags) {
		var fr = r;
		var ff = (flags.U & (~255)) | fr;
		var fa = r | 256;
		return _Utils_update(
			flags,
			{aE: fa, aF: 0, U: ff, ag: fr});
	});
var $author$project$CpuTimeCTime$cont_port = F2(
	function (portn, z80env) {
		var _v0 = z80env.aC;
		if (!_v0.$) {
			return z80env;
		} else {
			var ctime = _v0.a;
			var n = z80env.F - ctime;
			var env1_time = (n > 0) ? A2($author$project$CpuTimeCTime$cont, n, z80env) : z80env;
			if ((portn & 49152) !== 16384) {
				var env3 = (!(portn & 1)) ? A2($author$project$CpuTimeCTime$cont1, 1, env1_time) : env1_time;
				return _Utils_update(
					env3,
					{aC: $author$project$CpuTimeCTime$NoCont});
			} else {
				var env3 = _Utils_update(
					env1_time,
					{
						aC: $author$project$CpuTimeCTime$ContUntil(env1_time.F)
					});
				var contval = (portn & 1) << 1;
				var env4 = A2($author$project$CpuTimeCTime$cont, 2 + contval, env3);
				return A2($author$project$CpuTimeCTime$addCpuTimeTime, 4, env4);
			}
		}
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Keyboard$kempstonMapping = function (kempston) {
	switch (kempston) {
		case 0:
			return 2;
		case 1:
			return 1;
		case 2:
			return 8;
		case 3:
			return 4;
		default:
			return 16;
	}
};
var $Chadtech$elm_vector$Vector8$toList = function (_v0) {
	var vector = _v0;
	return _List_fromArray(
		[vector.j, vector.b3, vector.b, vector.c, vector.d, vector.e, vector.f, vector.g]);
};
var $author$project$Keyboard$z80_keyboard_input = F2(
	function (portnum, keyboard) {
		if (!(portnum & 224)) {
			return $elm$core$List$isEmpty(keyboard.aI) ? 255 : A3(
				$elm$core$List$foldl,
				F2(
					function (kemp, total) {
						return $author$project$Keyboard$kempstonMapping(kemp) | total;
					}),
				0,
				keyboard.aI);
		} else {
			if (!(portnum & 1)) {
				var list1 = A2(
					$elm$core$List$indexedMap,
					$elm$core$Tuple$pair,
					$Chadtech$elm_vector$Vector8$toList(keyboard.b$));
				var list2 = A2(
					$elm$core$List$filter,
					function (_v1) {
						var index = _v1.a;
						var value_ = _v1.b;
						return !(portnum & (256 << index));
					},
					list1);
				var list3 = A2(
					$elm$core$List$map,
					function (_v0) {
						var bitmask = _v0.a;
						var listval = _v0.b;
						return listval;
					},
					list2);
				return A3(
					$elm$core$List$foldl,
					F2(
						function (num, total) {
							return num & total;
						}),
					255,
					list3);
			} else {
				return 255;
			}
		}
	});
var $author$project$Z80Env$z80_in = F4(
	function (portnum, keyboard, clockTime, _v0) {
		var value = (!(1 & portnum)) ? (191 & A2($author$project$Keyboard$z80_keyboard_input, portnum, keyboard)) : 255;
		var newTime = A2($author$project$CpuTimeCTime$cont_port, portnum, clockTime);
		return A2($author$project$CpuTimeCTime$CpuTimeAndValue, newTime, value);
	});
var $author$project$GroupED$execute_ED70 = F3(
	function (rom48k, clockTime, z80) {
		var v = $author$project$Z80Types$get_bc(z80.u);
		var new_a = A4($author$project$Z80Env$z80_in, v, rom48k.b$, clockTime, z80.B);
		var new_flags = A2(
			$author$project$Z80Flags$f_szh0n0p,
			new_a.e3,
			A3(
				$author$project$Z80Debug$debugLog,
				'ED70 - IN (C)',
				_Utils_Tuple3(
					new_a.e3,
					$author$project$Utils$toHexString2(z80.u.dw),
					$author$project$Utils$toHexString2(z80.u.dI)),
				z80.K));
		return _Utils_update(
			z80,
			{K: new_flags});
	});
var $author$project$GroupED$execute_ED78 = F3(
	function (rom48k, clockTime, z80) {
		var v = $author$project$Z80Types$get_bc(z80.u);
		var new_a = A4($author$project$Z80Env$z80_in, v, rom48k.b$, clockTime, z80.B);
		var flags = z80.K;
		var new_flags = A2(
			$author$project$Z80Flags$f_szh0n0p,
			new_a.e3,
			_Utils_update(
				flags,
				{bA: new_a.e3}));
		return _Utils_update(
			z80,
			{K: new_flags});
	});
var $author$project$GroupED$inirOtirFlags = F4(
	function (d, bc, v, flags) {
		var x_orig = bc ^ (7 & d);
		var x = 4928640 >> (15 & ((x_orig >> 4) ^ x_orig));
		var fr = bc;
		var ff = (256 & d) | bc;
		var fb = ((128 & v) << 2) | ((d >> 4) | (128 & (bc ^ x)));
		var fa = 128 ^ fr;
		return _Utils_update(
			flags,
			{aE: fa, aF: fb, U: ff, ag: fr});
	});
var $author$project$CpuTimeCTime$FiveExtraTStates = 0;
var $author$project$Z80Flags$c_F3 = 8;
var $author$project$Z80Flags$c_F5 = 32;
var $author$project$GroupED$ldir = F5(
	function (incOrDec, repeat, rom48k, clockTime, z80) {
		var main = z80.u;
		var new_bc = ($author$project$Z80Types$get_bc(main) - 1) & 65535;
		var v1 = A4($author$project$Z80Mem$mem, main.aG, clockTime, rom48k, z80.B);
		var de = $author$project$Z80Types$get_de(main);
		var _v0 = (!(!new_bc)) ? (repeat ? _Utils_Tuple3(
			128,
			1,
			$elm$core$Maybe$Just(0)) : _Utils_Tuple3(128, 0, $elm$core$Maybe$Nothing)) : _Utils_Tuple3(0, 0, $elm$core$Maybe$Nothing);
		var v = _v0.a;
		var pc = _v0.b;
		var time = _v0.c;
		var _v1 = function () {
			if (!incOrDec) {
				return _Utils_Tuple2(main.aG + 1, de + 1);
			} else {
				return _Utils_Tuple2(main.aG - 1, de - 1);
			}
		}();
		var new_hl = _v1.a;
		var new_de = _v1.b;
		var _v3 = A4($author$project$Z80Env$setMem, de, v1.e3, v1.aQ, z80.B);
		var env_1 = _v3.a;
		var newClock = _v3.b;
		var z80_2 = _Utils_update(
			z80,
			{
				B: env_1,
				u: A2(
					$author$project$Z80Types$set_de_main,
					65535 & new_de,
					_Utils_update(
						main,
						{aG: 65535 & new_hl}))
			});
		var flags = z80_2.K;
		var fr = (!(!z80_2.K.ag)) ? 1 : z80_2.K.ag;
		var v2 = v1.e3 + z80_2.K.bA;
		var ff = ($author$project$Z80Flags$c_F5 & (v2 << 4)) | (($author$project$Z80Flags$c_F3 & v2) | ((~$author$project$Z80Flags$c_F53) & z80_2.K.U));
		return _Utils_Tuple3(
			_Utils_update(
				z80_2,
				{
					K: _Utils_update(
						flags,
						{aE: v, aF: v, U: ff, ag: fr}),
					u: A2($author$project$Z80Types$set_bc_main, new_bc, z80_2.u)
				}),
			time,
			pc);
	});
var $author$project$GroupED$rld = F3(
	function (rom48k, clockTime, z80) {
		var v_rhs = z80.K.bA & 15;
		var v_lhs_1 = A4($author$project$Z80Mem$mem, z80.u.aG, clockTime, rom48k, z80.B);
		var v_lhs = v_lhs_1.e3 << 4;
		var v = v_lhs | v_rhs;
		var new_a = $author$project$Utils$shiftRightBy8(v) | (z80.K.bA & 240);
		var flags = z80.K;
		var new_flags = A2(
			$author$project$Z80Flags$f_szh0n0p,
			new_a,
			_Utils_update(
				flags,
				{bA: new_a}));
		var _v0 = A4($author$project$Z80Env$setMem, z80.u.aG, v & 255, v_lhs_1.aQ, z80.B);
		var env_1 = _v0.a;
		var newClock = _v0.b;
		return _Utils_update(
			z80,
			{B: env_1, K: new_flags});
	});
var $author$project$GroupED$rrd = F3(
	function (rom48k, clockTime, z80) {
		var v_rhs = $author$project$Utils$shiftLeftBy8(z80.K.bA);
		var v_lhs = A4($author$project$Z80Mem$mem, z80.u.aG, clockTime, rom48k, z80.B);
		var v = v_lhs.e3 | v_rhs;
		var new_a = (15 & v) | (z80.K.bA & 240);
		var flags = z80.K;
		var new_flags = A2(
			$author$project$Z80Flags$f_szh0n0p,
			new_a,
			_Utils_update(
				flags,
				{bA: new_a}));
		var env_1 = A4($author$project$Z80Env$setMemIgnoringTime, z80.u.aG, (v >> 4) & 255, v_lhs.aQ, z80.B);
		return _Utils_update(
			z80,
			{B: env_1, K: new_flags});
	});
var $author$project$GroupED$sbc_hl = F2(
	function (b, z80) {
		var main = z80.u;
		var flags = z80.K;
		var fb = ~$author$project$Utils$shiftRightBy8(b);
		var a = z80.u.aG;
		var fa = $author$project$Utils$shiftRightBy8(a);
		var r1 = (a - b) - ($author$project$Utils$shiftRightBy8(z80.K.U) & $author$project$Z80Flags$c_FC);
		var ff = $author$project$Utils$shiftRightBy8(r1);
		var r = $author$project$Utils$char(r1);
		var fr = $author$project$Utils$shiftRightBy8(r) | $author$project$Utils$shiftLeftBy8(r);
		return _Utils_Tuple2(
			_Utils_update(
				flags,
				{aE: fa, aF: fb, U: ff, ag: fr}),
			_Utils_update(
				main,
				{aG: r}));
	});
var $author$project$Z80Env$z80_out = F4(
	function (portnum, value, clockTime, env_in) {
		var newTime = A2($author$project$CpuTimeCTime$cont_port, portnum, clockTime);
		if (!(1 & portnum)) {
			var border = 7 & value;
			return (!_Utils_eq(border, env_in.dE)) ? _Utils_Tuple2(
				A3(
					$author$project$Z80Debug$debugLog,
					'border',
					$elm$core$String$fromInt(border),
					_Utils_update(
						env_in,
						{dE: border})),
				newTime) : _Utils_Tuple2(env_in, newTime);
		} else {
			return _Utils_Tuple2(env_in, newTime);
		}
	});
var $author$project$Z80Execute$applyEdRegisterDelta = F4(
	function (clockTime, z80changeData, rom48k, z80_core) {
		var env = z80_core.B;
		switch (z80changeData.$) {
			case 0:
				return $author$project$Z80Core$CoreOnly(z80_core);
			case 8:
				return $author$project$Z80Core$CoreOnly(
					A3($author$project$GroupED$rrd, rom48k, clockTime, z80_core));
			case 9:
				return $author$project$Z80Core$CoreOnly(
					A3($author$project$GroupED$rld, rom48k, clockTime, z80_core));
			case 10:
				return $author$project$Z80Core$CoreOnly(
					A3($author$project$GroupED$execute_ED70, rom48k, clockTime, z80_core));
			case 11:
				return $author$project$Z80Core$CoreOnly(
					A3($author$project$GroupED$execute_ED78, rom48k, clockTime, z80_core));
			case 12:
				return $author$project$Z80Core$CoreOnly(
					A3($author$project$GroupED$adc_hl_sp, rom48k, clockTime, z80_core));
			case 6:
				var direction = z80changeData.a;
				var repeat = z80changeData.b;
				var _v1 = A5($author$project$GroupED$cpir, direction, repeat, rom48k, clockTime, z80_core);
				var core2 = _v1.a;
				var newTime = _v1.b;
				var newpc = _v1.c;
				return A2($author$project$Z80Core$Looper, newpc, core2);
			case 7:
				var reg16type = z80changeData.a;
				var reg = function () {
					switch (reg16type) {
						case 0:
							return z80_core.u.aG;
						case 1:
							return $author$project$Z80Types$get_de(z80_core.u);
						case 2:
							return $author$project$Z80Types$get_bc(z80_core.u);
						default:
							return z80_core.B.eN;
					}
				}();
				var _v2 = A2($author$project$GroupED$sbc_hl, reg, z80_core);
				var flags = _v2.a;
				var main = _v2.b;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{K: flags, u: main}));
			case 5:
				var direction = z80changeData.a;
				var repeat = z80changeData.b;
				var _v4 = A5($author$project$GroupED$ldir, direction, repeat, rom48k, clockTime, z80_core);
				var result = _v4.a;
				var maybeDelay = _v4.b;
				var new_pc = _v4.c;
				if (!maybeDelay.$) {
					var a = maybeDelay.a;
					return A3($author$project$Z80Core$LooperWithDelay, new_pc, a, result);
				} else {
					return A2($author$project$Z80Core$Looper, new_pc, result);
				}
			case 1:
				var intMode = z80changeData.a;
				var interrupts = A3($author$project$Z80Debug$debugLog, 'SetInterruptMode', intMode, z80_core.be);
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{
							be: _Utils_update(
								interrupts,
								{d1: intMode})
						}));
			case 2:
				var direction = z80changeData.a;
				var repeat = z80changeData.b;
				var main = z80_core.u;
				var new_b = 255 & (main.dw - 1);
				var pc2 = (repeat && (!(!new_b))) ? 1 : 0;
				var new_hl = function () {
					if (!direction) {
						return 65535 & (main.aG + 1);
					} else {
						return 65535 & (main.aG - 1);
					}
				}();
				var new_main = _Utils_update(
					main,
					{dw: new_b, aG: new_hl});
				var in_value = A4(
					$author$project$Z80Env$z80_in,
					$author$project$Z80Types$get_bc(main),
					rom48k.b$,
					clockTime,
					z80_core.B);
				var d_flag = function () {
					if (!direction) {
						return 65535 & ($author$project$Z80Types$get_bc(new_main) + 1);
					} else {
						return 65535 & ($author$project$Z80Types$get_bc(new_main) - 1);
					}
				}();
				var flags = A4(
					$author$project$GroupED$inirOtirFlags,
					d_flag,
					$author$project$Z80Types$get_bc(new_main),
					in_value.e3,
					z80_core.K);
				var _v6 = A4($author$project$Z80Env$setMem, main.aG, in_value.e3, in_value.aQ, env);
				var env_2 = _v6.a;
				var newTme2 = _v6.b;
				return A2(
					$author$project$Z80Core$Looper,
					pc2,
					_Utils_update(
						z80_core,
						{B: env_2, K: flags, u: new_main}));
			case 3:
				var direction = z80changeData.a;
				var repeat = z80changeData.b;
				var main = z80_core.u;
				var new_b = 255 & (main.dw - 1);
				var pc2 = (repeat && (!(!new_b))) ? 1 : 0;
				var new_hl = function () {
					if (!direction) {
						return 65535 & (main.aG + 1);
					} else {
						return 65535 & (main.aG - 1);
					}
				}();
				var main_2 = _Utils_update(
					main,
					{dw: new_b, aG: new_hl});
				var new_bc = $author$project$Z80Types$get_bc(main_2);
				var outvalue = A4($author$project$Z80Mem$mem, main.aG, clockTime, rom48k, z80_core.B);
				var flags = A4($author$project$GroupED$inirOtirFlags, new_hl, new_bc, outvalue.e3, z80_core.K);
				var _v9 = A4($author$project$Z80Env$z80_out, new_bc, outvalue.e3, outvalue.aQ, z80_core.B);
				var env2 = _v9.a;
				var newTime2 = _v9.b;
				return A2(
					$author$project$Z80Core$Looper,
					pc2,
					_Utils_update(
						z80_core,
						{B: env2, K: flags, u: main_2}));
			default:
				var changeMainRegister = z80changeData.a;
				var z80_main = z80_core.u;
				var z80_flags = z80_core.K;
				var in_value = A4(
					$author$project$Z80Env$z80_in,
					$author$project$Z80Types$get_bc(z80_main),
					rom48k.b$,
					clockTime,
					z80_core.B);
				var main = function () {
					switch (changeMainRegister) {
						case 0:
							return _Utils_update(
								z80_main,
								{dw: in_value.e3});
						case 1:
							return _Utils_update(
								z80_main,
								{dI: in_value.e3});
						case 2:
							return _Utils_update(
								z80_main,
								{dN: in_value.e3});
						case 3:
							return _Utils_update(
								z80_main,
								{dT: in_value.e3});
						case 4:
							return _Utils_update(
								z80_main,
								{
									aG: (z80_main.aG & 255) | $author$project$Utils$shiftLeftBy8(in_value.e3)
								});
						default:
							return _Utils_update(
								z80_main,
								{aG: (z80_main.aG & 65280) | in_value.e3});
					}
				}();
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{
							K: A2($author$project$Z80Flags$f_szh0n0p, in_value.e3, z80_flags),
							u: main
						}));
		}
	});
var $author$project$Z80Execute$applyInterruptChange = F3(
	function (chaange, iff, z80) {
		var value = chaange;
		var z80_flags = z80.K;
		var fr = (!value) ? 0 : 1;
		var ff = value | ((~255) & z80_flags.U);
		var fab = function () {
			if (!iff) {
				return 0;
			} else {
				return 128;
			}
		}();
		var flags = _Utils_update(
			z80_flags,
			{bA: value, aE: fab, aF: fab, U: ff, ag: fr});
		return _Utils_update(
			z80,
			{K: flags});
	});
var $author$project$Z80Core$JumpOffsetWithDelay = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Z80Core$JumpWithOffset = function (a) {
	return {$: 5, a: a};
};
var $author$project$Z80Core$MainOnly = function (a) {
	return {$: 11, a: a};
};
var $author$project$Z80Core$MainWithOffsetAndDelay = F3(
	function (a, b, c) {
		return {$: 13, a: a, b: b, c: c};
	});
var $author$project$Z80Core$NoCore = {$: 1};
var $author$project$Z80Execute$applyJumpChangeDelta = F3(
	function (cpu_time, z80changeData, z80) {
		switch (z80changeData.$) {
			case 0:
				var offset = z80changeData.a;
				return $author$project$Z80Core$JumpWithOffset(offset);
			case 1:
				var offset = z80changeData.a;
				var shortDelay = z80changeData.b;
				var _function = z80changeData.c;
				return _function(z80.K) ? A2($author$project$Z80Core$JumpOffsetWithDelay, offset, shortDelay) : $author$project$Z80Core$NoCore;
			case 2:
				var offset = z80changeData.a;
				var shortDelay = z80changeData.b;
				var main = z80.u;
				var b = (z80.u.dw - 1) & 255;
				return (!(!b)) ? A3(
					$author$project$Z80Core$MainWithOffsetAndDelay,
					offset,
					shortDelay,
					_Utils_update(
						main,
						{dw: b})) : $author$project$Z80Core$MainOnly(
					_Utils_update(
						main,
						{dw: b}));
			case 3:
				var addr_f = z80changeData.a;
				var value = z80changeData.b;
				var addr = addr_f(z80.u);
				var _v1 = A4($author$project$Z80Env$setMem, addr, value, cpu_time, z80.B);
				var env_1 = _v1.a;
				var newTime = _v1.b;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80,
						{B: env_1}));
			case 4:
				var param = z80changeData.a;
				var main = z80.u;
				var _int = $author$project$Utils$shiftLeftBy8(param) | (main.aG & 255);
				return $author$project$Z80Core$MainOnly(
					_Utils_update(
						main,
						{aG: _int}));
			default:
				var param = z80changeData.a;
				var main = z80.u;
				var _int = param | (main.aG & 65280);
				return $author$project$Z80Core$MainOnly(
					_Utils_update(
						main,
						{aG: _int}));
		}
	});
var $author$project$Z80Execute$applyPureDelta = F3(
	function (clockTime, z80changeData, z80) {
		switch (z80changeData.$) {
			case 1:
				var flagRegisters = z80changeData.a;
				var _int = z80changeData.b;
				var main = z80.u;
				return _Utils_update(
					z80,
					{
						K: flagRegisters,
						u: _Utils_update(
							main,
							{aG: _int})
					});
			case 2:
				var flagRegisters = z80changeData.a;
				return _Utils_update(
					z80,
					{K: flagRegisters});
			case 3:
				var addr = z80changeData.a;
				var _int = z80changeData.b;
				var _v1 = A4($author$project$Z80Env$setMem, addr, _int, clockTime, z80.B);
				var env = _v1.a;
				var clockTime2 = _v1.b;
				return _Utils_update(
					z80,
					{B: env});
			default:
				var changeMainRegister = z80changeData.a;
				var intWithFlags = z80changeData.b;
				var z80_main = z80.u;
				var new_main = function () {
					switch (changeMainRegister) {
						case 0:
							return _Utils_update(
								z80_main,
								{dw: intWithFlags.e3});
						case 1:
							return _Utils_update(
								z80_main,
								{dI: intWithFlags.e3});
						case 2:
							return _Utils_update(
								z80_main,
								{dN: intWithFlags.e3});
						default:
							return _Utils_update(
								z80_main,
								{dT: intWithFlags.e3});
					}
				}();
				return _Utils_update(
					z80,
					{K: intWithFlags.K, u: new_main});
		}
	});
var $author$project$Z80Core$CallWithPC = function (a) {
	return {$: 8, a: a};
};
var $author$project$Z80Core$CoreWithPC = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Z80Core$FlagsOnly = function (a) {
	return {$: 12, a: a};
};
var $author$project$Z80Core$JumpOnlyPC = function (a) {
	return {$: 4, a: a};
};
var $author$project$SingleByteWithEnv$applyEnvChangeDelta = F2(
	function (z80changeData, z80) {
		var _int = z80changeData;
		var env = z80.B;
		return _Utils_update(
			z80,
			{
				B: _Utils_update(
					env,
					{eN: _int})
			});
	});
var $author$project$Z80Execute$applyIndexedPureDelta = F2(
	function (z80changeData, z80) {
		switch (z80changeData.$) {
			case 0:
				var flagRegisters = z80changeData.a;
				var _int = z80changeData.b;
				var main = z80.u;
				return _Utils_update(
					z80,
					{
						K: flagRegisters,
						u: _Utils_update(
							main,
							{o: _int})
					});
			case 1:
				var flagRegisters = z80changeData.a;
				var _int = z80changeData.b;
				var main = z80.u;
				return _Utils_update(
					z80,
					{
						K: flagRegisters,
						u: _Utils_update(
							main,
							{p: _int})
					});
			case 2:
				var _int = z80changeData.a;
				var main = z80.u;
				return _Utils_update(
					z80,
					{
						u: _Utils_update(
							main,
							{o: _int})
					});
			default:
				var _int = z80changeData.a;
				var main = z80.u;
				return _Utils_update(
					z80,
					{
						u: _Utils_update(
							main,
							{p: _int})
					});
		}
	});
var $author$project$Z80Flags$shifter_v = F2(
	function (v, flagRegs) {
		var fr = 255 & v;
		return A2(
			$author$project$Z80Flags$IntWithFlags,
			fr,
			_Utils_update(
				flagRegs,
				{aE: 256 | fr, aF: 0, U: v, ag: fr}));
	});
var $author$project$Z80Flags$shifter0 = F2(
	function (v_in, flagRegs) {
		var v = v_in + $author$project$Utils$shiftLeftBy8(v_in);
		return A2($author$project$Z80Flags$shifter_v, v >> 7, flagRegs);
	});
var $author$project$Z80Flags$shifter1 = F2(
	function (v_in, flagRegs) {
		return A2($author$project$Z80Flags$shifter_v, (v_in * 2155872256) >> 24, flagRegs);
	});
var $author$project$Utils$shiftLeftBy1 = function (reg) {
	return reg << 1;
};
var $author$project$Z80Flags$shifter2 = F2(
	function (v_in, flagRegs) {
		return A2(
			$author$project$Z80Flags$shifter_v,
			$author$project$Utils$shiftLeftBy1(v_in) | ($author$project$Utils$shiftRightBy8(flagRegs.U) & 1),
			flagRegs);
	});
var $author$project$Utils$shiftRightBy1 = function (reg) {
	return reg >> 1;
};
var $author$project$Z80Flags$shifter3 = F2(
	function (v_in, flagRegs) {
		return A2(
			$author$project$Z80Flags$shifter_v,
			$author$project$Utils$shiftRightBy1((v_in * 513) | (flagRegs.U & 256)),
			flagRegs);
	});
var $author$project$Z80Flags$shifter4 = F2(
	function (v_in, flagRegs) {
		return A2(
			$author$project$Z80Flags$shifter_v,
			$author$project$Utils$shiftLeftBy1(v_in),
			flagRegs);
	});
var $author$project$Z80Flags$shifter5 = F2(
	function (v_in, flagRegs) {
		return A2(
			$author$project$Z80Flags$shifter_v,
			($author$project$Utils$shiftRightBy1(v_in) | (v_in & 128)) | $author$project$Utils$shiftLeftBy8(v_in),
			flagRegs);
	});
var $author$project$Z80Flags$shifter6 = F2(
	function (v_in, flagRegs) {
		return A2(
			$author$project$Z80Flags$shifter_v,
			$author$project$Utils$shiftLeftBy1(v_in) | 1,
			flagRegs);
	});
var $author$project$Z80Flags$shifter7 = F2(
	function (v_in, flagRegs) {
		return A2(
			$author$project$Z80Flags$shifter_v,
			$author$project$Utils$shiftRightBy1(v_in * 513),
			flagRegs);
	});
var $author$project$Z80Execute$applyShifter = F5(
	function (shifterFunc, addr, cpu_time, rom48k, z80) {
		var value = A4($author$project$Z80Mem$mem, addr, cpu_time, rom48k, z80.B);
		var result = function () {
			switch (shifterFunc) {
				case 0:
					return A2($author$project$Z80Flags$shifter0, value.e3, z80.K);
				case 1:
					return A2($author$project$Z80Flags$shifter1, value.e3, z80.K);
				case 2:
					return A2($author$project$Z80Flags$shifter2, value.e3, z80.K);
				case 3:
					return A2($author$project$Z80Flags$shifter3, value.e3, z80.K);
				case 4:
					return A2($author$project$Z80Flags$shifter4, value.e3, z80.K);
				case 5:
					return A2($author$project$Z80Flags$shifter5, value.e3, z80.K);
				case 6:
					return A2($author$project$Z80Flags$shifter6, value.e3, z80.K);
				default:
					return A2($author$project$Z80Flags$shifter7, value.e3, z80.K);
			}
		}();
		var _v0 = A4($author$project$Z80Env$setMem, addr, result.e3, value.aQ, z80.B);
		var env_2 = _v0.a;
		var newTime2 = _v0.b;
		return _Utils_update(
			z80,
			{B: env_2, K: result.K});
	});
var $author$project$Z80Flags$add16 = F3(
	function (a, b, main_flags) {
		var r = a + b;
		var shiftright = $author$project$Utils$shiftRightBy8((r ^ a) ^ b);
		var shiftrightxor = shiftright ^ main_flags.ag;
		var ff = (main_flags.U & $author$project$Z80Flags$c_FS) | ($author$project$Utils$shiftRightBy8(r) & 296);
		var fb_rhs = shiftrightxor & $author$project$Z80Flags$c_FH;
		var fb = (main_flags.aF & 128) | fb_rhs;
		var fa = main_flags.aE & (~$author$project$Z80Flags$c_FH);
		var new_flags = _Utils_update(
			main_flags,
			{aE: fa, aF: fb, U: ff});
		return A2($author$project$Z80Flags$IntWithFlags, r & 65535, new_flags);
	});
var $author$project$Z80Types$set_xy = F3(
	function (value, ixiyhl, z80) {
		switch (ixiyhl) {
			case 0:
				return _Utils_update(
					z80,
					{o: value});
			case 1:
				return _Utils_update(
					z80,
					{p: value});
			default:
				return _Utils_update(
					z80,
					{aG: value});
		}
	});
var $author$project$Utils$bitMaskFromBit = function (testType) {
	switch (testType) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 8;
		case 4:
			return 16;
		case 5:
			return 32;
		case 6:
			return 64;
		default:
			return 128;
	}
};
var $author$project$Z80Flags$testBit = F3(
	function (testType, v, flagRegs) {
		var m = v & $author$project$Utils$bitMaskFromBit(testType);
		var ff = m | (($author$project$Z80Flags$c_F53 & v) | ((~255) & flagRegs.U));
		return _Utils_update(
			flagRegs,
			{aE: ~m, aF: 0, U: ff, ag: m});
	});
var $author$project$SingleEnvWithMain$applySingleEnvMainChange = F4(
	function (clockTime, z80changeData, rom48k, z80) {
		switch (z80changeData.$) {
			case 0:
				var _int = z80changeData.a;
				var cpuTimeCTime = z80changeData.b;
				var flags = z80.K;
				return _Utils_update(
					z80,
					{
						K: _Utils_update(
							flags,
							{bA: _int})
					});
			case 1:
				var eightBit = z80changeData.a;
				var _int = z80changeData.b;
				var cpuTimeCTime = z80changeData.c;
				var main = z80.u;
				var main_1 = function () {
					switch (eightBit) {
						case 0:
							return _Utils_update(
								main,
								{dw: _int});
						case 1:
							return _Utils_update(
								main,
								{dI: _int});
						case 2:
							return _Utils_update(
								main,
								{dN: _int});
						default:
							return _Utils_update(
								main,
								{dT: _int});
					}
				}();
				return _Utils_update(
					z80,
					{u: main_1});
			case 2:
				var _int = z80changeData.a;
				var cpuTimeCTime = z80changeData.b;
				var main = z80.u;
				return _Utils_update(
					z80,
					{
						u: _Utils_update(
							main,
							{aG: _int})
					});
			case 3:
				var bitTest = z80changeData.a;
				var mp_address = z80changeData.b;
				var value = A4($author$project$Z80Mem$mem, mp_address, clockTime, rom48k, z80.B);
				var new_flags = A3($author$project$Z80Flags$testBit, bitTest, value.e3, z80.K);
				return _Utils_update(
					z80,
					{
						K: _Utils_update(
							new_flags,
							{
								U: ($author$project$Z80Flags$c_F53 & $author$project$Utils$shiftRightBy8(mp_address)) | ((~$author$project$Z80Flags$c_F53) & new_flags.U)
							})
					});
			case 4:
				var flagFunc = z80changeData.a;
				var _int = z80changeData.b;
				var cpuTimeCTime = z80changeData.c;
				var flags = z80.K;
				return _Utils_update(
					z80,
					{
						K: A3($author$project$Z80Flags$changeFlags, flagFunc, _int, flags)
					});
			default:
				var ixiyhl = z80changeData.a;
				var hl = z80changeData.b;
				var sp = z80changeData.c;
				var new_xy = A3($author$project$Z80Flags$add16, hl, sp, z80.K);
				return _Utils_update(
					z80,
					{
						K: new_xy.K,
						u: A3($author$project$Z80Types$set_xy, new_xy.e3, ixiyhl, z80.u)
					});
		}
	});
var $author$project$Utils$inverseBitMaskFromBit = function (testType) {
	switch (testType) {
		case 0:
			return 254;
		case 1:
			return 253;
		case 2:
			return 251;
		case 3:
			return 247;
		case 4:
			return 239;
		case 5:
			return 223;
		case 6:
			return 191;
		default:
			return 127;
	}
};
var $author$project$Utils$clearBit = F2(
	function (testType, input) {
		return input & $author$project$Utils$inverseBitMaskFromBit(testType);
	});
var $author$project$Z80Flags$get_af = function (z80_flags) {
	return $author$project$Utils$shiftLeftBy8(z80_flags.bA) | $author$project$Z80Flags$getFlags(z80_flags);
};
var $author$project$Z80Types$get_xy = F2(
	function (ixiyhl, z80_main) {
		switch (ixiyhl) {
			case 0:
				return z80_main.o;
			case 1:
				return z80_main.p;
			default:
				return z80_main.aG;
		}
	});
var $author$project$Utils$setBit = F2(
	function (testType, input) {
		return input | $author$project$Utils$bitMaskFromBit(testType);
	});
var $author$project$Z80Flags$set_af = function (v) {
	var flagRegs = v & 255;
	var a = $author$project$Utils$shiftRightBy8(v);
	var blankFlags = {bA: a, aE: 0, aF: 0, U: 0, ag: 0};
	return A2($author$project$Z80Flags$setFlags, flagRegs, blankFlags);
};
var $author$project$Z80Env$z80_push = F3(
	function (v, clockTime, z80env) {
		var sp_minus_1 = (z80env.eN - 1) & 65535;
		var new_sp = (z80env.eN - 2) & 65535;
		var env_2 = A4(
			$author$project$Z80Env$setMemIgnoringTime,
			new_sp,
			v & 255,
			clockTime,
			A4(
				$author$project$Z80Env$setMemIgnoringTime,
				sp_minus_1,
				$author$project$Utils$shiftRightBy8(v),
				clockTime,
				z80env));
		return _Utils_update(
			env_2,
			{eN: new_sp});
	});
var $author$project$Z80Execute$applyRegisterDelta = F4(
	function (clockTime, z80changeData, rom48k, z80_core) {
		switch (z80changeData.$) {
			case 38:
				var f = z80changeData.a;
				var old_env = z80_core.B;
				return $author$project$Z80Core$CoreOnly(
					A2(
						$author$project$SingleByteWithEnv$applyEnvChangeDelta,
						f(old_env),
						z80_core));
			case 40:
				var f = z80changeData.a;
				var old_env = z80_core.B;
				var singleEnvMainChange = A3(f, z80_core.u, rom48k, old_env);
				return $author$project$Z80Core$CoreOnly(
					A4($author$project$SingleEnvWithMain$applySingleEnvMainChange, clockTime, singleEnvMainChange, rom48k, z80_core));
			case 39:
				var f = z80changeData.a;
				var old_env = z80_core.B;
				var singleEnvMainChange = A4(f, z80_core.u, rom48k, clockTime, old_env);
				return $author$project$Z80Core$CoreOnly(
					A4($author$project$SingleEnvWithMain$applySingleEnvMainChange, clockTime, singleEnvMainChange, rom48k, z80_core));
			case 36:
				var f = z80changeData.a;
				var z80change = A2(f, z80_core.u, z80_core.K);
				return $author$project$Z80Core$CoreOnly(
					A3($author$project$Z80Execute$applyPureDelta, clockTime, z80change, z80_core));
			case 37:
				var f = z80changeData.a;
				var z80change = A2(f, z80_core.u, z80_core.K);
				return $author$project$Z80Core$CoreOnly(
					A2($author$project$Z80Execute$applyIndexedPureDelta, z80change, z80_core));
			case 35:
				var new_pc = z80changeData.a;
				return $author$project$Z80Core$CallWithPC(new_pc);
			case 28:
				var old_env = z80_core.B;
				var v = A3($author$project$Z80Mem$z80_pop, rom48k, clockTime, old_env);
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{
							B: _Utils_update(
								old_env,
								{eN: v.eN}),
							u: A2($author$project$Z80Types$set_bc_main, v.bx, z80_core.u)
						}));
			case 30:
				var old_env = z80_core.B;
				var v = A3($author$project$Z80Mem$z80_pop, rom48k, clockTime, old_env);
				var main = z80_core.u;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{
							B: _Utils_update(
								old_env,
								{eN: v.eN}),
							u: _Utils_update(
								main,
								{aG: v.bx})
						}));
			case 31:
				var old_env = z80_core.B;
				var v = A3($author$project$Z80Mem$z80_pop, rom48k, clockTime, old_env);
				var main = z80_core.u;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{
							B: _Utils_update(
								old_env,
								{eN: v.eN}),
							u: _Utils_update(
								main,
								{o: v.bx})
						}));
			case 32:
				var old_env = z80_core.B;
				var v = A3($author$project$Z80Mem$z80_pop, rom48k, clockTime, old_env);
				var main = z80_core.u;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{
							B: _Utils_update(
								old_env,
								{eN: v.eN}),
							u: _Utils_update(
								main,
								{p: v.bx})
						}));
			case 33:
				var old_env = z80_core.B;
				var v = A3($author$project$Z80Mem$z80_pop, rom48k, clockTime, old_env);
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{
							B: _Utils_update(
								old_env,
								{eN: v.eN}),
							K: $author$project$Z80Flags$set_af(v.bx)
						}));
			case 29:
				var old_env = z80_core.B;
				var v = A3($author$project$Z80Mem$z80_pop, rom48k, clockTime, old_env);
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{
							B: _Utils_update(
								old_env,
								{eN: v.eN}),
							u: A2($author$project$Z80Types$set_de_main, v.bx, z80_core.u)
						}));
			case 34:
				var old_env = z80_core.B;
				var a = A3($author$project$Z80Mem$z80_pop, rom48k, clockTime, z80_core.B);
				return A2(
					$author$project$Z80Core$CoreWithPC,
					a.bx,
					_Utils_update(
						z80_core,
						{
							B: _Utils_update(
								old_env,
								{eN: a.eN})
						}));
			case 21:
				var f = z80changeData.a;
				return $author$project$Z80Core$MainOnly(
					f(z80_core.u));
			case 0:
				var f = z80changeData.a;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{
							B: A3(
								$author$project$Z80Env$z80_push,
								f(z80_core.u),
								clockTime,
								z80_core.B)
						}));
			case 1:
				var f = z80changeData.a;
				var old_env = z80_core.B;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{
							B: _Utils_update(
								old_env,
								{
									eN: f(z80_core.u)
								})
						}));
			case 2:
				var f = z80changeData.a;
				var old_env = z80_core.B;
				var addr = f(z80_core.u);
				var value = A4($author$project$Z80Mem$mem, addr, clockTime, rom48k, z80_core.B);
				var flags = A2($author$project$Z80Flags$inc, value.e3, z80_core.K);
				var _v1 = A4($author$project$Z80Env$setMem, addr, flags.e3, value.aQ, old_env);
				var env_3 = _v1.a;
				var newNew = _v1.b;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{B: env_3, K: flags.K}));
			case 3:
				var f = z80changeData.a;
				var old_env = z80_core.B;
				var addr = f(z80_core.u);
				var value = A4($author$project$Z80Mem$mem, addr, clockTime, rom48k, z80_core.B);
				var flags = A2($author$project$Z80Flags$dec, value.e3, z80_core.K);
				var _v2 = A4($author$project$Z80Env$setMem, addr, flags.e3, clockTime, old_env);
				var env_3 = _v2.a;
				var newNew = _v2.b;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{B: env_3, K: flags.K}));
			case 4:
				var f = z80changeData.a;
				return $author$project$Z80Core$JumpOnlyPC(
					f(z80_core.u));
			case 5:
				var addrvaluefunc = z80changeData.a;
				var old_env = z80_core.B;
				var main = z80_core.u;
				var _v3 = addrvaluefunc(main);
				var addr = _v3.a;
				var value = _v3.b;
				var _v4 = A4($author$project$Z80Env$setMem, addr, value, clockTime, old_env);
				var env_2 = _v4.a;
				var newTime = _v4.b;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{B: env_2}));
			case 6:
				var shifter = z80changeData.a;
				var addr = z80changeData.b;
				return $author$project$Z80Core$CoreOnly(
					A5(
						$author$project$Z80Execute$applyShifter,
						shifter,
						addr(z80_core.u),
						clockTime,
						rom48k,
						z80_core));
			case 7:
				var shifter = z80changeData.a;
				var raw_addr = z80changeData.b;
				return $author$project$Z80Core$CoreOnly(
					A5($author$project$Z80Execute$applyShifter, shifter, 65535 & raw_addr, clockTime, rom48k, z80_core));
			case 8:
				var bitMask = z80changeData.a;
				var addr = z80changeData.b;
				var old_env = z80_core.B;
				var value = A4($author$project$Z80Mem$mem, addr, clockTime, rom48k, old_env);
				var new_value = value.e3 & $author$project$Utils$inverseBitMaskFromBit(bitMask);
				var _v5 = A4($author$project$Z80Env$setMem, addr, new_value, value.aQ, old_env);
				var env_3 = _v5.a;
				var newNewTime = _v5.b;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{B: env_3}));
			case 9:
				var bitMask = z80changeData.a;
				var raw_addr = z80changeData.b;
				var old_env = z80_core.B;
				var addr = 65535 & raw_addr;
				var value = A4($author$project$Z80Mem$mem, addr, clockTime, rom48k, z80_core.B);
				var new_value = value.e3 | $author$project$Utils$bitMaskFromBit(bitMask);
				var _v6 = A4($author$project$Z80Env$setMem, addr, new_value, value.aQ, old_env);
				var env_3 = _v6.a;
				var newNewTime = _v6.b;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{B: env_3}));
			case 10:
				return $author$project$Z80Core$NoCore;
			case 11:
				var flagFunc = z80changeData.a;
				var valueFunc = z80changeData.b;
				var z80_flags = z80_core.K;
				var value = valueFunc(z80_core.u);
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{
							K: A3($author$project$Z80Flags$changeFlags, flagFunc, value, z80_flags)
						}));
			case 12:
				var ixiyhl = z80changeData.a;
				var xy = A2($author$project$Z80Types$get_xy, ixiyhl, z80_core.u);
				var old_env = z80_core.B;
				var popped = A3($author$project$Z80Mem$z80_pop, rom48k, clockTime, old_env);
				var main = A3($author$project$Z80Types$set_xy, popped.bx, ixiyhl, z80_core.u);
				var env_2 = A3(
					$author$project$Z80Env$z80_push,
					xy,
					popped.aQ,
					_Utils_update(
						old_env,
						{eN: popped.eN}));
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{B: env_2, u: main}));
			case 13:
				var changeOneRegister = z80changeData.a;
				var _int = z80changeData.b;
				var z80_main = z80_core.u;
				if (!changeOneRegister) {
					return $author$project$Z80Core$MainOnly(
						_Utils_update(
							z80_main,
							{
								aG: (z80_main.aG & 255) | $author$project$Utils$shiftLeftBy8(_int)
							}));
				} else {
					return $author$project$Z80Core$MainOnly(
						_Utils_update(
							z80_main,
							{aG: (z80_main.aG & 65280) | _int}));
				}
			case 14:
				var mainf = z80changeData.a;
				var z80_flags = z80_core.K;
				return $author$project$Z80Core$FlagsOnly(
					_Utils_update(
						z80_flags,
						{
							bA: mainf(z80_core.u)
						}));
			case 15:
				var shifterFunc = z80changeData.a;
				var changeOneRegister = z80changeData.b;
				var raw_addr = z80changeData.c;
				var old_env = z80_core.B;
				var main = z80_core.u;
				var addr = 65535 & raw_addr;
				var input = A4($author$project$Z80Mem$mem, addr, clockTime, rom48k, z80_core.B);
				var value = function () {
					switch (shifterFunc) {
						case 0:
							return A2($author$project$Z80Flags$shifter0, input.e3, z80_core.K);
						case 1:
							return A2($author$project$Z80Flags$shifter1, input.e3, z80_core.K);
						case 2:
							return A2($author$project$Z80Flags$shifter2, input.e3, z80_core.K);
						case 3:
							return A2($author$project$Z80Flags$shifter3, input.e3, z80_core.K);
						case 4:
							return A2($author$project$Z80Flags$shifter4, input.e3, z80_core.K);
						case 5:
							return A2($author$project$Z80Flags$shifter5, input.e3, z80_core.K);
						case 6:
							return A2($author$project$Z80Flags$shifter6, input.e3, z80_core.K);
						default:
							return A2($author$project$Z80Flags$shifter7, input.e3, z80_core.K);
					}
				}();
				var new_main = function () {
					switch (changeOneRegister) {
						case 0:
							return _Utils_update(
								main,
								{dw: value.e3});
						case 1:
							return _Utils_update(
								main,
								{dI: value.e3});
						case 2:
							return _Utils_update(
								main,
								{dN: value.e3});
						case 3:
							return _Utils_update(
								main,
								{dT: value.e3});
						case 4:
							return _Utils_update(
								main,
								{
									aG: $author$project$Utils$shiftLeftBy8(value.e3) | (z80_core.u.aG & 255)
								});
						default:
							return _Utils_update(
								main,
								{aG: value.e3 | (z80_core.u.aG & 65280)});
					}
				}();
				var _v8 = A4($author$project$Z80Env$setMem, addr, value.e3, input.aQ, old_env);
				var env_2 = _v8.a;
				var newNew = _v8.b;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{B: env_2, K: value.K, u: new_main}));
			case 16:
				var bitTest = z80changeData.a;
				var changeOneRegister = z80changeData.b;
				var raw_addr = z80changeData.c;
				var old_env = z80_core.B;
				var main = z80_core.u;
				var addr = 65535 & raw_addr;
				var input = A4($author$project$Z80Mem$mem, addr, clockTime, rom48k, old_env);
				var value = A2($author$project$Utils$setBit, bitTest, input.e3);
				var new_main = function () {
					switch (changeOneRegister) {
						case 0:
							return _Utils_update(
								main,
								{dw: value});
						case 1:
							return _Utils_update(
								main,
								{dI: value});
						case 2:
							return _Utils_update(
								main,
								{dN: value});
						case 3:
							return _Utils_update(
								main,
								{dT: value});
						case 4:
							return _Utils_update(
								main,
								{
									aG: $author$project$Utils$shiftLeftBy8(value) | (z80_core.u.aG & 255)
								});
						default:
							return _Utils_update(
								main,
								{aG: value | (z80_core.u.aG & 65280)});
					}
				}();
				var _v11 = A4($author$project$Z80Env$setMem, addr, value, input.aQ, old_env);
				var env_2 = _v11.a;
				var newTime2 = _v11.b;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{B: env_2, u: new_main}));
			case 17:
				var bitTest = z80changeData.a;
				var changeOneRegister = z80changeData.b;
				var raw_addr = z80changeData.c;
				var old_env = z80_core.B;
				var main = z80_core.u;
				var addr = 65535 & raw_addr;
				var input = A4($author$project$Z80Mem$mem, addr, clockTime, rom48k, old_env);
				var value = A2($author$project$Utils$clearBit, bitTest, input.e3);
				var new_main = function () {
					switch (changeOneRegister) {
						case 0:
							return _Utils_update(
								main,
								{dw: value});
						case 1:
							return _Utils_update(
								main,
								{dI: value});
						case 2:
							return _Utils_update(
								main,
								{dN: value});
						case 3:
							return _Utils_update(
								main,
								{dT: value});
						case 4:
							return _Utils_update(
								main,
								{
									aG: $author$project$Utils$shiftLeftBy8(value) | (z80_core.u.aG & 255)
								});
						default:
							return _Utils_update(
								main,
								{aG: value | (z80_core.u.aG & 65280)});
					}
				}();
				var _v13 = A4($author$project$Z80Env$setMem, addr, value, input.aQ, old_env);
				var env_2 = _v13.a;
				var newTime = _v13.b;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{B: env_2, u: new_main}));
			case 18:
				var shifterFunc = z80changeData.a;
				var raw_addr = z80changeData.b;
				var address = 65535 & raw_addr;
				var value = A4($author$project$Z80Mem$mem, address, clockTime, rom48k, z80_core.B);
				var result = function () {
					switch (shifterFunc) {
						case 0:
							return A2($author$project$Z80Flags$shifter0, value.e3, z80_core.K);
						case 1:
							return A2($author$project$Z80Flags$shifter1, value.e3, z80_core.K);
						case 2:
							return A2($author$project$Z80Flags$shifter2, value.e3, z80_core.K);
						case 3:
							return A2($author$project$Z80Flags$shifter3, value.e3, z80_core.K);
						case 4:
							return A2($author$project$Z80Flags$shifter4, value.e3, z80_core.K);
						case 5:
							return A2($author$project$Z80Flags$shifter5, value.e3, z80_core.K);
						case 6:
							return A2($author$project$Z80Flags$shifter6, value.e3, z80_core.K);
						default:
							return A2($author$project$Z80Flags$shifter7, value.e3, z80_core.K);
					}
				}();
				var newFlags = result.K;
				var _v15 = A4($author$project$Z80Env$setMem, address, result.e3, value.aQ, z80_core.B);
				var env_2 = _v15.a;
				var newTime2 = _v15.b;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{
							B: env_2,
							K: _Utils_update(
								newFlags,
								{bA: result.e3})
						}));
			case 19:
				var bitTest = z80changeData.a;
				var raw_addr = z80changeData.b;
				var old_env = z80_core.B;
				var flags = z80_core.K;
				var addr = 65535 & raw_addr;
				var input = A4($author$project$Z80Mem$mem, addr, clockTime, rom48k, old_env);
				var value = A2($author$project$Utils$setBit, bitTest, input.e3);
				var _v17 = A4($author$project$Z80Env$setMem, addr, value, input.aQ, old_env);
				var env_2 = _v17.a;
				var newTime2 = _v17.b;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{
							B: env_2,
							K: _Utils_update(
								flags,
								{bA: value})
						}));
			case 20:
				var bitTest = z80changeData.a;
				var raw_addr = z80changeData.b;
				var old_env = z80_core.B;
				var flags = z80_core.K;
				var addr = 65535 & raw_addr;
				var input = A4($author$project$Z80Mem$mem, addr, clockTime, rom48k, old_env);
				var value = A2($author$project$Utils$clearBit, bitTest, input.e3);
				var _v18 = A4($author$project$Z80Env$setMem, addr, value, input.aQ, old_env);
				var env_2 = _v18.a;
				var newTime2 = _v18.b;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{
							B: env_2,
							K: _Utils_update(
								flags,
								{bA: value})
						}));
			case 24:
				var f = z80changeData.a;
				return $author$project$Z80Core$FlagsOnly(
					f(z80_core.K));
			case 25:
				var f = z80changeData.a;
				return $author$project$Z80Core$MainOnly(
					A2(f, z80_core.K, z80_core.u));
			case 26:
				var f = z80changeData.a;
				if (f(z80_core.K)) {
					var result = A3($author$project$Z80Mem$z80_pop, rom48k, clockTime, z80_core.B);
					var env1 = z80_core.B;
					return A2(
						$author$project$Z80Core$CoreWithPC,
						result.bx,
						_Utils_update(
							z80_core,
							{
								B: _Utils_update(
									env1,
									{eN: result.eN})
							}));
				} else {
					return $author$project$Z80Core$NoCore;
				}
			case 22:
				var _int = z80changeData.a;
				var ints = z80_core.be;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{
							be: _Utils_update(
								ints,
								{et: _int})
						}));
			case 23:
				var _int = z80changeData.a;
				var ints = z80_core.be;
				var new_ir = $author$project$Utils$shiftLeftBy8(_int) | (255 & ints.bZ);
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{
							be: _Utils_update(
								ints,
								{bZ: new_ir})
						}));
			default:
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80_core,
						{
							B: A3(
								$author$project$Z80Env$z80_push,
								$author$project$Z80Flags$get_af(z80_core.K),
								clockTime,
								z80_core.B)
						}));
		}
	});
var $author$project$SingleWith8BitParameter$applySimple8BitChange = F3(
	function (change, _int, z80_main) {
		switch (change) {
			case 0:
				return _Utils_update(
					z80_main,
					{dw: _int});
			case 1:
				return _Utils_update(
					z80_main,
					{dI: _int});
			case 2:
				return _Utils_update(
					z80_main,
					{dN: _int});
			default:
				return _Utils_update(
					z80_main,
					{dT: _int});
		}
	});
var $author$project$Z80Execute$applySimple8BitDelta = F4(
	function (cpu_time, z80changeData, rom48k, z80) {
		switch (z80changeData.$) {
			case 0:
				var coreRegister = z80changeData.a;
				var _int = z80changeData.b;
				var main = A3($author$project$SingleWith8BitParameter$applySimple8BitChange, coreRegister, _int, z80.u);
				return _Utils_update(
					z80,
					{u: main});
			case 3:
				var new_a = z80changeData.a;
				var flags = z80.K;
				return _Utils_update(
					z80,
					{
						K: _Utils_update(
							flags,
							{bA: new_a})
					});
			case 4:
				var operation = z80changeData.a;
				var param = z80changeData.b;
				var flags = A3($author$project$Z80Flags$changeFlags, operation, param, z80.K);
				return _Utils_update(
					z80,
					{K: flags});
			case 1:
				var param = z80changeData.a;
				var flags = z80.K;
				var portNum = param | $author$project$Utils$shiftLeftBy8(flags.bA);
				var new_a = A4($author$project$Z80Env$z80_in, portNum, rom48k.b$, cpu_time, z80.B);
				return _Utils_update(
					z80,
					{
						K: _Utils_update(
							flags,
							{bA: new_a.e3})
					});
			default:
				var param = z80changeData.a;
				var portNum = param | $author$project$Utils$shiftLeftBy8(z80.K.bA);
				var _v1 = A4($author$project$Z80Env$z80_out, portNum, z80.K.bA, cpu_time, z80.B);
				var env = _v1.a;
				var newTime = _v1.b;
				return _Utils_update(
					z80,
					{B: env});
		}
	});
var $author$project$Z80Execute$applySimpleTripleChangeDelta = F4(
	function (rom48k, cpu_time, z80changeData, z80) {
		var env = z80.B;
		switch (z80changeData.$) {
			case 1:
				var _int = z80changeData.a;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80,
						{
							B: _Utils_update(
								env,
								{eN: _int})
						}));
			case 0:
				var _int = z80changeData.a;
				var value = A4($author$project$Z80Mem$mem16, _int, rom48k, cpu_time, env);
				var main = z80.u;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80,
						{
							u: _Utils_update(
								main,
								{aG: value.bx})
						}));
			case 2:
				var _int = z80changeData.a;
				var value = A4($author$project$Z80Mem$mem, _int, cpu_time, rom48k, env);
				var flags = z80.K;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80,
						{
							K: _Utils_update(
								flags,
								{bA: value.e3})
						}));
			case 4:
				var addr = z80changeData.a;
				var _v1 = A4($author$project$Z80Env$setMem, addr, z80.K.bA, cpu_time, env);
				var env2 = _v1.a;
				var time2 = _v1.b;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80,
						{B: env2}));
			case 3:
				var _int = z80changeData.a;
				var tripleByteRegister = z80changeData.b;
				var z80_main = function () {
					switch (tripleByteRegister) {
						case 0:
							return A2($author$project$Z80Types$set_bc_main, _int, z80.u);
						case 1:
							return A2($author$project$Z80Types$set_de_main, _int, z80.u);
						default:
							var main = z80.u;
							return _Utils_update(
								main,
								{aG: _int});
					}
				}();
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80,
						{u: z80_main}));
			default:
				var address = z80changeData.a;
				var value = z80.u.aG;
				var _v3 = A4($author$project$Z80Env$setMem16, address, value, cpu_time, env);
				var env1 = _v3.a;
				var clockTime = _v3.b;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80,
						{B: env1}));
		}
	});
var $author$project$Z80Execute$applyTripleChangeDelta = F4(
	function (rom48k, cpu_time, z80changeData, z80) {
		var env = z80.B;
		switch (z80changeData.$) {
			case 4:
				var address = z80changeData.a;
				var value_f = z80changeData.b;
				var value = value_f(z80.u);
				var _v1 = A4($author$project$Z80Env$setMem16, address, value, cpu_time, z80.B);
				var env1 = _v1.a;
				var clockTime = _v1.b;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80,
						{B: env1}));
			case 5:
				var offset = z80changeData.a;
				var address_f = z80changeData.b;
				var value = z80changeData.c;
				var address = 65535 & (address_f(z80.u) + $author$project$Utils$byte(offset));
				var _v2 = A4($author$project$Z80Env$setMem, address, value, cpu_time, z80.B);
				var env1 = _v2.a;
				var clockTime = _v2.b;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80,
						{B: env1}));
			case 0:
				var _int = z80changeData.a;
				var main = z80.u;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80,
						{
							u: _Utils_update(
								main,
								{o: _int})
						}));
			case 2:
				var _int = z80changeData.a;
				var main = z80.u;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80,
						{
							u: _Utils_update(
								main,
								{p: _int})
						}));
			case 1:
				var _int = z80changeData.a;
				var value = A4($author$project$Z80Mem$mem16, _int, rom48k, cpu_time, env);
				var main = z80.u;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80,
						{
							u: _Utils_update(
								main,
								{o: value.bx})
						}));
			default:
				var _int = z80changeData.a;
				var value = A4($author$project$Z80Mem$mem16, _int, rom48k, cpu_time, env);
				var main = z80.u;
				return $author$project$Z80Core$CoreOnly(
					_Utils_update(
						z80,
						{
							u: _Utils_update(
								main,
								{p: value.bx})
						}));
		}
	});
var $author$project$Z80Core$CallWithPCAndDelay = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Z80Execute$applyTripleFlagChange = F2(
	function (z80changeData, z80) {
		switch (z80changeData.$) {
			case 0:
				var _int = z80changeData.a;
				var _function = z80changeData.b;
				return _function(z80.K) ? $author$project$Z80Core$JumpOnlyPC(_int) : $author$project$Z80Core$CoreOnly(z80);
			case 1:
				var address = z80changeData.a;
				var shortdelay = z80changeData.b;
				var _function = z80changeData.c;
				return _function(z80.K) ? A2($author$project$Z80Core$CallWithPCAndDelay, address, shortdelay) : $author$project$Z80Core$CoreOnly(z80);
			case 2:
				var _int = z80changeData.a;
				return $author$project$Z80Core$CallWithPC(_int);
			default:
				var _int = z80changeData.a;
				return $author$project$Z80Core$JumpOnlyPC(_int);
		}
	});
var $author$project$Z80Execute$apply_delta = F5(
	function (z80, iff, rom48k, clockTime, z80delta) {
		switch (z80delta.$) {
			case 0:
				var z80ChangeData = z80delta.a;
				return $author$project$Z80Core$CoreOnly(
					A3($author$project$Z80Execute$applyPureDelta, clockTime, z80ChangeData, z80));
			case 2:
				var registerChange = z80delta.a;
				return A4($author$project$Z80Execute$applyRegisterDelta, clockTime, registerChange, rom48k, z80);
			case 6:
				var doubleWithRegisterChange = z80delta.a;
				return $author$project$Z80Core$CoreOnly(
					A4($author$project$DoubleWithRegisters$applyDoubleWithRegistersDelta, clockTime, doubleWithRegisterChange, rom48k, z80));
			case 7:
				var singleEnvMainChange = z80delta.a;
				return $author$project$Z80Core$CoreOnly(
					A4($author$project$SingleEnvWithMain$applySingleEnvMainChange, clockTime, singleEnvMainChange, rom48k, z80));
			case 8:
				var tripleByteChange = z80delta.a;
				return A4($author$project$Z80Execute$applyTripleChangeDelta, rom48k, clockTime, tripleByteChange, z80);
			case 10:
				var threeByteChange = z80delta.a;
				if (!threeByteChange.$) {
					var tripleWithFlagsChange = threeByteChange.a;
					return A2($author$project$Z80Execute$applyTripleFlagChange, tripleWithFlagsChange, z80);
				} else {
					var tripleByteChange = threeByteChange.a;
					return A4($author$project$Z80Execute$applySimpleTripleChangeDelta, rom48k, clockTime, tripleByteChange, z80);
				}
			case 9:
				var tripleWithFlagsChange = z80delta.a;
				return A2($author$project$Z80Execute$applyTripleFlagChange, tripleWithFlagsChange, z80);
			case 11:
				var string = z80delta.a;
				var _int = z80delta.b;
				return $author$project$Z80Core$CoreOnly(
					A3(
						$author$project$Z80Debug$debugTodo,
						string,
						$author$project$Utils$toHexString2(_int),
						z80));
			case 1:
				var interruptChange = z80delta.a;
				return $author$project$Z80Core$CoreOnly(
					A3($author$project$Z80Execute$applyInterruptChange, interruptChange, iff, z80));
			case 3:
				var eDRegisterChange = z80delta.a;
				return A4($author$project$Z80Execute$applyEdRegisterDelta, clockTime, eDRegisterChange, rom48k, z80);
			case 4:
				var fourByteChnage = z80delta.a;
				return A4($author$project$Z80Execute$applyEdFourByte, clockTime, fourByteChnage, rom48k, z80);
			default:
				var twoByteChange = z80delta.a;
				if (!twoByteChange.$) {
					var single8BitChange = twoByteChange.a;
					return $author$project$Z80Core$CoreOnly(
						A4($author$project$Z80Execute$applySimple8BitDelta, clockTime, single8BitChange, rom48k, z80));
				} else {
					var jumpChange = twoByteChange.a;
					return A3($author$project$Z80Execute$applyJumpChangeDelta, clockTime, jumpChange, z80);
				}
		}
	});
var $author$project$Z80$BitManipCB = function (a) {
	return {$: 0, a: a};
};
var $author$project$Z80$EDMisc = function (a) {
	return {$: 3, a: a};
};
var $author$project$Z80$IXCB = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Z80$IYCB = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Z80$IndexIX = function (a) {
	return {$: 1, a: a};
};
var $author$project$Z80$IndexIY = function (a) {
	return {$: 2, a: a};
};
var $author$project$Z80$Ordinary = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Z80$Special = function (a) {
	return {$: 3, a: a};
};
var $author$project$Z80Execute$DoubleWithRegistersDelta = function (a) {
	return {$: 6, a: a};
};
var $author$project$PCIncrement$IncrementByFour = 3;
var $author$project$PCIncrement$IncrementByThree = 2;
var $author$project$PCIncrement$IncrementByTwo = 1;
var $author$project$Z80Execute$RegisterChangeDelta = function (a) {
	return {$: 2, a: a};
};
var $author$project$Z80Execute$Triple16ParamDelta = function (a) {
	return {$: 8, a: a};
};
var $author$project$Z80Execute$UnknownInstruction = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$RegisterChange$IndexedRegisterZ80Change = function (a) {
	return {$: 37, a: a};
};
var $author$project$RegisterChange$RegisterEnvMainChange = function (a) {
	return {$: 40, a: a};
};
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$CpuTimeCTime$EightTStates = 4;
var $author$project$RegisterChange$FlagChangeMain = function (a) {
	return {$: 25, a: a};
};
var $author$project$SimpleFlagOps$ld_b_a = F2(
	function (z80_flags, z80_main) {
		return _Utils_update(
			z80_main,
			{dw: z80_flags.bA});
	});
var $author$project$SimpleFlagOps$ld_c_a = F2(
	function (z80_flags, z80_main) {
		return _Utils_update(
			z80_main,
			{dI: z80_flags.bA});
	});
var $author$project$SimpleFlagOps$ld_d_a = F2(
	function (z80_flags, z80_main) {
		return _Utils_update(
			z80_main,
			{dN: z80_flags.bA});
	});
var $author$project$SimpleFlagOps$ld_e_a = F2(
	function (z80_flags, z80_main) {
		return _Utils_update(
			z80_main,
			{dT: z80_flags.bA});
	});
var $author$project$SimpleFlagOps$singleByteFlagsDD = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			71,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeMain($author$project$SimpleFlagOps$ld_b_a),
				4)),
			_Utils_Tuple2(
			79,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeMain($author$project$SimpleFlagOps$ld_c_a),
				4)),
			_Utils_Tuple2(
			87,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeMain($author$project$SimpleFlagOps$ld_d_a),
				4)),
			_Utils_Tuple2(
			95,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeMain($author$project$SimpleFlagOps$ld_e_a),
				4))
		]));
var $author$project$CpuTimeCTime$FifteenTStates = 11;
var $author$project$Z80Change$FlagsWithIXRegister = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$SingleMainWithFlags$add_ix_bc = F2(
	function (z80_main, z80_flags) {
		var xy = z80_main.o;
		var new_xy = A3(
			$author$project$Z80Flags$add16,
			xy,
			$author$project$Z80Types$get_bc(z80_main),
			z80_flags);
		return A2($author$project$Z80Change$FlagsWithIXRegister, new_xy.K, new_xy.e3);
	});
var $author$project$SingleMainWithFlags$add_ix_de = F2(
	function (z80_main, z80_flags) {
		var xy = z80_main.o;
		var new_xy = A3(
			$author$project$Z80Flags$add16,
			xy,
			$author$project$Z80Types$get_de(z80_main),
			z80_flags);
		return A2($author$project$Z80Change$FlagsWithIXRegister, new_xy.K, new_xy.e3);
	});
var $author$project$SingleMainWithFlags$add_ix_ix = F2(
	function (z80_main, z80_flags) {
		var new_xy = A3($author$project$Z80Flags$add16, z80_main.o, z80_main.o, z80_flags);
		return A2($author$project$Z80Change$FlagsWithIXRegister, new_xy.K, new_xy.e3);
	});
var $author$project$SingleMainWithFlags$dec_h_ix = F2(
	function (z80_main, z80_flags) {
		var value = A2(
			$author$project$Z80Flags$dec,
			$author$project$Utils$shiftRightBy8(z80_main.o),
			z80_flags);
		var new_xy = (z80_main.o & 255) | $author$project$Utils$shiftLeftBy8(value.e3);
		return A2($author$project$Z80Change$FlagsWithIXRegister, value.K, new_xy);
	});
var $author$project$SingleMainWithFlags$dec_ix_l = F2(
	function (z80_main, z80_flags) {
		var l = A2($author$project$Z80Flags$dec, z80_main.o & 255, z80_flags);
		var h = z80_main.o & 65280;
		var new_xy = h | l.e3;
		return A2($author$project$Z80Change$FlagsWithIXRegister, l.K, new_xy);
	});
var $author$project$SingleMainWithFlags$inc_h_ix = F2(
	function (z80_main, z80_flags) {
		var value = A2(
			$author$project$Z80Flags$inc,
			$author$project$Utils$shiftRightBy8(z80_main.o),
			z80_flags);
		var new_xy = (z80_main.o & 255) | $author$project$Utils$shiftLeftBy8(value.e3);
		return A2($author$project$Z80Change$FlagsWithIXRegister, value.K, new_xy);
	});
var $author$project$SingleMainWithFlags$inc_ix_l = F2(
	function (z80_main, z80_flags) {
		var l = A2($author$project$Z80Flags$inc, z80_main.o & 255, z80_flags);
		var h = z80_main.o & 65280;
		var new_xy = h | l.e3;
		return A2($author$project$Z80Change$FlagsWithIXRegister, l.K, new_xy);
	});
var $author$project$Z80Change$JustIXRegister = function (a) {
	return {$: 2, a: a};
};
var $author$project$SingleMainWithFlags$ld_ixh_a = F2(
	function (z80_main, z80_flags) {
		var l = z80_main.o & 255;
		var new_xy = $author$project$Utils$shiftLeftBy8(z80_flags.bA) | l;
		return $author$project$Z80Change$JustIXRegister(new_xy);
	});
var $author$project$SingleMainWithFlags$ld_ixl_a = F2(
	function (z80_main, z80_flags) {
		var h = z80_main.o & 65280;
		var new_xy = z80_flags.bA | h;
		return $author$project$Z80Change$JustIXRegister(new_xy);
	});
var $author$project$SingleMainWithFlags$singleByteMainAndFlagRegistersIX = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			9,
			_Utils_Tuple2($author$project$SingleMainWithFlags$add_ix_bc, 11)),
			_Utils_Tuple2(
			25,
			_Utils_Tuple2($author$project$SingleMainWithFlags$add_ix_de, 11)),
			_Utils_Tuple2(
			36,
			_Utils_Tuple2($author$project$SingleMainWithFlags$inc_h_ix, 4)),
			_Utils_Tuple2(
			37,
			_Utils_Tuple2($author$project$SingleMainWithFlags$dec_h_ix, 4)),
			_Utils_Tuple2(
			41,
			_Utils_Tuple2($author$project$SingleMainWithFlags$add_ix_ix, 11)),
			_Utils_Tuple2(
			44,
			_Utils_Tuple2($author$project$SingleMainWithFlags$inc_ix_l, 4)),
			_Utils_Tuple2(
			45,
			_Utils_Tuple2($author$project$SingleMainWithFlags$dec_ix_l, 4)),
			_Utils_Tuple2(
			103,
			_Utils_Tuple2($author$project$SingleMainWithFlags$ld_ixh_a, 4)),
			_Utils_Tuple2(
			111,
			_Utils_Tuple2($author$project$SingleMainWithFlags$ld_ixl_a, 4))
		]));
var $author$project$Z80Flags$AdcA = 0;
var $author$project$Z80Flags$AddA = 1;
var $author$project$Z80Flags$AndA = 4;
var $author$project$Z80Flags$CpA = 7;
var $author$project$RegisterChange$ExchangeTopOfStackWith = function (a) {
	return {$: 12, a: a};
};
var $author$project$Z80Types$IX = 0;
var $author$project$Z80Flags$OrA = 6;
var $author$project$RegisterChange$Pushed16BitValue = function (a) {
	return {$: 0, a: a};
};
var $author$project$RegisterChange$RegChangeNewSP = function (a) {
	return {$: 1, a: a};
};
var $author$project$RegisterChange$RegisterChangeA = function (a) {
	return {$: 14, a: a};
};
var $author$project$RegisterChange$RegisterChangeJump = function (a) {
	return {$: 4, a: a};
};
var $author$project$Z80Flags$SbcA = 3;
var $author$project$RegisterChange$SingleEnvFlagFunc = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Z80Flags$SubA = 2;
var $author$project$CpuTimeCTime$TenTStates = 6;
var $author$project$RegisterChange$TransformMainRegisters = function (a) {
	return {$: 21, a: a};
};
var $author$project$CpuTimeCTime$TwentyThreeTStates = 17;
var $author$project$Z80Flags$XorA = 5;
var $author$project$RegisterChange$RegChangeNoOp = {$: 10};
var $author$project$SimpleSingleByte$ex_de_hl = function (z80_main) {
	return A2(
		$author$project$Z80Types$set_de_main,
		z80_main.aG,
		_Utils_update(
			z80_main,
			{
				aG: $author$project$Z80Types$get_de(z80_main)
			}));
};
var $author$project$SimpleSingleByte$ld_a_c = $author$project$RegisterChange$RegisterChangeA(
	function ($) {
		return $.dI;
	});
var $author$project$SimpleSingleByte$ld_a_d = $author$project$RegisterChange$RegisterChangeA(
	function ($) {
		return $.dN;
	});
var $author$project$SimpleSingleByte$ld_a_e = $author$project$RegisterChange$RegisterChangeA(
	function ($) {
		return $.dT;
	});
var $author$project$SimpleSingleByte$ld_b_c = function (z80_main) {
	return _Utils_update(
		z80_main,
		{dw: z80_main.dI});
};
var $author$project$SimpleSingleByte$ld_b_d = function (z80_main) {
	return _Utils_update(
		z80_main,
		{dw: z80_main.dN});
};
var $author$project$SimpleSingleByte$ld_b_e = function (z80_main) {
	return _Utils_update(
		z80_main,
		{dw: z80_main.dT});
};
var $author$project$SimpleSingleByte$ld_c_b = function (z80_main) {
	return _Utils_update(
		z80_main,
		{dI: z80_main.dw});
};
var $author$project$SimpleSingleByte$ld_c_d = function (z80_main) {
	return _Utils_update(
		z80_main,
		{dI: z80_main.dN});
};
var $author$project$SimpleSingleByte$ld_c_e = function (z80_main) {
	return _Utils_update(
		z80_main,
		{dI: z80_main.dT});
};
var $author$project$SimpleSingleByte$ld_d_b = function (z80_main) {
	return _Utils_update(
		z80_main,
		{dN: z80_main.dw});
};
var $author$project$SimpleSingleByte$ld_d_c = function (z80_main) {
	return _Utils_update(
		z80_main,
		{dN: z80_main.dI});
};
var $author$project$SimpleSingleByte$ld_d_e = function (z80_main) {
	return _Utils_update(
		z80_main,
		{dN: z80_main.dT});
};
var $author$project$SimpleSingleByte$ld_e_b = function (z80_main) {
	return _Utils_update(
		z80_main,
		{dT: z80_main.dw});
};
var $author$project$SimpleSingleByte$ld_e_c = function (z80_main) {
	return _Utils_update(
		z80_main,
		{dT: z80_main.dI});
};
var $author$project$SimpleSingleByte$ld_e_d = function (z80_main) {
	return _Utils_update(
		z80_main,
		{dT: z80_main.dN});
};
var $author$project$SimpleSingleByte$commonDDFDOps = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			64,
			_Utils_Tuple2($author$project$RegisterChange$RegChangeNoOp, 4)),
			_Utils_Tuple2(
			65,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_b_c),
				4)),
			_Utils_Tuple2(
			66,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_b_d),
				4)),
			_Utils_Tuple2(
			67,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_b_e),
				4)),
			_Utils_Tuple2(
			72,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_c_b),
				4)),
			_Utils_Tuple2(
			73,
			_Utils_Tuple2($author$project$RegisterChange$RegChangeNoOp, 4)),
			_Utils_Tuple2(
			74,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_c_d),
				4)),
			_Utils_Tuple2(
			75,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_c_e),
				4)),
			_Utils_Tuple2(
			80,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_d_b),
				4)),
			_Utils_Tuple2(
			81,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_d_c),
				4)),
			_Utils_Tuple2(
			82,
			_Utils_Tuple2($author$project$RegisterChange$RegChangeNoOp, 4)),
			_Utils_Tuple2(
			83,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_d_e),
				4)),
			_Utils_Tuple2(
			88,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_e_b),
				4)),
			_Utils_Tuple2(
			89,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_e_c),
				4)),
			_Utils_Tuple2(
			90,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_e_d),
				4)),
			_Utils_Tuple2(
			91,
			_Utils_Tuple2($author$project$RegisterChange$RegChangeNoOp, 4)),
			_Utils_Tuple2(
			120,
			_Utils_Tuple2(
				$author$project$RegisterChange$RegisterChangeA(
					function ($) {
						return $.dw;
					}),
				4)),
			_Utils_Tuple2(
			121,
			_Utils_Tuple2($author$project$SimpleSingleByte$ld_a_c, 4)),
			_Utils_Tuple2(
			122,
			_Utils_Tuple2($author$project$SimpleSingleByte$ld_a_d, 4)),
			_Utils_Tuple2(
			123,
			_Utils_Tuple2($author$project$SimpleSingleByte$ld_a_e, 4)),
			_Utils_Tuple2(
			100,
			_Utils_Tuple2($author$project$RegisterChange$RegChangeNoOp, 4)),
			_Utils_Tuple2(
			109,
			_Utils_Tuple2($author$project$RegisterChange$RegChangeNoOp, 4)),
			_Utils_Tuple2(
			127,
			_Utils_Tuple2($author$project$RegisterChange$RegChangeNoOp, 4)),
			_Utils_Tuple2(
			235,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ex_de_hl),
				0))
		]));
var $author$project$SimpleSingleByte$dec_ix = function (z80_main) {
	return _Utils_update(
		z80_main,
		{o: (z80_main.o - 1) & 65535});
};
var $author$project$Z80Types$get_ixh = function (z80_main) {
	return $author$project$Utils$shiftRightBy8(z80_main.o);
};
var $author$project$Z80Types$get_ixl = function (z80_main) {
	return z80_main.o & 255;
};
var $author$project$SimpleSingleByte$inc_ix = function (z80_main) {
	return _Utils_update(
		z80_main,
		{o: (z80_main.o + 1) & 65535});
};
var $author$project$SimpleSingleByte$ld_b_h = F2(
	function (hlf, z80_main) {
		return _Utils_update(
			z80_main,
			{
				dw: $author$project$Utils$shiftRightBy8(
					hlf(z80_main))
			});
	});
var $author$project$SimpleSingleByte$ld_b_l = F2(
	function (hlf, z80_main) {
		return _Utils_update(
			z80_main,
			{
				dw: hlf(z80_main) & 255
			});
	});
var $author$project$SimpleSingleByte$ld_c_h = F2(
	function (hlf, z80_main) {
		return _Utils_update(
			z80_main,
			{
				dI: $author$project$Utils$shiftRightBy8(
					hlf(z80_main))
			});
	});
var $author$project$SimpleSingleByte$ld_c_l = F2(
	function (hlf, z80_main) {
		return _Utils_update(
			z80_main,
			{
				dI: hlf(z80_main) & 255
			});
	});
var $author$project$SimpleSingleByte$ld_d_ix_h = function (z80_main) {
	return _Utils_update(
		z80_main,
		{
			dN: $author$project$Utils$shiftRightBy8(z80_main.o)
		});
};
var $author$project$SimpleSingleByte$ld_d_ix_l = function (z80_main) {
	return _Utils_update(
		z80_main,
		{dN: z80_main.o & 255});
};
var $author$project$SimpleSingleByte$ld_e_ix_h = function (z80_main) {
	return _Utils_update(
		z80_main,
		{
			dT: $author$project$Utils$shiftRightBy8(z80_main.o)
		});
};
var $author$project$SimpleSingleByte$ld_e_ix_l = function (z80_main) {
	return _Utils_update(
		z80_main,
		{dT: z80_main.o & 255});
};
var $author$project$SimpleSingleByte$set_ix_h = F2(
	function (_int, main) {
		return _Utils_update(
			main,
			{
				o: (main.o & 255) | $author$project$Utils$shiftLeftBy8(_int)
			});
	});
var $author$project$SimpleSingleByte$set_ix_l = F2(
	function (_int, main) {
		return _Utils_update(
			main,
			{o: (main.o & 65280) | _int});
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $author$project$SimpleSingleByte$singleByteMainRegsDD = A2(
	$elm$core$Dict$union,
	$author$project$SimpleSingleByte$commonDDFDOps,
	$elm$core$Dict$fromList(
		_List_fromArray(
			[
				_Utils_Tuple2(
				35,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$inc_ix),
					6)),
				_Utils_Tuple2(
				43,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$dec_ix),
					6)),
				_Utils_Tuple2(
				68,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						$author$project$SimpleSingleByte$ld_b_h(
							function ($) {
								return $.o;
							})),
					4)),
				_Utils_Tuple2(
				69,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						$author$project$SimpleSingleByte$ld_b_l(
							function ($) {
								return $.o;
							})),
					4)),
				_Utils_Tuple2(
				76,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						$author$project$SimpleSingleByte$ld_c_h(
							function ($) {
								return $.o;
							})),
					4)),
				_Utils_Tuple2(
				77,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						$author$project$SimpleSingleByte$ld_c_l(
							function ($) {
								return $.o;
							})),
					4)),
				_Utils_Tuple2(
				84,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_d_ix_h),
					4)),
				_Utils_Tuple2(
				85,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_d_ix_l),
					4)),
				_Utils_Tuple2(
				92,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_e_ix_h),
					4)),
				_Utils_Tuple2(
				93,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_e_ix_l),
					4)),
				_Utils_Tuple2(
				96,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2($author$project$SimpleSingleByte$set_ix_h, main.dw, main);
						}),
					4)),
				_Utils_Tuple2(
				97,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2($author$project$SimpleSingleByte$set_ix_h, main.dI, main);
						}),
					4)),
				_Utils_Tuple2(
				98,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2($author$project$SimpleSingleByte$set_ix_h, main.dN, main);
						}),
					4)),
				_Utils_Tuple2(
				99,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2($author$project$SimpleSingleByte$set_ix_h, main.dT, main);
						}),
					4)),
				_Utils_Tuple2(
				101,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2($author$project$SimpleSingleByte$set_ix_h, main.o & 255, main);
						}),
					4)),
				_Utils_Tuple2(
				104,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2($author$project$SimpleSingleByte$set_ix_l, main.dw, main);
						}),
					4)),
				_Utils_Tuple2(
				105,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2($author$project$SimpleSingleByte$set_ix_l, main.dI, main);
						}),
					4)),
				_Utils_Tuple2(
				106,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2($author$project$SimpleSingleByte$set_ix_l, main.dN, main);
						}),
					4)),
				_Utils_Tuple2(
				107,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2($author$project$SimpleSingleByte$set_ix_l, main.dT, main);
						}),
					4)),
				_Utils_Tuple2(
				108,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2(
								$author$project$SimpleSingleByte$set_ix_l,
								$author$project$Utils$shiftRightBy8(main.o),
								main);
						}),
					4)),
				_Utils_Tuple2(
				124,
				_Utils_Tuple2(
					$author$project$RegisterChange$RegisterChangeA($author$project$Z80Types$get_ixh),
					4)),
				_Utils_Tuple2(
				125,
				_Utils_Tuple2(
					$author$project$RegisterChange$RegisterChangeA($author$project$Z80Types$get_ixl),
					4)),
				_Utils_Tuple2(
				132,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 1, $author$project$Z80Types$get_ixh),
					4)),
				_Utils_Tuple2(
				133,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 1, $author$project$Z80Types$get_ixl),
					4)),
				_Utils_Tuple2(
				140,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 0, $author$project$Z80Types$get_ixh),
					4)),
				_Utils_Tuple2(
				141,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 0, $author$project$Z80Types$get_ixl),
					4)),
				_Utils_Tuple2(
				148,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 2, $author$project$Z80Types$get_ixh),
					4)),
				_Utils_Tuple2(
				149,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 2, $author$project$Z80Types$get_ixl),
					4)),
				_Utils_Tuple2(
				156,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 3, $author$project$Z80Types$get_ixh),
					4)),
				_Utils_Tuple2(
				157,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 3, $author$project$Z80Types$get_ixl),
					4)),
				_Utils_Tuple2(
				164,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 4, $author$project$Z80Types$get_ixh),
					4)),
				_Utils_Tuple2(
				165,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 4, $author$project$Z80Types$get_ixl),
					4)),
				_Utils_Tuple2(
				172,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 5, $author$project$Z80Types$get_ixh),
					4)),
				_Utils_Tuple2(
				173,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 5, $author$project$Z80Types$get_ixl),
					4)),
				_Utils_Tuple2(
				180,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 6, $author$project$Z80Types$get_ixh),
					4)),
				_Utils_Tuple2(
				181,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 6, $author$project$Z80Types$get_ixl),
					4)),
				_Utils_Tuple2(
				188,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 7, $author$project$Z80Types$get_ixh),
					4)),
				_Utils_Tuple2(
				189,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 7, $author$project$Z80Types$get_ixl),
					4)),
				_Utils_Tuple2(
				227,
				_Utils_Tuple2(
					$author$project$RegisterChange$ExchangeTopOfStackWith(0),
					17)),
				_Utils_Tuple2(
				229,
				_Utils_Tuple2(
					$author$project$RegisterChange$Pushed16BitValue(
						function ($) {
							return $.o;
						}),
					11)),
				_Utils_Tuple2(
				233,
				_Utils_Tuple2(
					$author$project$RegisterChange$RegisterChangeJump(
						function ($) {
							return $.o;
						}),
					4)),
				_Utils_Tuple2(
				249,
				_Utils_Tuple2(
					$author$project$RegisterChange$RegChangeNewSP(
						function ($) {
							return $.o;
						}),
					6))
			])));
var $author$project$SingleEnvWithMain$SingleEnvNewHL16BitAdd = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$SingleEnvWithMain$add_ix_sp = F3(
	function (z80_main, rom48k, z80_env) {
		return A3($author$project$SingleEnvWithMain$SingleEnvNewHL16BitAdd, 0, z80_main.o, z80_env.eN);
	});
var $author$project$SingleEnvWithMain$singleEnvMainRegsIX = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			57,
			_Utils_Tuple2($author$project$SingleEnvWithMain$add_ix_sp, 11))
		]));
var $author$project$CpuTimeCTime$FourteenTStates = 10;
var $author$project$RegisterChange$PopIX = {$: 31};
var $author$project$SingleNoParams$singleWithNoParamDD = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			225,
			_Utils_Tuple2($author$project$RegisterChange$PopIX, 10))
		]));
var $author$project$Z80OpCode$singleByteMainFlagsRegsIX = A2(
	$elm$core$Dict$union,
	A2(
		$elm$core$Dict$map,
		F2(
			function (_v2, _v3) {
				var f = _v3.a;
				var duration = _v3.b;
				return _Utils_Tuple2(
					$author$project$RegisterChange$RegisterEnvMainChange(f),
					duration);
			}),
		$author$project$SingleEnvWithMain$singleEnvMainRegsIX),
	A2(
		$elm$core$Dict$union,
		A2(
			$elm$core$Dict$map,
			F2(
				function (_v0, _v1) {
					var f = _v1.a;
					var duration = _v1.b;
					return _Utils_Tuple2(
						$author$project$RegisterChange$IndexedRegisterZ80Change(f),
						duration);
				}),
			$author$project$SingleMainWithFlags$singleByteMainAndFlagRegistersIX),
		A2(
			$elm$core$Dict$union,
			$author$project$SingleNoParams$singleWithNoParamDD,
			A2($elm$core$Dict$union, $author$project$SimpleSingleByte$singleByteMainRegsDD, $author$project$SimpleFlagOps$singleByteFlagsDD))));
var $author$project$CpuTimeCTime$TwentyTStates = 16;
var $author$project$TripleByte$NewIXIndirect = function (a) {
	return {$: 1, a: a};
};
var $author$project$TripleByte$ld_ix_indirect_nn = function (param16) {
	return $author$project$TripleByte$NewIXIndirect(param16);
};
var $author$project$TripleByte$NewIXRegister = function (a) {
	return {$: 0, a: a};
};
var $author$project$TripleByte$ld_ix_nn = function (param16) {
	return $author$project$TripleByte$NewIXRegister(param16);
};
var $author$project$TripleByte$tripleByteWith16BitParamDD = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			33,
			_Utils_Tuple2($author$project$TripleByte$ld_ix_nn, 16)),
			_Utils_Tuple2(
			42,
			_Utils_Tuple2($author$project$TripleByte$ld_ix_indirect_nn, 16))
		]));
var $author$project$TripleByte$Store8BitValue = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$TripleWithMain$ld_indirect_ix_n = function (param16) {
	var value = $author$project$Utils$shiftRightBy8(param16);
	var offset = 255 & param16;
	return A3(
		$author$project$TripleByte$Store8BitValue,
		offset,
		function ($) {
			return $.o;
		},
		value);
};
var $author$project$TripleByte$Store16BitValue = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$TripleWithMain$ld_nn_indirect_ix = function (param16) {
	return A2(
		$author$project$TripleByte$Store16BitValue,
		param16,
		function ($) {
			return $.o;
		});
};
var $author$project$TripleWithMain$tripleMainRegsIXFour = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			34,
			_Utils_Tuple2($author$project$TripleWithMain$ld_nn_indirect_ix, 16)),
			_Utils_Tuple2(
			54,
			_Utils_Tuple2($author$project$TripleWithMain$ld_indirect_ix_n, 16))
		]));
var $author$project$Z80OpCode$threeByteWithRegistersIX = A2($elm$core$Dict$union, $author$project$TripleWithMain$tripleMainRegsIXFour, $author$project$TripleByte$tripleByteWith16BitParamDD);
var $author$project$Z80Registers$ChangeMainB = 0;
var $author$project$Z80Registers$ChangeMainC = 1;
var $author$project$Z80Registers$ChangeMainD = 2;
var $author$project$Z80Registers$ChangeMainE = 3;
var $author$project$Z80Registers$ChangeMainH = 4;
var $author$project$Z80Registers$ChangeMainL = 5;
var $author$project$CpuTimeCTime$ElevenTStates = 7;
var $author$project$DoubleWithRegisters$FlagOpIndexedIndirect = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$DoubleWithRegisters$NewRegisterIndirect = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$CpuTimeCTime$NineteenTStates = 15;
var $author$project$CpuTimeCTime$SevenTStates = 3;
var $author$project$DoubleWithRegisters$IndexedIndirectDecrement = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$DoubleWithRegisters$dec_indirect_ix = function (param) {
	return A2(
		$author$project$DoubleWithRegisters$IndexedIndirectDecrement,
		function ($) {
			return $.o;
		},
		param);
};
var $author$project$DoubleWithRegisters$IndexedIndirectIncrement = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$DoubleWithRegisters$inc_indirect_ix = function (param) {
	return A2(
		$author$project$DoubleWithRegisters$IndexedIndirectIncrement,
		function ($) {
			return $.o;
		},
		param);
};
var $author$project$DoubleWithRegisters$NewARegisterIndirect = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$DoubleWithRegisters$ld_a_indirect_ix = function (param) {
	return A2(
		$author$project$DoubleWithRegisters$NewARegisterIndirect,
		function ($) {
			return $.o;
		},
		param);
};
var $author$project$DoubleWithRegisters$SetARegisterIndirect = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$DoubleWithRegisters$ld_indirect_ix_a = function (param) {
	return A2(
		$author$project$DoubleWithRegisters$SetARegisterIndirect,
		function ($) {
			return $.o;
		},
		param);
};
var $author$project$DoubleWithRegisters$NewIXHRegisterValue = function (a) {
	return {$: 0, a: a};
};
var $author$project$DoubleWithRegisters$ld_ix_h_n = function (param) {
	return $author$project$DoubleWithRegisters$NewIXHRegisterValue(param);
};
var $author$project$DoubleWithRegisters$NewIXLRegisterValue = function (a) {
	return {$: 1, a: a};
};
var $author$project$DoubleWithRegisters$ld_ix_l_n = function (param) {
	return $author$project$DoubleWithRegisters$NewIXLRegisterValue(param);
};
var $author$project$DoubleWithRegisters$doubleWithRegistersIX = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			38,
			_Utils_Tuple2($author$project$DoubleWithRegisters$ld_ix_h_n, 7)),
			_Utils_Tuple2(
			46,
			_Utils_Tuple2($author$project$DoubleWithRegisters$ld_ix_l_n, 7)),
			_Utils_Tuple2(
			52,
			_Utils_Tuple2($author$project$DoubleWithRegisters$inc_indirect_ix, 17)),
			_Utils_Tuple2(
			53,
			_Utils_Tuple2($author$project$DoubleWithRegisters$dec_indirect_ix, 17)),
			_Utils_Tuple2(
			70,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$NewRegisterIndirect,
						0,
						function ($) {
							return $.o;
						},
						param);
				},
				3)),
			_Utils_Tuple2(
			78,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$NewRegisterIndirect,
						1,
						function ($) {
							return $.o;
						},
						param);
				},
				3)),
			_Utils_Tuple2(
			86,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$NewRegisterIndirect,
						2,
						function ($) {
							return $.o;
						},
						param);
				},
				3)),
			_Utils_Tuple2(
			94,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$NewRegisterIndirect,
						3,
						function ($) {
							return $.o;
						},
						param);
				},
				3)),
			_Utils_Tuple2(
			102,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$NewRegisterIndirect,
						4,
						function ($) {
							return $.o;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			110,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$NewRegisterIndirect,
						5,
						function ($) {
							return $.o;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			134,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$FlagOpIndexedIndirect,
						1,
						function ($) {
							return $.o;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			142,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$FlagOpIndexedIndirect,
						0,
						function ($) {
							return $.o;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			150,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$FlagOpIndexedIndirect,
						2,
						function ($) {
							return $.o;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			158,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$FlagOpIndexedIndirect,
						3,
						function ($) {
							return $.o;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			166,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$FlagOpIndexedIndirect,
						4,
						function ($) {
							return $.o;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			174,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$FlagOpIndexedIndirect,
						5,
						function ($) {
							return $.o;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			182,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$FlagOpIndexedIndirect,
						6,
						function ($) {
							return $.o;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			190,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$FlagOpIndexedIndirect,
						7,
						function ($) {
							return $.o;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			119,
			_Utils_Tuple2($author$project$DoubleWithRegisters$ld_indirect_ix_a, 15)),
			_Utils_Tuple2(
			126,
			_Utils_Tuple2($author$project$DoubleWithRegisters$ld_a_indirect_ix, 15))
		]));
var $author$project$DoubleWithRegisters$RegStore8BitValue = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$TripleWithMain$store_reg_indirect = F3(
	function (param, source, dest) {
		return A3($author$project$DoubleWithRegisters$RegStore8BitValue, param, source, dest);
	});
var $author$project$TripleWithMain$tripleMainRegsIXThree = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			112,
			_Utils_Tuple2(
				function (offset) {
					return A3(
						$author$project$TripleWithMain$store_reg_indirect,
						offset,
						function ($) {
							return $.o;
						},
						function ($) {
							return $.dw;
						});
				},
				15)),
			_Utils_Tuple2(
			113,
			_Utils_Tuple2(
				function (param16) {
					return A3(
						$author$project$TripleWithMain$store_reg_indirect,
						param16,
						function ($) {
							return $.o;
						},
						function ($) {
							return $.dI;
						});
				},
				15)),
			_Utils_Tuple2(
			114,
			_Utils_Tuple2(
				function (param16) {
					return A3(
						$author$project$TripleWithMain$store_reg_indirect,
						param16,
						function ($) {
							return $.o;
						},
						function ($) {
							return $.dN;
						});
				},
				15)),
			_Utils_Tuple2(
			115,
			_Utils_Tuple2(
				function (param16) {
					return A3(
						$author$project$TripleWithMain$store_reg_indirect,
						param16,
						function ($) {
							return $.o;
						},
						function ($) {
							return $.dT;
						});
				},
				15)),
			_Utils_Tuple2(
			116,
			_Utils_Tuple2(
				function (param16) {
					return A3(
						$author$project$TripleWithMain$store_reg_indirect,
						param16,
						function ($) {
							return $.o;
						},
						function (z80_main) {
							return $author$project$Utils$shiftRightBy8(z80_main.aG);
						});
				},
				15)),
			_Utils_Tuple2(
			117,
			_Utils_Tuple2(
				function (param16) {
					return A3(
						$author$project$TripleWithMain$store_reg_indirect,
						param16,
						function ($) {
							return $.o;
						},
						function (z80_main) {
							return 255 & z80_main.aG;
						});
				},
				15))
		]));
var $author$project$Z80OpCode$twoByteWithRegistersIX = A2($elm$core$Dict$union, $author$project$TripleWithMain$tripleMainRegsIXThree, $author$project$DoubleWithRegisters$doubleWithRegistersIX);
var $author$project$Z80$runIndexIX = F4(
	function (param, rom48k, pc, z80) {
		var _v0 = A2($elm$core$Dict$get, param.e3, $author$project$Z80OpCode$singleByteMainFlagsRegsIX);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var mainRegFunc = _v1.a;
			var duration = _v1.b;
			return _Utils_Tuple3(
				$author$project$Z80Execute$RegisterChangeDelta(mainRegFunc),
				A2($author$project$CpuTimeCTime$addDuration, duration, param.aQ),
				1);
		} else {
			var _v2 = A2($elm$core$Dict$get, param.e3, $author$project$Z80OpCode$twoByteWithRegistersIX);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var f = _v3.a;
				var duration = _v3.b;
				var time = A2($author$project$CpuTimeCTime$addDuration, duration, param.aQ);
				var doubleParamTimeValue = A4($author$project$Z80Mem$mem, (pc + 2) & 65535, time, rom48k, z80.B);
				return _Utils_Tuple3(
					$author$project$Z80Execute$DoubleWithRegistersDelta(
						f(doubleParamTimeValue.e3)),
					doubleParamTimeValue.aQ,
					2);
			} else {
				var _v4 = A2($elm$core$Dict$get, param.e3, $author$project$Z80OpCode$threeByteWithRegistersIX);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var f = _v5.a;
					var duration = _v5.b;
					var env_1 = A2($author$project$CpuTimeCTime$addDuration, duration, param.aQ);
					var doubleParam = A4($author$project$Z80Mem$mem16, (pc + 2) & 65535, rom48k, env_1, z80.B);
					return _Utils_Tuple3(
						$author$project$Z80Execute$Triple16ParamDelta(
							f(doubleParam.bx)),
						doubleParam.aQ,
						3);
				} else {
					return _Utils_Tuple3(
						A2($author$project$Z80Execute$UnknownInstruction, 'execute IndexIX', param.e3),
						param.aQ,
						1);
				}
			}
		}
	});
var $author$project$SimpleFlagOps$singleByteFlagsFD = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			71,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeMain($author$project$SimpleFlagOps$ld_b_a),
				4)),
			_Utils_Tuple2(
			79,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeMain($author$project$SimpleFlagOps$ld_c_a),
				4)),
			_Utils_Tuple2(
			87,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeMain($author$project$SimpleFlagOps$ld_d_a),
				4)),
			_Utils_Tuple2(
			95,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeMain($author$project$SimpleFlagOps$ld_e_a),
				4))
		]));
var $author$project$Z80Change$FlagsWithIYRegister = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$SingleMainWithFlags$add_iy_bc = F2(
	function (z80_main, z80_flags) {
		var xy = z80_main.p;
		var new_xy = A3(
			$author$project$Z80Flags$add16,
			xy,
			$author$project$Z80Types$get_bc(z80_main),
			z80_flags);
		return A2($author$project$Z80Change$FlagsWithIYRegister, new_xy.K, new_xy.e3);
	});
var $author$project$SingleMainWithFlags$add_iy_de = F2(
	function (z80_main, z80_flags) {
		var xy = z80_main.p;
		var new_xy = A3(
			$author$project$Z80Flags$add16,
			xy,
			$author$project$Z80Types$get_de(z80_main),
			z80_flags);
		return A2($author$project$Z80Change$FlagsWithIYRegister, new_xy.K, new_xy.e3);
	});
var $author$project$SingleMainWithFlags$add_iy_iy = F2(
	function (z80_main, z80_flags) {
		var new_xy = A3($author$project$Z80Flags$add16, z80_main.p, z80_main.p, z80_flags);
		return A2($author$project$Z80Change$FlagsWithIYRegister, new_xy.K, new_xy.e3);
	});
var $author$project$SingleMainWithFlags$dec_h_iy = F2(
	function (z80_main, z80_flags) {
		var value = A2(
			$author$project$Z80Flags$dec,
			$author$project$Utils$shiftRightBy8(z80_main.p),
			z80_flags);
		var new_xy = (z80_main.p & 255) | $author$project$Utils$shiftLeftBy8(value.e3);
		return A2($author$project$Z80Change$FlagsWithIYRegister, value.K, new_xy);
	});
var $author$project$SingleMainWithFlags$dec_iy_l = F2(
	function (z80_main, z80_flags) {
		var l = A2($author$project$Z80Flags$dec, z80_main.p & 255, z80_flags);
		var h = z80_main.p & 65280;
		var new_xy = h | l.e3;
		return A2($author$project$Z80Change$FlagsWithIYRegister, l.K, new_xy);
	});
var $author$project$SingleMainWithFlags$inc_h_iy = F2(
	function (z80_main, z80_flags) {
		var value = A2(
			$author$project$Z80Flags$inc,
			$author$project$Utils$shiftRightBy8(z80_main.p),
			z80_flags);
		var new_xy = (z80_main.p & 255) | $author$project$Utils$shiftLeftBy8(value.e3);
		return A2($author$project$Z80Change$FlagsWithIYRegister, value.K, new_xy);
	});
var $author$project$SingleMainWithFlags$inc_iy_l = F2(
	function (z80_main, z80_flags) {
		var l = A2($author$project$Z80Flags$inc, z80_main.p & 255, z80_flags);
		var h = z80_main.p & 65280;
		var new_xy = h | l.e3;
		return A2($author$project$Z80Change$FlagsWithIYRegister, l.K, new_xy);
	});
var $author$project$Z80Change$JustIYRegister = function (a) {
	return {$: 3, a: a};
};
var $author$project$SingleMainWithFlags$ld_iyh_a = F2(
	function (z80_main, z80_flags) {
		var l = z80_main.p & 255;
		var new_xy = $author$project$Utils$shiftLeftBy8(z80_flags.bA) | l;
		return $author$project$Z80Change$JustIYRegister(new_xy);
	});
var $author$project$SingleMainWithFlags$ld_iyl_a = F2(
	function (z80_main, z80_flags) {
		var h = z80_main.p & 65280;
		var new_xy = z80_flags.bA | h;
		return $author$project$Z80Change$JustIYRegister(new_xy);
	});
var $author$project$SingleMainWithFlags$singleByteMainAndFlagRegistersIY = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			9,
			_Utils_Tuple2($author$project$SingleMainWithFlags$add_iy_bc, 11)),
			_Utils_Tuple2(
			25,
			_Utils_Tuple2($author$project$SingleMainWithFlags$add_iy_de, 11)),
			_Utils_Tuple2(
			36,
			_Utils_Tuple2($author$project$SingleMainWithFlags$inc_h_iy, 4)),
			_Utils_Tuple2(
			37,
			_Utils_Tuple2($author$project$SingleMainWithFlags$dec_h_iy, 4)),
			_Utils_Tuple2(
			41,
			_Utils_Tuple2($author$project$SingleMainWithFlags$add_iy_iy, 11)),
			_Utils_Tuple2(
			44,
			_Utils_Tuple2($author$project$SingleMainWithFlags$inc_iy_l, 4)),
			_Utils_Tuple2(
			45,
			_Utils_Tuple2($author$project$SingleMainWithFlags$dec_iy_l, 4)),
			_Utils_Tuple2(
			103,
			_Utils_Tuple2($author$project$SingleMainWithFlags$ld_iyh_a, 4)),
			_Utils_Tuple2(
			111,
			_Utils_Tuple2($author$project$SingleMainWithFlags$ld_iyl_a, 4))
		]));
var $author$project$Z80Types$IY = 1;
var $author$project$SimpleSingleByte$dec_iy = function (z80_main) {
	return _Utils_update(
		z80_main,
		{p: (z80_main.p - 1) & 65535});
};
var $author$project$Z80Types$get_iyh = function (z80_main) {
	return $author$project$Utils$shiftRightBy8(z80_main.p);
};
var $author$project$Z80Types$get_iyl = function (z80_main) {
	return z80_main.p & 255;
};
var $author$project$SimpleSingleByte$inc_iy = function (z80_main) {
	return _Utils_update(
		z80_main,
		{p: (z80_main.p + 1) & 65535});
};
var $author$project$SimpleSingleByte$ld_d_iy_h = function (z80_main) {
	return _Utils_update(
		z80_main,
		{
			dN: $author$project$Utils$shiftRightBy8(z80_main.p)
		});
};
var $author$project$SimpleSingleByte$ld_d_iy_l = function (z80_main) {
	return _Utils_update(
		z80_main,
		{dN: z80_main.p & 255});
};
var $author$project$SimpleSingleByte$ld_e_iy_h = function (z80_main) {
	return _Utils_update(
		z80_main,
		{
			dT: $author$project$Utils$shiftRightBy8(z80_main.p)
		});
};
var $author$project$SimpleSingleByte$ld_e_iy_l = function (z80_main) {
	return _Utils_update(
		z80_main,
		{dT: z80_main.p & 255});
};
var $author$project$SimpleSingleByte$set_iy_h = F2(
	function (_int, main) {
		return _Utils_update(
			main,
			{
				p: (main.p & 255) | $author$project$Utils$shiftLeftBy8(_int)
			});
	});
var $author$project$SimpleSingleByte$set_iy_l = F2(
	function (_int, main) {
		return _Utils_update(
			main,
			{p: (main.p & 65280) | _int});
	});
var $author$project$SimpleSingleByte$singleByteMainRegsFD = A2(
	$elm$core$Dict$union,
	$author$project$SimpleSingleByte$commonDDFDOps,
	$elm$core$Dict$fromList(
		_List_fromArray(
			[
				_Utils_Tuple2(
				35,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$inc_iy),
					6)),
				_Utils_Tuple2(
				43,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$dec_iy),
					6)),
				_Utils_Tuple2(
				68,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						$author$project$SimpleSingleByte$ld_b_h(
							function ($) {
								return $.p;
							})),
					4)),
				_Utils_Tuple2(
				69,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						$author$project$SimpleSingleByte$ld_b_l(
							function ($) {
								return $.p;
							})),
					4)),
				_Utils_Tuple2(
				76,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						$author$project$SimpleSingleByte$ld_c_h(
							function ($) {
								return $.p;
							})),
					4)),
				_Utils_Tuple2(
				77,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						$author$project$SimpleSingleByte$ld_c_l(
							function ($) {
								return $.p;
							})),
					4)),
				_Utils_Tuple2(
				84,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_d_iy_h),
					4)),
				_Utils_Tuple2(
				85,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_d_iy_l),
					4)),
				_Utils_Tuple2(
				92,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_e_iy_h),
					4)),
				_Utils_Tuple2(
				93,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_e_iy_l),
					4)),
				_Utils_Tuple2(
				96,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2($author$project$SimpleSingleByte$set_iy_h, main.dw, main);
						}),
					4)),
				_Utils_Tuple2(
				97,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2($author$project$SimpleSingleByte$set_iy_h, main.dI, main);
						}),
					4)),
				_Utils_Tuple2(
				98,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2($author$project$SimpleSingleByte$set_iy_h, main.dN, main);
						}),
					4)),
				_Utils_Tuple2(
				99,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2($author$project$SimpleSingleByte$set_iy_h, main.dT, main);
						}),
					4)),
				_Utils_Tuple2(
				101,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2($author$project$SimpleSingleByte$set_iy_h, main.p & 255, main);
						}),
					4)),
				_Utils_Tuple2(
				104,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2($author$project$SimpleSingleByte$set_iy_l, main.dw, main);
						}),
					4)),
				_Utils_Tuple2(
				105,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2($author$project$SimpleSingleByte$set_iy_l, main.dI, main);
						}),
					4)),
				_Utils_Tuple2(
				106,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2($author$project$SimpleSingleByte$set_iy_l, main.dN, main);
						}),
					4)),
				_Utils_Tuple2(
				107,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2($author$project$SimpleSingleByte$set_iy_l, main.dT, main);
						}),
					4)),
				_Utils_Tuple2(
				108,
				_Utils_Tuple2(
					$author$project$RegisterChange$TransformMainRegisters(
						function (main) {
							return A2(
								$author$project$SimpleSingleByte$set_iy_l,
								$author$project$Utils$shiftRightBy8(main.p),
								main);
						}),
					4)),
				_Utils_Tuple2(
				124,
				_Utils_Tuple2(
					$author$project$RegisterChange$RegisterChangeA($author$project$Z80Types$get_iyh),
					4)),
				_Utils_Tuple2(
				125,
				_Utils_Tuple2(
					$author$project$RegisterChange$RegisterChangeA($author$project$Z80Types$get_iyl),
					4)),
				_Utils_Tuple2(
				132,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 1, $author$project$Z80Types$get_iyh),
					4)),
				_Utils_Tuple2(
				133,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 1, $author$project$Z80Types$get_iyl),
					4)),
				_Utils_Tuple2(
				140,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 0, $author$project$Z80Types$get_iyh),
					4)),
				_Utils_Tuple2(
				141,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 0, $author$project$Z80Types$get_iyl),
					4)),
				_Utils_Tuple2(
				148,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 2, $author$project$Z80Types$get_iyh),
					4)),
				_Utils_Tuple2(
				149,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 2, $author$project$Z80Types$get_iyl),
					4)),
				_Utils_Tuple2(
				156,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 3, $author$project$Z80Types$get_iyh),
					4)),
				_Utils_Tuple2(
				157,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 3, $author$project$Z80Types$get_iyl),
					4)),
				_Utils_Tuple2(
				164,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 4, $author$project$Z80Types$get_iyh),
					4)),
				_Utils_Tuple2(
				165,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 4, $author$project$Z80Types$get_iyl),
					4)),
				_Utils_Tuple2(
				172,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 5, $author$project$Z80Types$get_iyh),
					4)),
				_Utils_Tuple2(
				173,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 5, $author$project$Z80Types$get_iyl),
					4)),
				_Utils_Tuple2(
				180,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 6, $author$project$Z80Types$get_iyh),
					4)),
				_Utils_Tuple2(
				181,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 6, $author$project$Z80Types$get_iyl),
					4)),
				_Utils_Tuple2(
				188,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 7, $author$project$Z80Types$get_iyh),
					4)),
				_Utils_Tuple2(
				189,
				_Utils_Tuple2(
					A2($author$project$RegisterChange$SingleEnvFlagFunc, 7, $author$project$Z80Types$get_iyl),
					4)),
				_Utils_Tuple2(
				227,
				_Utils_Tuple2(
					$author$project$RegisterChange$ExchangeTopOfStackWith(1),
					17)),
				_Utils_Tuple2(
				229,
				_Utils_Tuple2(
					$author$project$RegisterChange$Pushed16BitValue(
						function ($) {
							return $.p;
						}),
					11)),
				_Utils_Tuple2(
				233,
				_Utils_Tuple2(
					$author$project$RegisterChange$RegisterChangeJump(
						function ($) {
							return $.p;
						}),
					4)),
				_Utils_Tuple2(
				249,
				_Utils_Tuple2(
					$author$project$RegisterChange$RegChangeNewSP(
						function ($) {
							return $.p;
						}),
					6))
			])));
var $author$project$SingleEnvWithMain$add_iy_sp = F3(
	function (z80_main, rom48k, z80_env) {
		return A3($author$project$SingleEnvWithMain$SingleEnvNewHL16BitAdd, 1, z80_main.p, z80_env.eN);
	});
var $author$project$SingleEnvWithMain$singleEnvMainRegsIY = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			57,
			_Utils_Tuple2($author$project$SingleEnvWithMain$add_iy_sp, 11))
		]));
var $author$project$RegisterChange$PopIY = {$: 32};
var $author$project$SingleNoParams$singleWithNoParamFD = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			225,
			_Utils_Tuple2($author$project$RegisterChange$PopIY, 10))
		]));
var $author$project$Z80OpCode$singleByteMainFlagsRegsIY = A2(
	$elm$core$Dict$union,
	A2(
		$elm$core$Dict$map,
		F2(
			function (_v2, _v3) {
				var f = _v3.a;
				var duration = _v3.b;
				return _Utils_Tuple2(
					$author$project$RegisterChange$RegisterEnvMainChange(f),
					duration);
			}),
		$author$project$SingleEnvWithMain$singleEnvMainRegsIY),
	A2(
		$elm$core$Dict$union,
		A2(
			$elm$core$Dict$map,
			F2(
				function (_v0, _v1) {
					var f = _v1.a;
					var duration = _v1.b;
					return _Utils_Tuple2(
						$author$project$RegisterChange$IndexedRegisterZ80Change(f),
						duration);
				}),
			$author$project$SingleMainWithFlags$singleByteMainAndFlagRegistersIY),
		A2(
			$elm$core$Dict$union,
			$author$project$SingleNoParams$singleWithNoParamFD,
			A2($elm$core$Dict$union, $author$project$SimpleSingleByte$singleByteMainRegsFD, $author$project$SimpleFlagOps$singleByteFlagsFD))));
var $author$project$TripleByte$NewIYIndirect = function (a) {
	return {$: 3, a: a};
};
var $author$project$TripleByte$ld_iy_indirect_nn = function (param16) {
	return $author$project$TripleByte$NewIYIndirect(param16);
};
var $author$project$TripleByte$NewIYRegister = function (a) {
	return {$: 2, a: a};
};
var $author$project$TripleByte$ld_iy_nn = function (param16) {
	return $author$project$TripleByte$NewIYRegister(param16);
};
var $author$project$TripleByte$tripleByteWith16BitParamFD = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			33,
			_Utils_Tuple2($author$project$TripleByte$ld_iy_nn, 16)),
			_Utils_Tuple2(
			42,
			_Utils_Tuple2($author$project$TripleByte$ld_iy_indirect_nn, 16))
		]));
var $author$project$TripleWithMain$ld_indirect_iy_n = function (param16) {
	var value = $author$project$Utils$shiftRightBy8(param16);
	var offset = 255 & param16;
	return A3(
		$author$project$TripleByte$Store8BitValue,
		offset,
		function ($) {
			return $.p;
		},
		value);
};
var $author$project$TripleWithMain$ld_nn_indirect_iy = function (param16) {
	return A2(
		$author$project$TripleByte$Store16BitValue,
		param16,
		function ($) {
			return $.p;
		});
};
var $author$project$TripleWithMain$tripleMainRegsIYFour = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			34,
			_Utils_Tuple2($author$project$TripleWithMain$ld_nn_indirect_iy, 16)),
			_Utils_Tuple2(
			54,
			_Utils_Tuple2($author$project$TripleWithMain$ld_indirect_iy_n, 16))
		]));
var $author$project$Z80OpCode$threeByteWithRegistersIY = A2($elm$core$Dict$union, $author$project$TripleWithMain$tripleMainRegsIYFour, $author$project$TripleByte$tripleByteWith16BitParamFD);
var $author$project$DoubleWithRegisters$dec_indirect_iy = function (param) {
	return A2(
		$author$project$DoubleWithRegisters$IndexedIndirectDecrement,
		function ($) {
			return $.p;
		},
		param);
};
var $author$project$DoubleWithRegisters$inc_indirect_iy = function (param) {
	return A2(
		$author$project$DoubleWithRegisters$IndexedIndirectIncrement,
		function ($) {
			return $.p;
		},
		param);
};
var $author$project$DoubleWithRegisters$ld_a_indirect_iy = function (param) {
	return A2(
		$author$project$DoubleWithRegisters$NewARegisterIndirect,
		function ($) {
			return $.p;
		},
		param);
};
var $author$project$DoubleWithRegisters$ld_indirect_iy_a = function (param) {
	return A2(
		$author$project$DoubleWithRegisters$SetARegisterIndirect,
		function ($) {
			return $.p;
		},
		param);
};
var $author$project$DoubleWithRegisters$NewIYHRegisterValue = function (a) {
	return {$: 2, a: a};
};
var $author$project$DoubleWithRegisters$ld_iy_h_n = function (param) {
	return $author$project$DoubleWithRegisters$NewIYHRegisterValue(param);
};
var $author$project$DoubleWithRegisters$NewIYLRegisterValue = function (a) {
	return {$: 3, a: a};
};
var $author$project$DoubleWithRegisters$ld_iy_l_n = function (param) {
	return $author$project$DoubleWithRegisters$NewIYLRegisterValue(param);
};
var $author$project$DoubleWithRegisters$doubleWithRegistersIY = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			38,
			_Utils_Tuple2($author$project$DoubleWithRegisters$ld_iy_h_n, 7)),
			_Utils_Tuple2(
			46,
			_Utils_Tuple2($author$project$DoubleWithRegisters$ld_iy_l_n, 7)),
			_Utils_Tuple2(
			52,
			_Utils_Tuple2($author$project$DoubleWithRegisters$inc_indirect_iy, 17)),
			_Utils_Tuple2(
			53,
			_Utils_Tuple2($author$project$DoubleWithRegisters$dec_indirect_iy, 17)),
			_Utils_Tuple2(
			70,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$NewRegisterIndirect,
						0,
						function ($) {
							return $.p;
						},
						param);
				},
				3)),
			_Utils_Tuple2(
			78,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$NewRegisterIndirect,
						1,
						function ($) {
							return $.p;
						},
						param);
				},
				3)),
			_Utils_Tuple2(
			86,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$NewRegisterIndirect,
						2,
						function ($) {
							return $.p;
						},
						param);
				},
				3)),
			_Utils_Tuple2(
			94,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$NewRegisterIndirect,
						3,
						function ($) {
							return $.p;
						},
						param);
				},
				3)),
			_Utils_Tuple2(
			102,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$NewRegisterIndirect,
						4,
						function ($) {
							return $.p;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			110,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$NewRegisterIndirect,
						5,
						function ($) {
							return $.p;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			134,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$FlagOpIndexedIndirect,
						1,
						function ($) {
							return $.p;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			142,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$FlagOpIndexedIndirect,
						0,
						function ($) {
							return $.p;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			150,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$FlagOpIndexedIndirect,
						2,
						function ($) {
							return $.p;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			158,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$FlagOpIndexedIndirect,
						3,
						function ($) {
							return $.p;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			166,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$FlagOpIndexedIndirect,
						4,
						function ($) {
							return $.p;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			174,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$FlagOpIndexedIndirect,
						5,
						function ($) {
							return $.p;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			182,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$FlagOpIndexedIndirect,
						6,
						function ($) {
							return $.p;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			190,
			_Utils_Tuple2(
				function (param) {
					return A3(
						$author$project$DoubleWithRegisters$FlagOpIndexedIndirect,
						7,
						function ($) {
							return $.p;
						},
						param);
				},
				15)),
			_Utils_Tuple2(
			119,
			_Utils_Tuple2($author$project$DoubleWithRegisters$ld_indirect_iy_a, 15)),
			_Utils_Tuple2(
			126,
			_Utils_Tuple2($author$project$DoubleWithRegisters$ld_a_indirect_iy, 15))
		]));
var $author$project$TripleWithMain$tripleMainRegsIYThree = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			112,
			_Utils_Tuple2(
				function (offset) {
					return A3(
						$author$project$TripleWithMain$store_reg_indirect,
						offset,
						function ($) {
							return $.p;
						},
						function ($) {
							return $.dw;
						});
				},
				15)),
			_Utils_Tuple2(
			113,
			_Utils_Tuple2(
				function (offset) {
					return A3(
						$author$project$TripleWithMain$store_reg_indirect,
						offset,
						function ($) {
							return $.p;
						},
						function ($) {
							return $.dI;
						});
				},
				15)),
			_Utils_Tuple2(
			114,
			_Utils_Tuple2(
				function (param16) {
					return A3(
						$author$project$TripleWithMain$store_reg_indirect,
						param16,
						function ($) {
							return $.p;
						},
						function ($) {
							return $.dN;
						});
				},
				15)),
			_Utils_Tuple2(
			115,
			_Utils_Tuple2(
				function (param16) {
					return A3(
						$author$project$TripleWithMain$store_reg_indirect,
						param16,
						function ($) {
							return $.p;
						},
						function ($) {
							return $.dT;
						});
				},
				15)),
			_Utils_Tuple2(
			116,
			_Utils_Tuple2(
				function (param16) {
					return A3(
						$author$project$TripleWithMain$store_reg_indirect,
						param16,
						function ($) {
							return $.p;
						},
						function (z80_main) {
							return $author$project$Utils$shiftRightBy8(z80_main.aG);
						});
				},
				15)),
			_Utils_Tuple2(
			117,
			_Utils_Tuple2(
				function (param16) {
					return A3(
						$author$project$TripleWithMain$store_reg_indirect,
						param16,
						function ($) {
							return $.p;
						},
						function (z80_main) {
							return 255 & z80_main.aG;
						});
				},
				15))
		]));
var $author$project$Z80OpCode$twoByteWithRegistersIY = A2($elm$core$Dict$union, $author$project$TripleWithMain$tripleMainRegsIYThree, $author$project$DoubleWithRegisters$doubleWithRegistersIY);
var $author$project$Z80$runIndexIY = F4(
	function (param, rom48k, pc, z80) {
		var _v0 = A2($elm$core$Dict$get, param.e3, $author$project$Z80OpCode$singleByteMainFlagsRegsIY);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var mainRegFunc = _v1.a;
			var duration = _v1.b;
			return _Utils_Tuple3(
				$author$project$Z80Execute$RegisterChangeDelta(mainRegFunc),
				A2($author$project$CpuTimeCTime$addDuration, duration, param.aQ),
				1);
		} else {
			var _v2 = A2($elm$core$Dict$get, param.e3, $author$project$Z80OpCode$twoByteWithRegistersIY);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var f = _v3.a;
				var duration = _v3.b;
				var time = A2($author$project$CpuTimeCTime$addDuration, duration, param.aQ);
				var doubleParam = A4($author$project$Z80Mem$mem, (pc + 2) & 65535, time, rom48k, z80.B);
				return _Utils_Tuple3(
					$author$project$Z80Execute$DoubleWithRegistersDelta(
						f(doubleParam.e3)),
					doubleParam.aQ,
					2);
			} else {
				var _v4 = A2($elm$core$Dict$get, param.e3, $author$project$Z80OpCode$threeByteWithRegistersIY);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var f = _v5.a;
					var duration = _v5.b;
					var env_1 = A2($author$project$CpuTimeCTime$addDuration, duration, param.aQ);
					var env = z80.B;
					var doubleParam = A4($author$project$Z80Mem$mem16, (pc + 2) & 65535, rom48k, env_1, env);
					return _Utils_Tuple3(
						$author$project$Z80Execute$Triple16ParamDelta(
							f(doubleParam.bx)),
						doubleParam.aQ,
						3);
				} else {
					return _Utils_Tuple3(
						A2($author$project$Z80Execute$UnknownInstruction, 'execute IndexIY', param.e3),
						param.aQ,
						1);
				}
			}
		}
	});
var $author$project$PCIncrement$IncrementByOne = 0;
var $author$project$Z80Execute$ThreeByteDelta = function (a) {
	return {$: 10, a: a};
};
var $author$project$Z80Execute$TwoByteDelta = function (a) {
	return {$: 5, a: a};
};
var $author$project$RegisterChange$RegisterEnvMainChangeWithClockTime = function (a) {
	return {$: 39, a: a};
};
var $author$project$RegisterChange$RegisterSingleByteEnv = function (a) {
	return {$: 38, a: a};
};
var $author$project$RegisterChange$RegisterZ80Change = function (a) {
	return {$: 36, a: a};
};
var $author$project$RegisterChange$ConditionalReturn = function (a) {
	return {$: 26, a: a};
};
var $author$project$CpuTimeCTime$FiveTStates = 1;
var $author$project$RegisterChange$FlagChangeFunc = function (a) {
	return {$: 24, a: a};
};
var $author$project$RegisterChange$FlagsPushAF = {$: 27};
var $author$project$SimpleFlagOps$adc_a_a = function (z80_flags) {
	return A2($author$project$Z80Flags$adc, z80_flags.bA, z80_flags);
};
var $author$project$SimpleFlagOps$add_a_a = function (z80_flags) {
	return A2($author$project$Z80Flags$z80_add, z80_flags.bA, z80_flags);
};
var $author$project$SimpleFlagOps$and_a = function (z80_flags) {
	return {bA: z80_flags.bA, aE: ~z80_flags.bA, aF: 0, U: z80_flags.bA, ag: z80_flags.bA};
};
var $author$project$Z80Flags$scf_ccf = F2(
	function (x, flagRegs) {
		var ff = ((256 ^ x) | (flagRegs.U & $author$project$Z80Flags$c_FS)) | (flagRegs.bA & $author$project$Z80Flags$c_F53);
		var fb = (flagRegs.aF & 128) | (((x >> 4) ^ flagRegs.ag) & $author$project$Z80Flags$c_FH);
		var fa = flagRegs.aE & (~$author$project$Z80Flags$c_FH);
		return _Utils_update(
			flagRegs,
			{aE: fa, aF: fb, U: ff});
	});
var $author$project$SimpleFlagOps$ccf = function (z80_flags) {
	return A2($author$project$Z80Flags$scf_ccf, z80_flags.U & 256, z80_flags);
};
var $author$project$SimpleFlagOps$cp_a = function (z80_flags) {
	return A2($author$project$Z80Flags$z80_cp, z80_flags.bA, z80_flags);
};
var $author$project$SimpleFlagOps$dec_a = function (z80_flags) {
	var v = A2($author$project$Z80Flags$dec, z80_flags.bA, z80_flags);
	var new_flags = v.K;
	return _Utils_update(
		new_flags,
		{bA: v.e3});
};
var $author$project$SimpleFlagOps$inc_a = function (z80_flags) {
	var v = A2($author$project$Z80Flags$inc, z80_flags.bA, z80_flags);
	var new_flags = v.K;
	return _Utils_update(
		new_flags,
		{bA: v.e3});
};
var $author$project$SimpleFlagOps$ld_h_a = F2(
	function (z80_flags, main) {
		return _Utils_update(
			main,
			{
				aG: $author$project$Utils$shiftLeftBy8(z80_flags.bA) | (main.aG & 255)
			});
	});
var $author$project$SimpleFlagOps$ld_l_a = F2(
	function (z80_flags, main) {
		return _Utils_update(
			main,
			{aG: z80_flags.bA | (main.aG & 65280)});
	});
var $author$project$SimpleFlagOps$or_a = function (z80_flags) {
	return A2($author$project$Z80Flags$z80_or, z80_flags.bA, z80_flags);
};
var $author$project$SimpleFlagOps$ret_m = $author$project$RegisterChange$ConditionalReturn(
	function (flags) {
		return !(!(flags.U & $author$project$Z80Flags$c_FS));
	});
var $author$project$SimpleFlagOps$ret_p = $author$project$RegisterChange$ConditionalReturn(
	function (flags) {
		return !(flags.U & $author$project$Z80Flags$c_FS);
	});
var $author$project$SimpleFlagOps$ret_pe = $author$project$RegisterChange$ConditionalReturn(
	function (flags) {
		return !(!($author$project$Z80Flags$getFlags(flags) & $author$project$Z80Flags$c_FP));
	});
var $author$project$SimpleFlagOps$ret_po = $author$project$RegisterChange$ConditionalReturn(
	function (flags) {
		return !($author$project$Z80Flags$getFlags(flags) & $author$project$Z80Flags$c_FP);
	});
var $author$project$Z80Flags$rot = F2(
	function (a, flagRegs) {
		var ff = (flagRegs.U & 215) | (a & 296);
		var fb = flagRegs.aF & 128;
		var fa_rhs = flagRegs.ag & $author$project$Z80Flags$c_FH;
		var fa_lhs = flagRegs.aE & (~$author$project$Z80Flags$c_FH);
		var fa = fa_lhs | fa_rhs;
		return _Utils_update(
			flagRegs,
			{bA: a & 255, aE: fa, aF: fb, U: ff});
	});
var $author$project$SimpleFlagOps$rla = function (z80_flags) {
	return A2(
		$author$project$Z80Flags$rot,
		(z80_flags.bA << 1) | ($author$project$Utils$shiftRightBy8(z80_flags.U) & 1),
		z80_flags);
};
var $author$project$SimpleFlagOps$rlca = function (z80_flags) {
	var a101 = z80_flags.bA + $author$project$Utils$shiftLeftBy8(z80_flags.bA);
	return A2($author$project$Z80Flags$rot, a101 >> 7, z80_flags);
};
var $author$project$SimpleFlagOps$rra = function (z80_flags) {
	return A2($author$project$Z80Flags$rot, ((z80_flags.bA * 513) | (z80_flags.U & 256)) >> 1, z80_flags);
};
var $author$project$SimpleFlagOps$rrca = function (z80_flags) {
	return A2($author$project$Z80Flags$rot, (z80_flags.bA * 2155872256) >> 24, z80_flags);
};
var $author$project$SimpleFlagOps$sbc_a = function (z80_flags) {
	return A2($author$project$Z80Flags$sbc, z80_flags.bA, z80_flags);
};
var $author$project$SimpleFlagOps$scf = function (z80_flags) {
	return A2($author$project$Z80Flags$scf_ccf, 0, z80_flags);
};
var $author$project$SimpleFlagOps$sub_a = function (z80_flags) {
	return A2($author$project$Z80Flags$z80_sub, z80_flags.bA, z80_flags);
};
var $author$project$SimpleFlagOps$xor_a = function (z80_flags) {
	return A2($author$project$Z80Flags$z80_xor, z80_flags.bA, z80_flags);
};
var $author$project$Z80Flags$z80_cpl = function (flagRegs) {
	var new_a = flagRegs.bA ^ 255;
	var ff = (flagRegs.U & (~$author$project$Z80Flags$c_F53)) | (new_a & $author$project$Z80Flags$c_F53);
	var fb = flagRegs.aF | (~128);
	var fa = (flagRegs.aE & (~$author$project$Z80Flags$c_FH)) | ((~flagRegs.ag) & $author$project$Z80Flags$c_FH);
	return _Utils_update(
		flagRegs,
		{bA: new_a, aE: fa, aF: fb, U: ff});
};
var $author$project$Z80Flags$z80_daa = function (flagRegs) {
	var h = (((flagRegs.ag ^ flagRegs.aE) ^ flagRegs.aF) ^ $author$project$Utils$shiftRightBy8(flagRegs.aF)) & $author$project$Z80Flags$c_FH;
	var fa = flagRegs.bA | 256;
	var d0 = ((flagRegs.bA | (flagRegs.U & 256)) > 153) ? 352 : 0;
	var d = (((flagRegs.bA & 15) | h) > 9) ? (d0 + 6) : d0;
	var _v0 = (!(flagRegs.aF & 512)) ? _Utils_Tuple2(flagRegs.bA + d, d) : _Utils_Tuple2(flagRegs.bA - d, ~d);
	var a0 = _v0.a;
	var fb = _v0.b;
	var a = a0 & 255;
	var fr = a;
	var ff = fr | (d & 256);
	return _Utils_update(
		flagRegs,
		{bA: a, aE: fa, aF: fb, U: ff, ag: fr});
};
var $author$project$SimpleFlagOps$singleByteFlags = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			7,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$rlca),
				0)),
			_Utils_Tuple2(
			15,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$rrca),
				0)),
			_Utils_Tuple2(
			23,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$rla),
				0)),
			_Utils_Tuple2(
			31,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$rra),
				0)),
			_Utils_Tuple2(
			39,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$Z80Flags$z80_daa),
				0)),
			_Utils_Tuple2(
			47,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$Z80Flags$z80_cpl),
				0)),
			_Utils_Tuple2(
			55,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$scf),
				0)),
			_Utils_Tuple2(
			60,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$inc_a),
				0)),
			_Utils_Tuple2(
			61,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$dec_a),
				0)),
			_Utils_Tuple2(
			63,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$ccf),
				0)),
			_Utils_Tuple2(
			71,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeMain($author$project$SimpleFlagOps$ld_b_a),
				0)),
			_Utils_Tuple2(
			79,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeMain($author$project$SimpleFlagOps$ld_c_a),
				0)),
			_Utils_Tuple2(
			87,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeMain($author$project$SimpleFlagOps$ld_d_a),
				0)),
			_Utils_Tuple2(
			95,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeMain($author$project$SimpleFlagOps$ld_e_a),
				0)),
			_Utils_Tuple2(
			103,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeMain($author$project$SimpleFlagOps$ld_h_a),
				0)),
			_Utils_Tuple2(
			111,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeMain($author$project$SimpleFlagOps$ld_l_a),
				0)),
			_Utils_Tuple2(
			135,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$add_a_a),
				0)),
			_Utils_Tuple2(
			143,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$adc_a_a),
				0)),
			_Utils_Tuple2(
			151,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$sub_a),
				0)),
			_Utils_Tuple2(
			159,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$sbc_a),
				0)),
			_Utils_Tuple2(
			167,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$and_a),
				0)),
			_Utils_Tuple2(
			175,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$xor_a),
				0)),
			_Utils_Tuple2(
			183,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$or_a),
				0)),
			_Utils_Tuple2(
			191,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$cp_a),
				0)),
			_Utils_Tuple2(
			192,
			_Utils_Tuple2(
				$author$project$RegisterChange$ConditionalReturn(
					function (flags) {
						return !(!flags.ag);
					}),
				1)),
			_Utils_Tuple2(
			200,
			_Utils_Tuple2(
				$author$project$RegisterChange$ConditionalReturn(
					function (flags) {
						return !flags.ag;
					}),
				1)),
			_Utils_Tuple2(
			208,
			_Utils_Tuple2(
				$author$project$RegisterChange$ConditionalReturn(
					function (flags) {
						return !(flags.U & 256);
					}),
				1)),
			_Utils_Tuple2(
			216,
			_Utils_Tuple2(
				$author$project$RegisterChange$ConditionalReturn(
					function (flags) {
						return !(!(flags.U & 256));
					}),
				1)),
			_Utils_Tuple2(
			224,
			_Utils_Tuple2($author$project$SimpleFlagOps$ret_po, 1)),
			_Utils_Tuple2(
			232,
			_Utils_Tuple2($author$project$SimpleFlagOps$ret_pe, 1)),
			_Utils_Tuple2(
			240,
			_Utils_Tuple2($author$project$SimpleFlagOps$ret_p, 1)),
			_Utils_Tuple2(
			245,
			_Utils_Tuple2($author$project$RegisterChange$FlagsPushAF, 7)),
			_Utils_Tuple2(
			248,
			_Utils_Tuple2($author$project$SimpleFlagOps$ret_m, 1))
		]));
var $author$project$Z80Change$Z80ChangeFlags = function (a) {
	return {$: 2, a: a};
};
var $author$project$SingleMainWithFlags$adc_a_b = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$adc, z80_main.dw, z80_flags));
	});
var $author$project$SingleMainWithFlags$adc_a_c = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$adc, z80_main.dI, z80_flags));
	});
var $author$project$SingleMainWithFlags$adc_a_d = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$adc, z80_main.dN, z80_flags));
	});
var $author$project$SingleMainWithFlags$adc_a_e = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$adc, z80_main.dT, z80_flags));
	});
var $author$project$SingleMainWithFlags$adc_a_h = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2(
				$author$project$Z80Flags$adc,
				$author$project$Utils$shiftRightBy8(z80_main.aG),
				z80_flags));
	});
var $author$project$SingleMainWithFlags$adc_a_l = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$adc, z80_main.aG & 255, z80_flags));
	});
var $author$project$SingleMainWithFlags$add_a_b = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_add, z80_main.dw, z80_flags));
	});
var $author$project$SingleMainWithFlags$add_a_c = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_add, z80_main.dI, z80_flags));
	});
var $author$project$SingleMainWithFlags$add_a_d = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_add, z80_main.dN, z80_flags));
	});
var $author$project$SingleMainWithFlags$add_a_e = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_add, z80_main.dT, z80_flags));
	});
var $author$project$SingleMainWithFlags$add_a_h = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2(
				$author$project$Z80Flags$z80_add,
				$author$project$Utils$shiftRightBy8(z80_main.aG),
				z80_flags));
	});
var $author$project$SingleMainWithFlags$add_a_l = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_add, z80_main.aG & 255, z80_flags));
	});
var $author$project$Z80Change$FlagsWithHLRegister = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$SingleMainWithFlags$add_hl_bc = F2(
	function (z80_main, z80_flags) {
		var xy = z80_main.aG;
		var new_xy = A3(
			$author$project$Z80Flags$add16,
			xy,
			$author$project$Z80Types$get_bc(z80_main),
			z80_flags);
		return A2($author$project$Z80Change$FlagsWithHLRegister, new_xy.K, new_xy.e3);
	});
var $author$project$SingleMainWithFlags$add_hl_de = F2(
	function (z80_main, z80_flags) {
		var new_xy = A3(
			$author$project$Z80Flags$add16,
			z80_main.aG,
			$author$project$Z80Types$get_de(z80_main),
			z80_flags);
		return A2($author$project$Z80Change$FlagsWithHLRegister, new_xy.K, new_xy.e3);
	});
var $author$project$SingleMainWithFlags$add_hl_hl = F2(
	function (z80_main, z80_flags) {
		var new_xy = A3($author$project$Z80Flags$add16, z80_main.aG, z80_main.aG, z80_flags);
		return A2($author$project$Z80Change$FlagsWithHLRegister, new_xy.K, new_xy.e3);
	});
var $author$project$SingleMainWithFlags$and_b = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_and, z80_main.dw, z80_flags));
	});
var $author$project$SingleMainWithFlags$and_c = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_and, z80_main.dI, z80_flags));
	});
var $author$project$SingleMainWithFlags$and_d = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_and, z80_main.dN, z80_flags));
	});
var $author$project$SingleMainWithFlags$and_e = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_and, z80_main.dT, z80_flags));
	});
var $author$project$SingleMainWithFlags$and_h = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2(
				$author$project$Z80Flags$z80_and,
				$author$project$Utils$shiftRightBy8(z80_main.aG),
				z80_flags));
	});
var $author$project$SingleMainWithFlags$and_l = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_and, z80_main.aG & 255, z80_flags));
	});
var $author$project$SingleMainWithFlags$cp_b = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_cp, z80_main.dw, z80_flags));
	});
var $author$project$SingleMainWithFlags$cp_c = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_cp, z80_main.dI, z80_flags));
	});
var $author$project$SingleMainWithFlags$cp_d = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_cp, z80_main.dN, z80_flags));
	});
var $author$project$SingleMainWithFlags$cp_e = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_cp, z80_main.dT, z80_flags));
	});
var $author$project$SingleMainWithFlags$cp_h = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2(
				$author$project$Z80Flags$z80_cp,
				$author$project$Utils$shiftRightBy8(z80_main.aG),
				z80_flags));
	});
var $author$project$SingleMainWithFlags$cp_l = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_cp, z80_main.aG & 255, z80_flags));
	});
var $author$project$Z80Change$FlagsWithRegisterChange = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Z80Registers$RegisterB = 0;
var $author$project$SingleMainWithFlags$dec_b = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			0,
			A2($author$project$Z80Flags$dec, z80_main.dw, z80_flags));
	});
var $author$project$Z80Registers$RegisterC = 1;
var $author$project$SingleMainWithFlags$dec_c = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			1,
			A2($author$project$Z80Flags$dec, z80_main.dI, z80_flags));
	});
var $author$project$Z80Registers$RegisterD = 2;
var $author$project$SingleMainWithFlags$dec_d = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			2,
			A2($author$project$Z80Flags$dec, z80_main.dN, z80_flags));
	});
var $author$project$Z80Registers$RegisterE = 3;
var $author$project$SingleMainWithFlags$dec_e = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			3,
			A2($author$project$Z80Flags$dec, z80_main.dT, z80_flags));
	});
var $author$project$SingleMainWithFlags$dec_h = F2(
	function (z80_main, z80_flags) {
		var value = A2(
			$author$project$Z80Flags$dec,
			$author$project$Utils$shiftRightBy8(z80_main.aG),
			z80_flags);
		var new_xy = (z80_main.aG & 255) | $author$project$Utils$shiftLeftBy8(value.e3);
		return A2($author$project$Z80Change$FlagsWithHLRegister, value.K, new_xy);
	});
var $author$project$SingleMainWithFlags$dec_l = F2(
	function (z80_main, z80_flags) {
		var l = A2($author$project$Z80Flags$dec, z80_main.aG & 255, z80_flags);
		var h = z80_main.aG & 65280;
		var new_xy = h | l.e3;
		return A2($author$project$Z80Change$FlagsWithHLRegister, l.K, new_xy);
	});
var $author$project$SingleMainWithFlags$inc_b = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			0,
			A2($author$project$Z80Flags$inc, z80_main.dw, z80_flags));
	});
var $author$project$SingleMainWithFlags$inc_c = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			1,
			A2($author$project$Z80Flags$inc, z80_main.dI, z80_flags));
	});
var $author$project$SingleMainWithFlags$inc_d = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			2,
			A2($author$project$Z80Flags$inc, z80_main.dN, z80_flags));
	});
var $author$project$SingleMainWithFlags$inc_e = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			3,
			A2($author$project$Z80Flags$inc, z80_main.dT, z80_flags));
	});
var $author$project$SingleMainWithFlags$inc_h = F2(
	function (z80_main, z80_flags) {
		var value = A2(
			$author$project$Z80Flags$inc,
			$author$project$Utils$shiftRightBy8(z80_main.aG),
			z80_flags);
		var new_xy = (z80_main.aG & 255) | $author$project$Utils$shiftLeftBy8(value.e3);
		return A2($author$project$Z80Change$FlagsWithHLRegister, value.K, new_xy);
	});
var $author$project$SingleMainWithFlags$inc_l = F2(
	function (z80_main, z80_flags) {
		var l = A2($author$project$Z80Flags$inc, z80_main.aG & 255, z80_flags);
		var h = z80_main.aG & 65280;
		var new_xy = h | l.e3;
		return A2($author$project$Z80Change$FlagsWithHLRegister, l.K, new_xy);
	});
var $author$project$Z80Change$Z80ChangeSetIndirect = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$SingleMainWithFlags$ld_indirect_bc_a = F2(
	function (z80_main, z80_flags) {
		var addr = $author$project$Utils$shiftLeftBy8(z80_main.dw) + z80_main.dI;
		return A2($author$project$Z80Change$Z80ChangeSetIndirect, addr, z80_flags.bA);
	});
var $author$project$SingleMainWithFlags$ld_indirect_de_a = F2(
	function (z80_main, z80_flags) {
		var addr = $author$project$Utils$shiftLeftBy8(z80_main.dN) + z80_main.dT;
		return A2($author$project$Z80Change$Z80ChangeSetIndirect, addr, z80_flags.bA);
	});
var $author$project$SingleMainWithFlags$ld_indirect_hl_a = F2(
	function (z80_main, z80_flags) {
		return A2($author$project$Z80Change$Z80ChangeSetIndirect, z80_main.aG, z80_flags.bA);
	});
var $author$project$SingleMainWithFlags$or_b = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_or, z80_main.dw, z80_flags));
	});
var $author$project$SingleMainWithFlags$or_c = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_or, z80_main.dI, z80_flags));
	});
var $author$project$SingleMainWithFlags$or_d = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_or, z80_main.dN, z80_flags));
	});
var $author$project$SingleMainWithFlags$or_e = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_or, z80_main.dT, z80_flags));
	});
var $author$project$SingleMainWithFlags$or_h = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2(
				$author$project$Z80Flags$z80_or,
				$author$project$Utils$shiftRightBy8(z80_main.aG),
				z80_flags));
	});
var $author$project$SingleMainWithFlags$or_l = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_or, z80_main.aG & 255, z80_flags));
	});
var $author$project$SingleMainWithFlags$sbc_b = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$sbc, z80_main.dw, z80_flags));
	});
var $author$project$SingleMainWithFlags$sbc_c = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$sbc, z80_main.dI, z80_flags));
	});
var $author$project$SingleMainWithFlags$sbc_d = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$sbc, z80_main.dN, z80_flags));
	});
var $author$project$SingleMainWithFlags$sbc_e = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$sbc, z80_main.dT, z80_flags));
	});
var $author$project$SingleMainWithFlags$sbc_h = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2(
				$author$project$Z80Flags$sbc,
				$author$project$Utils$shiftRightBy8(z80_main.aG),
				z80_flags));
	});
var $author$project$SingleMainWithFlags$sbc_l = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$sbc, z80_main.aG & 255, z80_flags));
	});
var $author$project$SingleMainWithFlags$sub_b = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_sub, z80_main.dw, z80_flags));
	});
var $author$project$SingleMainWithFlags$sub_c = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_sub, z80_main.dI, z80_flags));
	});
var $author$project$SingleMainWithFlags$sub_d = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_sub, z80_main.dN, z80_flags));
	});
var $author$project$SingleMainWithFlags$sub_e = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_sub, z80_main.dT, z80_flags));
	});
var $author$project$SingleMainWithFlags$sub_h = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2(
				$author$project$Z80Flags$z80_sub,
				$author$project$Utils$shiftRightBy8(z80_main.aG),
				z80_flags));
	});
var $author$project$SingleMainWithFlags$sub_l = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_sub, z80_main.aG & 255, z80_flags));
	});
var $author$project$SingleMainWithFlags$xor_b = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_xor, z80_main.dw, z80_flags));
	});
var $author$project$SingleMainWithFlags$xor_c = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_xor, z80_main.dI, z80_flags));
	});
var $author$project$SingleMainWithFlags$xor_d = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_xor, z80_main.dN, z80_flags));
	});
var $author$project$SingleMainWithFlags$xor_e = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_xor, z80_main.dT, z80_flags));
	});
var $author$project$SingleMainWithFlags$xor_h = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2(
				$author$project$Z80Flags$z80_xor,
				$author$project$Utils$shiftRightBy8(z80_main.aG),
				z80_flags));
	});
var $author$project$SingleMainWithFlags$xor_l = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A2($author$project$Z80Flags$z80_xor, z80_main.aG & 255, z80_flags));
	});
var $author$project$SingleMainWithFlags$singleByteMainAndFlagRegisters = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			2,
			_Utils_Tuple2($author$project$SingleMainWithFlags$ld_indirect_bc_a, 3)),
			_Utils_Tuple2(
			4,
			_Utils_Tuple2($author$project$SingleMainWithFlags$inc_b, 0)),
			_Utils_Tuple2(
			5,
			_Utils_Tuple2($author$project$SingleMainWithFlags$dec_b, 0)),
			_Utils_Tuple2(
			9,
			_Utils_Tuple2($author$project$SingleMainWithFlags$add_hl_bc, 7)),
			_Utils_Tuple2(
			12,
			_Utils_Tuple2($author$project$SingleMainWithFlags$inc_c, 0)),
			_Utils_Tuple2(
			13,
			_Utils_Tuple2($author$project$SingleMainWithFlags$dec_c, 0)),
			_Utils_Tuple2(
			18,
			_Utils_Tuple2($author$project$SingleMainWithFlags$ld_indirect_de_a, 3)),
			_Utils_Tuple2(
			20,
			_Utils_Tuple2($author$project$SingleMainWithFlags$inc_d, 0)),
			_Utils_Tuple2(
			21,
			_Utils_Tuple2($author$project$SingleMainWithFlags$dec_d, 0)),
			_Utils_Tuple2(
			25,
			_Utils_Tuple2($author$project$SingleMainWithFlags$add_hl_de, 7)),
			_Utils_Tuple2(
			28,
			_Utils_Tuple2($author$project$SingleMainWithFlags$inc_e, 4)),
			_Utils_Tuple2(
			29,
			_Utils_Tuple2($author$project$SingleMainWithFlags$dec_e, 4)),
			_Utils_Tuple2(
			36,
			_Utils_Tuple2($author$project$SingleMainWithFlags$inc_h, 0)),
			_Utils_Tuple2(
			37,
			_Utils_Tuple2($author$project$SingleMainWithFlags$dec_h, 0)),
			_Utils_Tuple2(
			41,
			_Utils_Tuple2($author$project$SingleMainWithFlags$add_hl_hl, 7)),
			_Utils_Tuple2(
			44,
			_Utils_Tuple2($author$project$SingleMainWithFlags$inc_l, 0)),
			_Utils_Tuple2(
			45,
			_Utils_Tuple2($author$project$SingleMainWithFlags$dec_l, 0)),
			_Utils_Tuple2(
			119,
			_Utils_Tuple2($author$project$SingleMainWithFlags$ld_indirect_hl_a, 3)),
			_Utils_Tuple2(
			128,
			_Utils_Tuple2($author$project$SingleMainWithFlags$add_a_b, 0)),
			_Utils_Tuple2(
			129,
			_Utils_Tuple2($author$project$SingleMainWithFlags$add_a_c, 0)),
			_Utils_Tuple2(
			130,
			_Utils_Tuple2($author$project$SingleMainWithFlags$add_a_d, 0)),
			_Utils_Tuple2(
			131,
			_Utils_Tuple2($author$project$SingleMainWithFlags$add_a_e, 0)),
			_Utils_Tuple2(
			132,
			_Utils_Tuple2($author$project$SingleMainWithFlags$add_a_h, 0)),
			_Utils_Tuple2(
			133,
			_Utils_Tuple2($author$project$SingleMainWithFlags$add_a_l, 0)),
			_Utils_Tuple2(
			136,
			_Utils_Tuple2($author$project$SingleMainWithFlags$adc_a_b, 0)),
			_Utils_Tuple2(
			137,
			_Utils_Tuple2($author$project$SingleMainWithFlags$adc_a_c, 0)),
			_Utils_Tuple2(
			138,
			_Utils_Tuple2($author$project$SingleMainWithFlags$adc_a_d, 0)),
			_Utils_Tuple2(
			139,
			_Utils_Tuple2($author$project$SingleMainWithFlags$adc_a_e, 0)),
			_Utils_Tuple2(
			140,
			_Utils_Tuple2($author$project$SingleMainWithFlags$adc_a_h, 0)),
			_Utils_Tuple2(
			141,
			_Utils_Tuple2($author$project$SingleMainWithFlags$adc_a_l, 0)),
			_Utils_Tuple2(
			144,
			_Utils_Tuple2($author$project$SingleMainWithFlags$sub_b, 0)),
			_Utils_Tuple2(
			145,
			_Utils_Tuple2($author$project$SingleMainWithFlags$sub_c, 0)),
			_Utils_Tuple2(
			146,
			_Utils_Tuple2($author$project$SingleMainWithFlags$sub_d, 0)),
			_Utils_Tuple2(
			147,
			_Utils_Tuple2($author$project$SingleMainWithFlags$sub_e, 0)),
			_Utils_Tuple2(
			148,
			_Utils_Tuple2($author$project$SingleMainWithFlags$sub_h, 0)),
			_Utils_Tuple2(
			149,
			_Utils_Tuple2($author$project$SingleMainWithFlags$sub_l, 0)),
			_Utils_Tuple2(
			152,
			_Utils_Tuple2($author$project$SingleMainWithFlags$sbc_b, 0)),
			_Utils_Tuple2(
			153,
			_Utils_Tuple2($author$project$SingleMainWithFlags$sbc_c, 0)),
			_Utils_Tuple2(
			154,
			_Utils_Tuple2($author$project$SingleMainWithFlags$sbc_d, 0)),
			_Utils_Tuple2(
			155,
			_Utils_Tuple2($author$project$SingleMainWithFlags$sbc_e, 0)),
			_Utils_Tuple2(
			156,
			_Utils_Tuple2($author$project$SingleMainWithFlags$sbc_h, 0)),
			_Utils_Tuple2(
			157,
			_Utils_Tuple2($author$project$SingleMainWithFlags$sbc_l, 0)),
			_Utils_Tuple2(
			160,
			_Utils_Tuple2($author$project$SingleMainWithFlags$and_b, 0)),
			_Utils_Tuple2(
			161,
			_Utils_Tuple2($author$project$SingleMainWithFlags$and_c, 0)),
			_Utils_Tuple2(
			162,
			_Utils_Tuple2($author$project$SingleMainWithFlags$and_d, 0)),
			_Utils_Tuple2(
			163,
			_Utils_Tuple2($author$project$SingleMainWithFlags$and_e, 0)),
			_Utils_Tuple2(
			164,
			_Utils_Tuple2($author$project$SingleMainWithFlags$and_h, 0)),
			_Utils_Tuple2(
			165,
			_Utils_Tuple2($author$project$SingleMainWithFlags$and_l, 0)),
			_Utils_Tuple2(
			168,
			_Utils_Tuple2($author$project$SingleMainWithFlags$xor_b, 0)),
			_Utils_Tuple2(
			169,
			_Utils_Tuple2($author$project$SingleMainWithFlags$xor_c, 0)),
			_Utils_Tuple2(
			170,
			_Utils_Tuple2($author$project$SingleMainWithFlags$xor_d, 0)),
			_Utils_Tuple2(
			171,
			_Utils_Tuple2($author$project$SingleMainWithFlags$xor_e, 0)),
			_Utils_Tuple2(
			172,
			_Utils_Tuple2($author$project$SingleMainWithFlags$xor_h, 0)),
			_Utils_Tuple2(
			173,
			_Utils_Tuple2($author$project$SingleMainWithFlags$xor_l, 0)),
			_Utils_Tuple2(
			176,
			_Utils_Tuple2($author$project$SingleMainWithFlags$or_b, 0)),
			_Utils_Tuple2(
			177,
			_Utils_Tuple2($author$project$SingleMainWithFlags$or_c, 0)),
			_Utils_Tuple2(
			178,
			_Utils_Tuple2($author$project$SingleMainWithFlags$or_d, 0)),
			_Utils_Tuple2(
			179,
			_Utils_Tuple2($author$project$SingleMainWithFlags$or_e, 0)),
			_Utils_Tuple2(
			180,
			_Utils_Tuple2($author$project$SingleMainWithFlags$or_h, 0)),
			_Utils_Tuple2(
			181,
			_Utils_Tuple2($author$project$SingleMainWithFlags$or_l, 0)),
			_Utils_Tuple2(
			184,
			_Utils_Tuple2($author$project$SingleMainWithFlags$cp_b, 0)),
			_Utils_Tuple2(
			185,
			_Utils_Tuple2($author$project$SingleMainWithFlags$cp_c, 0)),
			_Utils_Tuple2(
			186,
			_Utils_Tuple2($author$project$SingleMainWithFlags$cp_d, 0)),
			_Utils_Tuple2(
			187,
			_Utils_Tuple2($author$project$SingleMainWithFlags$cp_e, 0)),
			_Utils_Tuple2(
			188,
			_Utils_Tuple2($author$project$SingleMainWithFlags$cp_h, 0)),
			_Utils_Tuple2(
			189,
			_Utils_Tuple2($author$project$SingleMainWithFlags$cp_l, 0))
		]));
var $author$project$RegisterChange$DecrementIndirect = function (a) {
	return {$: 3, a: a};
};
var $author$project$Z80Types$HL = 2;
var $author$project$RegisterChange$IncrementIndirect = function (a) {
	return {$: 2, a: a};
};
var $author$project$RegisterChange$SetIndirect = function (a) {
	return {$: 5, a: a};
};
var $author$project$CpuTimeCTime$SixTStates = 2;
var $author$project$SimpleSingleByte$dec_bc = function (z80_main) {
	var tmp_c = z80_main.dI - 1;
	return (tmp_c < 0) ? _Utils_update(
		z80_main,
		{dw: (z80_main.dw - 1) & 255, dI: 255}) : _Utils_update(
		z80_main,
		{dI: tmp_c});
};
var $author$project$SimpleSingleByte$dec_de = function (z80_main) {
	var new_e = z80_main.dT - 1;
	return (new_e < 0) ? _Utils_update(
		z80_main,
		{dN: (z80_main.dN - 1) & 255, dT: 255}) : _Utils_update(
		z80_main,
		{dT: new_e});
};
var $author$project$SimpleSingleByte$dec_hl = function (z80_main) {
	return _Utils_update(
		z80_main,
		{aG: (z80_main.aG - 1) & 65535});
};
var $author$project$Z80Types$get_h = function (z80_main) {
	return $author$project$Utils$shiftRightBy8(z80_main.aG);
};
var $author$project$Z80Types$get_l = function (z80_main) {
	return z80_main.aG & 255;
};
var $author$project$SimpleSingleByte$inc_bc = function (z80_main) {
	return (z80_main.dI === 255) ? _Utils_update(
		z80_main,
		{dw: (z80_main.dw + 1) & 255, dI: 0}) : _Utils_update(
		z80_main,
		{dI: z80_main.dI + 1});
};
var $author$project$SimpleSingleByte$inc_de = function (z80_main) {
	var new_e = z80_main.dT + 1;
	return (new_e === 256) ? _Utils_update(
		z80_main,
		{dN: (z80_main.dN + 1) & 255, dT: 0}) : _Utils_update(
		z80_main,
		{dT: new_e});
};
var $author$project$SimpleSingleByte$inc_hl = function (z80_main) {
	return _Utils_update(
		z80_main,
		{aG: (z80_main.aG + 1) & 65535});
};
var $author$project$SimpleSingleByte$ld_a_h = $author$project$RegisterChange$RegisterChangeA($author$project$Z80Types$get_h);
var $author$project$SimpleSingleByte$ld_a_l = $author$project$RegisterChange$RegisterChangeA($author$project$Z80Types$get_l);
var $author$project$SimpleSingleByte$ld_d_h = F2(
	function (hlf, z80_main) {
		return _Utils_update(
			z80_main,
			{
				dN: $author$project$Utils$shiftRightBy8(
					hlf(z80_main))
			});
	});
var $author$project$SimpleSingleByte$ld_d_l = F2(
	function (hlf, z80_main) {
		return _Utils_update(
			z80_main,
			{
				dN: hlf(z80_main) & 255
			});
	});
var $author$project$SimpleSingleByte$ld_e_h = function (z80_main) {
	return _Utils_update(
		z80_main,
		{
			dT: $author$project$Utils$shiftRightBy8(z80_main.aG)
		});
};
var $author$project$SimpleSingleByte$ld_e_l = function (z80_main) {
	return _Utils_update(
		z80_main,
		{dT: z80_main.aG & 255});
};
var $author$project$SimpleSingleByte$ld_h_b = F2(
	function (b_func, z80_main) {
		return _Utils_update(
			z80_main,
			{
				aG: (z80_main.aG & 255) | $author$project$Utils$shiftLeftBy8(
					b_func(z80_main))
			});
	});
var $author$project$SimpleSingleByte$ld_h_l = F2(
	function (bfunc, z80_main) {
		return _Utils_update(
			z80_main,
			{
				aG: (z80_main.aG & 255) | $author$project$Utils$shiftLeftBy8(
					bfunc(z80_main))
			});
	});
var $author$project$SimpleSingleByte$ld_l_b = F2(
	function (bfunc, z80_main) {
		return _Utils_update(
			z80_main,
			{
				aG: (z80_main.aG & 65280) | bfunc(z80_main)
			});
	});
var $author$project$SimpleSingleByte$singleByteMainRegs = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			3,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$inc_bc),
				2)),
			_Utils_Tuple2(
			11,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$dec_bc),
				2)),
			_Utils_Tuple2(
			19,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$inc_de),
				2)),
			_Utils_Tuple2(
			27,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$dec_de),
				2)),
			_Utils_Tuple2(
			35,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$inc_hl),
				2)),
			_Utils_Tuple2(
			43,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$dec_hl),
				2)),
			_Utils_Tuple2(
			52,
			_Utils_Tuple2(
				$author$project$RegisterChange$IncrementIndirect(
					function ($) {
						return $.aG;
					}),
				7)),
			_Utils_Tuple2(
			53,
			_Utils_Tuple2(
				$author$project$RegisterChange$DecrementIndirect(
					function ($) {
						return $.aG;
					}),
				7)),
			_Utils_Tuple2(
			65,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_b_c),
				0)),
			_Utils_Tuple2(
			66,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_b_d),
				0)),
			_Utils_Tuple2(
			67,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_b_e),
				0)),
			_Utils_Tuple2(
			68,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters(
					$author$project$SimpleSingleByte$ld_b_h(
						function ($) {
							return $.aG;
						})),
				0)),
			_Utils_Tuple2(
			69,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters(
					$author$project$SimpleSingleByte$ld_b_l(
						function ($) {
							return $.aG;
						})),
				0)),
			_Utils_Tuple2(
			72,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_c_b),
				0)),
			_Utils_Tuple2(
			74,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_c_d),
				0)),
			_Utils_Tuple2(
			75,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_c_e),
				0)),
			_Utils_Tuple2(
			76,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters(
					$author$project$SimpleSingleByte$ld_c_h(
						function ($) {
							return $.aG;
						})),
				0)),
			_Utils_Tuple2(
			77,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters(
					$author$project$SimpleSingleByte$ld_c_l(
						function ($) {
							return $.aG;
						})),
				0)),
			_Utils_Tuple2(
			80,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_d_b),
				0)),
			_Utils_Tuple2(
			81,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_d_c),
				0)),
			_Utils_Tuple2(
			83,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_d_e),
				0)),
			_Utils_Tuple2(
			84,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters(
					$author$project$SimpleSingleByte$ld_d_h(
						function ($) {
							return $.aG;
						})),
				0)),
			_Utils_Tuple2(
			85,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters(
					$author$project$SimpleSingleByte$ld_d_l(
						function ($) {
							return $.aG;
						})),
				0)),
			_Utils_Tuple2(
			88,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_e_b),
				0)),
			_Utils_Tuple2(
			89,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_e_c),
				0)),
			_Utils_Tuple2(
			90,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_e_d),
				0)),
			_Utils_Tuple2(
			92,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_e_h),
				0)),
			_Utils_Tuple2(
			93,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ld_e_l),
				0)),
			_Utils_Tuple2(
			96,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters(
					$author$project$SimpleSingleByte$ld_h_b(
						function ($) {
							return $.dw;
						})),
				0)),
			_Utils_Tuple2(
			97,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters(
					$author$project$SimpleSingleByte$ld_h_b(
						function ($) {
							return $.dI;
						})),
				0)),
			_Utils_Tuple2(
			98,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters(
					$author$project$SimpleSingleByte$ld_h_b(
						function ($) {
							return $.dN;
						})),
				0)),
			_Utils_Tuple2(
			99,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters(
					$author$project$SimpleSingleByte$ld_h_b(
						function ($) {
							return $.dT;
						})),
				0)),
			_Utils_Tuple2(
			101,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters(
					$author$project$SimpleSingleByte$ld_h_l($author$project$Z80Types$get_l)),
				0)),
			_Utils_Tuple2(
			104,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters(
					$author$project$SimpleSingleByte$ld_l_b(
						function ($) {
							return $.dw;
						})),
				0)),
			_Utils_Tuple2(
			105,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters(
					$author$project$SimpleSingleByte$ld_l_b(
						function ($) {
							return $.dI;
						})),
				0)),
			_Utils_Tuple2(
			106,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters(
					$author$project$SimpleSingleByte$ld_l_b(
						function ($) {
							return $.dN;
						})),
				0)),
			_Utils_Tuple2(
			107,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters(
					$author$project$SimpleSingleByte$ld_l_b(
						function ($) {
							return $.dT;
						})),
				0)),
			_Utils_Tuple2(
			108,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters(
					$author$project$SimpleSingleByte$ld_l_b($author$project$Z80Types$get_h)),
				0)),
			_Utils_Tuple2(
			112,
			_Utils_Tuple2(
				$author$project$RegisterChange$SetIndirect(
					function (main) {
						return _Utils_Tuple2(main.aG, main.dw);
					}),
				3)),
			_Utils_Tuple2(
			113,
			_Utils_Tuple2(
				$author$project$RegisterChange$SetIndirect(
					function (main) {
						return _Utils_Tuple2(main.aG, main.dI);
					}),
				3)),
			_Utils_Tuple2(
			114,
			_Utils_Tuple2(
				$author$project$RegisterChange$SetIndirect(
					function (main) {
						return _Utils_Tuple2(main.aG, main.dN);
					}),
				3)),
			_Utils_Tuple2(
			115,
			_Utils_Tuple2(
				$author$project$RegisterChange$SetIndirect(
					function (main) {
						return _Utils_Tuple2(main.aG, main.dT);
					}),
				3)),
			_Utils_Tuple2(
			116,
			_Utils_Tuple2(
				$author$project$RegisterChange$SetIndirect(
					function (main) {
						return _Utils_Tuple2(
							main.aG,
							$author$project$Z80Types$get_h(main));
					}),
				3)),
			_Utils_Tuple2(
			117,
			_Utils_Tuple2(
				$author$project$RegisterChange$SetIndirect(
					function (main) {
						return _Utils_Tuple2(
							main.aG,
							$author$project$Z80Types$get_l(main));
					}),
				3)),
			_Utils_Tuple2(
			120,
			_Utils_Tuple2(
				$author$project$RegisterChange$RegisterChangeA(
					function ($) {
						return $.dw;
					}),
				0)),
			_Utils_Tuple2(
			121,
			_Utils_Tuple2($author$project$SimpleSingleByte$ld_a_c, 0)),
			_Utils_Tuple2(
			122,
			_Utils_Tuple2($author$project$SimpleSingleByte$ld_a_d, 0)),
			_Utils_Tuple2(
			123,
			_Utils_Tuple2($author$project$SimpleSingleByte$ld_a_e, 0)),
			_Utils_Tuple2(
			124,
			_Utils_Tuple2($author$project$SimpleSingleByte$ld_a_h, 0)),
			_Utils_Tuple2(
			125,
			_Utils_Tuple2($author$project$SimpleSingleByte$ld_a_l, 0)),
			_Utils_Tuple2(
			197,
			_Utils_Tuple2(
				$author$project$RegisterChange$Pushed16BitValue($author$project$Z80Types$get_bc),
				7)),
			_Utils_Tuple2(
			213,
			_Utils_Tuple2(
				$author$project$RegisterChange$Pushed16BitValue($author$project$Z80Types$get_de),
				7)),
			_Utils_Tuple2(
			227,
			_Utils_Tuple2(
				$author$project$RegisterChange$ExchangeTopOfStackWith(2),
				15)),
			_Utils_Tuple2(
			229,
			_Utils_Tuple2(
				$author$project$RegisterChange$Pushed16BitValue(
					function ($) {
						return $.aG;
					}),
				7)),
			_Utils_Tuple2(
			233,
			_Utils_Tuple2(
				$author$project$RegisterChange$RegisterChangeJump(
					function ($) {
						return $.aG;
					}),
				0)),
			_Utils_Tuple2(
			235,
			_Utils_Tuple2(
				$author$project$RegisterChange$TransformMainRegisters($author$project$SimpleSingleByte$ex_de_hl),
				0)),
			_Utils_Tuple2(
			249,
			_Utils_Tuple2(
				$author$project$RegisterChange$RegChangeNewSP(
					function ($) {
						return $.aG;
					}),
				2))
		]));
var $author$project$SingleByteWithEnv$NewSPValue = $elm$core$Basics$identity;
var $author$project$SingleByteWithEnv$dec_sp = function (z80_env) {
	return (z80_env.eN - 1) & 65535;
};
var $author$project$SingleByteWithEnv$inc_sp = function (z80_env) {
	return (z80_env.eN + 1) & 65535;
};
var $author$project$SingleByteWithEnv$singleByteZ80Env = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			51,
			_Utils_Tuple2($author$project$SingleByteWithEnv$inc_sp, 2)),
			_Utils_Tuple2(
			59,
			_Utils_Tuple2($author$project$SingleByteWithEnv$dec_sp, 2))
		]));
var $author$project$SingleEnvWithMain$SingleEnvFlagFunc = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$SingleEnvWithMain$adc_a_indirect_hl = F4(
	function (z80_main, rom48k, clockTime, z80_env) {
		var value = A4($author$project$Z80Mem$mem, z80_main.aG, clockTime, rom48k, z80_env);
		return A3($author$project$SingleEnvWithMain$SingleEnvFlagFunc, 0, value.e3, value.aQ);
	});
var $author$project$SingleEnvWithMain$add_a_indirect_hl = F4(
	function (z80_main, rom48k, clockTime, z80_env) {
		var value = A4($author$project$Z80Mem$mem, z80_main.aG, clockTime, rom48k, z80_env);
		return A3($author$project$SingleEnvWithMain$SingleEnvFlagFunc, 1, value.e3, value.aQ);
	});
var $author$project$SingleEnvWithMain$add_hl_sp = F4(
	function (z80_main, rom48k, clockTime, z80_env) {
		return A3($author$project$SingleEnvWithMain$SingleEnvNewHL16BitAdd, 2, z80_main.aG, z80_env.eN);
	});
var $author$project$SingleEnvWithMain$and_indirect_hl = F4(
	function (z80_main, rom48k, clockTime, z80_env) {
		var value = A4($author$project$Z80Mem$mem, z80_main.aG, clockTime, rom48k, z80_env);
		return A3($author$project$SingleEnvWithMain$SingleEnvFlagFunc, 4, value.e3, value.aQ);
	});
var $author$project$SingleEnvWithMain$cp_indirect_hl = F4(
	function (z80_main, rom48k, clockTime, z80_env) {
		var value = A4($author$project$Z80Mem$mem, z80_main.aG, clockTime, rom48k, z80_env);
		return A3($author$project$SingleEnvWithMain$SingleEnvFlagFunc, 7, value.e3, value.aQ);
	});
var $author$project$SingleEnvWithMain$SingleEnvNewARegister = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$SingleEnvWithMain$ld_a_indirect_bc = F4(
	function (z80_main, rom48k, clockTime, z80_env) {
		var v = $author$project$Utils$shiftLeftBy8(z80_main.dw) | z80_main.dI;
		var new_a = A4($author$project$Z80Mem$mem, v, clockTime, rom48k, z80_env);
		return A2($author$project$SingleEnvWithMain$SingleEnvNewARegister, new_a.e3, new_a.aQ);
	});
var $author$project$SingleEnvWithMain$ld_a_indirect_de = F4(
	function (z80_main, rom48k, clockTime, z80_env) {
		var addr = $author$project$Utils$shiftLeftBy8(z80_main.dN) | z80_main.dT;
		var new_a = A4($author$project$Z80Mem$mem, addr, clockTime, rom48k, z80_env);
		return A2($author$project$SingleEnvWithMain$SingleEnvNewARegister, new_a.e3, new_a.aQ);
	});
var $author$project$SingleEnvWithMain$ld_a_indirect_hl = F4(
	function (z80_main, rom48k, clockTime, z80_env) {
		var value = A4($author$project$Z80Mem$mem, z80_main.aG, clockTime, rom48k, z80_env);
		return A2($author$project$SingleEnvWithMain$SingleEnvNewARegister, value.e3, value.aQ);
	});
var $author$project$SingleEnvWithMain$SingleEnv8BitMain = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$SingleEnvWithMain$ld_b_indirect_hl = F4(
	function (z80_main, rom48k, clockTime, z80_env) {
		var value = A4($author$project$Z80Mem$mem, z80_main.aG, clockTime, rom48k, z80_env);
		return A3($author$project$SingleEnvWithMain$SingleEnv8BitMain, 0, value.e3, value.aQ);
	});
var $author$project$SingleEnvWithMain$ld_c_indirect_hl = F4(
	function (z80_main, rom48k, clockTime, z80_env) {
		var value = A4($author$project$Z80Mem$mem, z80_main.aG, clockTime, rom48k, z80_env);
		return A3($author$project$SingleEnvWithMain$SingleEnv8BitMain, 1, value.e3, value.aQ);
	});
var $author$project$SingleEnvWithMain$ld_d_indirect_hl = F4(
	function (z80_main, rom48k, clockTime, z80_env) {
		var value = A4($author$project$Z80Mem$mem, z80_main.aG, clockTime, rom48k, z80_env);
		return A3($author$project$SingleEnvWithMain$SingleEnv8BitMain, 2, value.e3, value.aQ);
	});
var $author$project$SingleEnvWithMain$ld_e_indirect_hl = F4(
	function (z80_main, rom48k, clockTime, z80_env) {
		var value = A4($author$project$Z80Mem$mem, z80_main.aG, clockTime, rom48k, z80_env);
		return A3($author$project$SingleEnvWithMain$SingleEnv8BitMain, 3, value.e3, value.aQ);
	});
var $author$project$SingleEnvWithMain$SingleEnvNewHLRegister = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$SingleEnvWithMain$ld_h_indirect_hl = F4(
	function (z80_main, rom48k, clockTime, z80_env) {
		var value = A4($author$project$Z80Mem$mem, z80_main.aG, clockTime, rom48k, z80_env);
		var new_hl = $author$project$Utils$shiftLeftBy8(value.e3) | (255 & z80_main.aG);
		return A2($author$project$SingleEnvWithMain$SingleEnvNewHLRegister, new_hl, value.aQ);
	});
var $author$project$SingleEnvWithMain$ld_l_indirect_hl = F4(
	function (z80_main, rom48k, clockTime, z80_env) {
		var value = A4($author$project$Z80Mem$mem, z80_main.aG, clockTime, rom48k, z80_env);
		var new_hl = value.e3 | (65280 & z80_main.aG);
		return A2($author$project$SingleEnvWithMain$SingleEnvNewHLRegister, new_hl, value.aQ);
	});
var $author$project$SingleEnvWithMain$or_indirect_hl = F4(
	function (z80_main, rom48k, clockTime, z80_env) {
		var value = A4($author$project$Z80Mem$mem, z80_main.aG, clockTime, rom48k, z80_env);
		return A3($author$project$SingleEnvWithMain$SingleEnvFlagFunc, 6, value.e3, value.aQ);
	});
var $author$project$SingleEnvWithMain$sbc_indirect_hl = F4(
	function (z80_main, rom48k, clockTime, z80_env) {
		var value = A4($author$project$Z80Mem$mem, z80_main.aG, clockTime, rom48k, z80_env);
		return A3($author$project$SingleEnvWithMain$SingleEnvFlagFunc, 3, value.e3, value.aQ);
	});
var $author$project$SingleEnvWithMain$sub_indirect_hl = F4(
	function (z80_main, rom48k, clockTime, z80_env) {
		var value = A4($author$project$Z80Mem$mem, z80_main.aG, clockTime, rom48k, z80_env);
		return A3($author$project$SingleEnvWithMain$SingleEnvFlagFunc, 2, value.e3, value.aQ);
	});
var $author$project$SingleEnvWithMain$xor_indirect_hl = F4(
	function (z80_main, rom48k, clockTime, z80_env) {
		var value = A4($author$project$Z80Mem$mem, z80_main.aG, clockTime, rom48k, z80_env);
		return A3($author$project$SingleEnvWithMain$SingleEnvFlagFunc, 5, value.e3, value.aQ);
	});
var $author$project$SingleEnvWithMain$singleEnvMainRegs = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			10,
			_Utils_Tuple2($author$project$SingleEnvWithMain$ld_a_indirect_bc, 3)),
			_Utils_Tuple2(
			26,
			_Utils_Tuple2($author$project$SingleEnvWithMain$ld_a_indirect_de, 3)),
			_Utils_Tuple2(
			57,
			_Utils_Tuple2($author$project$SingleEnvWithMain$add_hl_sp, 7)),
			_Utils_Tuple2(
			70,
			_Utils_Tuple2($author$project$SingleEnvWithMain$ld_b_indirect_hl, 3)),
			_Utils_Tuple2(
			78,
			_Utils_Tuple2($author$project$SingleEnvWithMain$ld_c_indirect_hl, 3)),
			_Utils_Tuple2(
			86,
			_Utils_Tuple2($author$project$SingleEnvWithMain$ld_d_indirect_hl, 3)),
			_Utils_Tuple2(
			94,
			_Utils_Tuple2($author$project$SingleEnvWithMain$ld_e_indirect_hl, 3)),
			_Utils_Tuple2(
			102,
			_Utils_Tuple2($author$project$SingleEnvWithMain$ld_h_indirect_hl, 3)),
			_Utils_Tuple2(
			110,
			_Utils_Tuple2($author$project$SingleEnvWithMain$ld_l_indirect_hl, 3)),
			_Utils_Tuple2(
			126,
			_Utils_Tuple2($author$project$SingleEnvWithMain$ld_a_indirect_hl, 3)),
			_Utils_Tuple2(
			134,
			_Utils_Tuple2($author$project$SingleEnvWithMain$add_a_indirect_hl, 3)),
			_Utils_Tuple2(
			142,
			_Utils_Tuple2($author$project$SingleEnvWithMain$adc_a_indirect_hl, 3)),
			_Utils_Tuple2(
			150,
			_Utils_Tuple2($author$project$SingleEnvWithMain$sub_indirect_hl, 3)),
			_Utils_Tuple2(
			158,
			_Utils_Tuple2($author$project$SingleEnvWithMain$sbc_indirect_hl, 3)),
			_Utils_Tuple2(
			166,
			_Utils_Tuple2($author$project$SingleEnvWithMain$and_indirect_hl, 3)),
			_Utils_Tuple2(
			174,
			_Utils_Tuple2($author$project$SingleEnvWithMain$xor_indirect_hl, 3)),
			_Utils_Tuple2(
			182,
			_Utils_Tuple2($author$project$SingleEnvWithMain$or_indirect_hl, 3)),
			_Utils_Tuple2(
			190,
			_Utils_Tuple2($author$project$SingleEnvWithMain$cp_indirect_hl, 3))
		]));
var $author$project$RegisterChange$Rst = function (a) {
	return {$: 35, a: a};
};
var $author$project$SingleNoParams$singleNoParamCalls = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			199,
			_Utils_Tuple2(
				$author$project$RegisterChange$Rst(0),
				7)),
			_Utils_Tuple2(
			207,
			_Utils_Tuple2(
				$author$project$RegisterChange$Rst(8),
				7)),
			_Utils_Tuple2(
			215,
			_Utils_Tuple2(
				$author$project$RegisterChange$Rst(16),
				7)),
			_Utils_Tuple2(
			223,
			_Utils_Tuple2(
				$author$project$RegisterChange$Rst(24),
				7)),
			_Utils_Tuple2(
			231,
			_Utils_Tuple2(
				$author$project$RegisterChange$Rst(32),
				7)),
			_Utils_Tuple2(
			239,
			_Utils_Tuple2(
				$author$project$RegisterChange$Rst(40),
				7)),
			_Utils_Tuple2(
			247,
			_Utils_Tuple2(
				$author$project$RegisterChange$Rst(48),
				7)),
			_Utils_Tuple2(
			255,
			_Utils_Tuple2(
				$author$project$RegisterChange$Rst(56),
				7))
		]));
var $author$project$RegisterChange$PopAF = {$: 33};
var $author$project$RegisterChange$PopBC = {$: 28};
var $author$project$RegisterChange$PopDE = {$: 29};
var $author$project$RegisterChange$PopHL = {$: 30};
var $author$project$RegisterChange$Ret = {$: 34};
var $author$project$SingleNoParams$singleWithNoParam = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			0,
			_Utils_Tuple2($author$project$RegisterChange$RegChangeNoOp, 0)),
			_Utils_Tuple2(
			64,
			_Utils_Tuple2($author$project$RegisterChange$RegChangeNoOp, 0)),
			_Utils_Tuple2(
			73,
			_Utils_Tuple2($author$project$RegisterChange$RegChangeNoOp, 0)),
			_Utils_Tuple2(
			82,
			_Utils_Tuple2($author$project$RegisterChange$RegChangeNoOp, 0)),
			_Utils_Tuple2(
			91,
			_Utils_Tuple2($author$project$RegisterChange$RegChangeNoOp, 0)),
			_Utils_Tuple2(
			100,
			_Utils_Tuple2($author$project$RegisterChange$RegChangeNoOp, 0)),
			_Utils_Tuple2(
			109,
			_Utils_Tuple2($author$project$RegisterChange$RegChangeNoOp, 0)),
			_Utils_Tuple2(
			127,
			_Utils_Tuple2($author$project$RegisterChange$RegChangeNoOp, 0)),
			_Utils_Tuple2(
			193,
			_Utils_Tuple2($author$project$RegisterChange$PopBC, 6)),
			_Utils_Tuple2(
			201,
			_Utils_Tuple2($author$project$RegisterChange$Ret, 6)),
			_Utils_Tuple2(
			209,
			_Utils_Tuple2($author$project$RegisterChange$PopDE, 6)),
			_Utils_Tuple2(
			225,
			_Utils_Tuple2($author$project$RegisterChange$PopHL, 6)),
			_Utils_Tuple2(
			241,
			_Utils_Tuple2($author$project$RegisterChange$PopAF, 6))
		]));
var $author$project$Z80OpCode$singleByteInstructions = A2(
	$elm$core$Dict$union,
	A2(
		$elm$core$Dict$map,
		F2(
			function (_v4, _v5) {
				var f = _v5.a;
				var duration = _v5.b;
				return _Utils_Tuple2(
					$author$project$RegisterChange$RegisterSingleByteEnv(f),
					duration);
			}),
		$author$project$SingleByteWithEnv$singleByteZ80Env),
	A2(
		$elm$core$Dict$union,
		A2(
			$elm$core$Dict$map,
			F2(
				function (_v2, _v3) {
					var f = _v3.a;
					var duration = _v3.b;
					return _Utils_Tuple2(
						$author$project$RegisterChange$RegisterEnvMainChangeWithClockTime(f),
						duration);
				}),
			$author$project$SingleEnvWithMain$singleEnvMainRegs),
		A2(
			$elm$core$Dict$union,
			A2(
				$elm$core$Dict$map,
				F2(
					function (_v0, _v1) {
						var f = _v1.a;
						var duration = _v1.b;
						return _Utils_Tuple2(
							$author$project$RegisterChange$RegisterZ80Change(f),
							duration);
					}),
				$author$project$SingleMainWithFlags$singleByteMainAndFlagRegisters),
			A2(
				$elm$core$Dict$union,
				$author$project$SingleNoParams$singleNoParamCalls,
				A2(
					$elm$core$Dict$union,
					$author$project$SingleNoParams$singleWithNoParam,
					A2($elm$core$Dict$union, $author$project$SimpleFlagOps$singleByteFlags, $author$project$SimpleSingleByte$singleByteMainRegs))))));
var $author$project$RegisterChange$ThreeByteFlags = function (a) {
	return {$: 0, a: a};
};
var $author$project$RegisterChange$ThreeBytePlain = function (a) {
	return {$: 1, a: a};
};
var $author$project$CpuTimeCTime$SeventeenTStates = 13;
var $author$project$TripleWithFlags$CallImmediate = function (a) {
	return {$: 2, a: a};
};
var $author$project$TripleWithFlags$call_0xCD = function (param16) {
	return $author$project$TripleWithFlags$CallImmediate(param16);
};
var $author$project$TripleWithFlags$Conditional16BitCall = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$CpuTimeCTime$SevenExtraTStates = 1;
var $author$project$Z80Flags$jump_c = function (z80_flags) {
	return !(!(z80_flags.U & 256));
};
var $author$project$TripleWithFlags$call_c_nn = function (param) {
	return A3($author$project$TripleWithFlags$Conditional16BitCall, param, 1, $author$project$Z80Flags$jump_c);
};
var $author$project$Z80Flags$jump_m = function (z80_flags) {
	return !(!(z80_flags.U & $author$project$Z80Flags$c_FS));
};
var $author$project$TripleWithFlags$call_m_nn = function (param) {
	return A3($author$project$TripleWithFlags$Conditional16BitCall, param, 1, $author$project$Z80Flags$jump_m);
};
var $author$project$Z80Flags$jump_nc = function (z80_flags) {
	return !(z80_flags.U & 256);
};
var $author$project$TripleWithFlags$call_nc_nn = function (param) {
	return A3($author$project$TripleWithFlags$Conditional16BitCall, param, 1, $author$project$Z80Flags$jump_nc);
};
var $author$project$Z80Flags$jump_nz = function (z80_flags) {
	return !(!z80_flags.ag);
};
var $author$project$TripleWithFlags$call_nz_nn = function (param) {
	return A3($author$project$TripleWithFlags$Conditional16BitCall, param, 1, $author$project$Z80Flags$jump_nz);
};
var $author$project$Z80Flags$jump_p = function (z80_flags) {
	return !(z80_flags.U & $author$project$Z80Flags$c_FS);
};
var $author$project$TripleWithFlags$call_p_nn = function (param) {
	return A3($author$project$TripleWithFlags$Conditional16BitCall, param, 1, $author$project$Z80Flags$jump_p);
};
var $author$project$Z80Flags$jump_pe = function (z80_flags) {
	return !(!($author$project$Z80Flags$getFlags(z80_flags) & $author$project$Z80Flags$c_FP));
};
var $author$project$TripleWithFlags$call_pe_nn = function (param) {
	return A3($author$project$TripleWithFlags$Conditional16BitCall, param, 1, $author$project$Z80Flags$jump_pe);
};
var $author$project$Z80Flags$jump_po = function (z80_flags) {
	return !($author$project$Z80Flags$getFlags(z80_flags) & $author$project$Z80Flags$c_FP);
};
var $author$project$TripleWithFlags$call_po_nn = function (param) {
	return A3($author$project$TripleWithFlags$Conditional16BitCall, param, 1, $author$project$Z80Flags$jump_po);
};
var $author$project$Z80Flags$jump_z = function (z80_flags) {
	return !z80_flags.ag;
};
var $author$project$TripleWithFlags$call_z_nn = function (param) {
	return A3($author$project$TripleWithFlags$Conditional16BitCall, param, 1, $author$project$Z80Flags$jump_z);
};
var $author$project$TripleWithFlags$Conditional16BitJump = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$TripleWithFlags$jp_c_nn = function (param) {
	return A2($author$project$TripleWithFlags$Conditional16BitJump, param, $author$project$Z80Flags$jump_c);
};
var $author$project$TripleWithFlags$jp_m_nn = function (param) {
	return A2($author$project$TripleWithFlags$Conditional16BitJump, param, $author$project$Z80Flags$jump_m);
};
var $author$project$TripleWithFlags$jp_nc_nn = function (param) {
	return A2($author$project$TripleWithFlags$Conditional16BitJump, param, $author$project$Z80Flags$jump_nc);
};
var $author$project$TripleWithFlags$NewPCRegister = function (a) {
	return {$: 3, a: a};
};
var $author$project$TripleWithFlags$jp_nn = function (param16) {
	return $author$project$TripleWithFlags$NewPCRegister(param16);
};
var $author$project$TripleWithFlags$jp_nz = function (param) {
	return A2($author$project$TripleWithFlags$Conditional16BitJump, param, $author$project$Z80Flags$jump_nz);
};
var $author$project$TripleWithFlags$jp_p_nn = function (param) {
	return A2($author$project$TripleWithFlags$Conditional16BitJump, param, $author$project$Z80Flags$jump_p);
};
var $author$project$TripleWithFlags$jp_pe_nn = function (param) {
	return A2($author$project$TripleWithFlags$Conditional16BitJump, param, $author$project$Z80Flags$jump_pe);
};
var $author$project$TripleWithFlags$jp_po_nn = function (param) {
	return A2($author$project$TripleWithFlags$Conditional16BitJump, param, $author$project$Z80Flags$jump_po);
};
var $author$project$TripleWithFlags$jp_z_nn = function (param) {
	return A2($author$project$TripleWithFlags$Conditional16BitJump, param, $author$project$Z80Flags$jump_z);
};
var $author$project$TripleWithFlags$triple16bitJumps = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			194,
			_Utils_Tuple2($author$project$TripleWithFlags$jp_nz, 6)),
			_Utils_Tuple2(
			195,
			_Utils_Tuple2($author$project$TripleWithFlags$jp_nn, 6)),
			_Utils_Tuple2(
			196,
			_Utils_Tuple2($author$project$TripleWithFlags$call_nz_nn, 6)),
			_Utils_Tuple2(
			202,
			_Utils_Tuple2($author$project$TripleWithFlags$jp_z_nn, 6)),
			_Utils_Tuple2(
			204,
			_Utils_Tuple2($author$project$TripleWithFlags$call_z_nn, 6)),
			_Utils_Tuple2(
			205,
			_Utils_Tuple2($author$project$TripleWithFlags$call_0xCD, 13)),
			_Utils_Tuple2(
			210,
			_Utils_Tuple2($author$project$TripleWithFlags$jp_nc_nn, 6)),
			_Utils_Tuple2(
			212,
			_Utils_Tuple2($author$project$TripleWithFlags$call_nc_nn, 6)),
			_Utils_Tuple2(
			218,
			_Utils_Tuple2($author$project$TripleWithFlags$jp_c_nn, 6)),
			_Utils_Tuple2(
			220,
			_Utils_Tuple2($author$project$TripleWithFlags$call_c_nn, 6)),
			_Utils_Tuple2(
			226,
			_Utils_Tuple2($author$project$TripleWithFlags$jp_po_nn, 6)),
			_Utils_Tuple2(
			228,
			_Utils_Tuple2($author$project$TripleWithFlags$call_po_nn, 6)),
			_Utils_Tuple2(
			234,
			_Utils_Tuple2($author$project$TripleWithFlags$jp_pe_nn, 6)),
			_Utils_Tuple2(
			236,
			_Utils_Tuple2($author$project$TripleWithFlags$call_pe_nn, 6)),
			_Utils_Tuple2(
			242,
			_Utils_Tuple2($author$project$TripleWithFlags$jp_p_nn, 6)),
			_Utils_Tuple2(
			244,
			_Utils_Tuple2($author$project$TripleWithFlags$call_p_nn, 6)),
			_Utils_Tuple2(
			250,
			_Utils_Tuple2($author$project$TripleWithFlags$jp_m_nn, 6)),
			_Utils_Tuple2(
			252,
			_Utils_Tuple2($author$project$TripleWithFlags$call_m_nn, 6))
		]));
var $author$project$CpuTimeCTime$SixteenTStates = 12;
var $author$project$CpuTimeCTime$ThirteenTStates = 9;
var $author$project$TripleByte$NewAIndirect = function (a) {
	return {$: 2, a: a};
};
var $author$project$TripleByte$ld_a_indirect_nn = function (param16) {
	return $author$project$TripleByte$NewAIndirect(param16);
};
var $author$project$TripleByte$NewTripleRegister = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$TripleByte$TripleByteBC = 0;
var $author$project$TripleByte$ld_bc_nn = function (param16) {
	return A2($author$project$TripleByte$NewTripleRegister, param16, 0);
};
var $author$project$TripleByte$TripleByteDE = 1;
var $author$project$TripleByte$ld_de_nn = function (param16) {
	return A2($author$project$TripleByte$NewTripleRegister, param16, 1);
};
var $author$project$TripleByte$NewHLIndirect = function (a) {
	return {$: 0, a: a};
};
var $author$project$TripleByte$ld_hl_indirect_nn = function (param16) {
	return $author$project$TripleByte$NewHLIndirect(param16);
};
var $author$project$TripleByte$TripleByteHL = 2;
var $author$project$TripleByte$ld_hl_nn = function (param16) {
	return A2($author$project$TripleByte$NewTripleRegister, param16, 2);
};
var $author$project$TripleByte$TripleSetIndirectFromA = function (a) {
	return {$: 4, a: a};
};
var $author$project$TripleByte$ld_indirect_nn_a = function (param) {
	return $author$project$TripleByte$TripleSetIndirectFromA(param);
};
var $author$project$TripleByte$Store16BitFromHL = function (a) {
	return {$: 5, a: a};
};
var $author$project$TripleByte$ld_nn_indirect_hl = function (param16) {
	return $author$project$TripleByte$Store16BitFromHL(param16);
};
var $author$project$TripleByte$NewSPRegister = function (a) {
	return {$: 1, a: a};
};
var $author$project$TripleByte$ld_sp_nn = function (param16) {
	return $author$project$TripleByte$NewSPRegister(param16);
};
var $author$project$TripleByte$tripleByteWith16BitParam = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			1,
			_Utils_Tuple2($author$project$TripleByte$ld_bc_nn, 6)),
			_Utils_Tuple2(
			17,
			_Utils_Tuple2($author$project$TripleByte$ld_de_nn, 6)),
			_Utils_Tuple2(
			33,
			_Utils_Tuple2($author$project$TripleByte$ld_hl_nn, 6)),
			_Utils_Tuple2(
			34,
			_Utils_Tuple2($author$project$TripleByte$ld_nn_indirect_hl, 12)),
			_Utils_Tuple2(
			42,
			_Utils_Tuple2($author$project$TripleByte$ld_hl_indirect_nn, 12)),
			_Utils_Tuple2(
			49,
			_Utils_Tuple2($author$project$TripleByte$ld_sp_nn, 6)),
			_Utils_Tuple2(
			50,
			_Utils_Tuple2($author$project$TripleByte$ld_indirect_nn_a, 9)),
			_Utils_Tuple2(
			58,
			_Utils_Tuple2($author$project$TripleByte$ld_a_indirect_nn, 9))
		]));
var $author$project$Z80OpCode$threeByteInstructions = A2(
	$elm$core$Dict$union,
	A2(
		$elm$core$Dict$map,
		F2(
			function (_v2, _v3) {
				var f = _v3.a;
				var duration = _v3.b;
				return _Utils_Tuple2(
					function (param) {
						return $author$project$RegisterChange$ThreeByteFlags(
							f(param));
					},
					duration);
			}),
		$author$project$TripleWithFlags$triple16bitJumps),
	A2(
		$elm$core$Dict$map,
		F2(
			function (_v0, _v1) {
				var f = _v1.a;
				var duration = _v1.b;
				return _Utils_Tuple2(
					function (param) {
						return $author$project$RegisterChange$ThreeBytePlain(
							f(param));
					},
					duration);
			}),
		$author$project$TripleByte$tripleByteWith16BitParam));
var $author$project$RegisterChange$TwoByte8Bit = function (a) {
	return {$: 0, a: a};
};
var $author$project$RegisterChange$TwoByteJump = function (a) {
	return {$: 1, a: a};
};
var $author$project$SingleWith8BitParameter$SimpleNewHValue = function (a) {
	return {$: 4, a: a};
};
var $author$project$DoubleWithRegisters$ld_h_n = function (param) {
	return $author$project$SingleWith8BitParameter$SimpleNewHValue(param);
};
var $author$project$SingleWith8BitParameter$RegChangeStoreIndirect = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$DoubleWithRegisters$ld_indirect_hl_n = function (param) {
	return A2(
		$author$project$SingleWith8BitParameter$RegChangeStoreIndirect,
		function ($) {
			return $.aG;
		},
		param);
};
var $author$project$SingleWith8BitParameter$SimpleNewLValue = function (a) {
	return {$: 5, a: a};
};
var $author$project$DoubleWithRegisters$ld_l_n = function (param) {
	return $author$project$SingleWith8BitParameter$SimpleNewLValue(param);
};
var $author$project$DoubleWithRegisters$doubleWithRegisters = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			38,
			_Utils_Tuple2($author$project$DoubleWithRegisters$ld_h_n, 3)),
			_Utils_Tuple2(
			46,
			_Utils_Tuple2($author$project$DoubleWithRegisters$ld_l_n, 3)),
			_Utils_Tuple2(
			54,
			_Utils_Tuple2($author$project$DoubleWithRegisters$ld_indirect_hl_n, 6))
		]));
var $author$project$CpuTimeCTime$TwelveTStates = 8;
var $author$project$SingleWith8BitParameter$DJNZOffset = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$SingleWith8BitParameter$djnz = function (param) {
	return A2(
		$author$project$SingleWith8BitParameter$DJNZOffset,
		$author$project$Utils$byte(param),
		0);
};
var $author$project$SingleWith8BitParameter$ConditionalJumpOffset = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$SingleWith8BitParameter$jr_c_d = function (param) {
	return A3(
		$author$project$SingleWith8BitParameter$ConditionalJumpOffset,
		$author$project$Utils$byte(param),
		0,
		$author$project$Z80Flags$jump_c);
};
var $author$project$SingleWith8BitParameter$ActualJumpOffset = function (a) {
	return {$: 0, a: a};
};
var $author$project$SingleWith8BitParameter$jr_n = function (param) {
	return $author$project$SingleWith8BitParameter$ActualJumpOffset(
		$author$project$Utils$byte(param));
};
var $author$project$SingleWith8BitParameter$jr_nc_d = function (param) {
	return A3(
		$author$project$SingleWith8BitParameter$ConditionalJumpOffset,
		$author$project$Utils$byte(param),
		0,
		$author$project$Z80Flags$jump_nc);
};
var $author$project$SingleWith8BitParameter$jr_nz_d = function (param) {
	return A3(
		$author$project$SingleWith8BitParameter$ConditionalJumpOffset,
		$author$project$Utils$byte(param),
		0,
		$author$project$Z80Flags$jump_nz);
};
var $author$project$SingleWith8BitParameter$jr_z_d = function (param) {
	return A3(
		$author$project$SingleWith8BitParameter$ConditionalJumpOffset,
		$author$project$Utils$byte(param),
		0,
		$author$project$Z80Flags$jump_z);
};
var $author$project$SingleWith8BitParameter$maybeRelativeJump = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			16,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$djnz, 0)),
			_Utils_Tuple2(
			24,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$jr_n, 8)),
			_Utils_Tuple2(
			32,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$jr_nz_d, 3)),
			_Utils_Tuple2(
			40,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$jr_z_d, 3)),
			_Utils_Tuple2(
			48,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$jr_nc_d, 3)),
			_Utils_Tuple2(
			56,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$jr_c_d, 3))
		]));
var $author$project$SingleWith8BitParameter$FlagJump = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$SingleWith8BitParameter$adc_n = function (param) {
	return A2($author$project$SingleWith8BitParameter$FlagJump, 0, param);
};
var $author$project$SingleWith8BitParameter$add_a_n = function (param) {
	return A2($author$project$SingleWith8BitParameter$FlagJump, 1, param);
};
var $author$project$SingleWith8BitParameter$and_n = function (param) {
	return A2($author$project$SingleWith8BitParameter$FlagJump, 4, param);
};
var $author$project$SingleWith8BitParameter$cp_n = function (param) {
	return A2($author$project$SingleWith8BitParameter$FlagJump, 7, param);
};
var $author$project$SingleWith8BitParameter$Z80In = function (a) {
	return {$: 1, a: a};
};
var $author$project$SingleWith8BitParameter$in_a_n = function (param) {
	return $author$project$SingleWith8BitParameter$Z80In(param);
};
var $author$project$SingleWith8BitParameter$NewARegister = function (a) {
	return {$: 3, a: a};
};
var $author$project$SingleWith8BitParameter$ld_a_n = function (param) {
	return $author$project$SingleWith8BitParameter$NewARegister(param);
};
var $author$project$SingleWith8BitParameter$NewRegister = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$SingleWith8BitParameter$ld_b_n = function (param) {
	return A2($author$project$SingleWith8BitParameter$NewRegister, 0, param);
};
var $author$project$SingleWith8BitParameter$ld_c_n = function (param) {
	return A2($author$project$SingleWith8BitParameter$NewRegister, 1, param);
};
var $author$project$SingleWith8BitParameter$ld_d_n = function (param) {
	return A2($author$project$SingleWith8BitParameter$NewRegister, 2, param);
};
var $author$project$SingleWith8BitParameter$ld_e_n = function (param) {
	return A2($author$project$SingleWith8BitParameter$NewRegister, 3, param);
};
var $author$project$SingleWith8BitParameter$or_n = function (param) {
	return A2($author$project$SingleWith8BitParameter$FlagJump, 6, param);
};
var $author$project$SingleWith8BitParameter$Z80Out = function (a) {
	return {$: 2, a: a};
};
var $author$project$SingleWith8BitParameter$out_n_a = function (param) {
	return $author$project$SingleWith8BitParameter$Z80Out(param);
};
var $author$project$SingleWith8BitParameter$sbc_a_n = function (param) {
	return A2($author$project$SingleWith8BitParameter$FlagJump, 3, param);
};
var $author$project$SingleWith8BitParameter$sub_n = function (param) {
	return A2($author$project$SingleWith8BitParameter$FlagJump, 2, param);
};
var $author$project$SingleWith8BitParameter$xor_n = function (param) {
	return A2($author$project$SingleWith8BitParameter$FlagJump, 5, param);
};
var $author$project$SingleWith8BitParameter$singleWith8BitParam = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			6,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$ld_b_n, 3)),
			_Utils_Tuple2(
			14,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$ld_c_n, 3)),
			_Utils_Tuple2(
			22,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$ld_d_n, 3)),
			_Utils_Tuple2(
			30,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$ld_e_n, 3)),
			_Utils_Tuple2(
			62,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$ld_a_n, 3)),
			_Utils_Tuple2(
			198,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$add_a_n, 3)),
			_Utils_Tuple2(
			206,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$adc_n, 3)),
			_Utils_Tuple2(
			211,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$out_n_a, 7)),
			_Utils_Tuple2(
			214,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$sub_n, 3)),
			_Utils_Tuple2(
			219,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$in_a_n, 7)),
			_Utils_Tuple2(
			222,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$sbc_a_n, 3)),
			_Utils_Tuple2(
			230,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$and_n, 3)),
			_Utils_Tuple2(
			238,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$xor_n, 3)),
			_Utils_Tuple2(
			246,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$or_n, 3)),
			_Utils_Tuple2(
			254,
			_Utils_Tuple2($author$project$SingleWith8BitParameter$cp_n, 3))
		]));
var $author$project$Z80OpCode$twoByteInstructions = A2(
	$elm$core$Dict$union,
	A2(
		$elm$core$Dict$map,
		F2(
			function (_v4, _v5) {
				var f = _v5.a;
				var duration = _v5.b;
				return _Utils_Tuple2(
					function (param) {
						return $author$project$RegisterChange$TwoByteJump(
							f(param));
					},
					duration);
			}),
		$author$project$DoubleWithRegisters$doubleWithRegisters),
	A2(
		$elm$core$Dict$union,
		A2(
			$elm$core$Dict$map,
			F2(
				function (_v2, _v3) {
					var f = _v3.a;
					var duration = _v3.b;
					return _Utils_Tuple2(
						function (param) {
							return $author$project$RegisterChange$TwoByteJump(
								f(param));
						},
						duration);
				}),
			$author$project$SingleWith8BitParameter$maybeRelativeJump),
		A2(
			$elm$core$Dict$map,
			F2(
				function (_v0, _v1) {
					var f = _v1.a;
					var duration = _v1.b;
					return _Utils_Tuple2(
						function (param) {
							return $author$project$RegisterChange$TwoByte8Bit(
								f(param));
						},
						duration);
				}),
			$author$project$SingleWith8BitParameter$singleWith8BitParam)));
var $author$project$Z80$runOrdinary = F5(
	function (ct_value, instrTime, rom48k, pc, z80_core) {
		var _v0 = A2($elm$core$Dict$get, ct_value, $author$project$Z80OpCode$singleByteInstructions);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var mainRegFunc = _v1.a;
			var duration = _v1.b;
			return _Utils_Tuple3(
				$author$project$Z80Execute$RegisterChangeDelta(mainRegFunc),
				A2($author$project$CpuTimeCTime$addDuration, duration, instrTime),
				0);
		} else {
			var _v2 = A2($elm$core$Dict$get, ct_value, $author$project$Z80OpCode$twoByteInstructions);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var f = _v3.a;
				var duration = _v3.b;
				var paramTimeValue = A4($author$project$Z80Mem$mem, (pc + 1) & 65535, instrTime, rom48k, z80_core.B);
				var instrTime2 = A2($author$project$CpuTimeCTime$addDuration, duration, paramTimeValue.aQ);
				return _Utils_Tuple3(
					$author$project$Z80Execute$TwoByteDelta(
						f(paramTimeValue.e3)),
					instrTime2,
					1);
			} else {
				var _v4 = A2($elm$core$Dict$get, ct_value, $author$project$Z80OpCode$threeByteInstructions);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var f = _v5.a;
					var duration = _v5.b;
					var newTime = A2($author$project$CpuTimeCTime$addDuration, duration, instrTime);
					var env = z80_core.B;
					var doubleParam = A4($author$project$Z80Mem$mem16, (pc + 1) & 65535, rom48k, newTime, env);
					return _Utils_Tuple3(
						$author$project$Z80Execute$ThreeByteDelta(
							f(doubleParam.bx)),
						doubleParam.aQ,
						2);
				} else {
					return _Utils_Tuple3(
						A2($author$project$Z80Execute$UnknownInstruction, 'runOrdinary', ct_value),
						instrTime,
						0);
				}
			}
		}
	});
var $author$project$Z80Execute$EDChangeDelta = function (a) {
	return {$: 3, a: a};
};
var $author$project$Z80Execute$EDFourByteDelta = function (a) {
	return {$: 4, a: a};
};
var $author$project$Z80Execute$InterruptDelta = function (a) {
	return {$: 1, a: a};
};
var $author$project$Z80Execute$MainWithEnvDelta = function (a) {
	return {$: 7, a: a};
};
var $author$project$Z80Execute$PureDelta = function (a) {
	return {$: 0, a: a};
};
var $author$project$RegisterChange$LoadAFromIR = $elm$core$Basics$identity;
var $author$project$CpuTimeCTime$NineTStates = 5;
var $author$project$GroupED$edWithInterrupts = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			87,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$Utils$shiftRightBy8(z80_main.bZ);
				},
				5)),
			_Utils_Tuple2(
			95,
			_Utils_Tuple2(
				function (z80_main) {
					return (127 & z80_main.et) | (128 & z80_main.bZ);
				},
				5))
		]));
var $author$project$RegisterChange$GetFromMem = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$RegisterChange$RegBC = 2;
var $author$project$RegisterChange$RegDE = 1;
var $author$project$RegisterChange$RegHL = 0;
var $author$project$RegisterChange$RegSP = 3;
var $author$project$RegisterChange$SetMemFrom = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$GroupED$fourByteMainED = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			67,
			_Utils_Tuple2(
				F2(
					function (z80main, address) {
						return A2($author$project$RegisterChange$SetMemFrom, address, 2);
					}),
				16)),
			_Utils_Tuple2(
			75,
			_Utils_Tuple2(
				F2(
					function (z80main, address) {
						return A2($author$project$RegisterChange$GetFromMem, address, 2);
					}),
				16)),
			_Utils_Tuple2(
			83,
			_Utils_Tuple2(
				F2(
					function (z80main, address) {
						return A2($author$project$RegisterChange$SetMemFrom, address, 1);
					}),
				16)),
			_Utils_Tuple2(
			91,
			_Utils_Tuple2(
				F2(
					function (z80main, address) {
						return A2($author$project$RegisterChange$GetFromMem, address, 1);
					}),
				16)),
			_Utils_Tuple2(
			99,
			_Utils_Tuple2(
				F2(
					function (z80main, address) {
						return A2($author$project$RegisterChange$SetMemFrom, address, 0);
					}),
				16)),
			_Utils_Tuple2(
			107,
			_Utils_Tuple2(
				F2(
					function (z80main, address) {
						return A2($author$project$RegisterChange$GetFromMem, address, 0);
					}),
				16)),
			_Utils_Tuple2(
			115,
			_Utils_Tuple2(
				F2(
					function (z80main, address) {
						return A2($author$project$RegisterChange$SetMemFrom, address, 3);
					}),
				16)),
			_Utils_Tuple2(
			123,
			_Utils_Tuple2(
				F2(
					function (z80main, address) {
						return A2($author$project$RegisterChange$GetFromMem, address, 3);
					}),
				16))
		]));
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Utils$Bit_0 = 0;
var $author$project$Utils$Bit_1 = 1;
var $author$project$Utils$Bit_2 = 2;
var $author$project$Utils$Bit_3 = 3;
var $author$project$Utils$Bit_4 = 4;
var $author$project$Utils$Bit_5 = 5;
var $author$project$Utils$Bit_6 = 6;
var $author$project$Utils$Bit_7 = 7;
var $author$project$SimpleFlagOps$resetBit = F2(
	function (testType, flagRegs) {
		var new_a = flagRegs.bA & $author$project$Utils$inverseBitMaskFromBit(testType);
		return _Utils_update(
			flagRegs,
			{bA: new_a});
	});
var $author$project$SimpleFlagOps$applyFlagShifter = F2(
	function (shifter, z80_flags) {
		var value = A2(shifter, z80_flags.bA, z80_flags);
		var new_flags = value.K;
		return _Utils_update(
			new_flags,
			{bA: value.e3});
	});
var $author$project$SimpleFlagOps$rl_a = function (z80_flags) {
	return A2($author$project$SimpleFlagOps$applyFlagShifter, $author$project$Z80Flags$shifter2, z80_flags);
};
var $author$project$SimpleFlagOps$rlc_a = function (z80_flags) {
	return A2($author$project$SimpleFlagOps$applyFlagShifter, $author$project$Z80Flags$shifter0, z80_flags);
};
var $author$project$SimpleFlagOps$rr_a = function (z80_flags) {
	return A2($author$project$SimpleFlagOps$applyFlagShifter, $author$project$Z80Flags$shifter3, z80_flags);
};
var $author$project$SimpleFlagOps$rrc_a = function (z80_flags) {
	return A2($author$project$SimpleFlagOps$applyFlagShifter, $author$project$Z80Flags$shifter1, z80_flags);
};
var $author$project$SimpleFlagOps$setFlagBit = F2(
	function (testType, flagRegs) {
		var new_a = flagRegs.bA | $author$project$Utils$bitMaskFromBit(testType);
		return _Utils_update(
			flagRegs,
			{bA: new_a});
	});
var $author$project$SimpleFlagOps$sla_a = function (z80_flags) {
	return A2($author$project$SimpleFlagOps$applyFlagShifter, $author$project$Z80Flags$shifter4, z80_flags);
};
var $author$project$SimpleFlagOps$sll_a = function (z80_flags) {
	return A2($author$project$SimpleFlagOps$applyFlagShifter, $author$project$Z80Flags$shifter6, z80_flags);
};
var $author$project$SimpleFlagOps$sra_a = function (z80_flags) {
	return A2($author$project$SimpleFlagOps$applyFlagShifter, $author$project$Z80Flags$shifter5, z80_flags);
};
var $author$project$SimpleFlagOps$srl_a = function (z80_flags) {
	return A2($author$project$SimpleFlagOps$applyFlagShifter, $author$project$Z80Flags$shifter7, z80_flags);
};
var $author$project$SimpleFlagOps$singleByteFlagsCB = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			7,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$rlc_a),
				4)),
			_Utils_Tuple2(
			15,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$rrc_a),
				4)),
			_Utils_Tuple2(
			23,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$rl_a),
				4)),
			_Utils_Tuple2(
			31,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$rr_a),
				4)),
			_Utils_Tuple2(
			39,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$sla_a),
				4)),
			_Utils_Tuple2(
			47,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$sra_a),
				4)),
			_Utils_Tuple2(
			55,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$sll_a),
				4)),
			_Utils_Tuple2(
			63,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc($author$project$SimpleFlagOps$srl_a),
				4)),
			_Utils_Tuple2(
			71,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A3($author$project$Z80Flags$testBit, 0, z80_flags.bA, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			79,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A3($author$project$Z80Flags$testBit, 1, z80_flags.bA, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			87,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A3($author$project$Z80Flags$testBit, 2, z80_flags.bA, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			95,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A3($author$project$Z80Flags$testBit, 3, z80_flags.bA, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			103,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A3($author$project$Z80Flags$testBit, 4, z80_flags.bA, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			111,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A3($author$project$Z80Flags$testBit, 5, z80_flags.bA, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			119,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A3($author$project$Z80Flags$testBit, 6, z80_flags.bA, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			127,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A3($author$project$Z80Flags$testBit, 7, z80_flags.bA, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			135,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A2($author$project$SimpleFlagOps$resetBit, 0, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			143,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A2($author$project$SimpleFlagOps$resetBit, 1, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			151,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A2($author$project$SimpleFlagOps$resetBit, 2, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			159,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A2($author$project$SimpleFlagOps$resetBit, 3, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			167,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A2($author$project$SimpleFlagOps$resetBit, 4, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			175,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A2($author$project$SimpleFlagOps$resetBit, 5, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			183,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A2($author$project$SimpleFlagOps$resetBit, 6, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			191,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A2($author$project$SimpleFlagOps$resetBit, 7, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			199,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A2($author$project$SimpleFlagOps$setFlagBit, 0, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			207,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A2($author$project$SimpleFlagOps$setFlagBit, 1, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			215,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A2($author$project$SimpleFlagOps$setFlagBit, 2, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			223,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A2($author$project$SimpleFlagOps$setFlagBit, 3, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			231,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A2($author$project$SimpleFlagOps$setFlagBit, 4, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			239,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A2($author$project$SimpleFlagOps$setFlagBit, 5, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			247,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A2($author$project$SimpleFlagOps$setFlagBit, 6, z80_flags);
					}),
				4)),
			_Utils_Tuple2(
			255,
			_Utils_Tuple2(
				$author$project$RegisterChange$FlagChangeFunc(
					function (z80_flags) {
						return A2($author$project$SimpleFlagOps$setFlagBit, 7, z80_flags);
					}),
				4))
		]));
var $author$project$RegisterChange$FlagNewIValue = function (a) {
	return {$: 23, a: a};
};
var $author$project$RegisterChange$FlagNewRValue = function (a) {
	return {$: 22, a: a};
};
var $author$project$GroupED$ed_44_neg = function (z80_flags) {
	var v = z80_flags.bA;
	var new_flags = A2(
		$author$project$Z80Flags$z80_sub,
		v,
		_Utils_update(
			z80_flags,
			{bA: 0}));
	return new_flags;
};
var $author$project$GroupED$singleByteFlagsED = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			68,
			_Utils_Tuple2(
				function (flags) {
					return $author$project$RegisterChange$FlagChangeFunc($author$project$GroupED$ed_44_neg);
				},
				4)),
			_Utils_Tuple2(
			71,
			_Utils_Tuple2(
				function (z80_flags) {
					return $author$project$RegisterChange$FlagNewIValue(z80_flags.bA);
				},
				5)),
			_Utils_Tuple2(
			76,
			_Utils_Tuple2(
				function (z80_flags) {
					return $author$project$RegisterChange$FlagChangeFunc($author$project$GroupED$ed_44_neg);
				},
				4)),
			_Utils_Tuple2(
			79,
			_Utils_Tuple2(
				function (z80_flags) {
					return $author$project$RegisterChange$FlagNewRValue(z80_flags.bA);
				},
				5)),
			_Utils_Tuple2(
			84,
			_Utils_Tuple2(
				function (z80_flags) {
					return $author$project$RegisterChange$FlagChangeFunc($author$project$GroupED$ed_44_neg);
				},
				4)),
			_Utils_Tuple2(
			92,
			_Utils_Tuple2(
				function (z80_flags) {
					return $author$project$RegisterChange$FlagChangeFunc($author$project$GroupED$ed_44_neg);
				},
				4)),
			_Utils_Tuple2(
			100,
			_Utils_Tuple2(
				function (z80_flags) {
					return $author$project$RegisterChange$FlagChangeFunc($author$project$GroupED$ed_44_neg);
				},
				4)),
			_Utils_Tuple2(
			108,
			_Utils_Tuple2(
				function (z80_flags) {
					return $author$project$RegisterChange$FlagChangeFunc($author$project$GroupED$ed_44_neg);
				},
				4)),
			_Utils_Tuple2(
			116,
			_Utils_Tuple2(
				function (z80_flags) {
					return $author$project$RegisterChange$FlagChangeFunc($author$project$GroupED$ed_44_neg);
				},
				4)),
			_Utils_Tuple2(
			124,
			_Utils_Tuple2(
				function (z80_flags) {
					return $author$project$RegisterChange$FlagChangeFunc($author$project$GroupED$ed_44_neg);
				},
				4))
		]));
var $author$project$GroupCB$bit_1_b = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A3($author$project$Z80Flags$testBit, 1, z80_main.dw, z80_flags));
	});
var $author$project$GroupCB$bit_1_c = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A3($author$project$Z80Flags$testBit, 1, z80_main.dI, z80_flags));
	});
var $author$project$GroupCB$bit_1_d = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A3($author$project$Z80Flags$testBit, 1, z80_main.dN, z80_flags));
	});
var $author$project$GroupCB$bit_1_e = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A3($author$project$Z80Flags$testBit, 1, z80_main.dT, z80_flags));
	});
var $author$project$GroupCB$bit_1_h = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A3(
				$author$project$Z80Flags$testBit,
				1,
				$author$project$Utils$shiftRightBy8(z80_main.aG),
				z80_flags));
	});
var $author$project$GroupCB$bit_1_l = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A3($author$project$Z80Flags$testBit, 1, z80_main.aG & 255, z80_flags));
	});
var $author$project$GroupCB$bit_2_b = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A3($author$project$Z80Flags$testBit, 2, z80_main.dw, z80_flags));
	});
var $author$project$GroupCB$bit_2_c = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A3($author$project$Z80Flags$testBit, 2, z80_main.dI, z80_flags));
	});
var $author$project$GroupCB$bit_2_d = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A3($author$project$Z80Flags$testBit, 2, z80_main.dN, z80_flags));
	});
var $author$project$GroupCB$bit_2_e = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A3($author$project$Z80Flags$testBit, 2, z80_main.dT, z80_flags));
	});
var $author$project$GroupCB$bit_2_h = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A3(
				$author$project$Z80Flags$testBit,
				2,
				$author$project$Utils$shiftRightBy8(z80_main.aG),
				z80_flags));
	});
var $author$project$GroupCB$bit_2_l = F2(
	function (z80_main, z80_flags) {
		return $author$project$Z80Change$Z80ChangeFlags(
			A3($author$project$Z80Flags$testBit, 2, z80_main.aG & 255, z80_flags));
	});
var $author$project$GroupCB$rl_b = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			0,
			A2($author$project$Z80Flags$shifter2, z80_main.dw, z80_flags));
	});
var $author$project$GroupCB$rl_c = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			1,
			A2($author$project$Z80Flags$shifter2, z80_main.dI, z80_flags));
	});
var $author$project$GroupCB$rl_d = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			2,
			A2($author$project$Z80Flags$shifter2, z80_main.dN, z80_flags));
	});
var $author$project$GroupCB$rl_e = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			3,
			A2($author$project$Z80Flags$shifter2, z80_main.dT, z80_flags));
	});
var $author$project$GroupCB$rl_h = F2(
	function (z80_main, z80_flags) {
		var value = A2(
			$author$project$Z80Flags$shifter2,
			$author$project$Utils$shiftRightBy8(z80_main.aG),
			z80_flags);
		var new_hl = $author$project$Utils$shiftLeftBy8(value.e3) | (z80_main.aG & 255);
		return A2($author$project$Z80Change$FlagsWithHLRegister, value.K, new_hl);
	});
var $author$project$GroupCB$rl_l = F2(
	function (z80_main, z80_flags) {
		var value = A2($author$project$Z80Flags$shifter2, z80_main.aG & 255, z80_flags);
		var new_hl = value.e3 | (z80_main.aG & 65280);
		return A2($author$project$Z80Change$FlagsWithHLRegister, value.K, new_hl);
	});
var $author$project$GroupCB$rlc_b = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			0,
			A2($author$project$Z80Flags$shifter0, z80_main.dw, z80_flags));
	});
var $author$project$GroupCB$rlc_c = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			1,
			A2($author$project$Z80Flags$shifter0, z80_main.dI, z80_flags));
	});
var $author$project$GroupCB$rlc_d = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			2,
			A2($author$project$Z80Flags$shifter0, z80_main.dN, z80_flags));
	});
var $author$project$GroupCB$rlc_e = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			3,
			A2($author$project$Z80Flags$shifter0, z80_main.dT, z80_flags));
	});
var $author$project$GroupCB$rlc_h = F2(
	function (z80_main, z80_flags) {
		var value = A2(
			$author$project$Z80Flags$shifter0,
			$author$project$Utils$shiftRightBy8(z80_main.aG),
			z80_flags);
		var new_hl = $author$project$Utils$shiftLeftBy8(value.e3) | (z80_main.aG & 255);
		return A2($author$project$Z80Change$FlagsWithHLRegister, value.K, new_hl);
	});
var $author$project$GroupCB$rlc_l = F2(
	function (z80_main, z80_flags) {
		var value = A2($author$project$Z80Flags$shifter0, z80_main.aG & 255, z80_flags);
		var new_hl = value.e3 | (z80_main.aG & 65280);
		return A2($author$project$Z80Change$FlagsWithHLRegister, value.K, new_hl);
	});
var $author$project$GroupCB$rr_b = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			0,
			A2($author$project$Z80Flags$shifter3, z80_main.dw, z80_flags));
	});
var $author$project$GroupCB$rr_c = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			1,
			A2($author$project$Z80Flags$shifter3, z80_main.dI, z80_flags));
	});
var $author$project$GroupCB$rr_d = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			2,
			A2($author$project$Z80Flags$shifter3, z80_main.dN, z80_flags));
	});
var $author$project$GroupCB$rr_e = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			3,
			A2($author$project$Z80Flags$shifter3, z80_main.dT, z80_flags));
	});
var $author$project$GroupCB$rr_h = F2(
	function (z80_main, z80_flags) {
		var value = A2(
			$author$project$Z80Flags$shifter3,
			$author$project$Utils$shiftRightBy8(z80_main.aG),
			z80_flags);
		var new_hl = $author$project$Utils$shiftLeftBy8(value.e3) | (z80_main.aG & 255);
		return A2($author$project$Z80Change$FlagsWithHLRegister, value.K, new_hl);
	});
var $author$project$GroupCB$rr_l = F2(
	function (z80_main, z80_flags) {
		var value = A2($author$project$Z80Flags$shifter3, z80_main.aG & 255, z80_flags);
		var new_hl = value.e3 | (z80_main.aG & 65280);
		return A2($author$project$Z80Change$FlagsWithHLRegister, value.K, new_hl);
	});
var $author$project$GroupCB$rrc_b = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			0,
			A2($author$project$Z80Flags$shifter1, z80_main.dw, z80_flags));
	});
var $author$project$GroupCB$rrc_c = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			1,
			A2($author$project$Z80Flags$shifter1, z80_main.dI, z80_flags));
	});
var $author$project$GroupCB$rrc_d = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			2,
			A2($author$project$Z80Flags$shifter1, z80_main.dN, z80_flags));
	});
var $author$project$GroupCB$rrc_e = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			3,
			A2($author$project$Z80Flags$shifter1, z80_main.dT, z80_flags));
	});
var $author$project$GroupCB$rrc_h = F2(
	function (z80_main, z80_flags) {
		var value = A2(
			$author$project$Z80Flags$shifter1,
			$author$project$Utils$shiftRightBy8(z80_main.aG),
			z80_flags);
		var new_hl = $author$project$Utils$shiftLeftBy8(value.e3) | (z80_main.aG & 255);
		return A2($author$project$Z80Change$FlagsWithHLRegister, value.K, new_hl);
	});
var $author$project$GroupCB$rrc_l = F2(
	function (z80_main, z80_flags) {
		var value = A2($author$project$Z80Flags$shifter1, z80_main.aG & 255, z80_flags);
		var new_hl = value.e3 | (z80_main.aG & 65280);
		return A2($author$project$Z80Change$FlagsWithHLRegister, value.K, new_hl);
	});
var $author$project$GroupCB$sla_b = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			0,
			A2($author$project$Z80Flags$shifter4, z80_main.dw, z80_flags));
	});
var $author$project$GroupCB$sla_c = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			1,
			A2($author$project$Z80Flags$shifter4, z80_main.dI, z80_flags));
	});
var $author$project$GroupCB$sla_d = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			2,
			A2($author$project$Z80Flags$shifter4, z80_main.dN, z80_flags));
	});
var $author$project$GroupCB$sla_e = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			3,
			A2($author$project$Z80Flags$shifter4, z80_main.dT, z80_flags));
	});
var $author$project$GroupCB$sla_h = F2(
	function (z80_main, z80_flags) {
		var value = A2(
			$author$project$Z80Flags$shifter4,
			$author$project$Utils$shiftRightBy8(z80_main.aG),
			z80_flags);
		var new_hl = $author$project$Utils$shiftLeftBy8(value.e3) | (z80_main.aG & 255);
		return A2($author$project$Z80Change$FlagsWithHLRegister, value.K, new_hl);
	});
var $author$project$GroupCB$sla_l = F2(
	function (z80_main, z80_flags) {
		var value = A2($author$project$Z80Flags$shifter4, z80_main.aG & 255, z80_flags);
		var new_hl = value.e3 | (z80_main.aG & 65280);
		return A2($author$project$Z80Change$FlagsWithHLRegister, value.K, new_hl);
	});
var $author$project$GroupCB$sll_b = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			0,
			A2($author$project$Z80Flags$shifter6, z80_main.dw, z80_flags));
	});
var $author$project$GroupCB$sll_c = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			1,
			A2($author$project$Z80Flags$shifter6, z80_main.dI, z80_flags));
	});
var $author$project$GroupCB$sll_d = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			2,
			A2($author$project$Z80Flags$shifter6, z80_main.dN, z80_flags));
	});
var $author$project$GroupCB$sll_e = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			3,
			A2($author$project$Z80Flags$shifter6, z80_main.dT, z80_flags));
	});
var $author$project$GroupCB$sll_h = F2(
	function (z80_main, z80_flags) {
		var value = A2(
			$author$project$Z80Flags$shifter6,
			$author$project$Utils$shiftRightBy8(z80_main.aG),
			z80_flags);
		var new_hl = $author$project$Utils$shiftLeftBy8(value.e3) | (z80_main.aG & 255);
		return A2($author$project$Z80Change$FlagsWithHLRegister, value.K, new_hl);
	});
var $author$project$GroupCB$sll_l = F2(
	function (z80_main, z80_flags) {
		var value = A2($author$project$Z80Flags$shifter6, z80_main.aG & 255, z80_flags);
		var new_hl = value.e3 | (z80_main.aG & 65280);
		return A2($author$project$Z80Change$FlagsWithHLRegister, value.K, new_hl);
	});
var $author$project$GroupCB$sra_b = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			0,
			A2($author$project$Z80Flags$shifter5, z80_main.dw, z80_flags));
	});
var $author$project$GroupCB$sra_c = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			1,
			A2($author$project$Z80Flags$shifter5, z80_main.dI, z80_flags));
	});
var $author$project$GroupCB$sra_d = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			2,
			A2($author$project$Z80Flags$shifter5, z80_main.dN, z80_flags));
	});
var $author$project$GroupCB$sra_e = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			3,
			A2($author$project$Z80Flags$shifter5, z80_main.dT, z80_flags));
	});
var $author$project$GroupCB$sra_h = F2(
	function (z80_main, z80_flags) {
		var value = A2(
			$author$project$Z80Flags$shifter5,
			$author$project$Utils$shiftRightBy8(z80_main.aG),
			z80_flags);
		var new_hl = $author$project$Utils$shiftLeftBy8(value.e3) | (z80_main.aG & 255);
		return A2($author$project$Z80Change$FlagsWithHLRegister, value.K, new_hl);
	});
var $author$project$GroupCB$sra_l = F2(
	function (z80_main, z80_flags) {
		var value = A2($author$project$Z80Flags$shifter5, z80_main.aG & 255, z80_flags);
		var new_hl = value.e3 | (z80_main.aG & 65280);
		return A2($author$project$Z80Change$FlagsWithHLRegister, value.K, new_hl);
	});
var $author$project$GroupCB$srl_b = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			0,
			A2($author$project$Z80Flags$shifter7, z80_main.dw, z80_flags));
	});
var $author$project$GroupCB$srl_c = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			1,
			A2($author$project$Z80Flags$shifter7, z80_main.dI, z80_flags));
	});
var $author$project$GroupCB$srl_d = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			2,
			A2($author$project$Z80Flags$shifter7, z80_main.dN, z80_flags));
	});
var $author$project$GroupCB$srl_e = F2(
	function (z80_main, z80_flags) {
		return A2(
			$author$project$Z80Change$FlagsWithRegisterChange,
			3,
			A2($author$project$Z80Flags$shifter7, z80_main.dT, z80_flags));
	});
var $author$project$GroupCB$srl_h = F2(
	function (z80_main, z80_flags) {
		var value = A2(
			$author$project$Z80Flags$shifter7,
			$author$project$Utils$shiftRightBy8(z80_main.aG),
			z80_flags);
		var new_hl = $author$project$Utils$shiftLeftBy8(value.e3) | (z80_main.aG & 255);
		return A2($author$project$Z80Change$FlagsWithHLRegister, value.K, new_hl);
	});
var $author$project$GroupCB$srl_l = F2(
	function (z80_main, z80_flags) {
		var value = A2($author$project$Z80Flags$shifter7, z80_main.aG & 255, z80_flags);
		var new_hl = value.e3 | (z80_main.aG & 65280);
		return A2($author$project$Z80Change$FlagsWithHLRegister, value.K, new_hl);
	});
var $author$project$GroupCB$singleByteMainAndFlagRegistersCB = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			0,
			_Utils_Tuple2($author$project$GroupCB$rlc_b, 4)),
			_Utils_Tuple2(
			1,
			_Utils_Tuple2($author$project$GroupCB$rlc_c, 4)),
			_Utils_Tuple2(
			2,
			_Utils_Tuple2($author$project$GroupCB$rlc_d, 4)),
			_Utils_Tuple2(
			3,
			_Utils_Tuple2($author$project$GroupCB$rlc_e, 4)),
			_Utils_Tuple2(
			4,
			_Utils_Tuple2($author$project$GroupCB$rlc_h, 4)),
			_Utils_Tuple2(
			5,
			_Utils_Tuple2($author$project$GroupCB$rlc_l, 4)),
			_Utils_Tuple2(
			8,
			_Utils_Tuple2($author$project$GroupCB$rrc_b, 4)),
			_Utils_Tuple2(
			9,
			_Utils_Tuple2($author$project$GroupCB$rrc_c, 4)),
			_Utils_Tuple2(
			10,
			_Utils_Tuple2($author$project$GroupCB$rrc_d, 4)),
			_Utils_Tuple2(
			11,
			_Utils_Tuple2($author$project$GroupCB$rrc_e, 4)),
			_Utils_Tuple2(
			12,
			_Utils_Tuple2($author$project$GroupCB$rrc_h, 4)),
			_Utils_Tuple2(
			13,
			_Utils_Tuple2($author$project$GroupCB$rrc_l, 4)),
			_Utils_Tuple2(
			16,
			_Utils_Tuple2($author$project$GroupCB$rl_b, 4)),
			_Utils_Tuple2(
			17,
			_Utils_Tuple2($author$project$GroupCB$rl_c, 4)),
			_Utils_Tuple2(
			18,
			_Utils_Tuple2($author$project$GroupCB$rl_d, 4)),
			_Utils_Tuple2(
			19,
			_Utils_Tuple2($author$project$GroupCB$rl_e, 4)),
			_Utils_Tuple2(
			20,
			_Utils_Tuple2($author$project$GroupCB$rl_h, 4)),
			_Utils_Tuple2(
			21,
			_Utils_Tuple2($author$project$GroupCB$rl_l, 4)),
			_Utils_Tuple2(
			24,
			_Utils_Tuple2($author$project$GroupCB$rr_b, 4)),
			_Utils_Tuple2(
			25,
			_Utils_Tuple2($author$project$GroupCB$rr_c, 4)),
			_Utils_Tuple2(
			26,
			_Utils_Tuple2($author$project$GroupCB$rr_d, 4)),
			_Utils_Tuple2(
			27,
			_Utils_Tuple2($author$project$GroupCB$rr_e, 4)),
			_Utils_Tuple2(
			28,
			_Utils_Tuple2($author$project$GroupCB$rr_h, 4)),
			_Utils_Tuple2(
			29,
			_Utils_Tuple2($author$project$GroupCB$rr_l, 4)),
			_Utils_Tuple2(
			32,
			_Utils_Tuple2($author$project$GroupCB$sla_b, 4)),
			_Utils_Tuple2(
			33,
			_Utils_Tuple2($author$project$GroupCB$sla_c, 4)),
			_Utils_Tuple2(
			34,
			_Utils_Tuple2($author$project$GroupCB$sla_d, 4)),
			_Utils_Tuple2(
			35,
			_Utils_Tuple2($author$project$GroupCB$sla_e, 4)),
			_Utils_Tuple2(
			36,
			_Utils_Tuple2($author$project$GroupCB$sla_h, 4)),
			_Utils_Tuple2(
			37,
			_Utils_Tuple2($author$project$GroupCB$sla_l, 4)),
			_Utils_Tuple2(
			40,
			_Utils_Tuple2($author$project$GroupCB$sra_b, 4)),
			_Utils_Tuple2(
			41,
			_Utils_Tuple2($author$project$GroupCB$sra_c, 4)),
			_Utils_Tuple2(
			42,
			_Utils_Tuple2($author$project$GroupCB$sra_d, 4)),
			_Utils_Tuple2(
			43,
			_Utils_Tuple2($author$project$GroupCB$sra_e, 4)),
			_Utils_Tuple2(
			44,
			_Utils_Tuple2($author$project$GroupCB$sra_h, 4)),
			_Utils_Tuple2(
			45,
			_Utils_Tuple2($author$project$GroupCB$sra_l, 4)),
			_Utils_Tuple2(
			48,
			_Utils_Tuple2($author$project$GroupCB$sll_b, 4)),
			_Utils_Tuple2(
			49,
			_Utils_Tuple2($author$project$GroupCB$sll_c, 4)),
			_Utils_Tuple2(
			50,
			_Utils_Tuple2($author$project$GroupCB$sll_d, 4)),
			_Utils_Tuple2(
			51,
			_Utils_Tuple2($author$project$GroupCB$sll_e, 4)),
			_Utils_Tuple2(
			52,
			_Utils_Tuple2($author$project$GroupCB$sll_h, 4)),
			_Utils_Tuple2(
			53,
			_Utils_Tuple2($author$project$GroupCB$sll_l, 4)),
			_Utils_Tuple2(
			56,
			_Utils_Tuple2($author$project$GroupCB$srl_b, 4)),
			_Utils_Tuple2(
			57,
			_Utils_Tuple2($author$project$GroupCB$srl_c, 4)),
			_Utils_Tuple2(
			58,
			_Utils_Tuple2($author$project$GroupCB$srl_d, 4)),
			_Utils_Tuple2(
			59,
			_Utils_Tuple2($author$project$GroupCB$srl_e, 4)),
			_Utils_Tuple2(
			60,
			_Utils_Tuple2($author$project$GroupCB$srl_h, 4)),
			_Utils_Tuple2(
			61,
			_Utils_Tuple2($author$project$GroupCB$srl_l, 4)),
			_Utils_Tuple2(
			64,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 0, z80_main.dw, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			65,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 0, z80_main.dI, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			66,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 0, z80_main.dN, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			67,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 0, z80_main.dT, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			68,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3(
								$author$project$Z80Flags$testBit,
								0,
								$author$project$Utils$shiftRightBy8(z80_main.aG),
								z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			69,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 0, 255 & z80_main.aG, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			72,
			_Utils_Tuple2($author$project$GroupCB$bit_1_b, 4)),
			_Utils_Tuple2(
			73,
			_Utils_Tuple2($author$project$GroupCB$bit_1_c, 4)),
			_Utils_Tuple2(
			74,
			_Utils_Tuple2($author$project$GroupCB$bit_1_d, 4)),
			_Utils_Tuple2(
			75,
			_Utils_Tuple2($author$project$GroupCB$bit_1_e, 4)),
			_Utils_Tuple2(
			76,
			_Utils_Tuple2($author$project$GroupCB$bit_1_h, 4)),
			_Utils_Tuple2(
			77,
			_Utils_Tuple2($author$project$GroupCB$bit_1_l, 4)),
			_Utils_Tuple2(
			80,
			_Utils_Tuple2($author$project$GroupCB$bit_2_b, 4)),
			_Utils_Tuple2(
			81,
			_Utils_Tuple2($author$project$GroupCB$bit_2_c, 4)),
			_Utils_Tuple2(
			82,
			_Utils_Tuple2($author$project$GroupCB$bit_2_d, 4)),
			_Utils_Tuple2(
			83,
			_Utils_Tuple2($author$project$GroupCB$bit_2_e, 4)),
			_Utils_Tuple2(
			84,
			_Utils_Tuple2($author$project$GroupCB$bit_2_h, 4)),
			_Utils_Tuple2(
			85,
			_Utils_Tuple2($author$project$GroupCB$bit_2_l, 4)),
			_Utils_Tuple2(
			88,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 3, z80_main.dw, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			89,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 3, z80_main.dI, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			90,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 3, z80_main.dN, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			91,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 3, z80_main.dT, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			92,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3(
								$author$project$Z80Flags$testBit,
								3,
								$author$project$Utils$shiftRightBy8(z80_main.aG),
								z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			93,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 3, 255 & z80_main.aG, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			96,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 4, z80_main.dw, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			97,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 4, z80_main.dI, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			98,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 4, z80_main.dN, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			99,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 4, z80_main.dT, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			100,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3(
								$author$project$Z80Flags$testBit,
								4,
								$author$project$Utils$shiftRightBy8(z80_main.aG),
								z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			101,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 4, 255 & z80_main.aG, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			104,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 5, z80_main.dw, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			105,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 5, z80_main.dI, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			106,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 5, z80_main.dN, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			107,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 5, z80_main.dT, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			108,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3(
								$author$project$Z80Flags$testBit,
								5,
								$author$project$Utils$shiftRightBy8(z80_main.aG),
								z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			109,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 5, 255 & z80_main.aG, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			112,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 6, z80_main.dw, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			113,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 6, z80_main.dI, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			114,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 6, z80_main.dN, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			115,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 6, z80_main.dT, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			116,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3(
								$author$project$Z80Flags$testBit,
								6,
								$author$project$Utils$shiftRightBy8(z80_main.aG),
								z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			117,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 6, 255 & z80_main.aG, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			120,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 7, z80_main.dw, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			121,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 7, z80_main.dI, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			122,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 7, z80_main.dN, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			123,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 7, z80_main.dT, z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			124,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3(
								$author$project$Z80Flags$testBit,
								7,
								$author$project$Utils$shiftRightBy8(z80_main.aG),
								z80_flags));
					}),
				4)),
			_Utils_Tuple2(
			125,
			_Utils_Tuple2(
				F2(
					function (z80_main, z80_flags) {
						return $author$project$Z80Change$Z80ChangeFlags(
							A3($author$project$Z80Flags$testBit, 7, 255 & z80_main.aG, z80_flags));
					}),
				4))
		]));
var $author$project$GroupED$ed4a_adc_hl_bc = F2(
	function (z80_main, z80_flags) {
		var _v0 = A3(
			$author$project$GroupED$ed_adc_hl,
			$author$project$Z80Types$get_bc(z80_main),
			z80_main,
			z80_flags);
		var flags = _v0.a;
		var hl = _v0.b;
		return A2($author$project$Z80Change$FlagsWithHLRegister, flags, hl);
	});
var $author$project$GroupED$ed5a_adc_hl_de = F2(
	function (z80_main, z80_flags) {
		var _v0 = A3(
			$author$project$GroupED$ed_adc_hl,
			$author$project$Z80Types$get_de(z80_main),
			z80_main,
			z80_flags);
		var flags = _v0.a;
		var hl = _v0.b;
		return A2($author$project$Z80Change$FlagsWithHLRegister, flags, hl);
	});
var $author$project$GroupED$ed6a_adc_hl_hl = F2(
	function (z80_main, z80_flags) {
		var _v0 = A3($author$project$GroupED$ed_adc_hl, z80_main.aG, z80_main, z80_flags);
		var flags = _v0.a;
		var hl = _v0.b;
		return A2($author$project$Z80Change$FlagsWithHLRegister, flags, hl);
	});
var $author$project$GroupED$singleByteMainAndFlagsED = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			74,
			_Utils_Tuple3($author$project$GroupED$ed4a_adc_hl_bc, 1, 11)),
			_Utils_Tuple2(
			90,
			_Utils_Tuple3($author$project$GroupED$ed5a_adc_hl_de, 1, 11)),
			_Utils_Tuple2(
			106,
			_Utils_Tuple3($author$project$GroupED$ed6a_adc_hl_hl, 1, 11))
		]));
var $author$project$RegisterChange$RegisterChangeShifter = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$RegisterChange$Shifter0 = 0;
var $author$project$RegisterChange$Shifter1 = 1;
var $author$project$GroupCB$resetBbit = F2(
	function (bitMask, z80_main) {
		return _Utils_update(
			z80_main,
			{
				dw: z80_main.dw & $author$project$Utils$inverseBitMaskFromBit(bitMask)
			});
	});
var $author$project$GroupCB$resetCbit = F2(
	function (bitMask, z80_main) {
		return _Utils_update(
			z80_main,
			{
				dI: z80_main.dI & $author$project$Utils$inverseBitMaskFromBit(bitMask)
			});
	});
var $author$project$GroupCB$resetDbit = F2(
	function (bitMask, z80_main) {
		return _Utils_update(
			z80_main,
			{
				dN: z80_main.dN & $author$project$Utils$inverseBitMaskFromBit(bitMask)
			});
	});
var $author$project$GroupCB$resetEbit = F2(
	function (bitMask, z80_main) {
		return _Utils_update(
			z80_main,
			{
				dT: z80_main.dT & $author$project$Utils$inverseBitMaskFromBit(bitMask)
			});
	});
var $author$project$RegisterChange$IndirectBitReset = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$GroupCB$resetHLbit = F2(
	function (bitMask, z80_main) {
		return A2($author$project$RegisterChange$IndirectBitReset, bitMask, z80_main.aG);
	});
var $author$project$GroupCB$resetHbit = F2(
	function (bitMask, z80_main) {
		var new_h = $author$project$Utils$shiftRightBy8(z80_main.aG) & $author$project$Utils$inverseBitMaskFromBit(bitMask);
		return _Utils_update(
			z80_main,
			{
				aG: (z80_main.aG & 255) | $author$project$Utils$shiftLeftBy8(new_h)
			});
	});
var $author$project$Z80Registers$ChangeSingleL = 1;
var $author$project$RegisterChange$SingleRegisterChange = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$GroupCB$resetLbit = F2(
	function (bitMask, z80_main) {
		return A2(
			$author$project$RegisterChange$SingleRegisterChange,
			1,
			(255 & z80_main.aG) & $author$project$Utils$inverseBitMaskFromBit(bitMask));
	});
var $author$project$RegisterChange$Shifter2 = 2;
var $author$project$GroupCB$rl_indirect_hl = function (z80_main) {
	return A2(
		$author$project$RegisterChange$RegisterChangeShifter,
		2,
		function ($) {
			return $.aG;
		});
};
var $author$project$RegisterChange$Shifter3 = 3;
var $author$project$GroupCB$rr_indirect_hl = function (z80_main) {
	return A2(
		$author$project$RegisterChange$RegisterChangeShifter,
		3,
		function ($) {
			return $.aG;
		});
};
var $author$project$GroupCB$setBbit = F2(
	function (bitMask, z80_main) {
		return _Utils_update(
			z80_main,
			{
				dw: z80_main.dw | $author$project$Utils$bitMaskFromBit(bitMask)
			});
	});
var $author$project$GroupCB$setCbit = F2(
	function (bitMask, z80_main) {
		return _Utils_update(
			z80_main,
			{
				dI: z80_main.dI | $author$project$Utils$bitMaskFromBit(bitMask)
			});
	});
var $author$project$GroupCB$setDbit = F2(
	function (bitMask, z80_main) {
		return _Utils_update(
			z80_main,
			{
				dN: z80_main.dN | $author$project$Utils$bitMaskFromBit(bitMask)
			});
	});
var $author$project$GroupCB$setEbit = F2(
	function (bitMask, z80_main) {
		return _Utils_update(
			z80_main,
			{
				dT: z80_main.dT | $author$project$Utils$bitMaskFromBit(bitMask)
			});
	});
var $author$project$RegisterChange$IndirectBitSet = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$GroupCB$setHLbit = F2(
	function (bitMask, z80_main) {
		return A2($author$project$RegisterChange$IndirectBitSet, bitMask, z80_main.aG);
	});
var $author$project$GroupCB$setHbit = F2(
	function (bitMask, z80_main) {
		var new_h = $author$project$Utils$shiftRightBy8(z80_main.aG) | $author$project$Utils$bitMaskFromBit(bitMask);
		return _Utils_update(
			z80_main,
			{
				aG: (z80_main.aG & 255) | $author$project$Utils$shiftLeftBy8(new_h)
			});
	});
var $author$project$GroupCB$setLbit = F2(
	function (bitMask, z80_main) {
		return A2(
			$author$project$RegisterChange$SingleRegisterChange,
			1,
			(255 & z80_main.aG) | $author$project$Utils$bitMaskFromBit(bitMask));
	});
var $author$project$RegisterChange$Shifter4 = 4;
var $author$project$GroupCB$sla_indirect_hl = function (z80_main) {
	return A2(
		$author$project$RegisterChange$RegisterChangeShifter,
		4,
		function ($) {
			return $.aG;
		});
};
var $author$project$RegisterChange$Shifter6 = 6;
var $author$project$GroupCB$sll_indirect_hl = function (z80_main) {
	return A2(
		$author$project$RegisterChange$RegisterChangeShifter,
		6,
		function ($) {
			return $.aG;
		});
};
var $author$project$RegisterChange$Shifter5 = 5;
var $author$project$GroupCB$sra_indirect_hl = function (z80_main) {
	return A2(
		$author$project$RegisterChange$RegisterChangeShifter,
		5,
		function ($) {
			return $.aG;
		});
};
var $author$project$RegisterChange$Shifter7 = 7;
var $author$project$GroupCB$srl_indirect_hl = function (z80_main) {
	return A2(
		$author$project$RegisterChange$RegisterChangeShifter,
		7,
		function ($) {
			return $.aG;
		});
};
var $author$project$GroupCB$singleByteMainRegsCB = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			6,
			_Utils_Tuple2(
				function (z80_main) {
					return A2(
						$author$project$RegisterChange$RegisterChangeShifter,
						0,
						function ($) {
							return $.aG;
						});
				},
				11)),
			_Utils_Tuple2(
			14,
			_Utils_Tuple2(
				function (z80_main) {
					return A2(
						$author$project$RegisterChange$RegisterChangeShifter,
						1,
						function ($) {
							return $.aG;
						});
				},
				11)),
			_Utils_Tuple2(
			22,
			_Utils_Tuple2($author$project$GroupCB$rl_indirect_hl, 11)),
			_Utils_Tuple2(
			30,
			_Utils_Tuple2($author$project$GroupCB$rr_indirect_hl, 11)),
			_Utils_Tuple2(
			38,
			_Utils_Tuple2($author$project$GroupCB$sla_indirect_hl, 11)),
			_Utils_Tuple2(
			46,
			_Utils_Tuple2($author$project$GroupCB$sra_indirect_hl, 11)),
			_Utils_Tuple2(
			54,
			_Utils_Tuple2($author$project$GroupCB$sll_indirect_hl, 11)),
			_Utils_Tuple2(
			62,
			_Utils_Tuple2($author$project$GroupCB$srl_indirect_hl, 11)),
			_Utils_Tuple2(
			128,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetBbit(0));
				},
				4)),
			_Utils_Tuple2(
			129,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetCbit(0));
				},
				4)),
			_Utils_Tuple2(
			130,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetDbit(0));
				},
				4)),
			_Utils_Tuple2(
			131,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetEbit(0));
				},
				4)),
			_Utils_Tuple2(
			132,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetHbit(0));
				},
				4)),
			_Utils_Tuple2(
			133,
			_Utils_Tuple2(
				$author$project$GroupCB$resetLbit(0),
				4)),
			_Utils_Tuple2(
			134,
			_Utils_Tuple2(
				$author$project$GroupCB$resetHLbit(0),
				4)),
			_Utils_Tuple2(
			136,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetBbit(1));
				},
				4)),
			_Utils_Tuple2(
			137,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetCbit(1));
				},
				4)),
			_Utils_Tuple2(
			138,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetDbit(1));
				},
				4)),
			_Utils_Tuple2(
			139,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetEbit(1));
				},
				4)),
			_Utils_Tuple2(
			140,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetHbit(1));
				},
				4)),
			_Utils_Tuple2(
			141,
			_Utils_Tuple2(
				$author$project$GroupCB$resetLbit(1),
				4)),
			_Utils_Tuple2(
			142,
			_Utils_Tuple2(
				$author$project$GroupCB$resetHLbit(1),
				4)),
			_Utils_Tuple2(
			144,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetBbit(2));
				},
				4)),
			_Utils_Tuple2(
			145,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetCbit(2));
				},
				4)),
			_Utils_Tuple2(
			146,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetDbit(2));
				},
				4)),
			_Utils_Tuple2(
			147,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetEbit(2));
				},
				4)),
			_Utils_Tuple2(
			148,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetHbit(2));
				},
				4)),
			_Utils_Tuple2(
			149,
			_Utils_Tuple2(
				$author$project$GroupCB$resetLbit(2),
				4)),
			_Utils_Tuple2(
			150,
			_Utils_Tuple2(
				$author$project$GroupCB$resetHLbit(2),
				4)),
			_Utils_Tuple2(
			152,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetBbit(3));
				},
				4)),
			_Utils_Tuple2(
			153,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetCbit(3));
				},
				4)),
			_Utils_Tuple2(
			154,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetDbit(3));
				},
				4)),
			_Utils_Tuple2(
			155,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetEbit(3));
				},
				4)),
			_Utils_Tuple2(
			156,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetHbit(3));
				},
				4)),
			_Utils_Tuple2(
			157,
			_Utils_Tuple2(
				$author$project$GroupCB$resetLbit(3),
				4)),
			_Utils_Tuple2(
			158,
			_Utils_Tuple2(
				$author$project$GroupCB$resetHLbit(3),
				4)),
			_Utils_Tuple2(
			160,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetBbit(4));
				},
				4)),
			_Utils_Tuple2(
			161,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetCbit(4));
				},
				4)),
			_Utils_Tuple2(
			162,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetDbit(4));
				},
				4)),
			_Utils_Tuple2(
			163,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetEbit(4));
				},
				4)),
			_Utils_Tuple2(
			164,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetHbit(4));
				},
				4)),
			_Utils_Tuple2(
			165,
			_Utils_Tuple2(
				$author$project$GroupCB$resetLbit(4),
				4)),
			_Utils_Tuple2(
			166,
			_Utils_Tuple2(
				$author$project$GroupCB$resetHLbit(4),
				4)),
			_Utils_Tuple2(
			168,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetBbit(5));
				},
				4)),
			_Utils_Tuple2(
			169,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetCbit(5));
				},
				4)),
			_Utils_Tuple2(
			170,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetDbit(5));
				},
				4)),
			_Utils_Tuple2(
			171,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetEbit(5));
				},
				4)),
			_Utils_Tuple2(
			172,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetHbit(5));
				},
				4)),
			_Utils_Tuple2(
			173,
			_Utils_Tuple2(
				$author$project$GroupCB$resetLbit(5),
				4)),
			_Utils_Tuple2(
			174,
			_Utils_Tuple2(
				$author$project$GroupCB$resetHLbit(5),
				4)),
			_Utils_Tuple2(
			176,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetBbit(6));
				},
				4)),
			_Utils_Tuple2(
			177,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetCbit(6));
				},
				4)),
			_Utils_Tuple2(
			178,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetDbit(6));
				},
				4)),
			_Utils_Tuple2(
			179,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetEbit(6));
				},
				4)),
			_Utils_Tuple2(
			180,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetHbit(6));
				},
				4)),
			_Utils_Tuple2(
			181,
			_Utils_Tuple2(
				$author$project$GroupCB$resetLbit(6),
				4)),
			_Utils_Tuple2(
			182,
			_Utils_Tuple2(
				$author$project$GroupCB$resetHLbit(6),
				4)),
			_Utils_Tuple2(
			184,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetBbit(7));
				},
				4)),
			_Utils_Tuple2(
			185,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetCbit(7));
				},
				4)),
			_Utils_Tuple2(
			186,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetDbit(7));
				},
				4)),
			_Utils_Tuple2(
			187,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetEbit(7));
				},
				4)),
			_Utils_Tuple2(
			188,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$resetHbit(7));
				},
				4)),
			_Utils_Tuple2(
			189,
			_Utils_Tuple2(
				$author$project$GroupCB$resetLbit(7),
				4)),
			_Utils_Tuple2(
			190,
			_Utils_Tuple2(
				$author$project$GroupCB$resetHLbit(7),
				4)),
			_Utils_Tuple2(
			192,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setBbit(0));
				},
				4)),
			_Utils_Tuple2(
			193,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setCbit(0));
				},
				4)),
			_Utils_Tuple2(
			194,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setDbit(0));
				},
				4)),
			_Utils_Tuple2(
			195,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setEbit(0));
				},
				4)),
			_Utils_Tuple2(
			196,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setHbit(0));
				},
				4)),
			_Utils_Tuple2(
			197,
			_Utils_Tuple2(
				$author$project$GroupCB$setLbit(0),
				4)),
			_Utils_Tuple2(
			198,
			_Utils_Tuple2(
				$author$project$GroupCB$setHLbit(0),
				4)),
			_Utils_Tuple2(
			200,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setBbit(1));
				},
				4)),
			_Utils_Tuple2(
			201,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setCbit(1));
				},
				4)),
			_Utils_Tuple2(
			202,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setDbit(1));
				},
				4)),
			_Utils_Tuple2(
			203,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setEbit(1));
				},
				4)),
			_Utils_Tuple2(
			204,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setHbit(1));
				},
				4)),
			_Utils_Tuple2(
			205,
			_Utils_Tuple2(
				$author$project$GroupCB$setLbit(1),
				4)),
			_Utils_Tuple2(
			206,
			_Utils_Tuple2(
				$author$project$GroupCB$setHLbit(1),
				4)),
			_Utils_Tuple2(
			208,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setBbit(2));
				},
				4)),
			_Utils_Tuple2(
			209,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setCbit(2));
				},
				4)),
			_Utils_Tuple2(
			210,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setDbit(2));
				},
				4)),
			_Utils_Tuple2(
			211,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setEbit(2));
				},
				4)),
			_Utils_Tuple2(
			212,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setHbit(2));
				},
				4)),
			_Utils_Tuple2(
			213,
			_Utils_Tuple2(
				$author$project$GroupCB$setLbit(2),
				4)),
			_Utils_Tuple2(
			214,
			_Utils_Tuple2(
				$author$project$GroupCB$setHLbit(2),
				4)),
			_Utils_Tuple2(
			216,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setBbit(3));
				},
				4)),
			_Utils_Tuple2(
			217,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setCbit(3));
				},
				4)),
			_Utils_Tuple2(
			218,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setDbit(3));
				},
				4)),
			_Utils_Tuple2(
			219,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setEbit(3));
				},
				4)),
			_Utils_Tuple2(
			220,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setHbit(3));
				},
				4)),
			_Utils_Tuple2(
			221,
			_Utils_Tuple2(
				$author$project$GroupCB$setLbit(3),
				4)),
			_Utils_Tuple2(
			222,
			_Utils_Tuple2(
				$author$project$GroupCB$setHLbit(3),
				4)),
			_Utils_Tuple2(
			224,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setBbit(4));
				},
				4)),
			_Utils_Tuple2(
			225,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setCbit(4));
				},
				4)),
			_Utils_Tuple2(
			226,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setDbit(4));
				},
				4)),
			_Utils_Tuple2(
			227,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setEbit(4));
				},
				4)),
			_Utils_Tuple2(
			228,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setHbit(4));
				},
				4)),
			_Utils_Tuple2(
			229,
			_Utils_Tuple2(
				$author$project$GroupCB$setLbit(4),
				4)),
			_Utils_Tuple2(
			230,
			_Utils_Tuple2(
				$author$project$GroupCB$setHLbit(4),
				4)),
			_Utils_Tuple2(
			232,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setBbit(5));
				},
				4)),
			_Utils_Tuple2(
			233,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setCbit(5));
				},
				4)),
			_Utils_Tuple2(
			234,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setDbit(5));
				},
				4)),
			_Utils_Tuple2(
			235,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setEbit(5));
				},
				4)),
			_Utils_Tuple2(
			236,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setHbit(5));
				},
				4)),
			_Utils_Tuple2(
			237,
			_Utils_Tuple2(
				$author$project$GroupCB$setLbit(5),
				4)),
			_Utils_Tuple2(
			238,
			_Utils_Tuple2(
				$author$project$GroupCB$setHLbit(5),
				4)),
			_Utils_Tuple2(
			240,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setBbit(6));
				},
				4)),
			_Utils_Tuple2(
			241,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setCbit(6));
				},
				4)),
			_Utils_Tuple2(
			242,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setDbit(6));
				},
				4)),
			_Utils_Tuple2(
			243,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setEbit(6));
				},
				4)),
			_Utils_Tuple2(
			244,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setHbit(6));
				},
				4)),
			_Utils_Tuple2(
			245,
			_Utils_Tuple2(
				$author$project$GroupCB$setLbit(6),
				4)),
			_Utils_Tuple2(
			246,
			_Utils_Tuple2(
				$author$project$GroupCB$setHLbit(6),
				4)),
			_Utils_Tuple2(
			248,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setBbit(7));
				},
				4)),
			_Utils_Tuple2(
			249,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setCbit(7));
				},
				4)),
			_Utils_Tuple2(
			250,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setDbit(7));
				},
				4)),
			_Utils_Tuple2(
			251,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setEbit(7));
				},
				4)),
			_Utils_Tuple2(
			252,
			_Utils_Tuple2(
				function (z80_main) {
					return $author$project$RegisterChange$TransformMainRegisters(
						$author$project$GroupCB$setHbit(7));
				},
				4)),
			_Utils_Tuple2(
			253,
			_Utils_Tuple2(
				$author$project$GroupCB$setLbit(7),
				4)),
			_Utils_Tuple2(
			254,
			_Utils_Tuple2(
				$author$project$GroupCB$setHLbit(7),
				4))
		]));
var $author$project$RegisterChange$AdcHLSP = {$: 12};
var $author$project$Z80Core$Backwards = 1;
var $author$project$RegisterChange$Cpir = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$RegisterChange$EDNoOp = {$: 0};
var $author$project$CpuTimeCTime$EighteenTStates = 14;
var $author$project$Z80Core$Forwards = 0;
var $author$project$Interrupts$IM1 = 1;
var $author$project$Interrupts$IM2 = 2;
var $author$project$RegisterChange$IN_A_C = {$: 11};
var $author$project$RegisterChange$IN_C = {$: 10};
var $author$project$RegisterChange$InRC = function (a) {
	return {$: 4, a: a};
};
var $author$project$RegisterChange$Ldir = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$RegisterChange$RLD = {$: 9};
var $author$project$RegisterChange$RRD = {$: 8};
var $author$project$RegisterChange$RegChangeIm = function (a) {
	return {$: 1, a: a};
};
var $author$project$RegisterChange$SbcHL = function (a) {
	return {$: 7, a: a};
};
var $author$project$RegisterChange$Z80InI = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$RegisterChange$Z80OutI = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$GroupED$singleByteMainRegsED = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			0,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			1,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			4,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			8,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			9,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			16,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			17,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			20,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			24,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			25,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			32,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			33,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			36,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			40,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			41,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			52,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			56,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			57,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			64,
			_Utils_Tuple2(
				$author$project$RegisterChange$InRC(0),
				8)),
			_Utils_Tuple2(
			65,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			66,
			_Utils_Tuple2(
				$author$project$RegisterChange$SbcHL(2),
				11)),
			_Utils_Tuple2(
			69,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			70,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			72,
			_Utils_Tuple2(
				$author$project$RegisterChange$InRC(1),
				8)),
			_Utils_Tuple2(
			73,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			77,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			78,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			80,
			_Utils_Tuple2(
				$author$project$RegisterChange$InRC(2),
				8)),
			_Utils_Tuple2(
			81,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			82,
			_Utils_Tuple2(
				$author$project$RegisterChange$SbcHL(1),
				11)),
			_Utils_Tuple2(
			85,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			86,
			_Utils_Tuple2(
				$author$project$RegisterChange$RegChangeIm(1),
				4)),
			_Utils_Tuple2(
			88,
			_Utils_Tuple2(
				$author$project$RegisterChange$InRC(3),
				8)),
			_Utils_Tuple2(
			89,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			93,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			94,
			_Utils_Tuple2(
				$author$project$RegisterChange$RegChangeIm(2),
				4)),
			_Utils_Tuple2(
			96,
			_Utils_Tuple2(
				$author$project$RegisterChange$InRC(4),
				8)),
			_Utils_Tuple2(
			97,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			98,
			_Utils_Tuple2(
				$author$project$RegisterChange$SbcHL(0),
				11)),
			_Utils_Tuple2(
			101,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			102,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			103,
			_Utils_Tuple2($author$project$RegisterChange$RRD, 14)),
			_Utils_Tuple2(
			104,
			_Utils_Tuple2(
				$author$project$RegisterChange$InRC(5),
				8)),
			_Utils_Tuple2(
			105,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			109,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			110,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			111,
			_Utils_Tuple2($author$project$RegisterChange$RLD, 14)),
			_Utils_Tuple2(
			112,
			_Utils_Tuple2($author$project$RegisterChange$IN_C, 8)),
			_Utils_Tuple2(
			113,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			114,
			_Utils_Tuple2(
				$author$project$RegisterChange$SbcHL(3),
				11)),
			_Utils_Tuple2(
			117,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			118,
			_Utils_Tuple2(
				$author$project$RegisterChange$RegChangeIm(1),
				4)),
			_Utils_Tuple2(
			120,
			_Utils_Tuple2($author$project$RegisterChange$IN_A_C, 8)),
			_Utils_Tuple2(
			121,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			122,
			_Utils_Tuple2($author$project$RegisterChange$AdcHLSP, 11)),
			_Utils_Tuple2(
			125,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			126,
			_Utils_Tuple2(
				$author$project$RegisterChange$RegChangeIm(2),
				4)),
			_Utils_Tuple2(
			162,
			_Utils_Tuple2(
				A2($author$project$RegisterChange$Z80InI, 0, false),
				12)),
			_Utils_Tuple2(
			163,
			_Utils_Tuple2(
				A2($author$project$RegisterChange$Z80OutI, 0, false),
				12)),
			_Utils_Tuple2(
			170,
			_Utils_Tuple2(
				A2($author$project$RegisterChange$Z80InI, 1, false),
				12)),
			_Utils_Tuple2(
			171,
			_Utils_Tuple2(
				A2($author$project$RegisterChange$Z80OutI, 1, false),
				12)),
			_Utils_Tuple2(
			178,
			_Utils_Tuple2(
				A2($author$project$RegisterChange$Z80InI, 0, true),
				12)),
			_Utils_Tuple2(
			179,
			_Utils_Tuple2(
				A2($author$project$RegisterChange$Z80OutI, 0, true),
				12)),
			_Utils_Tuple2(
			186,
			_Utils_Tuple2(
				A2($author$project$RegisterChange$Z80InI, 1, true),
				12)),
			_Utils_Tuple2(
			187,
			_Utils_Tuple2(
				A2($author$project$RegisterChange$Z80OutI, 1, true),
				12)),
			_Utils_Tuple2(
			191,
			_Utils_Tuple2($author$project$RegisterChange$EDNoOp, 4)),
			_Utils_Tuple2(
			160,
			_Utils_Tuple2(
				A2($author$project$RegisterChange$Ldir, 0, false),
				12)),
			_Utils_Tuple2(
			161,
			_Utils_Tuple2(
				A2($author$project$RegisterChange$Cpir, 0, false),
				12)),
			_Utils_Tuple2(
			168,
			_Utils_Tuple2(
				A2($author$project$RegisterChange$Ldir, 1, false),
				12)),
			_Utils_Tuple2(
			169,
			_Utils_Tuple2(
				A2($author$project$RegisterChange$Cpir, 1, false),
				12)),
			_Utils_Tuple2(
			176,
			_Utils_Tuple2(
				A2($author$project$RegisterChange$Ldir, 0, true),
				12)),
			_Utils_Tuple2(
			177,
			_Utils_Tuple2(
				A2($author$project$RegisterChange$Cpir, 0, true),
				12)),
			_Utils_Tuple2(
			184,
			_Utils_Tuple2(
				A2($author$project$RegisterChange$Ldir, 1, true),
				12)),
			_Utils_Tuple2(
			185,
			_Utils_Tuple2(
				A2($author$project$RegisterChange$Cpir, 1, true),
				12))
		]));
var $author$project$RegisterChange$FlagsIndirectWithShifter = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$RegisterChange$RegisterChangeIndexShifter = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$RegisterChange$RegisterIndirectWithShifter = F3(
	function (a, b, c) {
		return {$: 15, a: a, b: b, c: c};
	});
var $author$project$RegisterChange$ResetBitIndirectA = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$RegisterChange$ResetBitIndirectWithCopy = F3(
	function (a, b, c) {
		return {$: 17, a: a, b: b, c: c};
	});
var $author$project$RegisterChange$SetBitIndirectA = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$RegisterChange$SetBitIndirectWithCopy = F3(
	function (a, b, c) {
		return {$: 16, a: a, b: b, c: c};
	});
var $author$project$GroupCBIXIY$resetIXbit = F3(
	function (bitMask, offset, z80_main) {
		return A2(
			$author$project$RegisterChange$IndirectBitReset,
			bitMask,
			65535 & (z80_main.o + $author$project$Utils$byte(offset)));
	});
var $author$project$GroupCBIXIY$singleByteMainRegsIXCB = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			0,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							0,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			1,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							0,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			2,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							0,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			3,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							0,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			4,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							0,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			5,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							0,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			6,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$RegisterChangeIndexShifter,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			7,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$FlagsIndirectWithShifter,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			8,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							1,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			9,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							1,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			10,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							1,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			11,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							1,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			12,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							1,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			13,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							1,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			14,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$RegisterChangeIndexShifter,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			15,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$FlagsIndirectWithShifter,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			16,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							2,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			17,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							2,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			18,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							2,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			19,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							2,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			20,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							2,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			21,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							2,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			22,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$RegisterChangeIndexShifter,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			23,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$FlagsIndirectWithShifter,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			24,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							3,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			25,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							3,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			26,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							3,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			27,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							3,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			28,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							3,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			29,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							3,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			30,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$RegisterChangeIndexShifter,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			31,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$FlagsIndirectWithShifter,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			32,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							4,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			33,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							4,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			34,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							4,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			35,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							4,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			36,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							4,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			37,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							4,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			38,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$RegisterChangeIndexShifter,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				11)),
			_Utils_Tuple2(
			39,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$FlagsIndirectWithShifter,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			40,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							5,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			41,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							5,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			42,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							5,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			43,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							5,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			44,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							5,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			45,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							5,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			46,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$RegisterChangeIndexShifter,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				11)),
			_Utils_Tuple2(
			47,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$FlagsIndirectWithShifter,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			48,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							6,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			49,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							6,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			50,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							6,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			51,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							6,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			52,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							6,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			53,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							6,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			54,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$RegisterChangeIndexShifter,
							6,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				11)),
			_Utils_Tuple2(
			55,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$FlagsIndirectWithShifter,
							6,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			56,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							7,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			57,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							7,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			58,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							7,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			59,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							7,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			60,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							7,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			61,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							7,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			62,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$RegisterChangeIndexShifter,
							7,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				11)),
			_Utils_Tuple2(
			63,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$FlagsIndirectWithShifter,
							7,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			128,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							0,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			129,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							0,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			130,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							0,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			131,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							0,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			132,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							0,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			133,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							0,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			134,
			_Utils_Tuple2(
				$author$project$GroupCBIXIY$resetIXbit(0),
				17)),
			_Utils_Tuple2(
			135,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$ResetBitIndirectA,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			136,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							1,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			137,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							1,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			138,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							1,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			139,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							1,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			140,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							1,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			141,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							1,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			142,
			_Utils_Tuple2(
				$author$project$GroupCBIXIY$resetIXbit(1),
				17)),
			_Utils_Tuple2(
			143,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$ResetBitIndirectA,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			144,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							2,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			145,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							2,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			146,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							2,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			147,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							2,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			148,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							2,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			149,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							2,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			150,
			_Utils_Tuple2(
				$author$project$GroupCBIXIY$resetIXbit(2),
				17)),
			_Utils_Tuple2(
			151,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$ResetBitIndirectA,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			152,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							3,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			153,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							3,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			154,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							3,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			155,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							3,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			156,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							3,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			157,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							3,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			158,
			_Utils_Tuple2(
				$author$project$GroupCBIXIY$resetIXbit(3),
				17)),
			_Utils_Tuple2(
			159,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$ResetBitIndirectA,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			160,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							4,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			161,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							4,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			162,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							4,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			163,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							4,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			164,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							4,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			165,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							4,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			166,
			_Utils_Tuple2(
				$author$project$GroupCBIXIY$resetIXbit(4),
				17)),
			_Utils_Tuple2(
			167,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$ResetBitIndirectA,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			168,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							5,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			169,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							5,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			170,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							5,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			171,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							5,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			172,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							5,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			173,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							5,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			174,
			_Utils_Tuple2(
				$author$project$GroupCBIXIY$resetIXbit(5),
				17)),
			_Utils_Tuple2(
			175,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$ResetBitIndirectA,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			176,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							6,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			177,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							6,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			178,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							6,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			179,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							6,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			180,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							6,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			181,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							6,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			182,
			_Utils_Tuple2(
				$author$project$GroupCBIXIY$resetIXbit(6),
				17)),
			_Utils_Tuple2(
			183,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$ResetBitIndirectA,
							6,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			184,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							7,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			185,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							7,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			186,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							7,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			187,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							7,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			188,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							7,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			189,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							7,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			190,
			_Utils_Tuple2(
				$author$project$GroupCBIXIY$resetIXbit(7),
				17)),
			_Utils_Tuple2(
			191,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$ResetBitIndirectA,
							7,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			192,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							0,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			193,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							0,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			194,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							0,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			195,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							0,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			196,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							0,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			197,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							0,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			198,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$IndirectBitSet,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			199,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$SetBitIndirectA,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			200,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							1,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			201,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							1,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			202,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							1,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			203,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							1,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			204,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							1,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			205,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							1,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			206,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$IndirectBitSet,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			207,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$SetBitIndirectA,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			208,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							2,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			209,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							2,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			210,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							2,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			211,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							2,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			212,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							2,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			213,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							2,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			214,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$IndirectBitSet,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			215,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$SetBitIndirectA,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			216,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							3,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			217,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							3,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			218,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							3,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			219,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							3,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			220,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							3,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			221,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							3,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			222,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$IndirectBitSet,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			223,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$SetBitIndirectA,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			224,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							4,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			225,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							4,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			226,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							4,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			227,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							4,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			228,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							4,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			229,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							4,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			230,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$IndirectBitSet,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			231,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$SetBitIndirectA,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			232,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							5,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			233,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							5,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			234,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							5,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			235,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							5,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			236,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							5,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			237,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							5,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			238,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$IndirectBitSet,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			239,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$SetBitIndirectA,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			240,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							6,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			241,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							6,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			242,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							6,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			243,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							6,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			244,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							6,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			245,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							6,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			246,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$IndirectBitSet,
							6,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			247,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$SetBitIndirectA,
							6,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			248,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							7,
							0,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			249,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							7,
							1,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			250,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							7,
							2,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			251,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							7,
							3,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			252,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							7,
							4,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			253,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							7,
							5,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			254,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$IndirectBitSet,
							7,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			255,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$SetBitIndirectA,
							7,
							z80_main.o + $author$project$Utils$byte(offset));
					}),
				17))
		]));
var $author$project$GroupCBIXIY$resetIYbit = F3(
	function (bitMask, offset, z80_main) {
		return A2(
			$author$project$RegisterChange$IndirectBitReset,
			bitMask,
			65535 & (z80_main.p + $author$project$Utils$byte(offset)));
	});
var $author$project$GroupCBIXIY$singleByteMainRegsIYCB = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			0,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							0,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			1,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							0,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			2,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							0,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			3,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							0,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			4,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							0,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			5,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							0,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			6,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$RegisterChangeIndexShifter,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			7,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$FlagsIndirectWithShifter,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			8,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							1,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			9,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							1,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			10,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							1,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			11,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							1,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			12,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							1,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			13,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							1,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			14,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$RegisterChangeIndexShifter,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			15,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$FlagsIndirectWithShifter,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			16,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							2,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			17,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							2,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			18,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							2,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			19,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							2,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			20,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							2,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			21,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							2,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			22,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$RegisterChangeIndexShifter,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			23,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$FlagsIndirectWithShifter,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			24,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							3,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			25,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							3,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			26,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							3,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			27,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							3,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			28,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							3,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			29,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							3,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			30,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$RegisterChangeIndexShifter,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			31,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$FlagsIndirectWithShifter,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			32,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							4,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			33,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							4,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			34,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							4,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			35,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							4,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			36,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							4,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			37,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							4,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			38,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$RegisterChangeIndexShifter,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			39,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$FlagsIndirectWithShifter,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			40,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							5,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			41,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							5,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			42,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							5,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			43,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							5,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			44,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							5,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			45,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							5,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			46,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$RegisterChangeIndexShifter,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			47,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$FlagsIndirectWithShifter,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			48,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							6,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			49,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							6,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			50,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							6,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			51,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							6,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			52,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							6,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			53,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							6,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			54,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$RegisterChangeIndexShifter,
							6,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			55,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$FlagsIndirectWithShifter,
							6,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			56,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							7,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			57,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							7,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			58,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							7,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			59,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							7,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			60,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							7,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			61,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$RegisterIndirectWithShifter,
							7,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			62,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$RegisterChangeIndexShifter,
							7,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			63,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$FlagsIndirectWithShifter,
							7,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			128,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							0,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			129,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							0,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			130,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							0,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			131,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							0,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			132,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							0,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			133,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							0,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			134,
			_Utils_Tuple2(
				$author$project$GroupCBIXIY$resetIYbit(0),
				17)),
			_Utils_Tuple2(
			135,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$ResetBitIndirectA,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			136,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							1,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			137,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							1,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			138,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							1,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			139,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							1,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			140,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							1,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			141,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							1,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			142,
			_Utils_Tuple2(
				$author$project$GroupCBIXIY$resetIYbit(1),
				17)),
			_Utils_Tuple2(
			143,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$ResetBitIndirectA,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			144,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							2,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			145,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							2,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			146,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							2,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			147,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							2,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			148,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							2,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			149,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							2,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			150,
			_Utils_Tuple2(
				$author$project$GroupCBIXIY$resetIYbit(2),
				17)),
			_Utils_Tuple2(
			151,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$ResetBitIndirectA,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			152,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							3,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			153,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							3,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			154,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							3,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			155,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							3,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			156,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							3,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			157,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							3,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			158,
			_Utils_Tuple2(
				$author$project$GroupCBIXIY$resetIYbit(3),
				17)),
			_Utils_Tuple2(
			159,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$ResetBitIndirectA,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			160,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							4,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			161,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							4,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			162,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							4,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			163,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							4,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			164,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							4,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			165,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							4,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			166,
			_Utils_Tuple2(
				$author$project$GroupCBIXIY$resetIYbit(4),
				17)),
			_Utils_Tuple2(
			167,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$ResetBitIndirectA,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			168,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							5,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			169,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							5,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			170,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							5,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			171,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							5,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			172,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							5,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			173,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							5,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			174,
			_Utils_Tuple2(
				$author$project$GroupCBIXIY$resetIYbit(5),
				17)),
			_Utils_Tuple2(
			175,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$ResetBitIndirectA,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			176,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							6,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			177,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							6,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			178,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							6,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			179,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							6,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			180,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							6,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			181,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							6,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			182,
			_Utils_Tuple2(
				$author$project$GroupCBIXIY$resetIYbit(6),
				17)),
			_Utils_Tuple2(
			183,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$ResetBitIndirectA,
							6,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			184,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							7,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			185,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							7,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			186,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							7,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			187,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							7,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			188,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							7,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			189,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$ResetBitIndirectWithCopy,
							7,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			190,
			_Utils_Tuple2(
				$author$project$GroupCBIXIY$resetIYbit(7),
				17)),
			_Utils_Tuple2(
			191,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$ResetBitIndirectA,
							7,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			192,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							0,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			193,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							0,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			194,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							0,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			195,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							0,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			196,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							0,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			197,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							0,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			198,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$IndirectBitSet,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			199,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$SetBitIndirectA,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			200,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							1,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			201,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							1,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			202,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							1,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			203,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							1,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			204,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							1,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			205,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							1,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			206,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$IndirectBitSet,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			207,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$SetBitIndirectA,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			208,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							2,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			209,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							2,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			210,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							2,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			211,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							2,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			212,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							2,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			213,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							2,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			214,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$IndirectBitSet,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			215,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$SetBitIndirectA,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			216,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							3,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			217,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							3,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			218,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							3,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			219,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							3,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			220,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							3,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			221,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							3,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			222,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$IndirectBitSet,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			223,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$SetBitIndirectA,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			224,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							4,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			225,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							4,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			226,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							4,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			227,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							4,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			228,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							4,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			229,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							4,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			230,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$IndirectBitSet,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			231,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$SetBitIndirectA,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			232,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							5,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			233,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							5,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			234,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							5,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			235,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							5,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			236,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							5,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			237,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							5,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			238,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$IndirectBitSet,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			239,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$SetBitIndirectA,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			240,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							6,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			241,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							6,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			242,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							6,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			243,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							6,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			244,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							6,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			245,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							6,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			246,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$IndirectBitSet,
							6,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			247,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$SetBitIndirectA,
							6,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			248,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							7,
							0,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			249,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							7,
							1,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			250,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							7,
							2,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			251,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							7,
							3,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			252,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							7,
							4,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			253,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A3(
							$author$project$RegisterChange$SetBitIndirectWithCopy,
							7,
							5,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			254,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$IndirectBitSet,
							7,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17)),
			_Utils_Tuple2(
			255,
			_Utils_Tuple2(
				F2(
					function (offset, z80_main) {
						return A2(
							$author$project$RegisterChange$SetBitIndirectA,
							7,
							z80_main.p + $author$project$Utils$byte(offset));
					}),
				17))
		]));
var $author$project$SingleEnvWithMain$IndirectBitTest = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$GroupCB$bit_0_indirect_hl = function (z80_main) {
	return A2($author$project$SingleEnvWithMain$IndirectBitTest, 0, z80_main.aG);
};
var $author$project$GroupCB$bit_1_indirect_hl = function (z80_main) {
	return A2($author$project$SingleEnvWithMain$IndirectBitTest, 1, z80_main.aG);
};
var $author$project$GroupCB$bit_2_indirect_hl = function (z80_main) {
	return A2($author$project$SingleEnvWithMain$IndirectBitTest, 2, z80_main.aG);
};
var $author$project$GroupCB$bit_3_indirect_hl = function (z80_main) {
	return A2($author$project$SingleEnvWithMain$IndirectBitTest, 3, z80_main.aG);
};
var $author$project$GroupCB$bit_4_indirect_hl = function (z80_main) {
	return A2($author$project$SingleEnvWithMain$IndirectBitTest, 4, z80_main.aG);
};
var $author$project$GroupCB$bit_5_indirect_hl = function (z80_main) {
	return A2($author$project$SingleEnvWithMain$IndirectBitTest, 5, z80_main.aG);
};
var $author$project$GroupCB$bit_6_indirect_hl = function (z80_main) {
	return A2($author$project$SingleEnvWithMain$IndirectBitTest, 6, z80_main.aG);
};
var $author$project$GroupCB$bit_7_indirect_hl = function (z80_main) {
	return A2($author$project$SingleEnvWithMain$IndirectBitTest, 7, z80_main.aG);
};
var $author$project$GroupCB$singleEnvMainRegsCB = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			70,
			_Utils_Tuple2($author$project$GroupCB$bit_0_indirect_hl, 8)),
			_Utils_Tuple2(
			78,
			_Utils_Tuple2($author$project$GroupCB$bit_1_indirect_hl, 8)),
			_Utils_Tuple2(
			86,
			_Utils_Tuple2($author$project$GroupCB$bit_2_indirect_hl, 8)),
			_Utils_Tuple2(
			94,
			_Utils_Tuple2($author$project$GroupCB$bit_3_indirect_hl, 8)),
			_Utils_Tuple2(
			102,
			_Utils_Tuple2($author$project$GroupCB$bit_4_indirect_hl, 8)),
			_Utils_Tuple2(
			110,
			_Utils_Tuple2($author$project$GroupCB$bit_5_indirect_hl, 8)),
			_Utils_Tuple2(
			118,
			_Utils_Tuple2($author$project$GroupCB$bit_6_indirect_hl, 8)),
			_Utils_Tuple2(
			126,
			_Utils_Tuple2($author$project$GroupCB$bit_7_indirect_hl, 8))
		]));
var $author$project$GroupCBIXIY$bitTests = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7]);
var $author$project$GroupCBIXIY$makeEnvMainDict = function (ix_func) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (d1, d2) {
				return A2($elm$core$Dict$union, d2, d1);
			}),
		$elm$core$Dict$empty,
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (bitIndex, bitType) {
					var start = 64 + (bitIndex * 8);
					return $elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (index) {
								return _Utils_Tuple2(
									index,
									_Utils_Tuple2(
										F4(
											function (z80_main, offset, rom48k, z80_env) {
												var address = 65535 & (ix_func(z80_main) + $author$project$Utils$byte(offset));
												return A2($author$project$SingleEnvWithMain$IndirectBitTest, bitType, address);
											}),
										16));
							},
							A2($elm$core$List$range, start, start + 7)));
				}),
			$author$project$GroupCBIXIY$bitTests));
};
var $author$project$GroupCBIXIY$singleEnvMainRegsIXCB = $author$project$GroupCBIXIY$makeEnvMainDict(
	function ($) {
		return $.o;
	});
var $author$project$GroupCBIXIY$singleEnvMainRegsIYCB = $author$project$GroupCBIXIY$makeEnvMainDict(
	function ($) {
		return $.p;
	});
var $author$project$Z80$runSpecial = F4(
	function (specialType, rom48k, pc, z80_core) {
		switch (specialType.$) {
			case 0:
				var param = specialType.a;
				var _v1 = A2($elm$core$Dict$get, param.e3, $author$project$GroupCB$singleByteMainRegsCB);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var mainRegFunc = _v2.a;
					var duration = _v2.b;
					return _Utils_Tuple3(
						$author$project$Z80Execute$RegisterChangeDelta(
							mainRegFunc(z80_core.u)),
						A2($author$project$CpuTimeCTime$addDuration, duration, param.aQ),
						1);
				} else {
					var _v3 = A2($elm$core$Dict$get, param.e3, $author$project$GroupCB$singleByteMainAndFlagRegistersCB);
					if (!_v3.$) {
						var _v4 = _v3.a;
						var f = _v4.a;
						var duration = _v4.b;
						return _Utils_Tuple3(
							$author$project$Z80Execute$PureDelta(
								A2(f, z80_core.u, z80_core.K)),
							A2($author$project$CpuTimeCTime$addDuration, duration, param.aQ),
							1);
					} else {
						var _v5 = A2($elm$core$Dict$get, param.e3, $author$project$SimpleFlagOps$singleByteFlagsCB);
						if (!_v5.$) {
							var _v6 = _v5.a;
							var flagFunc = _v6.a;
							var duration = _v6.b;
							return _Utils_Tuple3(
								$author$project$Z80Execute$RegisterChangeDelta(flagFunc),
								A2($author$project$CpuTimeCTime$addDuration, duration, param.aQ),
								1);
						} else {
							var _v7 = A2($elm$core$Dict$get, param.e3, $author$project$GroupCB$singleEnvMainRegsCB);
							if (!_v7.$) {
								var _v8 = _v7.a;
								var f = _v8.a;
								var duration = _v8.b;
								return _Utils_Tuple3(
									$author$project$Z80Execute$MainWithEnvDelta(
										f(z80_core.u)),
									A2($author$project$CpuTimeCTime$addDuration, duration, param.aQ),
									1);
							} else {
								return _Utils_Tuple3(
									A2($author$project$Z80Execute$UnknownInstruction, 'execute CB', param.e3),
									param.aQ,
									1);
							}
						}
					}
				}
			case 1:
				var offset = specialType.a;
				var param = specialType.b;
				var _v9 = A2(
					$elm$core$Maybe$map,
					function (_v10) {
						var f = _v10.a;
						var d = _v10.b;
						return _Utils_Tuple2(
							f(offset),
							d);
					},
					A2($elm$core$Dict$get, param.e3, $author$project$GroupCBIXIY$singleByteMainRegsIXCB));
				if (!_v9.$) {
					var _v11 = _v9.a;
					var mainRegFunc = _v11.a;
					var duration = _v11.b;
					return _Utils_Tuple3(
						$author$project$Z80Execute$RegisterChangeDelta(
							mainRegFunc(z80_core.u)),
						A2($author$project$CpuTimeCTime$addDuration, duration, param.aQ),
						3);
				} else {
					var _v12 = A2($elm$core$Dict$get, param.e3, $author$project$GroupCBIXIY$singleEnvMainRegsIXCB);
					if (!_v12.$) {
						var _v13 = _v12.a;
						var f = _v13.a;
						var duration = _v13.b;
						return _Utils_Tuple3(
							$author$project$Z80Execute$MainWithEnvDelta(
								A4(f, z80_core.u, offset, rom48k, z80_core.B)),
							A2($author$project$CpuTimeCTime$addDuration, duration, param.aQ),
							3);
					} else {
						return _Utils_Tuple3(
							A2($author$project$Z80Execute$UnknownInstruction, 'execute IXCB', param.e3),
							param.aQ,
							3);
					}
				}
			case 2:
				var iycboffset = specialType.a;
				var param = specialType.b;
				var _v14 = A2(
					$elm$core$Maybe$map,
					function (_v15) {
						var f = _v15.a;
						var d = _v15.b;
						return _Utils_Tuple2(
							f(iycboffset),
							d);
					},
					A2($elm$core$Dict$get, param.e3, $author$project$GroupCBIXIY$singleByteMainRegsIYCB));
				if (!_v14.$) {
					var _v16 = _v14.a;
					var mainRegFunc = _v16.a;
					var duration = _v16.b;
					return _Utils_Tuple3(
						$author$project$Z80Execute$RegisterChangeDelta(
							mainRegFunc(z80_core.u)),
						A2($author$project$CpuTimeCTime$addDuration, duration, param.aQ),
						3);
				} else {
					var _v17 = A2($elm$core$Dict$get, param.e3, $author$project$GroupCBIXIY$singleEnvMainRegsIYCB);
					if (!_v17.$) {
						var _v18 = _v17.a;
						var f = _v18.a;
						var duration = _v18.b;
						return _Utils_Tuple3(
							$author$project$Z80Execute$MainWithEnvDelta(
								A4(f, z80_core.u, iycboffset, rom48k, z80_core.B)),
							A2($author$project$CpuTimeCTime$addDuration, duration, param.aQ),
							3);
					} else {
						return _Utils_Tuple3(
							A2($author$project$Z80Execute$UnknownInstruction, 'execute IYCB', param.e3),
							param.aQ,
							3);
					}
				}
			default:
				var param = specialType.a;
				var _v19 = A2($elm$core$Dict$get, param.e3, $author$project$GroupED$singleByteMainRegsED);
				if (!_v19.$) {
					var _v20 = _v19.a;
					var mainRegFunc = _v20.a;
					var duration = _v20.b;
					return _Utils_Tuple3(
						$author$project$Z80Execute$EDChangeDelta(mainRegFunc),
						A2($author$project$CpuTimeCTime$addDuration, duration, param.aQ),
						1);
				} else {
					var _v21 = A2($elm$core$Dict$get, param.e3, $author$project$GroupED$singleByteFlagsED);
					if (!_v21.$) {
						var _v22 = _v21.a;
						var flagFunc = _v22.a;
						var duration = _v22.b;
						return _Utils_Tuple3(
							$author$project$Z80Execute$RegisterChangeDelta(
								flagFunc(z80_core.K)),
							A2($author$project$CpuTimeCTime$addDuration, duration, param.aQ),
							1);
					} else {
						var _v23 = A2($elm$core$Dict$get, param.e3, $author$project$GroupED$singleByteMainAndFlagsED);
						if (!_v23.$) {
							var _v24 = _v23.a;
							var f = _v24.a;
							var pcInc = _v24.b;
							var duration = _v24.c;
							return _Utils_Tuple3(
								$author$project$Z80Execute$PureDelta(
									A2(f, z80_core.u, z80_core.K)),
								A2($author$project$CpuTimeCTime$addDuration, duration, param.aQ),
								pcInc);
						} else {
							var _v25 = A2($elm$core$Dict$get, param.e3, $author$project$GroupED$edWithInterrupts);
							if (!_v25.$) {
								var _v26 = _v25.a;
								var f = _v26.a;
								var duration = _v26.b;
								return _Utils_Tuple3(
									$author$project$Z80Execute$InterruptDelta(
										f(z80_core.be)),
									A2($author$project$CpuTimeCTime$addDuration, duration, param.aQ),
									1);
							} else {
								var _v27 = A2($elm$core$Dict$get, param.e3, $author$project$GroupED$fourByteMainED);
								if (!_v27.$) {
									var _v28 = _v27.a;
									var mainRegFunc = _v28.a;
									var duration = _v28.b;
									var doubleParam = A4($author$project$Z80Mem$mem16, (pc + 2) & 65535, rom48k, param.aQ, z80_core.B);
									return _Utils_Tuple3(
										$author$project$Z80Execute$EDFourByteDelta(
											A2(mainRegFunc, z80_core.u, doubleParam.bx)),
										A2($author$project$CpuTimeCTime$addDuration, duration, doubleParam.aQ),
										3);
								} else {
									return _Utils_Tuple3(
										A2($author$project$Z80Execute$UnknownInstruction, 'runSpecial', param.e3),
										param.aQ,
										1);
								}
							}
						}
					}
				}
		}
	});
var $author$project$Z80$execute_delta = F4(
	function (ct, rom48k, pc, z80) {
		var executionType = function () {
			var _v1 = ct.e3;
			switch (_v1) {
				case 203:
					var param = A4($author$project$Z80Mem$mem, (pc + 1) & 65535, ct.aQ, rom48k, z80.B);
					return $author$project$Z80$Special(
						$author$project$Z80$BitManipCB(param));
				case 237:
					var param = A4($author$project$Z80Mem$mem, (pc + 1) & 65535, ct.aQ, rom48k, z80.B);
					return $author$project$Z80$Special(
						$author$project$Z80$EDMisc(param));
				case 221:
					var param = A4($author$project$Z80Mem$mem, (pc + 1) & 65535, ct.aQ, rom48k, z80.B);
					if (param.e3 === 203) {
						var ixcbparam = A4($author$project$Z80Mem$mem, (pc + 3) & 65535, ct.aQ, rom48k, z80.B);
						var ixcboffset = A4($author$project$Z80Mem$mem, (pc + 2) & 65535, ct.aQ, rom48k, z80.B);
						return $author$project$Z80$Special(
							A2($author$project$Z80$IXCB, ixcboffset.e3, ixcbparam));
					} else {
						return $author$project$Z80$IndexIX(param);
					}
				case 253:
					var param = A4($author$project$Z80Mem$mem, (pc + 1) & 65535, ct.aQ, rom48k, z80.B);
					if (param.e3 === 203) {
						var iycbparam = A4($author$project$Z80Mem$mem, (pc + 3) & 65535, ct.aQ, rom48k, z80.B);
						var iycboffset = A4($author$project$Z80Mem$mem, (pc + 2) & 65535, ct.aQ, rom48k, z80.B);
						return $author$project$Z80$Special(
							A2($author$project$Z80$IYCB, iycboffset.e3, iycbparam));
					} else {
						return $author$project$Z80$IndexIY(param);
					}
				default:
					return A2($author$project$Z80$Ordinary, ct.e3, ct.aQ);
			}
		}();
		switch (executionType.$) {
			case 0:
				var _int = executionType.a;
				var cpuTimeCTime = executionType.b;
				return A5($author$project$Z80$runOrdinary, _int, cpuTimeCTime, rom48k, pc, z80);
			case 1:
				var cpuTimeAndValue = executionType.a;
				return A4($author$project$Z80$runIndexIX, cpuTimeAndValue, rom48k, pc, z80);
			case 2:
				var cpuTimeAndValue = executionType.a;
				return A4($author$project$Z80$runIndexIY, cpuTimeAndValue, rom48k, pc, z80);
			default:
				var specialExecutionType = executionType.a;
				return A4($author$project$Z80$runSpecial, specialExecutionType, rom48k, pc, z80);
		}
	});
var $author$project$Z80$executeAndApplyDelta = F4(
	function (ct, iff, rom48k, z80clock) {
		var z80_core = z80clock.ae;
		var _v0 = A4($author$project$Z80$execute_delta, ct, rom48k, z80clock.cY, z80_core);
		var delta = _v0.a;
		var clockTime = _v0.b;
		var pc_inc = _v0.c;
		var pcAfter = function () {
			switch (pc_inc) {
				case 0:
					return (z80clock.cY + 1) & 65535;
				case 1:
					return (z80clock.cY + 2) & 65535;
				case 2:
					return (z80clock.cY + 3) & 65535;
				default:
					return (z80clock.cY + 4) & 65535;
			}
		}();
		var _v1 = A5($author$project$Z80Execute$apply_delta, z80_core, iff, rom48k, clockTime, delta);
		switch (_v1.$) {
			case 0:
				var z80Core = _v1.a;
				return _Utils_update(
					z80clock,
					{dM: clockTime, ae: z80Core, cY: pcAfter});
			case 11:
				var z80_main = _v1.a;
				return _Utils_update(
					z80clock,
					{
						dM: clockTime,
						ae: _Utils_update(
							z80_core,
							{u: z80_main}),
						cY: pcAfter
					});
			case 12:
				var z80_flags = _v1.a;
				return _Utils_update(
					z80clock,
					{
						dM: clockTime,
						ae: _Utils_update(
							z80_core,
							{K: z80_flags}),
						cY: pcAfter
					});
			case 2:
				var shortDelay = _v1.a;
				var z80Core = _v1.b;
				return _Utils_update(
					z80clock,
					{
						dM: A2($author$project$CpuTimeCTime$addExtraCpuTime, shortDelay, clockTime),
						ae: z80Core,
						cY: pcAfter
					});
			case 3:
				var new_pc = _v1.a;
				var z80Core = _v1.b;
				return _Utils_update(
					z80clock,
					{dM: clockTime, ae: z80Core, cY: new_pc});
			case 13:
				var offset = _v1.a;
				var shortDelay = _v1.b;
				var z80_main = _v1.c;
				return _Utils_update(
					z80clock,
					{
						dM: A2($author$project$CpuTimeCTime$addExtraCpuTime, shortDelay, clockTime),
						ae: _Utils_update(
							z80_core,
							{u: z80_main}),
						cY: 65535 & (pcAfter + offset)
					});
			case 4:
				var _int = _v1.a;
				return _Utils_update(
					z80clock,
					{dM: clockTime, cY: _int});
			case 5:
				var offset = _v1.a;
				return _Utils_update(
					z80clock,
					{dM: clockTime, cY: 65535 & (pcAfter + offset)});
			case 7:
				var _int = _v1.a;
				var shortDelay = _v1.b;
				var env = A3($author$project$Z80Env$z80_push, pcAfter, clockTime, z80_core.B);
				return _Utils_update(
					z80clock,
					{
						dM: A2($author$project$CpuTimeCTime$addExtraCpuTime, shortDelay, clockTime),
						ae: _Utils_update(
							z80_core,
							{B: env}),
						cY: _int
					});
			case 8:
				var _int = _v1.a;
				var env = A3($author$project$Z80Env$z80_push, pcAfter, clockTime, z80_core.B);
				return _Utils_update(
					z80clock,
					{
						dM: clockTime,
						ae: _Utils_update(
							z80_core,
							{B: env}),
						cY: _int
					});
			case 9:
				var repeatPCOffset = _v1.a;
				var z80Core = _v1.b;
				if (!repeatPCOffset) {
					return _Utils_update(
						z80clock,
						{dM: clockTime, ae: z80Core, cY: pcAfter});
				} else {
					return _Utils_update(
						z80clock,
						{dM: clockTime, ae: z80Core});
				}
			case 10:
				var repeatPCOffset = _v1.a;
				var shortDelay = _v1.b;
				var z80Core = _v1.c;
				if (!repeatPCOffset) {
					return _Utils_update(
						z80clock,
						{dM: clockTime, ae: z80Core, cY: pcAfter});
				} else {
					return _Utils_update(
						z80clock,
						{
							dM: A2($author$project$CpuTimeCTime$addExtraCpuTime, shortDelay, clockTime),
							ae: z80Core
						});
				}
			case 1:
				return _Utils_update(
					z80clock,
					{dM: clockTime, cY: pcAfter});
			default:
				var _int = _v1.a;
				var shortDelay = _v1.b;
				return _Utils_update(
					z80clock,
					{
						dM: A2($author$project$CpuTimeCTime$addExtraCpuTime, shortDelay, clockTime),
						cY: 65535 & (pcAfter + _int)
					});
		}
	});
var $author$project$Z80Mem$m1 = F5(
	function (addr, ir, rom48k, clockTime, z80env) {
		var z80env_time = function () {
			var _v0 = clockTime.aC;
			if (!_v0.$) {
				return clockTime;
			} else {
				var until = _v0.a;
				var n = clockTime.F - until;
				return (n > 0) ? A2($author$project$CpuTimeCTime$cont, n, clockTime) : clockTime;
			}
		}();
		var ramAddr = addr - 16384;
		var value = (ramAddr >= 0) ? A3($author$project$Z80Mem$getRamValue, ramAddr, rom48k, z80env) : A2($author$project$Z80Rom$getROMValue, addr, rom48k);
		var z80env_1_time = (!(ramAddr & 49152)) ? A2($author$project$CpuTimeCTime$cont1, 0, z80env_time) : z80env_time;
		var ctime = ((ir & 49152) === 16384) ? $author$project$CpuTimeCTime$ContUntil(z80env_1_time.F + 4) : $author$project$CpuTimeCTime$NoCont;
		return A2(
			$author$project$CpuTimeCTime$CpuTimeAndValue,
			_Utils_update(
				z80env_1_time,
				{aC: ctime}),
			value);
	});
var $author$project$Z80OpCode$fetchInstruction = F5(
	function (pc_value, rom48k, clockTime, r_register, z80_core) {
		return A5($author$project$Z80Mem$m1, pc_value, z80_core.be.bZ | (r_register & 127), rom48k, clockTime, z80_core.B);
	});
var $JohnBugner$elm_loop$Loop$while = F3(
	function (p, f, v) {
		_while:
		while (true) {
			if (p(v)) {
				var $temp$p = p,
					$temp$f = f,
					$temp$v = f(v);
				p = $temp$p;
				f = $temp$f;
				v = $temp$v;
				continue _while;
			} else {
				return v;
			}
		}
	});
var $author$project$Z80$executeCore = F2(
	function (rom48k, z80) {
		var z80_clock = z80.ao;
		var z80_core = z80_clock.ae;
		var execute_f = function (_v3) {
			var clock = _v3.a;
			var ct = _v3.b;
			var r_register = _v3.c;
			var core_1_clock = A4($author$project$Z80$executeAndApplyDelta, ct, z80.d2, rom48k, clock);
			return _Utils_Tuple3(
				core_1_clock,
				A5($author$project$Z80OpCode$fetchInstruction, core_1_clock.cY, rom48k, core_1_clock.dM, r_register, core_1_clock.ae),
				r_register + 1);
		};
		var _v0 = A3(
			$JohnBugner$elm_loop$Loop$while,
			$author$project$Z80$coreLooping,
			execute_f,
			_Utils_Tuple3(
				z80_clock,
				A5($author$project$Z80OpCode$fetchInstruction, z80_clock.cY, rom48k, z80_clock.dM, z80_clock.ae.be.et, z80_clock.ae),
				z80_core.be.et));
		var clock_2 = _v0.a;
		var ct1 = _v0.b;
		var new_r = _v0.c;
		var core_2 = clock_2.ae;
		var core_ints = core_2.be;
		var z80_1 = _Utils_update(
			z80,
			{
				ao: _Utils_update(
					clock_2,
					{
						ae: _Utils_update(
							core_2,
							{
								be: _Utils_update(
									core_ints,
									{et: new_r})
							})
					})
			});
		var _v1 = A2($elm$core$Dict$get, ct1.e3, $author$project$Z80$nonCoreFuncs);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var f = _v2.a;
			var duration = _v2.b;
			var z80_2 = f(z80_1);
			var clock = z80_2.ao;
			var core = clock.ae;
			var ints = core.be;
			var newTime = A2($author$project$CpuTimeCTime$addDuration, duration, clock.dM);
			var pc = (clock.cY + 1) & 65535;
			return _Utils_update(
				z80_2,
				{
					ao: _Utils_update(
						clock,
						{
							dM: newTime,
							ae: _Utils_update(
								core,
								{
									be: _Utils_update(
										ints,
										{et: ints.et + 1})
								}),
							cY: pc
						})
				});
		} else {
			return z80_1;
		}
	});
var $author$project$Z80$execute = F2(
	function (rom48k, z80) {
		var z80_clock = z80.ao;
		var z80_core = z80_clock.ae;
		if (z80_core.be.d$) {
			return $author$project$SingleNoParams$execute_0x76_halt(z80);
		} else {
			var execute_f = $author$project$Z80$executeCore(rom48k);
			return A3(
				$JohnBugner$elm_loop$Loop$while,
				function (x) {
					return $author$project$Z80$stillLooping(x.ao);
				},
				execute_f,
				z80);
		}
	});
var $author$project$Z80MemoryDict$setMemValue = F3(
	function (addr, value, z80mem) {
		var dict = z80mem;
		return A3($elm$core$Dict$insert, addr, value, dict);
	});
var $Chadtech$elm_vector$Vector24$set = F3(
	function (index, a, _v0) {
		var vector = _v0;
		switch (index) {
			case 0:
				return _Utils_update(
					vector,
					{j: a});
			case 1:
				return _Utils_update(
					vector,
					{b3: a});
			case 2:
				return _Utils_update(
					vector,
					{b: a});
			case 3:
				return _Utils_update(
					vector,
					{c: a});
			case 4:
				return _Utils_update(
					vector,
					{d: a});
			case 5:
				return _Utils_update(
					vector,
					{e: a});
			case 6:
				return _Utils_update(
					vector,
					{f: a});
			case 7:
				return _Utils_update(
					vector,
					{g: a});
			case 8:
				return _Utils_update(
					vector,
					{h: a});
			case 9:
				return _Utils_update(
					vector,
					{i: a});
			case 10:
				return _Utils_update(
					vector,
					{b4: a});
			case 11:
				return _Utils_update(
					vector,
					{b5: a});
			case 12:
				return _Utils_update(
					vector,
					{b6: a});
			case 13:
				return _Utils_update(
					vector,
					{b7: a});
			case 14:
				return _Utils_update(
					vector,
					{b8: a});
			case 15:
				return _Utils_update(
					vector,
					{b9: a});
			case 16:
				return _Utils_update(
					vector,
					{ca: a});
			case 17:
				return _Utils_update(
					vector,
					{cb: a});
			case 18:
				return _Utils_update(
					vector,
					{cc: a});
			case 19:
				return _Utils_update(
					vector,
					{cd: a});
			case 20:
				return _Utils_update(
					vector,
					{ce: a});
			case 21:
				return _Utils_update(
					vector,
					{cf: a});
			case 22:
				return _Utils_update(
					vector,
					{cg: a});
			default:
				return _Utils_update(
					vector,
					{ch: a});
		}
	});
var $Chadtech$elm_vector$Vector32$set = F3(
	function (index, a, _v0) {
		var vector = _v0;
		switch (index) {
			case 0:
				return _Utils_update(
					vector,
					{j: a});
			case 1:
				return _Utils_update(
					vector,
					{b3: a});
			case 2:
				return _Utils_update(
					vector,
					{b: a});
			case 3:
				return _Utils_update(
					vector,
					{c: a});
			case 4:
				return _Utils_update(
					vector,
					{d: a});
			case 5:
				return _Utils_update(
					vector,
					{e: a});
			case 6:
				return _Utils_update(
					vector,
					{f: a});
			case 7:
				return _Utils_update(
					vector,
					{g: a});
			case 8:
				return _Utils_update(
					vector,
					{h: a});
			case 9:
				return _Utils_update(
					vector,
					{i: a});
			case 10:
				return _Utils_update(
					vector,
					{b4: a});
			case 11:
				return _Utils_update(
					vector,
					{b5: a});
			case 12:
				return _Utils_update(
					vector,
					{b6: a});
			case 13:
				return _Utils_update(
					vector,
					{b7: a});
			case 14:
				return _Utils_update(
					vector,
					{b8: a});
			case 15:
				return _Utils_update(
					vector,
					{b9: a});
			case 16:
				return _Utils_update(
					vector,
					{ca: a});
			case 17:
				return _Utils_update(
					vector,
					{cb: a});
			case 18:
				return _Utils_update(
					vector,
					{cc: a});
			case 19:
				return _Utils_update(
					vector,
					{cd: a});
			case 20:
				return _Utils_update(
					vector,
					{ce: a});
			case 21:
				return _Utils_update(
					vector,
					{cf: a});
			case 22:
				return _Utils_update(
					vector,
					{cg: a});
			case 23:
				return _Utils_update(
					vector,
					{ch: a});
			case 24:
				return _Utils_update(
					vector,
					{ci: a});
			case 25:
				return _Utils_update(
					vector,
					{cj: a});
			case 26:
				return _Utils_update(
					vector,
					{ck: a});
			case 27:
				return _Utils_update(
					vector,
					{cl: a});
			case 28:
				return _Utils_update(
					vector,
					{cm: a});
			case 29:
				return _Utils_update(
					vector,
					{cn: a});
			case 30:
				return _Utils_update(
					vector,
					{co: a});
			default:
				return _Utils_update(
					vector,
					{cp: a});
		}
	});
var $author$project$ScreenStorage$setScreenValue = F3(
	function (addr, value, z80screen) {
		if (addr < 6144) {
			var _v0 = $author$project$ScreenStorage$getScreenDataOffset(addr);
			var lineNumber = _v0.a;
			var addr32 = _v0.b;
			var line32 = _v0.c;
			var lineOffset = ($Chadtech$elm_vector$Vector8$indexToInt(addr32) * 32) + $Chadtech$elm_vector$Vector32$indexToInt(line32);
			var line = A2($Chadtech$elm_vector$Vector24$get, lineNumber, z80screen.ea);
			if (_Utils_eq(
				A2($author$project$Z80MemoryDict$getMemValue, lineOffset, line.af),
				value)) {
				return z80screen;
			} else {
				var newLine = _Utils_update(
					line,
					{
						af: A3($author$project$Z80MemoryDict$setMemValue, lineOffset, value, line.af)
					});
				var newData = A3($Chadtech$elm_vector$Vector24$set, lineNumber, newLine, z80screen.ea);
				return _Utils_update(
					z80screen,
					{ea: newData});
			}
		} else {
			var offset = addr - 6144;
			var row = A2(
				$elm$core$Maybe$withDefault,
				0,
				$Chadtech$elm_vector$Vector24$intToIndex((offset / 32) | 0));
			var oldrow = A2($Chadtech$elm_vector$Vector24$get, row, z80screen.ea);
			var col = A2(
				$elm$core$Maybe$withDefault,
				0,
				$Chadtech$elm_vector$Vector32$intToIndex(offset % 32));
			if (_Utils_eq(
				A2($Chadtech$elm_vector$Vector32$get, col, oldrow.dv),
				value)) {
				return z80screen;
			} else {
				var new_row = _Utils_update(
					oldrow,
					{
						dv: A3($Chadtech$elm_vector$Vector32$set, col, value, oldrow.dv)
					});
				return _Utils_update(
					z80screen,
					{
						ea: A3($Chadtech$elm_vector$Vector24$set, row, new_row, z80screen.ea)
					});
			}
		}
	});
var $author$project$Z80Ram$foldDictIntoRam = F2(
	function (ramdict, z80_ram) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (addr, value, z80ram) {
					return (addr >= 6912) ? _Utils_update(
						z80ram,
						{
							a$: A3($author$project$Z80MemoryDict$setMemValue, addr - 6912, value, z80ram.a$)
						}) : _Utils_update(
						z80ram,
						{
							eK: A3($author$project$ScreenStorage$setScreenValue, addr, value, z80ram.eK)
						});
				}),
			z80_ram,
			ramdict);
	});
var $author$project$SpectrumColour$BorderBlack = 0;
var $author$project$SpectrumColour$BorderBlue = 1;
var $author$project$SpectrumColour$BorderCyan = 5;
var $author$project$SpectrumColour$BorderGreen = 4;
var $author$project$SpectrumColour$BorderMagenta = 3;
var $author$project$SpectrumColour$BorderRed = 2;
var $author$project$SpectrumColour$BorderYellow = 6;
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{s: nodeList, q: nodeListSize, r: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $author$project$SpectrumColour$borders = $elm$core$Array$fromList(
	_List_fromArray(
		[0, 1, 2, 3, 4, 5, 6, 7]));
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $author$project$SpectrumColour$intToBorderColour = function (value) {
	return A2(
		$elm$core$Maybe$withDefault,
		7,
		A2($elm$core$Array$get, value, $author$project$SpectrumColour$borders));
};
var $author$project$Z80CoreWithClockTime$set_pc = F2(
	function (pc, z80) {
		var clock = z80.ao;
		return _Utils_update(
			z80,
			{
				ao: _Utils_update(
					clock,
					{cY: pc & 65535})
			});
	});
var $author$project$Z80CoreWithClockTime$im0 = F2(
	function (bus, z80) {
		if ((bus & 56) === 255) {
			var new_pc = bus - 199;
			return A2($author$project$Z80CoreWithClockTime$set_pc, new_pc, z80);
		} else {
			return z80;
		}
	});
var $author$project$Z80CoreWithClockTime$interrupt = F3(
	function (bus, rom48k, full_z80) {
		var z80Clock = full_z80.ao;
		var z80_core = z80Clock.ae;
		var main = z80_core.u;
		var ints = z80_core.be;
		if ($author$project$Z80CoreWithClockTime$get_ei(full_z80)) {
			var z80_1 = _Utils_update(
				z80_core,
				{
					be: _Utils_update(
						ints,
						{d$: false})
				});
			var pushed = A3($author$project$Z80Env$z80_push, z80Clock.cY, z80Clock.dM, z80_1.B);
			var new_core = _Utils_update(
				z80_1,
				{B: pushed});
			var newClock = _Utils_update(
				z80Clock,
				{
					dM: A2($author$project$CpuTimeCTime$addCpuTimeTime, 6, z80Clock.dM),
					ae: new_core
				});
			var new_z80 = _Utils_update(
				full_z80,
				{ao: newClock, d2: 0});
			var _v0 = ints.d1;
			switch (_v0) {
				case 0:
					return A2($author$project$Z80CoreWithClockTime$im0, bus, new_z80);
				case 1:
					return A2($author$project$Z80CoreWithClockTime$set_pc, 56, new_z80);
				default:
					var new_ir = ints.bZ & 65280;
					var addr = new_ir | bus;
					var env_and_pc = A4($author$project$Z80Mem$mem16, addr, rom48k, newClock.dM, new_core.B);
					var newClock1 = _Utils_update(
						newClock,
						{
							dM: A2($author$project$CpuTimeCTime$addCpuTimeTime, 6, env_and_pc.aQ),
							ae: new_core,
							cY: env_and_pc.bx
						});
					return _Utils_update(
						new_z80,
						{ao: newClock1});
			}
		} else {
			return full_z80;
		}
	});
var $author$project$Keyboard$c_0100 = 64;
var $author$project$Keyboard$c_01000 = 512;
var $author$project$Keyboard$c_017 = 15;
var $author$project$Keyboard$c_0200 = 128;
var $author$project$Keyboard$c_0300 = 192;
var $author$project$Keyboard$initial_keyboard = A2(
	$author$project$Keyboard$Keyboard,
	$Chadtech$elm_vector$Vector8$repeat(255),
	_List_Nil);
var $author$project$Keyboard$JoystickControl = 4;
var $author$project$Keyboard$JoystickDown = 3;
var $author$project$Keyboard$JoystickLeft = 0;
var $author$project$Keyboard$JoystickRight = 1;
var $author$project$Keyboard$JoystickUp = 2;
var $author$project$Keyboard$c_0103 = 67;
var $author$project$Keyboard$c_ARROW_0 = 99;
var $author$project$Keyboard$c_ARROW_1 = 84;
var $author$project$Keyboard$c_ARROW_2 = 92;
var $author$project$Keyboard$c_ARROW_3 = 100;
var $author$project$Keyboard$c_SPECCY_KEYBOARD_CHARS = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$indexedMap,
		F2(
			function (index, _char) {
				return _Utils_Tuple2(_char, index);
			}),
		$elm$core$String$toList('[AQ10P\n ZSW29OL]XDE38IKMCFR47UJNVGT56YHB')));
var $author$project$Keyboard$c_SYMBOL_SHIFT_CHARS = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('\t', 0),
			_Utils_Tuple2('!', 3),
			_Utils_Tuple2('_', 4),
			_Utils_Tuple2('\"', 5),
			_Utils_Tuple2(':', 8),
			_Utils_Tuple2('@', 11),
			_Utils_Tuple2(')', 12),
			_Utils_Tuple2(';', 13),
			_Utils_Tuple2('=', 14),
			_Utils_Tuple2('#', 19),
			_Utils_Tuple2('(', 20),
			_Utils_Tuple2('+', 22),
			_Utils_Tuple2('.', 23),
			_Utils_Tuple2('?', 24),
			_Utils_Tuple2('<', 26),
			_Utils_Tuple2('$', 27),
			_Utils_Tuple2('\'', 28),
			_Utils_Tuple2('-', 30),
			_Utils_Tuple2(',', 31),
			_Utils_Tuple2('/', 32),
			_Utils_Tuple2('>', 34),
			_Utils_Tuple2('%', 35),
			_Utils_Tuple2('&', 36),
			_Utils_Tuple2('^', 38),
			_Utils_Tuple2('*', 39)
		]));
var $author$project$Keyboard$keyEventToValue = function (event) {
	if (!event.$) {
		var _char = event.a;
		var simple_key = A2($elm$core$Dict$get, _char, $author$project$Keyboard$c_SPECCY_KEYBOARD_CHARS);
		if (!simple_key.$) {
			var thekey = simple_key.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(thekey, _List_Nil));
		} else {
			var sym_shift = A2($elm$core$Dict$get, _char, $author$project$Keyboard$c_SYMBOL_SHIFT_CHARS);
			if (!sym_shift.$) {
				var sym = sym_shift.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2($author$project$Keyboard$c_0200 | sym, _List_Nil));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	} else {
		var controlKey = event.a;
		switch (controlKey) {
			case 5:
				return $elm$core$Maybe$Just(
					_Utils_Tuple2($author$project$Keyboard$c_0103, _List_Nil));
			case 6:
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						$author$project$Keyboard$c_ARROW_0,
						_List_fromArray(
							[0])));
			case 7:
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						$author$project$Keyboard$c_ARROW_3,
						_List_fromArray(
							[3])));
			case 8:
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						$author$project$Keyboard$c_ARROW_2,
						_List_fromArray(
							[2])));
			case 9:
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						$author$project$Keyboard$c_ARROW_1,
						_List_fromArray(
							[1])));
			case 4:
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(68, _List_Nil));
			case 0:
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(512, _List_Nil));
			case 1:
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						1024,
						_List_fromArray(
							[4])));
			case 3:
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(1024, _List_Nil));
			default:
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(6, _List_Nil));
		}
	}
};
var $Chadtech$elm_vector$Vector5$Internal$Vector = $elm$core$Basics$identity;
var $Chadtech$elm_vector$Vector5$repeat = function (a) {
	return {j: a, b3: a, b: a, c: a, d: a};
};
var $author$project$Keyboard$m_initial = $Chadtech$elm_vector$Vector5$repeat(-1);
var $Chadtech$elm_vector$Vector5$Index0 = 0;
var $Chadtech$elm_vector$Vector5$get = F2(
	function (index, _v0) {
		var vector = _v0;
		switch (index) {
			case 0:
				return vector.j;
			case 1:
				return vector.b3;
			case 2:
				return vector.b;
			case 3:
				return vector.c;
			default:
				return vector.d;
		}
	});
var $Chadtech$elm_vector$Vector5$Index1 = 1;
var $Chadtech$elm_vector$Vector5$Index2 = 2;
var $Chadtech$elm_vector$Vector5$Index3 = 3;
var $Chadtech$elm_vector$Vector5$Index4 = 4;
var $Chadtech$elm_vector$Vector5$intToIndex = function (_int) {
	switch (_int) {
		case 0:
			return $elm$core$Maybe$Just(0);
		case 1:
			return $elm$core$Maybe$Just(1);
		case 2:
			return $elm$core$Maybe$Just(2);
		case 3:
			return $elm$core$Maybe$Just(3);
		case 4:
			return $elm$core$Maybe$Just(4);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $Chadtech$elm_vector$Vector8$map = F2(
	function (f, _v0) {
		var vector = _v0;
		return {
			j: f(vector.j),
			b3: f(vector.b3),
			b: f(vector.b),
			c: f(vector.c),
			d: f(vector.d),
			e: f(vector.e),
			f: f(vector.f),
			g: f(vector.g)
		};
	});
var $Chadtech$elm_vector$Vector5$set = F3(
	function (index, a, _v0) {
		var vector = _v0;
		switch (index) {
			case 0:
				return _Utils_update(
					vector,
					{j: a});
			case 1:
				return _Utils_update(
					vector,
					{b3: a});
			case 2:
				return _Utils_update(
					vector,
					{b: a});
			case 3:
				return _Utils_update(
					vector,
					{c: a});
			default:
				return _Utils_update(
					vector,
					{d: a});
		}
	});
var $Chadtech$elm_vector$Vector8$set = F3(
	function (index, a, _v0) {
		var vector = _v0;
		switch (index) {
			case 0:
				return _Utils_update(
					vector,
					{j: a});
			case 1:
				return _Utils_update(
					vector,
					{b3: a});
			case 2:
				return _Utils_update(
					vector,
					{b: a});
			case 3:
				return _Utils_update(
					vector,
					{c: a});
			case 4:
				return _Utils_update(
					vector,
					{d: a});
			case 5:
				return _Utils_update(
					vector,
					{e: a});
			case 6:
				return _Utils_update(
					vector,
					{f: a});
			default:
				return _Utils_update(
					vector,
					{g: a});
		}
	});
var $author$project$Keyboard$pressed = F3(
	function (k, keyboard, mlist) {
		var b = (k >> 3) & 7;
		var vec_b = function () {
			var _v1 = $Chadtech$elm_vector$Vector5$intToIndex(b);
			if (!_v1.$) {
				var index = _v1.a;
				return index;
			} else {
				return A3(
					$author$project$Z80Debug$debugTodo,
					'pressed',
					'Error: b = ' + $elm$core$String$fromInt(b),
					0);
			}
		}();
		var n = A2($Chadtech$elm_vector$Vector5$get, vec_b, mlist);
		var a = k & 7;
		var new_mlist = A3($Chadtech$elm_vector$Vector5$set, vec_b, a, mlist);
		var vec_a = A2(
			$elm$core$Maybe$withDefault,
			0,
			$Chadtech$elm_vector$Vector8$intToIndex(a));
		var v1 = A2($Chadtech$elm_vector$Vector8$get, vec_a, keyboard.b$) & (~(1 << b));
		var keyboard1 = A3($Chadtech$elm_vector$Vector8$set, vec_a, v1, keyboard.b$);
		var new_v = function () {
			if (n >= 0) {
				var keyboard_n = function () {
					var _v0 = $Chadtech$elm_vector$Vector8$intToIndex(n);
					if (!_v0.$) {
						var vecIndex = _v0.a;
						return A2($Chadtech$elm_vector$Vector8$get, vecIndex, keyboard.b$);
					} else {
						return A3(
							$author$project$Z80Debug$debugTodo,
							'pressed',
							'keyboard_n impossible' + $elm$core$String$fromInt(n),
							0);
					}
				}();
				return v1 | keyboard_n;
			} else {
				return v1;
			}
		}();
		var keyboard2 = A2(
			$Chadtech$elm_vector$Vector8$map,
			function (kb) {
				return ((kb | new_v) !== 255) ? new_v : kb;
			},
			keyboard1);
		return _Utils_Tuple2(
			_Utils_update(
				keyboard,
				{b$: keyboard2}),
			new_mlist);
	});
var $author$project$Keyboard$update_keyboard = function (keys) {
	var k_list = A2($elm$core$List$filterMap, $author$project$Keyboard$keyEventToValue, keys);
	var s1 = A3(
		$elm$core$List$foldl,
		F2(
			function (k, total) {
				return k | total;
			}),
		0,
		A2($elm$core$List$map, $elm$core$Tuple$first, k_list));
	var s2 = (!(s1 & $author$project$Keyboard$c_0300)) ? (s1 | ((s1 >> 3) & $author$project$Keyboard$c_0300)) : s1;
	var _v0 = A3(
		$elm$core$List$foldl,
		F2(
			function (_v2, _v3) {
				var k = _v2.a;
				var kemp = _v2.b;
				var keyb = _v3.a;
				var m_list = _v3.b;
				return A3(
					$author$project$Keyboard$pressed,
					k,
					_Utils_update(
						keyb,
						{
							aI: _Utils_ap(keyb.aI, kemp)
						}),
					m_list);
			}),
		_Utils_Tuple2($author$project$Keyboard$initial_keyboard, $author$project$Keyboard$m_initial),
		A2(
			$elm$core$List$filter,
			function (_v1) {
				var v = _v1.a;
				var kemp = _v1.b;
				return _Utils_cmp(v, $author$project$Keyboard$c_01000) < 0;
			},
			k_list));
	var keyboard = _v0.a;
	var mlist = _v0.b;
	var _v4 = (!(!(s2 & $author$project$Keyboard$c_0100))) ? A3($author$project$Keyboard$pressed, 0, keyboard, mlist) : _Utils_Tuple2(keyboard, mlist);
	var keyb2 = _v4.a;
	var mlist2 = _v4.b;
	var _v5 = (!(!(s2 & $author$project$Keyboard$c_0200))) ? A3($author$project$Keyboard$pressed, $author$project$Keyboard$c_017, keyb2, mlist2) : _Utils_Tuple2(keyb2, mlist2);
	var keyb3 = _v5.a;
	return keyb3;
};
var $author$project$Spectrum$frames = F2(
	function (keys, speccy) {
		var sz80 = speccy.ap;
		var rom = speccy.eH;
		var new_rom = _Utils_update(
			rom,
			{
				b$: $author$project$Keyboard$update_keyboard(keys)
			});
		var loading_z80 = function () {
			if (!speccy.aN) {
				var _v5 = speccy.dj;
				if (!_v5.$) {
					return $author$project$Spectrum$checkLoad(speccy);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var clock = sz80.ao;
		var clock_1 = _Utils_update(
			clock,
			{dM: $author$project$CpuTimeCTime$reset_cpu_time});
		var cpu1 = _Utils_update(
			sz80,
			{ao: clock_1});
		var loadz80posrom = function () {
			if (!loading_z80.$) {
				var z80 = loading_z80.a;
				var _v3 = speccy.dj;
				if (!_v3.$) {
					var z80_tape = _v3.a;
					var _v4 = A3($author$project$Spectrum$doLoad, z80, speccy.eH, z80_tape);
					var new_z80 = _v4.a;
					var z80_load = _v4.b;
					var tape_position = _v4.c;
					var core_2 = new_z80.ao.ae;
					var env_2 = core_2.B;
					var newRam = A2($author$project$Z80Ram$foldDictIntoRam, env_2.bl, rom.e6);
					var rom_2 = _Utils_update(
						new_rom,
						{e6: newRam});
					return {
						au: z80_load,
						a0: $elm$core$Maybe$Just(tape_position),
						c7: rom_2,
						ay: new_z80
					};
				} else {
					return {au: false, a0: $elm$core$Maybe$Nothing, c7: new_rom, ay: z80};
				}
			} else {
				var new_z80 = A2(
					$author$project$Z80$execute,
					rom,
					A3($author$project$Z80CoreWithClockTime$interrupt, 255, rom, cpu1));
				var clock_2 = new_z80.ao;
				var core_2 = clock_2.ae;
				var env_2 = core_2.B;
				var newRam = A2($author$project$Z80Ram$foldDictIntoRam, env_2.bl, rom.e6);
				var rom_2 = function () {
					var newBorder = $author$project$SpectrumColour$intToBorderColour(env_2.dE);
					if (!_Utils_eq(newBorder, newRam.eK.dD)) {
						var screen = newRam.eK;
						return _Utils_update(
							new_rom,
							{
								e6: _Utils_update(
									newRam,
									{
										eK: _Utils_update(
											screen,
											{dD: newBorder})
									})
							});
					} else {
						return _Utils_update(
							new_rom,
							{e6: newRam});
					}
				}();
				var new_core = _Utils_update(
					core_2,
					{
						B: _Utils_update(
							env_2,
							{bl: $elm$core$Dict$empty})
					});
				return {
					au: false,
					a0: $elm$core$Maybe$Nothing,
					c7: rom_2,
					ay: _Utils_update(
						new_z80,
						{
							ao: _Utils_update(
								clock_2,
								{ae: new_core})
						})
				};
			}
		}();
		var _v0 = speccy.dj;
		if (!_v0.$) {
			var z80_tape = _v0.a;
			var _v1 = loadz80posrom.a0;
			if (!_v1.$) {
				var newPosition = _v1.a;
				return _Utils_update(
					speccy,
					{
						ap: loadz80posrom.ay,
						aY: loadz80posrom.au,
						eH: loadz80posrom.c7,
						dj: $elm$core$Maybe$Just(
							_Utils_update(
								z80_tape,
								{eT: newPosition}))
					});
			} else {
				return _Utils_update(
					speccy,
					{
						ap: loadz80posrom.ay,
						aY: loadz80posrom.au,
						eH: loadz80posrom.c7,
						dj: $elm$core$Maybe$Just(z80_tape)
					});
			}
		} else {
			return _Utils_update(
				speccy,
				{ap: loadz80posrom.ay, aY: loadz80posrom.au, eH: loadz80posrom.c7});
		}
	});
var $elm$core$Basics$xor = _Basics_xor;
var $author$project$Spectrum$pause = F2(
	function (m, spectrum) {
		var w = ((spectrum.by & (~m)) >> 3) ^ (m & 7);
		var paused = (spectrum.aN !== (!(!w))) ? (!(!A3($author$project$Z80Debug$debugLog, 'pause', !(!w), w))) : A3($author$project$Z80Debug$debugLog, 'pause', $elm$core$Maybe$Nothing, spectrum.aN);
		return _Utils_update(
			spectrum,
			{aN: paused, by: w});
	});
var $author$project$QaopModel$run = function (qaop) {
	return qaop.bn.aN ? _Utils_update(
		qaop,
		{
			bn: A2($author$project$Spectrum$pause, 8, qaop.bn),
			aO: qaop.aO & (~2)
		}) : _Utils_update(
		qaop,
		{
			bn: A2($author$project$Spectrum$frames, qaop.d7, qaop.bn)
		});
};
var $author$project$QaopModel$gotTap = F2(
	function (qaop, result) {
		if (!result.$) {
			var value = result.a;
			return $author$project$QaopModel$run(
				_Utils_update(
					qaop,
					{
						bn: A2($author$project$Spectrum$new_tape, value, qaop.bn)
					}));
		} else {
			return qaop;
		}
	});
var $author$project$Keyboard$KeyDownEvent = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Char$toUpper = _Char_toUpper;
var $author$project$Keyboard$keyDownEvent = F2(
	function (character, keys) {
		var upperchar = $elm$core$Char$toUpper(character);
		var event = $author$project$Keyboard$KeyDownEvent(upperchar);
		var newkeys = A2($elm$core$List$cons, event, keys);
		return A3(
			$author$project$Z80Debug$debugLog,
			'key down ' + ($elm$core$String$fromChar(character) + ' newkeys '),
			newkeys,
			newkeys);
	});
var $author$project$Keyboard$keyNotEqual = F2(
	function (event, character) {
		if (!event.$) {
			var _char = event.a;
			return !_Utils_eq(_char, character);
		} else {
			return true;
		}
	});
var $author$project$Keyboard$keyUpEvent = F2(
	function (character, keys) {
		var upperchar = $elm$core$Char$toUpper(character);
		var newkeys = A2(
			$elm$core$List$filter,
			function (item) {
				return A2($author$project$Keyboard$keyNotEqual, item, upperchar);
			},
			keys);
		return A3(
			$author$project$Z80Debug$debugLog,
			'key up ' + ($elm$core$String$fromChar(character) + ' newkeys '),
			newkeys,
			newkeys);
	});
var $author$project$QaopModel$CharacterKeyDown = function (a) {
	return {$: 5, a: a};
};
var $author$project$QaopModel$CharacterKeyUp = function (a) {
	return {$: 10, a: a};
};
var $author$project$QaopModel$ControlKeyDown = function (a) {
	return {$: 7, a: a};
};
var $author$project$QaopModel$ControlKeyUp = function (a) {
	return {$: 11, a: a};
};
var $author$project$QaopModel$c_LOADING_KEY_DELAY = 800;
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $author$project$QaopModel$AutoChar = function (a) {
	return {$: 0, a: a};
};
var $author$project$QaopModel$AutoControl = function (a) {
	return {$: 1, a: a};
};
var $author$project$QaopModel$loadQuoteQuoteEnter = _List_fromArray(
	[
		$author$project$QaopModel$AutoChar('j'),
		$author$project$QaopModel$AutoChar('\"'),
		$author$project$QaopModel$AutoChar('\"'),
		$author$project$QaopModel$AutoControl('Enter')
	]);
var $author$project$QaopModel$loadingCommands = $elm$core$List$concat(
	A2(
		$elm$core$List$indexedMap,
		F2(
			function (index, item) {
				var _v0 = function () {
					if (!item.$) {
						var _char = item.a;
						return _Utils_Tuple2(
							$author$project$QaopModel$CharacterKeyDown(_char),
							$author$project$QaopModel$CharacterKeyUp(_char));
					} else {
						var string = item.a;
						return _Utils_Tuple2(
							$author$project$QaopModel$ControlKeyDown(string),
							$author$project$QaopModel$ControlKeyUp(string));
					}
				}();
				var down = _v0.a;
				var up = _v0.b;
				return _List_fromArray(
					[
						A2($andrewMacmurray$elm_delay$Delay$after, $author$project$QaopModel$c_LOADING_KEY_DELAY * index, down),
						A2($andrewMacmurray$elm_delay$Delay$after, ($author$project$QaopModel$c_LOADING_KEY_DELAY * index) + (($author$project$QaopModel$c_LOADING_KEY_DELAY / 2) | 0), up)
					]);
			}),
		$author$project$QaopModel$loadQuoteQuoteEnter));
var $author$project$Qaop$pause = F2(
	function (v, qaop) {
		var pauser = v ? 68 : 64;
		var speccy = A2($author$project$Spectrum$pause, pauser, qaop.bn);
		return _Utils_update(
			qaop,
			{bn: speccy});
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $author$project$QaopModel$updateQaop = F2(
	function (message, model) {
		switch (message.$) {
			case 0:
				var result = message.a;
				var qaop = A2($author$project$QaopModel$gotTap, model.l, result);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{y: model.y + 1, l: qaop}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var posix = message.a;
				var state = function () {
					if (model.l.bn.aN) {
						return {y: model.y, a9: 0, l: model.l};
					} else {
						var q = $author$project$QaopModel$run(model.l);
						var elapsed = $elm$time$Time$posixToMillis(posix) - $elm$time$Time$posixToMillis(model.aQ);
						return {y: model.y + 1, a9: elapsed, l: q};
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{y: state.y, aq: model.aq + state.a9, l: state.l, aQ: posix}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l: A2($author$project$Qaop$pause, !model.l.bn.aN, model.l)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var _char = message.a;
				var qaop = model.l;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l: _Utils_update(
								qaop,
								{
									d7: A2($author$project$Keyboard$keyDownEvent, _char, qaop.d7)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var str = message.a;
				var qaop = model.l;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l: _Utils_update(
								qaop,
								{
									d7: A2($author$project$Keyboard$ctrlKeyDownEvent, str, qaop.d7)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var _char = message.a;
				var qaop = model.l;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l: _Utils_update(
								qaop,
								{
									d7: A2($author$project$Keyboard$keyUpEvent, _char, qaop.d7)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var str = message.a;
				var qaop = model.l;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							l: _Utils_update(
								qaop,
								{
									d7: A2($author$project$Keyboard$ctrlKeyUpEvent, str, qaop.d7)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 10:
				var _char = message.a;
				return _Utils_Tuple2(
					model,
					A2(
						$andrewMacmurray$elm_delay$Delay$after,
						2,
						$author$project$QaopModel$CharacterUnKey(_char)));
			case 11:
				var str = message.a;
				return _Utils_Tuple2(
					model,
					A2(
						$andrewMacmurray$elm_delay$Delay$after,
						2,
						$author$project$QaopModel$ControlUnKey(str)));
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bf: true}),
					$elm$core$Platform$Cmd$batch($author$project$QaopModel$loadingCommands));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aW: !model.aW}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$update = F2(
	function (message, model) {
		if (!message.$) {
			var initMessage = message.a;
			var _v1 = model.aO;
			if (!_v1.$) {
				var loadingModel = _v1.a;
				var _v2 = A2($author$project$LoadingModel$updateLoading, initMessage, loadingModel);
				var state = _v2.a;
				var qaopCmd = _v2.b;
				var cmd = A2($elm$core$Platform$Cmd$map, $author$project$Main$RunningMessage, qaopCmd);
				if (!state.$) {
					var newloadingModel = state.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aO: $author$project$Main$Loading(newloadingModel)
							}),
						cmd);
				} else {
					var qaopModel = state.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aO: $author$project$Main$Running(qaopModel)
							}),
						cmd);
				}
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		} else {
			var qaopMessage = message.a;
			var _v4 = model.aO;
			if (!_v4.$) {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			} else {
				var qaopModel = _v4.a;
				var _v5 = A2($author$project$QaopModel$updateQaop, qaopMessage, qaopModel);
				var x = _v5.a;
				var y = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aO: $author$project$Main$Running(x)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$RunningMessage, y));
			}
		}
	});
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$QaopModel$Autoload = {$: 4};
var $author$project$QaopModel$Pause = {$: 3};
var $author$project$QaopModel$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$json$Json$Encode$string = _Json_wrap;
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$QaopModel$KeyRepeat = {$: 9};
var $author$project$QaopModel$toKey = F2(
	function (keyValue, repeat) {
		if (repeat) {
			return $author$project$QaopModel$KeyRepeat;
		} else {
			var _v0 = $elm$core$String$uncons(keyValue);
			if ((!_v0.$) && (_v0.a.b === '')) {
				var _v1 = _v0.a;
				var _char = _v1.a;
				return $author$project$QaopModel$CharacterKeyDown(_char);
			} else {
				return $author$project$QaopModel$ControlKeyDown(keyValue);
			}
		}
	});
var $author$project$QaopModel$keyDownDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$QaopModel$toKey,
	A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'repeat', $elm$json$Json$Decode$bool));
var $author$project$QaopModel$toUnKey = function (keyValue) {
	var _v0 = $elm$core$String$uncons(keyValue);
	if ((!_v0.$) && (_v0.a.b === '')) {
		var _v1 = _v0.a;
		var _char = _v1.a;
		return $author$project$QaopModel$CharacterKeyUp(_char);
	} else {
		return $author$project$QaopModel$ControlKeyUp(keyValue);
	}
};
var $author$project$QaopModel$keyUpDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$QaopModel$toUnKey,
	A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
var $elm$virtual_dom$VirtualDom$lazy2 = _VirtualDom_lazy2;
var $elm$svg$Svg$Lazy$lazy2 = $elm$virtual_dom$VirtualDom$lazy2;
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Utils$c_DECIMAL_PLACES = 3;
var $elm$core$Basics$pow = _Basics_pow;
var $author$project$Utils$loop_time_in_ms = F2(
	function (elapsed_millis, count) {
		return ((A2($elm$core$Basics$pow, 10, $author$project$Utils$c_DECIMAL_PLACES) * elapsed_millis) / count) | 0;
	});
var $elm$core$Basics$round = _Basics_round;
var $author$project$Utils$speed_in_hz = F2(
	function (elapsed_millis, count) {
		var loop_time = A2($author$project$Utils$loop_time_in_ms, elapsed_millis, count);
		var speed_in_mhz = $elm$core$Basics$round((1000000 / loop_time) * 1000);
		var speed_in_hz_frac = A2($elm$core$Basics$modBy, 1000, speed_in_mhz);
		var speed_in_hz_mant = (speed_in_mhz / 1000) | 0;
		return $elm$core$String$fromInt(speed_in_hz_mant) + ('.' + A3(
			$elm$core$String$padLeft,
			3,
			'0',
			$elm$core$String$fromInt(speed_in_hz_frac)));
	});
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$SpectrumColour$c_BLACK = '#000000';
var $author$project$SpectrumColour$c_DULL_BLUE = '#0100CE';
var $author$project$SpectrumColour$c_DULL_CYAN = '#01CFCF';
var $author$project$SpectrumColour$c_DULL_GREEN = '#00CF15';
var $author$project$SpectrumColour$c_DULL_MAGENTA = '#CF01CE';
var $author$project$SpectrumColour$c_DULL_RED = '#CF0100';
var $author$project$SpectrumColour$c_DULL_WHITE = '#CFCFCF';
var $author$project$SpectrumColour$c_DULL_YELLOW = '#CFCF15';
var $author$project$SpectrumColour$borderColour = function (border) {
	switch (border) {
		case 0:
			return $author$project$SpectrumColour$c_BLACK;
		case 1:
			return $author$project$SpectrumColour$c_DULL_BLUE;
		case 2:
			return $author$project$SpectrumColour$c_DULL_RED;
		case 3:
			return $author$project$SpectrumColour$c_DULL_MAGENTA;
		case 4:
			return $author$project$SpectrumColour$c_DULL_GREEN;
		case 5:
			return $author$project$SpectrumColour$c_DULL_CYAN;
		case 6:
			return $author$project$SpectrumColour$c_DULL_YELLOW;
		default:
			return $author$project$SpectrumColour$c_DULL_WHITE;
	}
};
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$svg$Svg$Attributes$rx = _VirtualDom_attribute('rx');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$QaopModel$backgroundNode = function (screen) {
	var border_colour = $author$project$SpectrumColour$borderColour(screen.dD);
	return A2(
		$elm$svg$Svg$rect,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$height('100%'),
				$elm$svg$Svg$Attributes$width('100%'),
				$elm$svg$Svg$Attributes$fill(border_colour),
				$elm$svg$Svg$Attributes$rx('15')
			]),
		_List_Nil);
};
var $author$project$QaopModel$c_SCALEFACTOR = 2;
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$virtual_dom$VirtualDom$lazy = _VirtualDom_lazy;
var $elm$svg$Svg$Lazy$lazy = $elm$virtual_dom$VirtualDom$lazy;
var $Chadtech$elm_vector$Vector32$toList = function (_v0) {
	var vector = _v0;
	return _List_fromArray(
		[vector.j, vector.b3, vector.b, vector.c, vector.d, vector.e, vector.f, vector.g, vector.h, vector.i, vector.b4, vector.b5, vector.b6, vector.b7, vector.b8, vector.b9, vector.ca, vector.cb, vector.cc, vector.cd, vector.ce, vector.cf, vector.cg, vector.ch, vector.ci, vector.cj, vector.ck, vector.cl, vector.cm, vector.cn, vector.co, vector.cp]);
};
var $Chadtech$elm_vector$Vector32$foldl = F3(
	function (f, start, vector) {
		return A3(
			$elm$core$List$foldl,
			f,
			start,
			$Chadtech$elm_vector$Vector32$toList(vector));
	});
var $Chadtech$elm_vector$Vector24$indexedMap = F2(
	function (f, _v0) {
		var vector = _v0;
		return {
			j: A2(f, 0, vector.j),
			b3: A2(f, 1, vector.b3),
			b4: A2(f, 10, vector.b4),
			b5: A2(f, 11, vector.b5),
			b6: A2(f, 12, vector.b6),
			b7: A2(f, 13, vector.b7),
			b8: A2(f, 14, vector.b8),
			b9: A2(f, 15, vector.b9),
			ca: A2(f, 16, vector.ca),
			cb: A2(f, 17, vector.cb),
			cc: A2(f, 18, vector.cc),
			cd: A2(f, 19, vector.cd),
			b: A2(f, 2, vector.b),
			ce: A2(f, 20, vector.ce),
			cf: A2(f, 21, vector.cf),
			cg: A2(f, 22, vector.cg),
			ch: A2(f, 23, vector.ch),
			c: A2(f, 3, vector.c),
			d: A2(f, 4, vector.d),
			e: A2(f, 5, vector.e),
			f: A2(f, 6, vector.f),
			g: A2(f, 7, vector.g),
			h: A2(f, 8, vector.h),
			i: A2(f, 9, vector.i)
		};
	});
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $elm$svg$Svg$Lazy$lazy3 = $elm$virtual_dom$VirtualDom$lazy3;
var $Chadtech$elm_vector$Vector8$indexedMap = F2(
	function (f, _v0) {
		var vector = _v0;
		return {
			j: A2(f, 0, vector.j),
			b3: A2(f, 1, vector.b3),
			b: A2(f, 2, vector.b),
			c: A2(f, 3, vector.c),
			d: A2(f, 4, vector.d),
			e: A2(f, 5, vector.e),
			f: A2(f, 6, vector.f),
			g: A2(f, 7, vector.g)
		};
	});
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $author$project$QaopModel$mapLineToSvg = F2(
	function (y_index, _v0) {
		var start = _v0.a;
		var linedata = _v0.b;
		return A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1(
					$elm$core$String$fromInt(48 + start)),
					$elm$svg$Svg$Attributes$y1(
					$elm$core$String$fromInt(40 + y_index)),
					$elm$svg$Svg$Attributes$x2(
					$elm$core$String$fromInt((48 + start) + linedata.eI.y)),
					$elm$svg$Svg$Attributes$y2(
					$elm$core$String$fromInt(40 + y_index)),
					$elm$svg$Svg$Attributes$stroke(linedata.bJ.bJ)
				]),
			_List_Nil);
	});
var $Chadtech$elm_vector$Vector8$initializeFromIndex = function (f) {
	return {
		j: f(0),
		b3: f(1),
		b: f(2),
		c: f(3),
		d: f(4),
		e: f(5),
		f: f(6),
		g: f(7)
	};
};
var $Chadtech$elm_vector$Vector8$indices = $Chadtech$elm_vector$Vector8$initializeFromIndex($elm$core$Basics$identity);
var $Chadtech$elm_vector$Vector32$map2 = F3(
	function (f, _v0, _v1) {
		var va = _v0;
		var vb = _v1;
		return {
			j: A2(f, va.j, vb.j),
			b3: A2(f, va.b3, vb.b3),
			b4: A2(f, va.b4, vb.b4),
			b5: A2(f, va.b5, vb.b5),
			b6: A2(f, va.b6, vb.b6),
			b7: A2(f, va.b7, vb.b7),
			b8: A2(f, va.b8, vb.b8),
			b9: A2(f, va.b9, vb.b9),
			ca: A2(f, va.ca, vb.ca),
			cb: A2(f, va.cb, vb.cb),
			cc: A2(f, va.cc, vb.cc),
			cd: A2(f, va.cd, vb.cd),
			b: A2(f, va.b, vb.b),
			ce: A2(f, va.ce, vb.ce),
			cf: A2(f, va.cf, vb.cf),
			cg: A2(f, va.cg, vb.cg),
			ch: A2(f, va.ch, vb.ch),
			ci: A2(f, va.ci, vb.ci),
			cj: A2(f, va.cj, vb.cj),
			ck: A2(f, va.ck, vb.ck),
			cl: A2(f, va.cl, vb.cl),
			cm: A2(f, va.cm, vb.cm),
			cn: A2(f, va.cn, vb.cn),
			c: A2(f, va.c, vb.c),
			co: A2(f, va.co, vb.co),
			cp: A2(f, va.cp, vb.cp),
			d: A2(f, va.d, vb.d),
			e: A2(f, va.e, vb.e),
			f: A2(f, va.f, vb.f),
			g: A2(f, va.g, vb.g),
			h: A2(f, va.h, vb.h),
			i: A2(f, va.i, vb.i)
		};
	});
var $author$project$Z80Screen$RunCount = F2(
	function (value, count) {
		return {y: count, e3: value};
	});
var $author$project$Z80Screen$ScreenData = F2(
	function (colour, data) {
		return {bJ: colour, af: data};
	});
var $Chadtech$elm_vector$Vector32$foldr = F3(
	function (f, start, vector) {
		return A3(
			$elm$core$List$foldr,
			f,
			start,
			$Chadtech$elm_vector$Vector32$toList(vector));
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $Chadtech$elm_vector$Vector8$initializeFromInt = function (f) {
	return {
		j: f(0),
		b3: f(1),
		b: f(2),
		c: f(3),
		d: f(4),
		e: f(5),
		f: f(6),
		g: f(7)
	};
};
var $author$project$Z80Screen$bitsToLines = function (datum) {
	return A2(
		$Chadtech$elm_vector$Vector8$map,
		function (mask) {
			return !(!(datum & mask));
		},
		$Chadtech$elm_vector$Vector8$initializeFromInt(
			function (index) {
				return 1 << (7 - index);
			}));
};
var $elm_community$list_extra$List$Extra$groupWhile = F2(
	function (isSameGroup, items) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					if (!acc.b) {
						return _List_fromArray(
							[
								_Utils_Tuple2(x, _List_Nil)
							]);
					} else {
						var _v1 = acc.a;
						var y = _v1.a;
						var restOfGroup = _v1.b;
						var groups = acc.b;
						return A2(isSameGroup, x, y) ? A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								x,
								A2($elm$core$List$cons, y, restOfGroup)),
							groups) : A2(
							$elm$core$List$cons,
							_Utils_Tuple2(x, _List_Nil),
							acc);
					}
				}),
			_List_Nil,
			items);
	});
var $elm_community$list_extra$List$Extra$group = $elm_community$list_extra$List$Extra$groupWhile($elm$core$Basics$eq);
var $author$project$Z80Screen$runCounts0to255 = $elm$core$Array$fromList(
	A2(
		$elm$core$List$map,
		function (value) {
			return A2(
				$elm$core$List$map,
				function (_v0) {
					var first = _v0.a;
					var rest = _v0.b;
					return A2(
						$author$project$Z80Screen$RunCount,
						first,
						1 + $elm$core$List$length(rest));
				},
				$elm_community$list_extra$List$Extra$group(
					$Chadtech$elm_vector$Vector8$toList(
						$author$project$Z80Screen$bitsToLines(value))));
		},
		A2($elm$core$List$range, 0, 255)));
var $author$project$Z80Screen$intToRcList = function (index) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2($elm$core$Array$get, index, $author$project$Z80Screen$runCounts0to255));
};
var $author$project$Z80Screen$ScreenColourRun = F2(
	function (runcount, colour) {
		return {bJ: colour, eI: runcount};
	});
var $author$project$SpectrumColour$White = 7;
var $author$project$SpectrumColour$Black = 0;
var $author$project$SpectrumColour$BrightBlue = 8;
var $author$project$SpectrumColour$BrightCyan = 12;
var $author$project$SpectrumColour$BrightGreen = 11;
var $author$project$SpectrumColour$BrightMagenta = 10;
var $author$project$SpectrumColour$BrightRed = 9;
var $author$project$SpectrumColour$BrightWhite = 14;
var $author$project$SpectrumColour$BrightYellow = 13;
var $author$project$SpectrumColour$c_BRIGHT_BLUE = '#0200FD';
var $author$project$SpectrumColour$c_BRIGHT_CYAN = '#02FFFF';
var $author$project$SpectrumColour$c_BRIGHT_GREEN = '#00FF1C';
var $author$project$SpectrumColour$c_BRIGHT_MAGENTA = '#FF02FD';
var $author$project$SpectrumColour$c_BRIGHT_RED = '#FF0201';
var $author$project$SpectrumColour$c_BRIGHT_YELLOW = '#FFFF1D';
var $author$project$SpectrumColour$c_WHITE = '#FFFFFF';
var $author$project$SpectrumColour$spectrumBrightColours = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			0,
			{bJ: $author$project$SpectrumColour$c_BLACK, e3: 0}),
			_Utils_Tuple2(
			1,
			{bJ: $author$project$SpectrumColour$c_BRIGHT_BLUE, e3: 8}),
			_Utils_Tuple2(
			2,
			{bJ: $author$project$SpectrumColour$c_BRIGHT_RED, e3: 9}),
			_Utils_Tuple2(
			3,
			{bJ: $author$project$SpectrumColour$c_BRIGHT_MAGENTA, e3: 10}),
			_Utils_Tuple2(
			4,
			{bJ: $author$project$SpectrumColour$c_BRIGHT_GREEN, e3: 11}),
			_Utils_Tuple2(
			5,
			{bJ: $author$project$SpectrumColour$c_BRIGHT_CYAN, e3: 12}),
			_Utils_Tuple2(
			6,
			{bJ: $author$project$SpectrumColour$c_BRIGHT_YELLOW, e3: 13}),
			_Utils_Tuple2(
			7,
			{bJ: $author$project$SpectrumColour$c_WHITE, e3: 14})
		]));
var $author$project$SpectrumColour$Blue = 1;
var $author$project$SpectrumColour$Cyan = 5;
var $author$project$SpectrumColour$Green = 4;
var $author$project$SpectrumColour$Magenta = 3;
var $author$project$SpectrumColour$Red = 2;
var $author$project$SpectrumColour$Yellow = 6;
var $author$project$SpectrumColour$spectrumColours = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			0,
			{bJ: $author$project$SpectrumColour$c_BLACK, e3: 0}),
			_Utils_Tuple2(
			1,
			{bJ: $author$project$SpectrumColour$c_DULL_BLUE, e3: 1}),
			_Utils_Tuple2(
			2,
			{bJ: $author$project$SpectrumColour$c_DULL_RED, e3: 2}),
			_Utils_Tuple2(
			3,
			{bJ: $author$project$SpectrumColour$c_DULL_MAGENTA, e3: 3}),
			_Utils_Tuple2(
			4,
			{bJ: $author$project$SpectrumColour$c_DULL_GREEN, e3: 4}),
			_Utils_Tuple2(
			5,
			{bJ: $author$project$SpectrumColour$c_DULL_CYAN, e3: 5}),
			_Utils_Tuple2(
			6,
			{bJ: $author$project$SpectrumColour$c_DULL_YELLOW, e3: 6}),
			_Utils_Tuple2(
			7,
			{bJ: $author$project$SpectrumColour$c_DULL_WHITE, e3: 7})
		]));
var $author$project$SpectrumColour$spectrumColour = F2(
	function (value, bright) {
		return bright ? A2(
			$elm$core$Maybe$withDefault,
			{bJ: $author$project$SpectrumColour$c_DULL_WHITE, e3: 7},
			A2($elm$core$Dict$get, value, $author$project$SpectrumColour$spectrumBrightColours)) : A2(
			$elm$core$Maybe$withDefault,
			{bJ: $author$project$SpectrumColour$c_DULL_WHITE, e3: 7},
			A2($elm$core$Dict$get, value, $author$project$SpectrumColour$spectrumColours));
	});
var $author$project$Z80Screen$pairToColour = F3(
	function (globalFlash, raw_colour, runcount) {
		var _v0 = function () {
			var _v1 = 192 & raw_colour;
			switch (_v1) {
				case 0:
					return _Utils_Tuple2(false, false);
				case 64:
					return _Utils_Tuple2(false, true);
				case 128:
					return _Utils_Tuple2(true, false);
				default:
					return _Utils_Tuple2(true, true);
			}
		}();
		var flash = _v0.a;
		var bright = _v0.b;
		var value = (flash && globalFlash) ? (!runcount.e3) : runcount.e3;
		var colour_value = value ? (raw_colour & 7) : ((raw_colour & 56) >> 3);
		var colour = A2($author$project$SpectrumColour$spectrumColour, colour_value, bright);
		return A2($author$project$Z80Screen$ScreenColourRun, runcount, colour);
	});
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Z80Screen$mapScanLine = F2(
	function (globalFlash, v32) {
		return $elm$core$List$reverse(
			A3(
				$elm$core$List$foldl,
				F2(
					function (item, list) {
						var _v2 = $elm$core$List$head(list);
						if (!_v2.$) {
							var _v3 = _v2.a;
							var head = _v3.a;
							var headItem = _v3.b;
							return A2(
								$elm$core$List$cons,
								_Utils_Tuple2(head + headItem.eI.y, item),
								list);
						} else {
							return $elm$core$List$singleton(
								_Utils_Tuple2(0, item));
						}
					}),
				_List_Nil,
				A3(
					$elm$core$List$foldr,
					F2(
						function (screendata, linelist) {
							var list2 = A3(
								$elm$core$List$foldr,
								F2(
									function (item, list) {
										if (list.b) {
											var runcount = list.a;
											var tail = list.b;
											return _Utils_eq(item.e3, runcount.e3) ? A2(
												$elm$core$List$cons,
												A2($author$project$Z80Screen$RunCount, runcount.e3, runcount.y + item.y),
												tail) : A2($elm$core$List$cons, item, list);
										} else {
											return $elm$core$List$singleton(item);
										}
									}),
								_List_Nil,
								$elm$core$List$concat(
									A2($elm$core$List$map, $author$project$Z80Screen$intToRcList, screendata.af)));
							var newList = A2(
								$elm$core$List$map,
								A2($author$project$Z80Screen$pairToColour, globalFlash, screendata.bJ),
								list2);
							return _Utils_ap(newList, linelist);
						}),
					_List_Nil,
					A3(
						$Chadtech$elm_vector$Vector32$foldr,
						F2(
							function (raw, list) {
								if (list.b) {
									var head = list.a;
									var tail = list.b;
									return _Utils_eq(head.bJ, raw.bJ) ? A2(
										$elm$core$List$cons,
										A2(
											$author$project$Z80Screen$ScreenData,
											raw.bJ,
											A2($elm$core$List$cons, raw.af, head.af)),
										tail) : A2(
										$elm$core$List$cons,
										A2(
											$author$project$Z80Screen$ScreenData,
											raw.bJ,
											_List_fromArray(
												[raw.af])),
										list);
								} else {
									return _List_fromArray(
										[
											A2(
											$author$project$Z80Screen$ScreenData,
											raw.bJ,
											_List_fromArray(
												[raw.af]))
										]);
								}
							}),
						_List_Nil,
						v32))));
	});
var $Chadtech$elm_vector$Vector32$from32 = function (a0) {
	return function (a1) {
		return function (a2) {
			return function (a3) {
				return function (a4) {
					return function (a5) {
						return function (a6) {
							return function (a7) {
								return function (a8) {
									return function (a9) {
										return function (a10) {
											return function (a11) {
												return function (a12) {
													return function (a13) {
														return function (a14) {
															return function (a15) {
																return function (a16) {
																	return function (a17) {
																		return function (a18) {
																			return function (a19) {
																				return function (a20) {
																					return function (a21) {
																						return function (a22) {
																							return function (a23) {
																								return function (a24) {
																									return function (a25) {
																										return function (a26) {
																											return function (a27) {
																												return function (a28) {
																													return function (a29) {
																														return function (a30) {
																															return function (a31) {
																																return {j: a0, b3: a1, b4: a10, b5: a11, b6: a12, b7: a13, b8: a14, b9: a15, ca: a16, cb: a17, cc: a18, cd: a19, b: a2, ce: a20, cf: a21, cg: a22, ch: a23, ci: a24, cj: a25, ck: a26, cl: a27, cm: a28, cn: a29, c: a3, co: a30, cp: a31, d: a4, e: a5, f: a6, g: a7, h: a8, i: a9};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$ScreenStorage$memoryRow = F2(
	function (screenLine, index8) {
		var dataOffset = $Chadtech$elm_vector$Vector8$indexToInt(index8) * 32;
		var d9 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 9, screenLine);
		var d8 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 8, screenLine);
		var d7 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 7, screenLine);
		var d6 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 6, screenLine);
		var d5 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 5, screenLine);
		var d4 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 4, screenLine);
		var d31 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 31, screenLine);
		var d30 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 30, screenLine);
		var d3 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 3, screenLine);
		var d29 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 29, screenLine);
		var d28 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 28, screenLine);
		var d27 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 27, screenLine);
		var d26 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 26, screenLine);
		var d25 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 25, screenLine);
		var d24 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 24, screenLine);
		var d23 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 23, screenLine);
		var d22 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 22, screenLine);
		var d21 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 21, screenLine);
		var d20 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 20, screenLine);
		var d2 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 2, screenLine);
		var d19 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 19, screenLine);
		var d18 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 18, screenLine);
		var d17 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 17, screenLine);
		var d16 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 16, screenLine);
		var d15 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 15, screenLine);
		var d14 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 14, screenLine);
		var d13 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 13, screenLine);
		var d12 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 12, screenLine);
		var d11 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 11, screenLine);
		var d10 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 10, screenLine);
		var d1 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset + 1, screenLine);
		var d0 = A2($author$project$Z80MemoryDict$getMemValue, dataOffset, screenLine);
		return $Chadtech$elm_vector$Vector32$from32(d0)(d1)(d2)(d3)(d4)(d5)(d6)(d7)(d8)(d9)(d10)(d11)(d12)(d13)(d14)(d15)(d16)(d17)(d18)(d19)(d20)(d21)(d22)(d23)(d24)(d25)(d26)(d27)(d28)(d29)(d30)(d31);
	});
var $author$project$Z80Screen$mapScreenLine = F2(
	function (globalFlash, screenLine) {
		var rawData = A2(
			$Chadtech$elm_vector$Vector8$map,
			function (dataIndex) {
				var dataRow = A2($author$project$ScreenStorage$memoryRow, screenLine.af, dataIndex);
				var attr_row = screenLine.dv;
				return A3(
					$Chadtech$elm_vector$Vector32$map2,
					F2(
						function (data, attr) {
							return {bJ: attr, af: data};
						}),
					dataRow,
					attr_row);
			},
			$Chadtech$elm_vector$Vector8$indices);
		return A2(
			$Chadtech$elm_vector$Vector8$map,
			$author$project$Z80Screen$mapScanLine(globalFlash),
			rawData);
	});
var $author$project$QaopModel$mapScreenLineToSvg = F3(
	function (flash, index24, screenLine) {
		var scrFolded = A2($author$project$Z80Screen$mapScreenLine, flash, screenLine);
		var folded2 = A2(
			$Chadtech$elm_vector$Vector8$indexedMap,
			F2(
				function (index8, vec) {
					var y_index = ($Chadtech$elm_vector$Vector24$indexToInt(index24) * 8) + $Chadtech$elm_vector$Vector8$indexToInt(index8);
					return A2(
						$elm$core$List$map,
						$author$project$QaopModel$mapLineToSvg(y_index),
						vec);
				}),
			scrFolded);
		return A2(
			$elm$svg$Svg$g,
			_List_Nil,
			$Chadtech$elm_vector$Vector8$toList(
				A2(
					$Chadtech$elm_vector$Vector8$map,
					function (row) {
						return A2($elm$svg$Svg$g, _List_Nil, row);
					},
					folded2)));
	});
var $author$project$QaopModel$screenDataNodeList = F2(
	function (flash, screenLines) {
		return A2(
			$Chadtech$elm_vector$Vector24$indexedMap,
			F2(
				function (index, line) {
					var localFlash = (!(128 & A3(
						$Chadtech$elm_vector$Vector32$foldl,
						F2(
							function (x, y) {
								return x | y;
							}),
						0,
						line.dv))) ? false : flash;
					return A4($elm$svg$Svg$Lazy$lazy3, $author$project$QaopModel$mapScreenLineToSvg, localFlash, index, line);
				}),
			screenLines);
	});
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $Chadtech$elm_vector$Vector24$toList = function (_v0) {
	var vector = _v0;
	return _List_fromArray(
		[vector.j, vector.b3, vector.b, vector.c, vector.d, vector.e, vector.f, vector.g, vector.h, vector.i, vector.b4, vector.b5, vector.b6, vector.b7, vector.b8, vector.b9, vector.ca, vector.cb, vector.cc, vector.cd, vector.ce, vector.cf, vector.cg, vector.ch]);
};
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $author$project$QaopModel$svgNode = F2(
	function (screen, flash) {
		var nodelist = $author$project$QaopModel$screenDataNodeList(flash);
		var screenLines = $Chadtech$elm_vector$Vector24$toList(
			nodelist(screen.ea));
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromInt(272 * $author$project$QaopModel$c_SCALEFACTOR)),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromInt(352 * $author$project$QaopModel$c_SCALEFACTOR)),
					$elm$svg$Svg$Attributes$viewBox('0 0 352 272')
				]),
			_List_fromArray(
				[
					A2($elm$svg$Svg$Lazy$lazy, $author$project$QaopModel$backgroundNode, screen),
					A2($elm$svg$Svg$g, _List_Nil, screenLines)
				]));
	});
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Utils$digitToString = F2(
	function (pad, _int) {
		return A3(
			$elm$core$String$padLeft,
			pad,
			'0',
			$elm$core$String$fromInt(_int));
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$String$reverse = _String_reverse;
var $author$project$Utils$time_display = F2(
	function (elapsed_millis, count) {
		var loop_time = A2($author$project$Utils$loop_time_in_ms, elapsed_millis, count);
		var time_string = $elm$core$String$reverse(
			$elm$core$String$fromList(
				A2(
					$elm$core$List$drop,
					$author$project$Utils$c_DECIMAL_PLACES,
					$elm$core$String$toList(
						$elm$core$String$reverse(
							$elm$core$String$fromInt(loop_time))))));
		var last = A2(
			$author$project$Utils$digitToString,
			$author$project$Utils$c_DECIMAL_PLACES,
			A2(
				$elm$core$Basics$modBy,
				A2($elm$core$Basics$pow, 10, $author$project$Utils$c_DECIMAL_PLACES),
				loop_time));
		return 'time ' + (time_string + ('.' + (last + ' ms ')));
	});
var $author$project$QaopModel$viewQaop = F2(
	function (model, tickInterval) {
		var time_disp = A2($author$project$Utils$time_display, model.aq, model.y);
		var speed = A2($author$project$Utils$speed_in_hz, model.aq, model.y);
		var screen = model.l.bn.eH.e6.eK;
		var load_disabled = function () {
			var _v0 = model.l.bn.dj;
			if (!_v0.$) {
				var tape = _v0.a;
				return model.bf || ((model.y < 100) || _Utils_eq(
					tape.eT.eY,
					$elm$core$Dict$size(tape.eZ)));
			} else {
				return true;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Refresh Interval ' + ($elm$core$String$fromInt(tickInterval) + 'ms '))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('cyclecount')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(model.y))
										])),
									$elm$html$Html$text(' in '),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('elapsed')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt((model.aq / 1000) | 0))
										])),
									$elm$html$Html$text(' sec, '),
									$elm$html$Html$text(time_disp),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('hz')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(speed)
										])),
									$elm$html$Html$text(' Hz')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$QaopModel$Pause)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									model.l.bn.aN ? 'Unpause' : 'Pause')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$QaopModel$Autoload),
									$elm$html$Html$Attributes$disabled(load_disabled)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Load')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$tabindex(0),
							$elm$html$Html$Attributes$id('spectrum'),
							A2(
							$elm$html$Html$Events$preventDefaultOn,
							'keydown',
							A2($elm$json$Json$Decode$map, $author$project$QaopModel$alwaysPreventDefault, $author$project$QaopModel$keyDownDecoder)),
							A2(
							$elm$html$Html$Events$preventDefaultOn,
							'keyup',
							A2($elm$json$Json$Decode$map, $author$project$QaopModel$alwaysPreventDefault, $author$project$QaopModel$keyUpDecoder))
						]),
					_List_fromArray(
						[
							A3($elm$svg$Svg$Lazy$lazy2, $author$project$QaopModel$svgNode, screen, model.aW)
						]))
				]));
	});
var $author$project$Main$view = function (model) {
	var _v0 = model.aO;
	if (!_v0.$) {
		return A2($elm$html$Html$div, _List_Nil, _List_Nil);
	} else {
		var qaopModel = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Main$RunningMessage,
			A2($author$project$QaopModel$viewQaop, qaopModel, model.bw));
	}
};
var $author$project$Main$main = $elm$browser$Browser$element(
	{d5: $author$project$Main$init, eQ: $author$project$Main$subscriptions, e1: $author$project$Main$update, e4: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (tape) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (rom) {
					return $elm$json$Json$Decode$succeed(
						{c7: rom, dj: tape});
				},
				A2($elm$json$Json$Decode$field, 'rom', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'tape', $elm$json$Json$Decode$string)))(0)}});}(this));